import type { TranslationMap } from './types';

// Bengali (বাংলা) translations. Keys mirror en.ts; missing/
// English-identical values fall back to English via I18nContext.resolveEn().
const messages: TranslationMap = {
  'connections.header.companion': 'দ্রুত, সর্বদা-সক্রিয় সহায়তার জন্য একটি ভাসমান ডেস্কটপ সঙ্গী।',
  'settings.assistant.desktopCompanion': 'ডেস্কটপ সঙ্গী',
  'settings.assistant.desktopCompanionDesc': 'সিস্টেম ট্রে শর্টকাট সহ সর্বদা-চালু সঙ্গী মোড',
  'pages.settings.features.desktopCompanion': 'ডেস্কটপ কম্প্যানিয়ন',
  'settings.companion.title': 'ডেস্কটপ সঙ্গী',
  'settings.companion.session': 'সেশন',
  'settings.companion.activeLabel': 'সক্রিয়',
  'settings.companion.inactiveStatus': 'নিষ্ক্রিয়',
  'settings.companion.stopping': 'থামানো হচ্ছে…',
  'settings.companion.stopSession': 'সেশন বন্ধ করুন',
  'settings.companion.starting': 'শুরু হচ্ছে...',
  'settings.companion.startSession': 'সেশন শুরু করুন',
  'settings.companion.sessionId': 'সেশন আইডি',
  'settings.companion.turns': 'টার্ন',
  'settings.companion.remaining': 'অবশিষ্ট',
  'settings.companion.configuration': 'কনফিগারেশন',
  'settings.companion.hotkey': 'হটকি',
  'settings.companion.activationMode': 'সক্রিয়করণ মোড',
  'settings.companion.sessionTtl': 'সেশন TTL',
  // Share cards (#5006).
  'share.button': 'শেয়ার',
  'share.modalTitle': 'এই মুহূর্তটি শেয়ার করুন',
  'share.modalSubtitle': 'আপনার এজেন্ট যা করেছে তা X বা LinkedIn-এ পোস্ট করুন',
  'share.drafting': 'আপনার কার্ড ডিজাইন করা হচ্ছে...',
  'share.cardAlt': 'শেয়ার কার্ডের প্রিভিউ',
  'share.imageError': 'ছবিটি তৈরি করা যায়নি। আবার চেষ্টা করুন।',
  'share.captionLabel': 'ক্যাপশন',
  'share.captionPlaceholder': 'একটি ক্যাপশন লিখুন...',
  'share.privacyNote':
    'শুধু শিরোনাম, ক্যাপশন, এজেন্টের নাম এবং ব্র্যান্ডিং শেয়ার করা হয়। আপনার চ্যাট, মেমরি এবং ফাইল ব্যক্তিগত থাকে।',
  'share.defaultHeadline': 'দেখুন আমার OpenHuman এজেন্ট এইমাত্র কী করেছে',
  'share.defaultAgentName': 'আমার এজেন্ট',
  'share.defaultCaption': 'দেখুন আমার OpenHuman এজেন্ট এইমাত্র কী করেছে।',
  'share.captionWithHeadline': '{headline}। আমার OpenHuman এজেন্ট দিয়ে তৈরি।',
  'share.linkedInHint': 'ক্যাপশন কপি করা হয়েছে। আপনার LinkedIn পোস্টে পেস্ট করুন।',
  'share.shareX': 'X-এ শেয়ার করুন',
  'share.shareLinkedIn': 'LinkedIn-এ শেয়ার করুন',
  'share.copyImage': 'ছবি কপি করুন',
  'share.copiedImage': 'ছবি কপি হয়েছে',
  'share.copyCaption': 'ক্যাপশন কপি করুন',
  'share.copiedCaption': 'ক্যাপশন কপি হয়েছে',
  'agentWorld.welcome.nav': 'স্বাগতম',
  'agentWorld.welcome.eyebrow': 'TinyPlace',
  'agentWorld.welcome.title': 'একটি জগৎ যেখানে আপনার এজেন্টরা মিলিত হয়',
  'agentWorld.welcome.body':
    'TinyPlace হলো AI এজেন্টদের জন্য সামাজিক স্তর: আপনার এজেন্ট অন্য এজেন্টদের খুঁজে পেতে পারে, তাদের বার্তা পাঠাতে পারে, বাউন্টি নিতে পারে এবং লেনদেন করতে পারে, সবই আপনার পক্ষ থেকে। জগতে প্রবেশ করুন এবং দেখুন তারা কী করে।',
  'agentWorld.welcome.ctaWorld': 'জগতে প্রবেশ করুন',
  'agentWorld.welcome.ctaFeed': 'ফিড ব্রাউজ করুন',
  'agentWorld.welcome.ctaDirectory': 'এজেন্ট খুঁজুন',
  'agentWorld.welcome.featsLabel': 'এখানে কী ঘটে',
  'agentWorld.welcome.feat1Title': 'অন্য এজেন্টদের সাথে মিলিত হন',
  'agentWorld.welcome.feat1Body': 'নেটওয়ার্ক জুড়ে এজেন্টদের খুঁজে বের করুন এবং বার্তা পাঠান।',
  'agentWorld.welcome.feat2Title': 'বাউন্টি গ্রহণ করুন',
  'agentWorld.welcome.feat2Body': 'পোস্ট করা কাজ সম্পন্ন করে আপনার এজেন্ট উপার্জন করতে পারে।',
  'agentWorld.welcome.feat3Title': 'লেনদেন ও বিনিময়',
  'agentWorld.welcome.feat3Body': 'আপনার অনুমোদন সাপেক্ষে এজেন্টদের মধ্যে ওয়ালেট-সমর্থিত পেমেন্ট।',
  'brain.header.graph': 'আপনার এজেন্টের জ্ঞান কীভাবে যুক্ত: মানুষ, বিষয় এবং স্মৃতি।',
  'brain.header.goals': 'আপনার এজেন্ট কী লক্ষ্যে কাজ করছে, এবং কেন।',
  'brain.header.sources': 'যে ডেটা থেকে আপনার এজেন্ট শেখে।',
  'brain.header.sync': 'আপনার স্মৃতি তরতাজা রাখুন এবং কী বদলেছে তা পর্যালোচনা করুন।',
  'brain.header.subconscious': 'আপনি দূরে থাকাকালীন চলা পটভূমির চিন্তাভাবনা।',
  'brain.welcome.nav': 'স্বাগতম',
  'brain.welcome.eyebrow': 'Brain',
  'brain.welcome.title': 'আপনার এজেন্টের স্মৃতি, মানচিত্রায়িত',
  'brain.welcome.body':
    'Brain হলো যেখানে আপনার এজেন্ট তার জানা বিষয় রাখে: মানুষ, কথোপকথন, উৎস এবং লক্ষ্য যেগুলোর উপর নির্ভর করে সে প্রতিবার নতুন করে শুরু না করে প্রকৃত প্রেক্ষাপট নিয়ে আপনাকে সাহায্য করে।',
  'brain.welcome.ctaGraph': 'স্মৃতি গ্রাফ খুলুন',
  'brain.welcome.ctaGoals': 'লক্ষ্য নির্ধারণ করুন',
  'brain.welcome.ctaSources': 'উৎস সংযুক্ত করুন',
  'brain.welcome.featsLabel': 'এখানে কী থাকে',
  'brain.welcome.feat1Title': 'স্মৃতি গ্রাফ',
  'brain.welcome.feat1Body': 'এক নজরে দেখুন মানুষ, বিষয় এবং বার্তা কীভাবে যুক্ত।',
  'brain.welcome.feat2Title': 'লক্ষ্য ও মনোযোগ',
  'brain.welcome.feat2Body':
    'আপনার এজেন্টকে বলুন কী গুরুত্বপূর্ণ যাতে সে সঠিক কাজকে অগ্রাধিকার দেয়।',
  'brain.welcome.feat3Title': 'উৎস ও সিঙ্ক',
  'brain.welcome.feat3Body': 'যে ডেটা থেকে আপনার এজেন্ট শেখে তা সংযুক্ত করুন এবং তরতাজা রাখুন।',
  'feedback.header.title': 'মতামত',
  'feedback.header.desc': 'ধারণা শেয়ার করুন এবং আমরা পরবর্তীতে কী তৈরি করব তা ভোট দিন।',
  'feedback.welcome.nav': 'স্বাগতম',
  'feedback.welcome.main': 'মতামত বোর্ড',
  'feedback.welcome.eyebrow': 'মতামত',
  'feedback.welcome.title': 'আমরা কী তৈরি করব তা গড়তে সাহায্য করুন',
  'feedback.welcome.body':
    'আমাদের বলুন কী কাজ করছে, কী নেই, এবং কী OpenHuman-কে আরও ভালো করবে। একটি ধারণা পোস্ট করুন, অন্যরা যা প্রস্তাব করে তাতে ভোট দিন, এবং সেরাগুলোকে আমাদের রোডম্যাপের শীর্ষে উঠতে দেখুন।',
  'feedback.welcome.ctaShare': 'একটি ধারণা শেয়ার করুন',
  'feedback.welcome.ctaBoard': 'বোর্ড দেখুন',
  'feedback.welcome.featsLabel': 'আপনি যা করতে পারেন',
  'feedback.welcome.feat1Title': 'ধারণা শেয়ার করুন',
  'feedback.welcome.feat1Body': 'বাগ, ফিচার অনুরোধ, খসড়া চিন্তা: সবই স্বাগত।',
  'feedback.welcome.feat2Title': 'ভোট দিন',
  'feedback.welcome.feat2Body':
    'যা গুরুত্বপূর্ণ তাতে আপভোট দিন যাতে আমরা জানি কী অগ্রাধিকার দিতে হবে।',
  'feedback.welcome.feat3Title': 'অগ্রগতি ট্র্যাক করুন',
  'feedback.welcome.feat3Body': 'কী পরিকল্পিত, চলমান এবং সরবরাহ করা হয়েছে তা দেখুন।',
  'connections.header.composio': 'আপনার এজেন্ট যে অ্যাপে কাজ করতে পারে সেগুলো সংযুক্ত করুন।',
  'connections.header.channels': 'আপনার কমিউনিটি যে চ্যাট অ্যাপে থাকে সেগুলো যুক্ত করুন।',
  'connections.header.mcp': 'আপনার এজেন্টের টুল বাড়াতে MCP সার্ভার যোগ করুন।',
  'connections.header.skills': 'এজেন্ট দক্ষতা ইনস্টল ও পরিচালনা করুন।',
  'connections.header.meetings': 'ক্যালেন্ডার সংযুক্ত করুন এবং আপনার এজেন্টকে কলে যোগ দিতে দিন।',
  'connections.header.llm': 'AI প্রদানকারী, স্থানীয় মডেল এবং এজেন্ট চ্যাট টেস্টার কনফিগার করুন।',
  'connections.header.embeddings': 'মেমরি অনুসন্ধানে ব্যবহৃত এমবেডিং মডেল বেছে নিন।',
  'connections.header.search': 'আপনার এজেন্টের জন্য ওয়েব অনুসন্ধান কনফিগার করুন।',
  'connections.header.wallet': 'আপনার স্থানীয় ওয়ালেটের ব্যালেন্স এবং পুনরুদ্ধার বাক্যাংশ।',
  'connections.header.composioKey':
    'শত শত অ্যাপ ইন্টিগ্রেশন আনলক করতে একটি Composio API কী যোগ করুন।',
  'connections.llm.apiKeys': 'API কী ও রাউটিং',
  'connections.welcome.nav': 'স্বাগতম',
  'connections.welcome.eyebrow': 'সংযোগ',
  'connections.welcome.title': 'আপনি যা ব্যবহার করেন সবকিছু এক জায়গায়',
  'connections.welcome.body':
    'আপনার মেসেজিং অ্যাপ, ইমেল, ক্যালেন্ডার এবং টুল সংযুক্ত করুন যাতে আপনার এজেন্ট প্রেক্ষাপট পড়তে এবং সেগুলো জুড়ে পদক্ষেপ নিতে পারে, এক ডজন ট্যাবের মধ্যে কপি-পেস্ট না করে। এটি কী স্পর্শ করতে পারে তার নিয়ন্ত্রণ আপনার হাতেই থাকে।',
  'connections.welcome.ctaChannel': 'একটি চ্যানেল সংযুক্ত করুন',
  'connections.welcome.ctaApps': 'অ্যাপ সংযুক্ত করুন',
  'connections.welcome.ctaSkills': 'দক্ষতা ব্রাউজ করুন',
  'connections.welcome.featsLabel': 'আপনি এখানে যা করতে পারেন',
  'connections.welcome.feat1Title': 'চ্যানেল নিয়ে আসুন',
  'connections.welcome.feat1Body':
    'Slack, WhatsApp, Telegram, Gmail এবং আরও: কয়েকটি ক্লিকে যুক্ত।',
  'connections.welcome.feat2Title': 'আপনার এজেন্টকে কাজ করতে দিন',
  'connections.welcome.feat2Body':
    'সংযুক্ত সবকিছু থেকে পূর্ণ প্রেক্ষাপট নিয়ে এটি পড়ে, খসড়া করে এবং উত্তর দেয়।',
  'connections.welcome.feat3Title': 'নিয়ন্ত্রণে থাকুন',
  'connections.welcome.feat3Body':
    'যেকোনো সময় প্রতি চ্যানেলে অ্যাক্সেস দিন বা প্রত্যাহার করুন। আপনার সম্মতি ছাড়া কিছুই চলে না।',
  'alerts.header.desc': 'এজেন্ট কার্যকলাপ এবং আপনার মনোযোগ প্রয়োজন এমন সবকিছু।',
  'notifications.welcome.nav': 'স্বাগতম',
  'notifications.welcome.main': 'সতর্কতা',
  'notifications.welcome.eyebrow': 'বিজ্ঞপ্তি',
  'notifications.welcome.title': 'শুধু যা সত্যিই আপনাকে প্রয়োজন',
  'notifications.welcome.body':
    'আপনার এজেন্টরা কী করেছে এবং কী একটি সিদ্ধান্তের প্রয়োজন তার একটি শান্ত, স্কোরকৃত সারসংক্ষেপ, যাতে গুরুত্বপূর্ণ বিষয়গুলো সামনে আসে এবং কোলাহল আপনার পথ থেকে দূরে থাকে।',
  'notifications.welcome.ctaView': 'সতর্কতা দেখুন',
  'notifications.welcome.featsLabel': 'আপনি যা দেখবেন',
  'notifications.welcome.feat1Title': 'যা আপনাকে প্রয়োজন',
  'notifications.welcome.feat1Body': 'আপনার এজেন্টরা মানুষের জন্য চিহ্নিত করা সিদ্ধান্ত ও উল্লেখ।',
  'notifications.welcome.feat2Title': 'এজেন্ট কার্যকলাপ',
  'notifications.welcome.feat2Body': 'কী চলেছে এবং কী তৈরি করেছে তার একটি চলমান লগ।',
  'notifications.welcome.feat3Title': 'বিভাগ অনুযায়ী ফিল্টার',
  'notifications.welcome.feat3Body': 'বার্তা, মিটিং, রিমাইন্ডার: আপনার চিন্তা অনুযায়ী বিভক্ত।',
  'rewards.header.desc': 'আপনার পয়েন্ট, স্ট্রিক, রেফারেল এবং সুবিধা।',
  'rewards.welcome.nav': 'স্বাগতম',
  'rewards.welcome.main': 'পুরস্কার',
  'rewards.welcome.eyebrow': 'পুরস্কার',
  'rewards.welcome.title': 'হাজির থাকার জন্য পুরস্কৃত হন',
  'rewards.welcome.body':
    'আপনি OpenHuman ব্যবহার এবং অন্যদের আমন্ত্রণ জানানোর সময় পয়েন্ট অর্জন করুন, আপনার স্ট্রিক বজায় রাখুন এবং যা অর্জন করেছেন তা রিডিম করুন। সবকিছু এক জায়গায় ট্র্যাক করুন।',
  'rewards.welcome.ctaView': 'পুরস্কার দেখুন',
  'rewards.welcome.featsLabel': 'এটি কীভাবে কাজ করে',
  'rewards.welcome.feat1Title': 'পয়েন্ট অর্জন করুন',
  'rewards.welcome.feat1Body': 'প্রতিদিনের কাজ এবং রেফারেল সময়ের সাথে জমা হয়।',
  'rewards.welcome.feat2Title': 'আপনার স্ট্রিক বজায় রাখুন',
  'rewards.welcome.feat2Body': 'স্ট্রিক বোনাস আনলক করতে নিয়মিত হাজির থাকুন।',
  'rewards.welcome.feat3Title': 'সুবিধা রিডিম করুন',
  'rewards.welcome.feat3Body': 'পয়েন্টকে কুপন ও পুরস্কারে রূপান্তর করুন।',
  'flows.welcome.nav': 'স্বাগতম',
  'flows.welcome.main': 'ওয়ার্কফ্লো',
  'flows.welcome.eyebrow': 'ওয়ার্কফ্লো',
  'flows.welcome.title': 'ব্যস্ততার কাজকে অটোপাইলটে দিন',
  'flows.welcome.body':
    'আপনি বারবার যা করেন তা বর্ণনা করুন (ট্রায়াজ, ফলো-আপ, সারসংক্ষেপ) এবং আপনার এজেন্ট এটিকে একটি ওয়ার্কফ্লোতে পরিণত করে যা সে শুরু থেকে শেষ পর্যন্ত, একটি সময়সূচি অনুযায়ী বা চাহিদামতো চালাতে পারে।',
  'flows.welcome.ctaNew': 'নতুন ওয়ার্কফ্লো',
  'flows.welcome.ctaBrowse': 'ওয়ার্কফ্লো ব্রাউজ করুন',
  'flows.welcome.featsLabel': 'আপনি যা স্বয়ংক্রিয় করতে পারেন',
  'flows.welcome.feat1Title': 'শব্দে বর্ণনা করুন',
  'flows.welcome.feat1Body': 'সহজ ভাষায় বলুন আপনি কী চান; বিল্ডার ফ্লোর খসড়া তৈরি করে।',
  'flows.welcome.feat2Title': 'সময়সূচি অনুযায়ী চালান',
  'flows.welcome.feat2Body': 'একটি টাইমার, একটি ইভেন্ট বা একটি বোতামে চালু করুন: আপনার সিদ্ধান্ত।',
  'flows.welcome.feat3Title': 'মানুষকে লুপে রাখুন',
  'flows.welcome.feat3Body': 'কিছু বেরিয়ে যাওয়ার আগে সংবেদনশীল ধাপগুলো অনুমোদন করুন।',
  // Privacy Mode selector (#4435): data-egress posture
  'privacy.mode.title': 'গোপনীয়তা মোড',
  'privacy.mode.description':
    'আপনার কতটা ডেটা এই ডিভাইস থেকে বের হতে পারে তা নিয়ন্ত্রণ করে। এজেন্ট অ্যাক্সেস মোড থেকে আলাদা।',
  'privacy.mode.localOnly': 'শুধু লোকাল',
  'privacy.mode.localOnlyDesc': 'শুধুমাত্র ডিভাইসে থাকা মডেল। বাহ্যিক মডেল কল ব্লক করা হয়।',
  'privacy.mode.standard': 'স্ট্যান্ডার্ড',
  'privacy.mode.standardDesc': 'ভারসাম্যপূর্ণ। বাহ্যিক মডেল কনফিগার অনুযায়ী ব্যবহৃত হয়।',
  'privacy.mode.sensitive': 'সংবেদনশীল',
  'privacy.mode.sensitiveDesc': 'সংবেদনশীল ডেটার জন্য অতিরিক্ত যত্ন। আরও নিয়ন্ত্রণ শীঘ্রই আসছে।',
  'privacy.mode.saved': 'সংরক্ষিত',
  'privacy.mode.saveError': 'গোপনীয়তা মোড আপডেট করা যায়নি।',
  'skills.recallCalendar.title': 'গুগল ক্যালেন্ডার',
  'skills.recallCalendar.description':
    'Recall.ai-এর মাধ্যমে Google Meet কলে স্বয়ংক্রিয়ভাবে যোগ দিন',
  // Core connection panel (GH-4396)
  'settings.core.title': 'কোর সংযোগ',
  'settings.core.menuDesc':
    'অন্তর্নির্মিত স্থানীয় কোর ব্যবহার করুন বা একটি রিমোট কোরে সংযোগ করুন।',
  'settings.core.useRemoteToggle': 'রিমোট কোর ব্যবহার করুন',
  'settings.core.useRemoteToggleDesc':
    'অন্তর্নির্মিত স্থানীয় কোরের পরিবর্তে HTTP-এর মাধ্যমে একটি রিমোট কোরে সংযোগ করুন।',
  'settings.core.statusConnectedRemote': 'রিমোট কোরে সংযুক্ত',
  'settings.core.statusConnectedLocal': 'স্থানীয় কোরে সংযুক্ত',
  'settings.core.statusChecking': 'সংযোগ পরীক্ষা করা হচ্ছে…',
  'settings.core.statusAuthFailed': 'পৌঁছানো যায়, তবে টোকেন প্রত্যাখ্যাত হয়েছে',
  'settings.core.statusUnreachable': 'কোরে পৌঁছানো যাচ্ছে না',
  'settings.core.recheck': 'পুনরায় পরীক্ষা করুন',
  'settings.core.save': 'সংরক্ষণ করে পুনরায় চালু করুন',
  'settings.core.applyRestartNote': 'সংরক্ষণ করলে পুনরায় সংযোগের জন্য OpenHuman পুনরায় চালু হয়।',
  // Cross-host vault (#4278)
  'crossHostVault.title': 'ভল্টটি কোর হোস্টে রয়েছে।',
  'crossHostVault.message':
    'এই মেমরি ভল্টটি openhuman-core হোস্টে ({os}) সংরক্ষিত আছে। এটি কেবল সেই মেশিনেই খোলা বা দেখানো যায়, এই ডিভাইস থেকে নয়।',
  'conversations.toolFailure.whyLabel': 'কেন',
  'conversations.toolFailure.nextLabel': 'এরপর কী করবেন',
  'conversations.toolFailure.missingPermission.cause': 'OpenHuman-এর এখনও এটি করার অনুমতি নেই।',
  'conversations.toolFailure.missingPermission.next':
    'প্রয়োজনীয় অনুমতি দিন, তারপর আবার চেষ্টা করুন।',
  'conversations.toolFailure.missingApp.cause':
    'এই কাজের জন্য প্রয়োজনীয় অ্যাপ বা প্রোগ্রামটি উপলব্ধ নেই।',
  'conversations.toolFailure.missingApp.next':
    'অ্যাপটি ইনস্টল করুন বা খুলুন, তারপর আবার চেষ্টা করুন।',
  'conversations.toolFailure.serviceUnavailable.cause':
    'OpenHuman-এর প্রয়োজনীয় একটি পরিষেবা সাময়িকভাবে অনুপলব্ধ।',
  'conversations.toolFailure.serviceUnavailable.next':
    'OpenHuman শীঘ্রই আবার চেষ্টা করবে: কোনো পদক্ষেপের প্রয়োজন নেই।',
  'conversations.toolFailure.badCredentials.cause':
    'সংরক্ষিত সাইন-ইন তথ্য অনুপস্থিত বা আর বৈধ নয়।',
  'conversations.toolFailure.badCredentials.next':
    'আবার সাইন ইন করুন বা শংসাপত্র আপডেট করুন, তারপর আবার চেষ্টা করুন।',
  'conversations.toolFailure.blockedByPolicy.cause':
    'এই কাজটি আপনার নিরাপত্তা সেটিংস দ্বারা অবরুদ্ধ।',
  'conversations.toolFailure.blockedByPolicy.next':
    'আপনি চালাতে চাইলে সেটিংস → এজেন্ট অ্যাক্সেস-এ এটি অনুমতি দিন।',
  'conversations.toolFailure.modelConnection.cause': 'OpenHuman AI মডেলে পৌঁছাতে পারেনি।',
  'conversations.toolFailure.modelConnection.next':
    'আপনার সংযোগ বা মডেল সেটিংস পরীক্ষা করুন; OpenHuman আবার চেষ্টা করবে।',
  'conversations.toolFailure.timeout.cause': 'কাজটি অনেক বেশি সময় নেওয়ায় থামিয়ে দেওয়া হয়েছে।',
  'conversations.toolFailure.timeout.next':
    'OpenHuman আবার চেষ্টা করবে, অথবা আপনি নিজে আবার চেষ্টা করতে পারেন।',
  'conversations.toolFailure.denied.cause': 'আপনি এই কাজটি প্রত্যাখ্যান করেছেন।',
  'conversations.toolFailure.denied.next': 'কিছু করার নেই: এটি চালানো হয়নি। মত বদলালে আবার বলুন।',
  'conversations.toolFailure.approvalExpired.cause':
    'কেউ সাড়া দেওয়ার আগেই অনুমোদনের অনুরোধের মেয়াদ শেষ হয়ে গেছে।',
  'conversations.toolFailure.approvalExpired.next':
    'এটি চালাতে আবার বলুন: OpenHuman নিজে থেকে পুনরায় চেষ্টা করবে না।',
  'conversations.toolFailure.unknown.cause': 'এই কাজটিতে কিছু ভুল হয়েছে।',
  'conversations.toolFailure.unknown.next':
    'আবার চেষ্টা করুন; বারবার ব্যর্থ হলে সেটিংস থেকে ডায়াগনস্টিকস চালান।',
  'conversations.backgroundTasks.title': 'পটভূমি কাজ',
  'nav.feedback': 'মতামত দিন',
  'feedback.board': 'মতামত বোর্ড',
  'feedback.empty': 'এখনও কোনো মতামত নেই। প্রথম হয়ে একটি আইডিয়া শেয়ার করুন।',
  'feedback.loadMore': 'আরও দেখুন',
  'feedback.loadError': 'মতামত লোড করা যায়নি',
  'feedback.expand': 'আরও দেখান',
  'feedback.collapse': 'কম দেখান',
  'feedback.comments': 'মন্তব্য',
  'feedback.viewIssue': 'ইস্যু দেখুন',
  'feedback.status.open': 'খোলা',
  'feedback.status.planned': 'পরিকল্পিত',
  'feedback.status.completed': 'সম্পন্ন',
  'feedback.status.closed': 'বন্ধ',
  'feedback.type.feature': 'ফিচার',
  'feedback.type.bug': 'ত্রুটি',
  'feedback.sort.hot': 'জনপ্রিয়',
  'feedback.sort.top': 'শীর্ষ',
  'feedback.sort.new': 'নতুন',
  'feedback.filter.allTypes': 'সব ধরন',
  'feedback.filter.allStatuses': 'সব স্ট্যাটাস',
  'feedback.vote.up': 'আপভোট',
  'feedback.vote.down': 'ডাউনভোট',
  'feedback.submit.heading': 'মতামত দিন',
  'feedback.submit.subheading':
    'একটি ফিচারের প্রস্তাব দিন বা কোনো ত্রুটি জানান। অন্যরা এতে ভোট দিতে পারবেন।',
  'feedback.submit.titlePlaceholder': 'শিরোনাম',
  'feedback.submit.bodyPlaceholder': 'আপনার আইডিয়া বা যে সমস্যায় পড়েছেন তা বর্ণনা করুন',
  'feedback.submit.action': 'জমা দিন',
  'feedback.submit.success': 'ধন্যবাদ! আপনার মতামত এখন বোর্ডে রয়েছে।',
  'feedback.submit.rejected': 'আপনার মতামত প্রকাশ করা যায়নি।',
  'feedback.submit.error': 'কিছু একটা সমস্যা হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'feedback.admin.status': 'স্ট্যাটাস',
  'feedback.admin.updateFailed': 'স্ট্যাটাস আপডেট করা যায়নি',
  'feedback.comments.empty': 'এখনও কোনো মন্তব্য নেই।',
  'feedback.comments.placeholder': 'একটি মন্তব্য যোগ করুন',
  'feedback.comments.post': 'পোস্ট করুন',
  'feedback.comments.loadError': 'মন্তব্য লোড করা যায়নি',
  'feedback.comments.postError': 'মন্তব্য পোস্ট করা যায়নি',
  'feedback.comments.you': 'আপনি',
  'conversations.backgroundTasks.titleWithCount': 'ব্যাকগ্রাউন্ড টাস্ক ({count})',
  'conversations.backgroundTasks.running': '{count} চলছে',
  'conversations.backgroundTasks.noneRunning': 'চলমান না',
  'conversations.backgroundTasks.total': '{count} মোট',
  'conversations.backgroundTasks.empty':
    'এই চ্যাটে কোন ব্যাকগ্রাউন্ড টাস্ক নেই। সহকারীকে ব্যাকগ্রাউন্ডে কিছু করতে বলুন এবং এটি এখানে প্রদর্শিত হবে।',
  'conversations.backgroundTasks.statusRunning': 'Running',
  'conversations.backgroundTasks.statusDone': 'Done',
  'conversations.backgroundTasks.statusFailed': 'Failed',
  'conversations.backgroundTasks.statusNeedsYou': 'তোমাকে দরকার',
  'conversations.backgroundTasks.statusCancelled': 'বাতিল হয়েছে',
  'conversations.backgroundTasks.toolCallOne': '{count} টুল কল',
  'conversations.backgroundTasks.toolCallOther': '{count} টুল কল',
  'conversations.backgroundTasks.steps': '{count} ধাপ',
  'conversations.backgroundTasks.viewDetails': 'বিস্তারিত দেখুন →',
  'conversations.backgroundTasks.close': 'Close',
  'conversations.backgroundTasks.sectionThisChat': 'এই চ্যাটে',
  'conversations.backgroundTasks.sectionScheduled': 'নির্ধারিত কাজ',
  'conversations.backgroundTasks.sectionSubconscious': 'অবচেতন চিন্তা',
  'conversations.backgroundTasks.sectionMemory': 'মেমরি সিঙ্ক হচ্ছে',
  'conversations.backgroundTasks.cronEmpty': 'কোনো নির্ধারিত কাজ নেই।',
  'conversations.backgroundTasks.cronUnnamed': 'শিরোনামহীন কাজ',
  'conversations.backgroundTasks.cronPaused': 'বিরতি দেওয়া',
  'conversations.backgroundTasks.cronNext': 'পরবর্তী {time}',
  'conversations.backgroundTasks.cronLast': 'শেষ চালানো {time}',
  'conversations.backgroundTasks.cronNever': 'এখনও চালানো হয়নি',
  'conversations.backgroundTasks.cronSchedCron': 'Cron {expr}',
  'conversations.backgroundTasks.cronSchedEvery': 'প্রতি {duration}',
  'conversations.backgroundTasks.cronSchedAt': 'একবার',
  'conversations.backgroundTasks.subOff': 'বন্ধ',
  'conversations.backgroundTasks.subWorking': 'কাজ করছে…',
  'conversations.backgroundTasks.subIdle': 'নিষ্ক্রিয়',
  'conversations.backgroundTasks.subLastRan': 'শেষ চালানো {time}',
  'conversations.backgroundTasks.subNeverRan': 'এখনও চালানো হয়নি',
  'conversations.backgroundTasks.subTicks': '{count} বার চালানো',
  'conversations.backgroundTasks.subQueued': '{count} সারিবদ্ধ',
  'conversations.backgroundTasks.memUpToDate': 'সব মেমরি হালনাগাদ',
  'conversations.backgroundTasks.memIngesting': '{title} সূচিবদ্ধ হচ্ছে',
  'conversations.backgroundTasks.memIngestingUntitled': 'মেমরি সূচিবদ্ধ হচ্ছে',
  'conversations.backgroundTasks.memQueued': '{count} সারিবদ্ধ',
  'conversations.backgroundTasks.memProviderActive': 'এখন সিঙ্ক হচ্ছে',
  'conversations.backgroundTasks.memProviderRecent': 'সম্প্রতি সিঙ্ক হয়েছে',
  'conversations.backgroundTasks.memProviderIdle': 'নিষ্ক্রিয়',
  'nav.home': 'হোম',
  'nav.chat': 'চ্যাট',
  'nav.human': 'হিউম্যান',
  'nav.assistant': 'সহকারী',
  'assistant.faceMode.on': 'Tiny-র সাথে কথা বলছে',
  'assistant.faceMode.off': 'Tiny-র সাথে কথা বলুন',
  'assistant.faceMode.turnOn': 'মাসকট দেখান',
  'assistant.faceMode.turnOff': 'মাসকট লুকান',
  'nav.connections': 'সংযোগ',
  'nav.memory': 'ইন্টেলিজেন্স',
  'nav.alerts': 'সতর্কতা',
  'nav.rewards': 'পুরস্কার',
  'nav.settings': 'সেটিংস',
  'nav.agentProfiles': 'এজেন্ট প্রোফাইল',
  'nav.switchAgentProfile': 'এজেন্ট প্রোফাইল বদলান',
  'nav.defaultAgentProfile': 'ডিফল্ট এজেন্ট',
  'nav.noAgentProfiles': 'কোনো এজেন্ট প্রোফাইল পাওয়া যায়নি',
  'nav.activity': 'কার্যকলাপ',
  'nav.brain': 'ব্রেইন',
  'nav.flows': 'ওয়ার্কফ্লো',
  'nav.workflowRuns': 'ওয়ার্কফ্লো রান',
  'nav.workflowDiscoveries': 'ওয়ার্কফ্লো আবিষ্কার করুন',
  'nav.orchestration': 'অর্কেস্ট্রেশন',
  'orchestration.cloudUnreachable':
    'ক্লাউড ব্রেন-এ পৌঁছানো যাচ্ছে না: ক্যাশে করা ভিউ দেখানো হচ্ছে।',
  'orchPage.subtitle': 'আপনার প্রধান এজেন্ট সমন্বয় করুন',
  'orchPage.group.agent': 'এজেন্ট',
  'orchPage.group.network': 'নেটওয়ার্ক',
  'orchPage.group.insights': 'অন্তর্দৃষ্টি',
  'orchPage.overview.nav': 'এজেন্ট গ্রাফ',
  'orchPage.overview.desc':
    'আপনার এজেন্ট এবং এটি যে সাব-এজেন্টগুলিকে সমন্বয় করে তার একটি লাইভ মানচিত্র।',
  'orchPage.network.desc': 'আপনি যে পিয়ার এজেন্টগুলির সাথে সংযুক্ত, আবিষ্কার এবং ব্যবহার।',
  'wallet.tabs.balance': 'ওয়ালেট ব্যালেন্স',
  'wallet.tabs.recovery': 'পুনরুদ্ধার',
  'wallet.ariaLabel': 'ওয়ালেট ভিউ',
  'orchPage.medulla.nav': 'ওভারভিউ',
  'orchPage.medulla.badge': 'শীঘ্রই আসছে',
  'orchPage.medulla.title': 'Medulla',
  'orchPage.medulla.tagline': 'OpenHuman-এর অর্কেস্ট্রেশন মডেল',
  'orchPage.medulla.body':
    'Medulla হলো OpenHuman-এর নিজস্বভাবে তৈরি LLM, যা একসঙ্গে হাজার হাজার এজেন্ট অর্কেস্ট্রেট করার জন্য প্রকৌশলিত, 10 মিলিয়ন-টোকেন কনটেক্সট উইন্ডো এবং অত্যন্ত কম খরচের অর্কেস্ট্রেশন সহ।',
  'orchPage.medulla.featAgents': 'হাজার হাজার এজেন্ট',
  'orchPage.medulla.featContext': '10M-টোকেন কনটেক্সট',
  'orchPage.medulla.featCost': 'কম খরচের অর্কেস্ট্রেশন',
  'orchPage.medulla.subscriberTitle': 'OpenHuman সাবস্ক্রাইবার',
  'orchPage.medulla.subscriberNote':
    'Medulla লাইভ হলে এটি শুধুমাত্র OpenHuman সাবস্ক্রাইবারদের জন্য এক্সক্লুসিভ হবে।',
  'orchPage.medulla.subscriberCta': 'সাবস্ক্রিপশন নিন',
  'orchPage.medulla.discordTitle': 'Discord-এ যোগ দিন',
  'orchPage.medulla.earlyAccess':
    'আগেভাগে পেতে চান? আমাদের Discord-এ যোগ দিন এবং আর্লি-অ্যাক্সেস আমন্ত্রণ নিন।',
  'orchPage.medulla.cta': 'আমাদের Discord-এ যোগ দিন',
  'orchPage.demo.banner': 'বড় পরিসরে অর্কেস্ট্রেশন কেমন দেখাবে তার একটি উদাহরণ এটি।',
  'orchPage.demo.device': 'ডিভাইস',
  'orchPage.demo.taskRoute': 'ইনকামিং অনুরোধ রুট করুন',
  'orchPage.demo.taskSummarize': 'কথোপকথন সংক্ষিপ্ত করুন',
  'orchPage.demo.taskEnrich': 'যোগাযোগের রেকর্ড সমৃদ্ধ করুন',
  'orchPage.demo.taskSchedule': 'ফলো-আপ শিডিউল করুন',
  'orchPage.demo.taskDraft': 'উত্তর খসড়া করুন',
  'orchPage.demo.taskSync': 'ডেটা উৎস সিঙ্ক করুন',
  'orchPage.demo.networkTitle': 'পিয়ার এজেন্ট',
  'orchPage.demo.networkSummary': '{peers} সংযুক্ত · {sessions} সক্রিয় সাব-এজেন্ট',
  'orchPage.demo.peer.connected': 'সংযুক্ত',
  'orchPage.demo.peer.connecting': 'সংযোগ হচ্ছে',
  'orchPage.demo.peer.idle': 'নিষ্ক্রিয়',
  'orchPage.demo.peerSessions': '{count} সাব-এজেন্ট',
  'orchPage.demo.chat.user1': 'আমার সব চ্যানেল জুড়ে আউটরিচ ক্যাম্পেইন সমন্বয় করুন।',
  'orchPage.demo.chat.assistant1':
    'কাজ চলছে: আউটরিচ, সমৃদ্ধকরণ এবং ফলো-আপ সমান্তরালভাবে চালাতে 2টি ডিভাইসে 120টি এজেন্ট চালু করা হচ্ছে।',
  'orchPage.demo.chat.activity1': 'ডিভাইস 1 · 100টি এজেন্ট 1,284টি কথোপকথন রুট করছে',
  'orchPage.demo.chat.activity2': 'ডিভাইস 2 · 20টি এজেন্ট 512টি যোগাযোগ সমৃদ্ধ করছে',
  'orchPage.demo.chat.activity3': '640টি ব্যক্তিগতকৃত উত্তর খসড়া করা হচ্ছে',
  'orchPage.demo.chat.assistant2':
    'সম্পন্ন। 120টি এজেন্ট 38 সেকেন্ডে 1,796টি কথোপকথন প্রক্রিয়া করেছে।',
  'orchPage.demo.chat.composerDisabled': 'Medulla অ্যাক্সেস থাকলে চ্যাট উপলব্ধ',
  'orchPage.tasks.nav': 'টাস্ক',
  'orchPage.tasks.subtitle': 'অর্কেস্ট্রেটরের গ্লোবাল টাস্ক বোর্ড',
  'orchPage.tasks.colPending': 'মুলতুবি',
  'orchPage.tasks.colActive': 'সক্রিয়',
  'orchPage.tasks.colBlocked': 'অবরুদ্ধ',
  'orchPage.tasks.colCompleted': 'সম্পন্ন',
  'orchPage.overview.core': 'এজেন্ট কোর',
  'orchPage.overview.empty': 'এখনও ভিজ্যুয়ালাইজ করার মতো কোনো সাব-এজেন্ট নেই',
  'orchPage.agent.nav': 'চ্যাট',
  'orchPage.agent.mainTab': 'প্রধান এজেন্ট',
  'orchPage.agent.consciousTab': 'সচেতন',
  'orchPage.agent.subconsciousTab': 'অবচেতন',
  'orchPage.agent.modeLabel': 'এজেন্টের মন',
  'orchPage.agent.description': 'প্রধান এজেন্টের সাথে চ্যাট করুন এবং তার অবচেতন দেখুন',
  'orchPage.agent.viewSession': 'সেশন দেখুন',
  'orchPage.sessions.railTitle': 'সক্রিয় এজেন্ট',
  'orchPage.sessions.empty': 'এখনও কোনো সক্রিয় এজেন্ট নেই',
  'orchPage.sessions.statusConnected': 'সংযুক্ত',
  'orchPage.sessions.statusDisconnected': 'সংযোগ বিচ্ছিন্ন',
  'orchPage.sessions.statusWaiting': 'ইনপুটের অপেক্ষায়',
  'orchPage.session.runtime': 'রানটাইম',
  'orchPage.session.directory': 'ডিরেক্টরি',
  'orchPage.session.runningOn': 'চলছে',
  'orchPage.connections.nav': 'সংযোগ',
  'orchPage.connections.title': 'সংযুক্ত এজেন্ট',
  'orchPage.connections.description':
    'যাদের সঙ্গে আপনার এজেন্ট সমন্বয় করে: একটি প্রসারিত করে তাদের সঙ্গে আপনার সেশনগুলো দেখুন',
  'orchPage.connections.empty': 'এখনও কোনো সংযোগ নেই।',
  'orchPage.connections.emptyCta': 'একটি সংযোগ যোগ করুন',
  'orchPage.connections.statContacts': 'সংযোগ',
  'orchPage.connections.statPending': 'অপেক্ষমাণ',
  'orchPage.connections.statSessions': 'সেশন',
  'orchPage.connections.sessionCount': '{n}টি সেশন',
  'orchPage.connections.noSessions': 'কোনো সেশন নেই',
  'orchPage.connections.messageCount': '{n}টি বার্তা',
  'orchPage.connections.back': 'সংযোগ',
  'orchPage.connections.replyPlaceholder': 'উত্তর…',
  'orchPage.connections.initTitle': 'একটি এজেন্ট বা ইনস্ট্যান্স চালু করুন',
  'orchPage.connections.initDesc':
    'আপনার সাথে কাজ করার জন্য একটি নতুন সাব-এজেন্ট চালু করুন। এজেন্ট চ্যাট খুলুন এবং এর ভূমিকা, লক্ষ্য ও ব্যবহার্য টুল বর্ণনা করুন: OpenHuman একটি ডেডিকেটেড ইনস্ট্যান্স তৈরি করে যা আপনি এখান থেকে পরিচালনা করতে পারেন।',
  'orchPage.connections.initCta': 'চ্যাটে শুরু করুন',
  'orchPage.connections.status.needsYou': 'আপনাকে প্রয়োজন',
  'orchPage.connections.status.running': 'চলছে',
  'orchPage.connections.status.idle': 'নিষ্ক্রিয়',
  'orchPage.connections.status.done': 'সম্পন্ন',
  'orchPage.connections.status.error': 'ত্রুটি',
  'orchPage.connections.pendingHint': 'গ্রহণের অপেক্ষায়',
  'orchPage.discover.nav': 'আবিষ্কার',
  'orchPage.discover.linkAction': 'যোগ করুন',
  'orchPage.discover.identityTitle': 'আপনার আবিষ্কারযোগ্যতা',
  'orchPage.discover.notDiscoverableGuide':
    'একটি @handle নিবন্ধন করুন যাতে অন্য এজেন্টরা আপনাকে খুঁজে বার্তা পাঠাতে পারে।',
  'orchPage.discover.linkTitle': 'নতুন এজেন্ট লিঙ্ক করুন',
  'orchPage.discover.linkDescription': 'সংযোগের অনুরোধ পাঠাতে একটি এজেন্ট আইডি পেস্ট করুন।',
  'orchPage.discover.noRequests': 'কোনো আগত অনুরোধ নেই।',
  'orchPage.usage.nav': 'ব্যবহার',
  'orchPage.usage.connections': 'সংযোগ',
  'orchPage.usage.balance': 'ক্রেডিট ব্যালেন্স',
  'orchPage.usage.balanceHint': 'প্রচারমূলক + টপ-আপ',
  'orchPage.usage.cycleSpend': 'চক্রের ব্যয়',
  'orchPage.usage.ofBudget': 'এর',
  'orchPage.usage.inferenceCalls': 'মডেল কল',
  'orchPage.usage.integrationCalls': 'ইন্টিগ্রেশন কল',
  'orchPage.usage.tokensSaved': 'সংরক্ষিত টোকেন',
  'orchPage.usage.saved': 'সংরক্ষিত',
  'orchPage.usage.footnote': 'ব্যবহার আপনার বর্তমান বিলিং চক্র প্রতিফলিত করে।',
  'nav.agentWorld': 'Tiny Place',
  'nav.wallet': 'ওয়ালেট',
  'agentWorld.description':
    'Tiny.Place হলো এআই এজেন্টদের জন্য একটি সোশ্যাল নেটওয়ার্ক। যোগাযোগ করতে, কাজ খুঁজতে ও পোস্ট করতে, লেনদেন করতে এবং একসাথে বেড়ে উঠতে OpenHuman ব্যবহার করুন।',
  'agentWorld.world': 'বিশ্ব',
  'agentWorld.world.booting': 'রেন্ডারার চালু হচ্ছে...',
  'agentWorld.world.initError': 'ওয়ার্ল্ড রেন্ডারার চালু করা যায়নি।',
  'agentWorld.world.retry': 'আবার চেষ্টা করুন',
  'agentWorld.world.title': 'Tiny Place',
  'agentWorld.world.description':
    'tiny.place-এ যোগ দিন যাতে আপনার এজেন্ট নেটওয়ার্কের অন্য এজেন্টদের সাথে সমন্বয় করতে পারে: কাজ খুঁজে পাওয়া ও পোস্ট করা, লেনদেন, বার্তা পাঠানো এবং বাউন্টিতে একসাথে কাজ করা।',
  'agentWorld.world.offlineBadge': 'অফলাইন প্রিভিউ',
  'agentWorld.world.offlineBadgeTitle':
    'এখানে দেখানো এজেন্টগুলো একটি স্থানীয় সিমুলেশন। সরাসরি উপস্থিতি ও ওয়ার্ল্ড সিঙ্ক শীঘ্রই আসছে।',
  'agentWorld.world.room': 'রুম',
  'agentWorld.world.rooms.poker.name': 'পোকার',
  'agentWorld.world.rooms.poker.description': 'ফেল্ট টেবিলের চারপাশে আটটি আসন।',
  'agentWorld.world.rooms.court.name': 'আদালত',
  'agentWorld.world.rooms.court.description': 'উঁচু বেঞ্চ, জুরি বক্স এবং গ্যালারি।',
  'agentWorld.world.rooms.office.name': 'অফিস',
  'agentWorld.world.rooms.office.description': 'কিউবিকল, ডেস্ক এবং হোয়াইটবোর্ড।',
  'agentWorld.world.rooms.home.name': 'বাড়ি',
  'agentWorld.world.rooms.home.description': 'সোফা ও কার্পেটসহ আরামদায়ক লাউঞ্জ।',
  'agentWorld.world.rooms.outside.name': 'বিশ্ব',
  'agentWorld.world.rooms.outside.description': 'ভবনঘেরা বড় খোলা প্লাজা।',
  'agentWorld.feed': 'ফিড',
  'agentWorld.feed.loadMore': 'আরও লোড করুন',
  'agentWorld.feed.loadingMore': 'আরও লোড হচ্ছে…',
  'agentWorld.feed.loadMoreError': 'আরও পোস্ট লোড করা যায়নি। আবার চেষ্টা করুন।',
  'agentWorld.ledger': 'লেজার',
  'agentWorld.profileViewer.description': 'সর্বজনীন প্রোফাইল',
  'agentWorld.profileViewer.agentCard': 'এজেন্ট কার্ড',
  'agentWorld.profileViewer.loading': 'প্রোফাইল লোড হচ্ছে…',
  'agentWorld.profileViewer.notFoundTitle': 'প্রোফাইল পাওয়া যায়নি',
  'agentWorld.profileViewer.notFoundBody': 'এই হ্যান্ডেলের জন্য এখনও কোনো প্রকাশিত প্রোফাইল নেই।',
  'agentWorld.profileViewer.errorTitle': 'প্রোফাইল লোড করা যায়নি',
  'agentWorld.profileViewer.follow': 'অনুসরণ করুন',
  'agentWorld.profileViewer.following': 'অনুসরণ করছেন',
  'agentWorld.profileViewer.copyLink': 'লিঙ্ক কপি করুন',
  'agentWorld.profileViewer.linkCopied': 'লিঙ্ক কপি হয়েছে',
  'agentWorld.profileViewer.skills': 'দক্ষতা',
  'agentWorld.profileViewer.verifiedAccounts': 'যাচাই করা অ্যাকাউন্ট',
  'agentWorld.profileViewer.handlesOwned': 'মালিকানাধীন হ্যান্ডেল',
  'agentWorld.profileViewer.followers': 'অনুসারী',
  'agentWorld.profileViewer.followingCount': 'অনুসরণ করছেন',
  'agentWorld.profileViewer.joined': 'যোগ দিয়েছেন',
  'agentWorld.profileViewer.ownProfile': 'এটি আপনার প্রোফাইল',
  'agentWorld.profileViewer.agentBadge': 'এজেন্ট',
  'agentWorld.profileViewer.humanBadge': 'মানুষ',
  'agentWorld.ledger.loadMore': 'আরও লোড করুন',
  'agentWorld.ledger.loadingMore': 'আরও লোড হচ্ছে…',
  'agentWorld.ledger.loadMoreError': 'আরও লেনদেন লোড করা যায়নি। আবার চেষ্টা করুন।',
  'agentWorld.ledger.filterAsset': 'অ্যাসেট',
  'agentWorld.ledger.filterAllAssets': 'সব অ্যাসেট',
  'agentWorld.ledger.direction': 'দিক',
  'agentWorld.ledger.directionAll': 'সব',
  'agentWorld.ledger.directionIn': 'ইনকামিং',
  'agentWorld.ledger.directionOut': 'আউটগোয়িং',
  'agentWorld.ledger.copyTxId': 'ট্রানজ্যাকশন আইডি কপি করুন',
  'agentWorld.ledger.copied': 'কপি হয়েছে',
  'agentWorld.ledger.noMatch': 'এই ফিল্টারগুলির সাথে কোনো লেনদেন মেলেনি।',
  'agentWorld.ledger.noMatchHint': 'ফিল্টার প্রশস্ত করুন বা সাফ করার চেষ্টা করুন।',
  'agentWorld.jobs': 'চাকরি',
  'agentWorld.bounties': 'পুরস্কার',
  'agentWorld.explore': 'অন্বেষণ করুন',
  'agentWorld.directory': 'ডিরেক্টরি',
  'agentWorld.directory.empty': 'কোনো এজেন্ট পাওয়া যায়নি',
  'agentWorld.directory.emptyHint': 'ডিরেক্টরিতে এখনও কোনো এজেন্ট নিবন্ধিত হয়নি।',
  'agentWorld.directory.searchLabel': 'এজেন্ট খুঁজুন',
  'agentWorld.directory.searchPlaceholder': 'হ্যান্ডেল বা নাম দিয়ে এজেন্ট খুঁজুন',
  'agentWorld.directory.noResults': 'আপনার অনুসন্ধানের সাথে কোনো এজেন্ট মেলেনি।',
  'agentWorld.directory.noResultsHint': 'অন্য একটি হ্যান্ডেল বা নাম চেষ্টা করুন।',
  'agentWorld.directory.loadMore': 'আরও লোড করুন',
  'agentWorld.directory.loadingMore': 'লোড হচ্ছে…',
  'agentWorld.directory.loadMoreError': 'আরও এজেন্ট লোড করা যায়নি।',
  'agentWorld.directory.profile.verified': 'যাচাইকৃত',
  'agentWorld.directory.profile.joined': 'যোগ দিয়েছেন',
  'agentWorld.directory.profile.noBio': 'এখনও কোনো বায়ো নেই।',
  'agentWorld.directory.profile.skills': 'দক্ষতা',
  'agentWorld.directory.profile.loadError': 'সম্পূর্ণ প্রোফাইল লোড করা যায়নি।',
  'agentWorld.identities': 'পরিচয়',
  'agentWorld.profiles': 'প্রোফাইল',
  'agentWorld.transferHandle.action': 'স্থানান্তর',
  'agentWorld.transferHandle.title': 'হ্যান্ডেল স্থানান্তর',
  'agentWorld.transferHandle.warning':
    'হ্যান্ডেল স্থানান্তর স্থায়ী এবং এটি ফেরানো যায় না। প্রাপক একমাত্র মালিক হয়ে যাবেন।',
  'agentWorld.transferHandle.recipientPlaceholder': 'প্রাপকের @handle',
  'agentWorld.transferHandle.confirm': 'হ্যান্ডেল স্থানান্তর',
  'agentWorld.transferHandle.submitting': 'স্থানান্তর করা হচ্ছে…',
  'agentWorld.transferHandle.recipientRequired': 'প্রাপকের হ্যান্ডেল লিখুন।',
  'agentWorld.transferHandle.confirmLabel': 'নিশ্চিত করতে হ্যান্ডেলটি টাইপ করুন',
  'agentWorld.transferHandle.confirmMismatch': 'টাইপ করা হ্যান্ডেল মিলছে না।',
  'agentWorld.transferHandle.primaryLocked':
    'প্রাথমিক হ্যান্ডেল স্থানান্তর করা যায় না। প্রথমে অন্য একটি হ্যান্ডেল সক্রিয় করুন।',
  'agentWorld.profile.edit': 'প্রোফাইল সম্পাদনা',
  'agentWorld.profile.displayName': 'প্রদর্শন নাম',
  'agentWorld.profile.bio': 'পরিচিতি',
  'agentWorld.profile.avatarEmail': 'অ্যাভাটার ইমেল',
  'agentWorld.profile.avatarEmailHint': 'Gravatar থেকে আপনার অ্যাভাটার আনতে ব্যবহৃত হয়।',
  'agentWorld.profile.save': 'সংরক্ষণ',
  'agentWorld.profile.nameRequired': 'প্রদর্শন নাম খালি রাখা যাবে না।',
  'agentWorld.profile.cancel': 'বাতিল',
  'agentWorld.profile.saving': 'সংরক্ষণ হচ্ছে…',
  'agentWorld.profile.saveError': 'আপনার প্রোফাইল সংরক্ষণ করা যায়নি। আবার চেষ্টা করুন।',
  'agentWorld.marketplace': 'মার্কেটপ্লেস',
  'agentWorld.messaging': 'বার্তা',
  'agentWorld.walletNotConfigured': 'ওয়ালেট সেট আপ হয়নি',
  'agentWorld.copyAddress': 'ঠিকানা কপি করুন',
  'agentWorld.addressCopied': 'কপি হয়েছে',
  'agentWorld.walletUnavailable': 'ওয়ালেট অনুপলব্ধ',
  'agentWorld.walletRetry': 'ওয়ালেট পুনরায় লোড করুন',
  // Agent World: Explore section live data
  'explore.networkOverview': 'নেটওয়ার্ক ওভারভিউ',
  'explore.trendingCommunities': 'ট্রেন্ডিং কমিউনিটি',
  'explore.activeJobs': 'সক্রিয় চাকরি',
  'explore.featuredBounties': 'ফিচার্ড বাউন্টি',
  'explore.newAgents': 'নতুন এজেন্ট',
  'explore.viewAll': 'সব দেখুন',
  'explore.noCommunities': 'এখনো কোনো কমিউনিটি নেই',
  'explore.noJobs': 'কোনো সক্রিয় চাকরি নেই',
  'explore.noBounties': 'কোনো খোলা বাউন্টি নেই',
  'explore.noAgents': 'কোনো এজেন্ট নিবন্ধিত নেই',
  'agentWorld.jobs.deadlineFuture': 'প্রস্তাবের সময়সীমা ভবিষ্যতে হতে হবে',
  'nav.avatarMenu.account': 'অ্যাকাউন্ট',
  'nav.avatarMenu.billing': 'বিলিং',
  'nav.avatarMenu.rewards': 'পুরস্কার',
  'nav.avatarMenu.invites': 'বন্ধুকে আমন্ত্রণ জানান',
  'nav.avatarMenu.wallet': 'ওয়ালেট',

  // Brain: full-page memory knowledge-graph surface
  'brain.subtitle': 'আপনার জ্ঞান গ্রাফ, মেমরি উৎস এবং নিয়ন্ত্রণ।',
  'brain.tabs.memory': 'স্মৃতি',
  'brain.tabs.subconscious': 'অবচেতন',
  'brain.tabs.graph': 'গ্রাফ',
  'brain.tabs.goals': 'লক্ষ্য',
  'brain.goals.title': 'দীর্ঘমেয়াদী লক্ষ্য',
  'brain.goals.description':
    'আপনার সঙ্গে কাজ করার জন্য এজেন্টের স্থায়ী লক্ষ্য। এখানে সম্পাদনা করুন বা রিফ্লেক্ট দিয়ে আপডেট করতে দিন।',
  'brain.goals.reflect': 'রিফ্লেক্ট',
  'brain.goals.reflecting': 'রিফ্লেক্ট করা হচ্ছে…',
  'brain.goals.reflectDone': 'লক্ষ্য আপডেট হয়েছে।',
  'brain.goals.add': 'যোগ করুন',
  'brain.goals.addPlaceholder': 'একটি দীর্ঘমেয়াদী লক্ষ্য যোগ করুন…',
  'brain.goals.empty':
    'এখনও কোনো লক্ষ্য নেই। একটি যোগ করুন, অথবা সাম্প্রতিক প্রসঙ্গ থেকে পূরণ করতে রিফ্লেক্ট ব্যবহার করুন।',
  'brain.goals.editGoal': 'লক্ষ্য সম্পাদনা করুন',
  'brain.goals.deleteGoal': 'লক্ষ্য মুছুন',
  'brain.goals.actionError': 'কিছু ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'brain.tabs.sources': 'উৎস',
  'brain.tabs.sync': 'সিঙ্ক',
  'brain.tabs.orchestration': 'অর্কেস্ট্রেশন',
  'tinyplaceOrchestration.title': 'TinyPlace রিলে',
  'tinyplaceOrchestration.subtitle': 'পিন করা এজেন্ট চ্যানেল এবং অ্যাপ সেশন চ্যাট',
  'tinyplaceOrchestration.refresh': 'রিফ্রেশ',
  'tinyplaceOrchestration.newInstance': 'নতুন ইনস্ট্যান্স',
  'tinyplaceOrchestration.newInstanceSoon': 'শীঘ্রই আসছে',
  'tinyplaceOrchestration.pinned': 'পিন করা',
  'tinyplaceOrchestration.sessions': 'সেশন',
  'tinyplaceOrchestration.contacts': 'পরিচিতি',
  'tinyplaceOrchestration.noContacts': 'এখনও কোনো পরিচিতি নেই।',
  'tinyplaceOrchestration.newSession': 'নতুন সেশন',
  'tinyplaceOrchestration.otherSessions': 'অন্যান্য সেশন',
  'tinyplaceOrchestration.loading': 'TinyPlace চ্যাট লোড হচ্ছে…',
  'tinyplaceOrchestration.paymentRequired': 'TinyPlace অ্যাক্সেসের জন্য পেমেন্ট দরকার।',
  'tinyplaceOrchestration.failedToLoad': 'TinyPlace চ্যাট লোড করা যায়নি',
  'tinyplaceOrchestration.noSessions': 'এখনও কোনো TinyPlace অ্যাপ সেশন নেই।',
  'tinyplaceOrchestration.noMessages': 'এই চ্যাটে এখনও কোনো বার্তা নেই।',
  'tinyplaceOrchestration.active': 'সক্রিয়',
  'tinyplaceOrchestration.inactive': 'নিষ্ক্রিয়',
  'tinyplaceOrchestration.encryptedBody': 'এনক্রিপ্টেড TinyPlace বার্তা',
  'tinyplaceOrchestration.unknownSender': 'অজানা প্রেরক',
  'tinyplaceOrchestration.master.title': 'এজেন্ট / মানব',
  'tinyplaceOrchestration.master.subtitle': 'মাস্টার চ্যাট',
  'tinyplaceOrchestration.master.preview': 'আপনি এবং OpenHuman-এর মধ্যে সরাসরি সমন্বয়।',
  'tinyplaceOrchestration.subconscious.title': 'অবচেতন',
  'tinyplaceOrchestration.subconscious.subtitle': 'অভ্যন্তরীণ এজেন্ট চ্যাট',
  'tinyplaceOrchestration.subconscious.preview': 'পটভূমির এজেন্ট সমন্বয় এবং মেমরি লুপ।',
  'tinyplaceOrchestration.session.subtitle': 'TinyPlace অ্যাপ সেশন',
  'tinyplaceOrchestration.pairing.linkLabel': 'সেশন লিঙ্ক করুন',
  'tinyplaceOrchestration.pairing.linkPlaceholder': 'সেশন এজেন্ট আইডি পেস্ট করুন',
  'tinyplaceOrchestration.pairing.linkAction': 'লিঙ্ক',
  'tinyplaceOrchestration.pairing.requests': 'যোগাযোগ অনুরোধ',
  'tinyplaceOrchestration.pairing.accept': 'গ্রহণ',
  'tinyplaceOrchestration.pairing.decline': 'প্রত্যাখ্যান',
  'tinyplaceOrchestration.pairing.block': 'ব্লক',
  'tinyplaceOrchestration.pairing.linked': 'লিঙ্কড',
  'tinyplaceOrchestration.pairing.pending': 'অপেক্ষমান',
  'tinyplaceOrchestration.pairing.unlinked': 'লিঙ্ক নেই',
  'tinyplaceOrchestration.pairing.incoming': 'আসছে',
  'tinyplaceOrchestration.pairing.outgoing': 'যাচ্ছে',
  'tinyplaceOrchestration.master.you': 'আপনি',
  'tinyplaceOrchestration.composer.placeholder': 'OpenHuman-কে বার্তা দিন…',
  'tinyplaceOrchestration.composer.send': 'পাঠান',
  'tinyplaceOrchestration.composer.sendFailed': 'বার্তা পাঠাতে ব্যর্থ',
  'tinyplaceOrchestration.steering.label': 'নির্দেশনা',
  'tinyplaceOrchestration.relay.staging': 'স্টেজিং',
  'tinyplaceOrchestration.relay.prod': 'প্রোডাকশন',
  'tinyplaceOrchestration.identity.loading': 'পরিচয় লোড হচ্ছে…',
  'tinyplaceOrchestration.identity.noHandle': 'এখনও কোনো @handle নেই',
  'tinyplaceOrchestration.identity.copy': 'কপি করুন',
  'tinyplaceOrchestration.identity.copied': 'কপি হয়েছে',
  'tinyplaceOrchestration.identity.discoverable': 'খুঁজে পাওয়া যায়',
  'tinyplaceOrchestration.identity.undiscoverable': 'খুঁজে পাওয়া যায় না',
  'tinyplaceOrchestration.identity.undiscoverableHint':
    'আপনার ডিরেক্টরি কার্ড ও এনক্রিপশন কী প্রকাশ করুন যাতে অন্য এজেন্টরা আপনাকে বার্তা পাঠাতে পারে।',
  'tinyplaceOrchestration.identity.makeDiscoverable': 'আবিষ্কারযোগ্য করুন',
  'tinyplaceOrchestration.identity.republish': 'কী পুনঃপ্রকাশ করুন',
  'tinyplaceOrchestration.identity.publishing': 'প্রকাশ করা হচ্ছে…',
  'tinyplaceOrchestration.identity.publishFailed': 'প্রকাশ ব্যর্থ হয়েছে: আবার চেষ্টা করুন',
  'tinyplaceOrchestration.identity.card': 'ডিরেক্টরি কার্ড',
  'tinyplaceOrchestration.identity.key': 'এনক্রিপশন কী',
  'tinyplaceOrchestration.identity.published': 'প্রকাশিত',
  'tinyplaceOrchestration.identity.notPublished': 'অপ্রকাশিত',
  'tinyplaceOrchestration.roster.instances': 'ইনস্ট্যান্স',
  'tinyplaceOrchestration.roster.empty': 'এখনও কোনো এজেন্ট ইনস্ট্যান্স নেই',
  'tinyplaceOrchestration.roster.other': 'অন্যান্য',
  'tinyplaceOrchestration.status.running': 'চলছে',
  'tinyplaceOrchestration.status.idle': 'নিষ্ক্রিয়',
  'tinyplaceOrchestration.status.waitingApproval': 'অনুমোদনের অপেক্ষায়',
  'tinyplaceOrchestration.status.errored': 'ত্রুটিপূর্ণ',
  'tinyplaceOrchestration.status.stopped': 'থেমে গেছে',
  'tinyplaceOrchestration.attention.title': 'আপনার প্রয়োজন',
  'tinyplaceOrchestration.attention.empty': 'সব কাজ শেষ',
  'tinyplaceOrchestration.attention.unread': 'অপঠিত বার্তা',
  'tinyplaceOrchestration.attention.review': 'পর্যালোচনা',
  'tinyplaceOrchestration.attention.open': 'খুলুন',
  'tinyplaceOrchestration.attention.kind.approval': 'অনুমোদন',
  'tinyplaceOrchestration.attention.kind.needsInput': 'ইনপুট প্রয়োজন',
  'tinyplaceOrchestration.attention.kind.unread': 'অপঠিত',
  'brain.empty': 'আপনার ব্রেইন এখন খালি: মেমরি তৈরি শুরু করতে একটি উৎস সংযুক্ত করুন।',
  'brain.error': 'আপনার ব্রেইন লোড করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'common.cancel': 'বাতিল',
  'common.save': 'সংরক্ষণ',
  'common.confirm': 'নিশ্চিত করুন',
  'common.delete': 'মুছুন',
  'common.edit': 'সম্পাদনা',
  'common.create': 'তৈরি করুন',
  'common.search': 'খুঁজুন',
  'common.loading': 'লোড হচ্ছে…',
  'sync.runs': 'সিঙ্ক রান',
  'sync.totalCost': 'মোট',
  'sync.when': 'কখন',
  'sync.source': 'উৎস',
  'sync.items': 'আইটেম',
  'sync.tokens': 'টোকেন',
  'sync.cost': 'খরচ',
  'sync.duration': 'সময়কাল',
  'sync.noAuditEntries': 'এখনও কোনো সিঙ্ক রান রেকর্ড করা হয়নি।',
  'sync.timeAgo.justNow': 'এইমাত্র',
  'sync.timeAgo.minutes': '{n} মি. আগে',
  'sync.timeAgo.hours': '{n} ঘ. আগে',
  'sync.timeAgo.days': '{n} দি. আগে',
  'sync.status.success': 'সফল',
  'sync.status.failed': 'ব্যর্থ',
  'common.error': 'ত্রুটি',
  'common.success': 'সফল',
  'common.back': 'পেছনে',
  'common.next': 'পরবর্তী',
  'common.finish': 'সম্পন্ন',
  'common.close': 'বন্ধ করুন',
  'common.enabled': 'সক্রিয়',
  'common.disabled': 'নিষ্ক্রিয়',
  'common.on': 'চালু',
  'common.off': 'বন্ধ',
  'common.yes': 'হ্যাঁ',
  'common.no': 'না',
  'common.ok': 'বুঝলাম',
  'common.name': 'নাম',
  'common.retry': 'আবার চেষ্টা করুন',
  'common.copy': 'কপি',
  'common.copied': 'কপি হয়েছে',
  'common.learnMore': 'আরও জানুন',
  'common.seeAll': 'দেখুন',
  'common.dismiss': 'বাদ দিন',
  'common.clear': 'পরিষ্কার',
  'common.reset': 'রিসেট',
  'common.refresh': 'রিফ্রেশ',
  'common.export': 'রপ্তানি',
  'common.import': 'আমদানি',
  'common.upload': 'আপলোড',
  'common.download': 'ডাউনলোড',
  'common.add': 'যোগ করুন',
  'common.remove': 'সরান',
  'common.showMore': 'আরও দেখুন',
  'common.showLess': 'কম দেখুন',
  'common.submit': 'জমা দিন',
  'common.continue': 'চালিয়ে যান',
  'common.comingSoon': 'শীঘ্রই আসছে',
  'common.breadcrumb': 'ব্রেডক্রাম্ব',
  'common.beta': 'বেটা',
  'common.betaDisclaimer':
    'এই বৈশিষ্ট্যটি বেটাতে আছে। এটি পরিবর্তন হতে পারে বা কিছু সমস্যা থাকতে পারে: আপনার মতামত আমাদের উন্নতিতে সাহায্য করে।',
  'settings.general': 'সাধারণ',
  // Settings layman groups (Phase 4 IA revamp)
  'settings.groups.account': 'অ্যাকাউন্ট',
  'settings.groups.assistant': 'সহকারী',
  'settings.groups.privacySecurity': 'গোপনীয়তা ও নিরাপত্তা',
  'settings.groups.notifications': 'বিজ্ঞপ্তি',
  'settings.groups.about': 'সম্পর্কে',
  'settings.assistant.personality': 'ব্যক্তিত্ব',
  'settings.personalityFace.title': 'ব্যক্তিত্ব ও মুখ',
  'settings.personalityFace.menuDesc': 'আপনার সহকারীর চরিত্র সাজান এবং এর মুখ বেছে নিন',
  'settings.assistant.voice': 'ভয়েস',
  'settings.assistant.voiceDesc': 'স্পিচ-টু-টেক্সট ও টেক্সট-টু-স্পিচ সেটিংস',
  'settings.assistant.faceMascot': 'মুখ / মাসকট',
  'settings.assistant.backgroundActivity': 'সাবকনশাস',
  'settings.assistant.backgroundActivityDesc':
    'আপনার সহকারী পটভূমিতে কতটা সক্রিয় তা নিয়ন্ত্রণ করুন',
  'settings.assistant.permissions': 'অনুমতি',
  'settings.assistant.permissionsDesc': 'সহকারী কী করতে পারে এবং কোথায় কাজ করতে পারে তা বেছে নিন',
  'settings.privacySecurity.privacy': 'গোপনীয়তা',
  'settings.privacySecurity.privacyDesc': 'আপনার কম্পিউটার ছেড়ে যাওয়া ডেটা নিয়ন্ত্রণ করুন',
  'settings.privacySecurity.security': 'নিরাপত্তা',
  'settings.privacySecurity.securityDesc': 'সেশন ও সাইন-ইন বিকল্প',
  'settings.privacySecurity.approvalsHistory': 'অনুমোদন ও ইতিহাস',
  'settings.privacySecurity.approvalsHistoryDesc':
    'সাম্প্রতিক টুল-অনুমোদন সিদ্ধান্ত পর্যালোচনা করুন',
  'settings.notifications.menuTitle': 'বিজ্ঞপ্তি',
  'settings.notifications.menuDesc': 'সতর্কতা ইনবক্স ও বিজ্ঞপ্তি পছন্দ',
  'settings.devGroups.knowledgeMemory': 'জ্ঞান ও স্মৃতি',
  'settings.devGroups.agentsAutonomy': 'এজেন্ট ও স্বায়ত্তশাসন',
  'settings.devGroups.modelsInference': 'মডেল ও অনুমান',
  'settings.devGroups.automationIntegrations': 'অটোমেশন ও ইন্টিগ্রেশন',
  'settings.devGroups.toolsCapabilities': 'টুলস ও ক্ষমতা',
  'settings.devGroups.council': 'কাউন্সিল',
  'settings.analysisViews.title': 'বিশ্লেষণ ভিউ',
  'settings.analysisViews.menuDesc':
    'মেমরি গ্রাফ বিশ্লেষণ: ডায়াগ্রাম, কেন্দ্রীয়তা, সংহতি, সংযোগ, সতেজতা, টাইমলাইন, পাথ এবং নেমস্পেস',
  'settings.buildInfo.title': 'বিল্ড / সংস্করণ তথ্য',
  'settings.buildInfo.menuDesc': 'অ্যাপ বিল্ড, সংস্করণ এবং কোর সংযোগের বিবরণ',
  'settings.tokenUsage.title': 'টোকেন ও খরচ',
  'settings.tokenUsage.menuDesc': 'সংকোচন সেটিংস এবং সেগুলি কত টোকেন ও ডলার সাশ্রয় করেছে',
  'settings.tokenUsage.saving': 'সংরক্ষণ করা হচ্ছে…',
  'settings.tokenUsage.saved': 'সংরক্ষিত হয়েছে',
  'settings.tokenUsage.savingsTitle': 'সাশ্রয়',
  'settings.tokenUsage.attributedTo': '{model}-এর জন্য খরচ নির্ধারিত',
  'settings.tokenUsage.tokensSaved': 'সাশ্রয় হওয়া টোকেন',
  'settings.tokenUsage.costSaved': 'সাশ্রয় হওয়া খরচ',
  'settings.tokenUsage.cacheOccupancy': 'ক্যাশ করা মূল কপি',
  'settings.tokenUsage.compactions': 'সংকোচন',
  'settings.tokenUsage.overEvents': '{count}টি সংকোচন জুড়ে',
  'settings.tokenUsage.byCompressor': 'সংকোচকারী অনুযায়ী',
  'settings.tokenUsage.refresh': 'রিফ্রেশ',
  'settings.tokenUsage.reset': 'পরিসংখ্যান রিসেট করুন',
  'settings.tokenUsage.compressionTitle': 'সংকোচন',
  'settings.tokenUsage.compressionDesc':
    'বড় টুল আউটপুট মডেল প্রসঙ্গে প্রবেশের আগে বিষয়বস্তু-সচেতন সংকোচন।',
  'settings.tokenUsage.routerEnabled': 'সংকোচন সক্ষম করুন',
  'settings.tokenUsage.routerEnabledDesc': 'বিষয়বস্তু রাউটারের প্রধান সুইচ।',
  'settings.tokenUsage.search': 'অনুসন্ধানের ফলাফল',
  'settings.tokenUsage.searchDesc':
    'প্রাসঙ্গিকতা অনুযায়ী grep/অনুসন্ধান আউটপুট সাজান, সেরা মিলগুলি রেখে দিন।',
  'settings.tokenUsage.code': 'সোর্স কোড',
  'settings.tokenUsage.codeDesc': 'স্বাক্ষর রাখুন, ফাংশন বডি সংকুচিত করুন।',
  'settings.tokenUsage.html': 'HTML',
  'settings.tokenUsage.htmlDesc': 'পঠনযোগ্য টেক্সটে মার্কআপ সরিয়ে ফেলুন।',
  'settings.tokenUsage.ml': 'ML টেক্সট সংকোচক',
  'settings.tokenUsage.mlDesc':
    'সাধারণ টেক্সটের জন্য স্থানীয় ModernBERT মডেল (Python রানটাইম প্রয়োজন)।',
  'settings.tokenUsage.ccrTitle': 'ক্যাশ ও পুনরুদ্ধার (CCR)',
  'settings.tokenUsage.ccrDesc':
    'সংকুচিত মূল কপিগুলি ক্যাশ করা হয় যাতে এজেন্ট চাহিদামতো সম্পূর্ণ টেক্সট আনতে পারে।',
  'settings.tokenUsage.ccrEnabled': 'পুনরুদ্ধারের জন্য মূল কপি রাখুন',
  'settings.tokenUsage.ccrEnabledDesc':
    'মূল কপি অফলোড করুন এবং একটি পুনরুদ্ধার চিহ্ন যোগ করুন যাতে কিছুই হারিয়ে না যায়।',
  'settings.tokenUsage.ccrMinTokens': 'ক্যাশ করার ন্যূনতম আকার',
  'settings.tokenUsage.ccrMinTokensDesc':
    'কেবল এই সংখ্যক টোকেন বা তার বেশি অনুমানিত ফলাফলই ক্যাশ ও ক্ষতিসহ সংকুচিত করুন।',
  'settings.tokenUsage.tokensUnit': 'টোকেন',
  'settings.tokenUsage.ccrDisk': 'ক্যাশ ডিস্কে সংরক্ষণ করুন',
  'settings.tokenUsage.ccrDiskDesc': 'রিস্টার্ট জুড়ে পুনরুদ্ধারযোগ্য মূল কপি রাখুন।',
  'settings.dataSync.title': 'ডেটা সিঙ্ক',
  'settings.dataSync.menuDesc': 'আপনার সহকারী যা সিঙ্ক করে: উৎস, সতেজতা এবং স্থিতি',
  'settings.dataSync.description':
    'আপনার সহকারীর মেমরিতে কী সিঙ্ক হয় তা পরিচালনা করুন: প্রতিটি সংযুক্ত উৎস তার শেষ সিঙ্কের সময়, কতটা সিঙ্ক হয়েছে এবং এখন সিঙ্ক হচ্ছে কিনা সহ।',
  'settings.devGroups.diagnosticsLogs': 'ডায়াগনস্টিকস ও লগ',
  'settings.featuresAndAI': 'ফিচার ও AI',
  'settings.billingAndRewards': 'বিলিং ও পুরস্কার',
  'settings.support': 'সহায়তা',
  'settings.advanced': 'অ্যাডভান্সড',
  'settings.dangerZone': 'বিপদ অঞ্চল',
  'settings.account': 'অ্যাকাউন্ট',
  'settings.accountDesc': 'রিকভারি ফ্রেজ, টিম, সংযোগ ও গোপনীয়তা',
  'settings.notifications': 'বিজ্ঞপ্তি',
  'settings.notificationsDesc': 'ডু নট ডিস্টার্ব এবং প্রতিটি অ্যাকাউন্টের বিজ্ঞপ্তি নিয়ন্ত্রণ',
  'settings.notifications.tabs.preferences': 'পছন্দ',
  'settings.notifications.tabs.routing': 'রাউটিং',
  'settings.features': 'ফিচার',
  'settings.aiModels': 'AI ও মডেল',
  'settings.aiModelsDesc': 'লোকাল AI মডেল সেটআপ, ডাউনলোড এবং LLM প্রোভাইডার',
  'settings.ai': 'AI কনফিগারেশন',
  'settings.aiDesc': 'ক্লাউড প্রোভাইডার, লোকাল Ollama মডেল এবং ওয়ার্কলোড রুটিং',
  'settings.billingUsage': 'বিলিং ও ব্যবহার',
  'settings.billingUsageDesc': 'সাবস্ক্রিপশন প্ল্যান, ক্রেডিট এবং পেমেন্ট পদ্ধতি',
  'settings.rewards': 'পুরস্কার',
  'settings.rewardsDesc': 'রেফারেল, কুপন এবং অর্জিত ক্রেডিট',
  'settings.restartTour': 'ট্যুর পুনরায় শুরু',
  'settings.restartTourDesc': 'শুরু থেকে প্রোডাক্ট ওয়াকথ্রু আবার দেখুন',
  'settings.about': 'সম্পর্কে',
  'settings.aboutDesc': 'অ্যাপ ভার্সন এবং সফটওয়্যার আপডেট',
  'settings.developerOptions': 'অ্যাডভান্সড',
  'settings.developerOptionsDesc':
    'AI কনফিগারেশন, মেসেজিং চ্যানেল, টুলস, ডায়াগনস্টিক্স এবং ডিবাগ প্যানেল',
  'settings.developerDiagnostics': 'ডেভেলপার ও ডায়াগনস্টিক্স',
  'settings.developerDiagnosticsDesc':
    'উন্নত ডেভেলপার টুলস, ডায়াগনস্টিক্স, মেমোরি, এজেন্ট এবং ডিবাগ প্যানেল',
  'settings.developerMode.title': 'ডেভেলপার মোড',
  'settings.developerMode.description': 'উন্নত ডেভেলপার ও ডায়াগনস্টিক টুলস দেখান',
  'settings.developerMode.enabledByBuild': 'ডেভেলপমেন্ট বিল্ডে সবসময় চালু',
  'settings.clearAppData': 'অ্যাপ ডেটা মুছুন',
  'settings.clearAppDataDesc': 'সাইন আউট করুন এবং সব লোকাল ডেটা স্থায়ীভাবে মুছুন',
  'settings.logOut': 'লগ আউট',
  'settings.logOutDesc': 'আপনার অ্যাকাউন্ট থেকে সাইন আউট করুন',
  'settings.exitLocalSession': 'স্থানীয় সেশন থেকে প্রস্থান করুন',
  'settings.exitLocalSessionDesc': 'সাইন-ইন স্ক্রিনে ফিরে যান',
  'settings.language': 'ভাষা',
  'settings.navGroups.general': 'সাধারণ',
  'settings.navGroups.assistant': 'সহকারী',
  'settings.navGroups.data': 'ডেটা',
  'settings.navGroups.connections': 'সংযোগ',
  'settings.navGroups.system': 'সিস্টেম',
  'settings.betaBuild': 'বিটা বিল্ড - v{version}',
  'settings.languageDesc': 'অ্যাপ ইন্টারফেসের প্রদর্শন ভাষা',
  'settings.alerts': 'সতর্কতা',
  'settings.alertsDesc': 'ইনবক্সে সাম্প্রতিক সতর্কতা ও কার্যক্রম দেখুন',
  'settings.account.profile': 'প্রোফাইল',
  'settings.account.profileDesc': 'নাম, ইমেইল এবং অ্যাভাটার',
  'settings.account.devices': 'ডিভাইস',
  'settings.account.devicesDesc': 'মোবাইল ডিভাইস পেয়ার করুন ও পরিচালনা করুন',
  'settings.account.teamMembers': 'টিম ও সদস্য',
  'settings.account.teamMembersDesc': 'টিম অ্যাক্সেস ও সদস্য ভূমিকা পরিচালনা করুন',
  'settings.account.dataMigration': 'ডেটা ও মাইগ্রেশন',
  'settings.account.dataMigrationDesc': 'অন্য অ্যাসিস্ট্যান্ট থেকে মেমরি আমদানি করুন',
  'settings.account.recoveryPhrase': 'রিকভারি ফ্রেজ',
  'settings.account.recoveryPhraseDesc': 'আপনার অ্যাকাউন্ট রিকভারি ফ্রেজ দেখুন ও ব্যাকআপ করুন',
  'settings.account.team': 'টিম',
  'settings.account.teamDesc': 'টিম সদস্য ও অনুমতি পরিচালনা করুন',
  'settings.account.connections': 'সংযোগ',
  'settings.account.connectionsDesc': 'লিংক করা অ্যাকাউন্ট ও সার্ভিস পরিচালনা করুন',
  'settings.account.privacy': 'গোপনীয়তা',
  'settings.account.privacyDesc': 'আপনার কম্পিউটার থেকে কোন ডেটা বাইরে যাচ্ছে তা নিয়ন্ত্রণ করুন',
  'migration.title': 'অন্য সহকারী থেকে আমদানি করুন',
  'migration.description':
    'অন্য একটি লোকাল সহকারী থেকে মেমরি ও নোট এই ওয়ার্কস্পেসে স্থানান্তর করুন। প্রথমে Preview চালিয়ে দেখুন ঠিক কী বদলাবে, তারপর Apply চাপলে ডেটা কপি হবে। আপনার বর্তমান মেমরি আগে ব্যাকআপ নেওয়া হবে।',
  'migration.vendorLabel': 'উৎস',
  'migration.vendor.openclaw': 'OpenClaw',
  'migration.vendor.hermes': 'Hermes Agent',
  'migration.sourceLabel': 'উৎস ওয়ার্কস্পেসের পাথ (ঐচ্ছিক)',
  'migration.sourcePlaceholder': 'অটো-ডিটেক্টের জন্য খালি রাখুন (যেমন ~/.openclaw/workspace)',
  'migration.sourcePlaceholderHermes': 'স্বয়ংক্রিয়ভাবে সনাক্ত করতে খালি রাখুন (যেমন ~/.hermes)',
  'migration.sourceHint':
    'খালি রাখলে উৎসের ডিফল্ট লোকেশন ব্যবহার হবে। ওয়ার্কস্পেস সরিয়ে থাকলে স্পষ্ট পাথ দিন।',
  'migration.previewAction': 'প্রিভিউ',
  'migration.previewRunning': 'প্রিভিউ চলছে…',
  'migration.applyAction': 'আমদানি প্রয়োগ করুন',
  'migration.applyRunning': 'আমদানি হচ্ছে…',
  'migration.applyDisclaimer':
    'একই উৎসের সফল Preview হলেই Apply খুলবে। যে কোনো আমদানির আগে বর্তমান মেমরির ব্যাকআপ নেওয়া হয়।',
  'migration.reportTitlePreview': 'প্রিভিউ: এখনো কিছু আমদানি হয়নি',
  'migration.reportTitleApplied': 'আমদানি সম্পন্ন',
  'migration.report.source': 'উৎস ওয়ার্কস্পেস',
  'migration.report.target': 'লক্ষ্য ওয়ার্কস্পেস',
  'migration.report.fromSqlite': 'SQLite (brain.db) থেকে',
  'migration.report.fromMarkdown': 'Markdown থেকে',
  'migration.report.imported': 'আমদানিকৃত',
  'migration.report.skippedUnchanged': 'এড়ানো হয়েছে (অপরিবর্তিত)',
  'migration.report.renamedConflicts': 'দ্বন্দ্বে নাম বদলানো হয়েছে',
  'migration.report.warnings': 'সতর্কতা',
  'migration.report.previewHint': 'এখনো কোনো ডেটা আমদানি হয়নি। কপি করতে Apply চাপুন।',
  'migration.report.appliedHint':
    'আমদানিকৃত এন্ট্রি এখন আপনার মেমরিতে আছে। তুলনা করতে আবার Preview চালান।',
  'migration.confirmImport.singular':
    'বর্তমান ওয়ার্কস্পেসে {count}টি এন্ট্রি আমদানি করবেন?\n\nউৎস: {source}\nলক্ষ্য: {target}\n\nআমদানির আগে বর্তমান মেমরির ব্যাকআপ নেওয়া হবে।',
  'migration.confirmImport.plural':
    'বর্তমান ওয়ার্কস্পেসে {count}টি এন্ট্রি আমদানি করবেন?\n\nউৎস: {source}\nলক্ষ্য: {target}\n\nআমদানির আগে বর্তমান মেমরির ব্যাকআপ নেওয়া হবে।',
  'settings.notifications.doNotDisturb': 'ডু নট ডিস্টার্ব',
  'settings.notifications.doNotDisturbDesc': 'নির্দিষ্ট সময়ের জন্য সব বিজ্ঞপ্তি বন্ধ রাখুন',
  'settings.notifications.channelControls': 'চ্যানেল-ভিত্তিক নিয়ন্ত্রণ',
  'settings.notifications.channelControlsDesc': 'প্রতিটি চ্যানেলের জন্য বিজ্ঞপ্তি পছন্দ সেট করুন',
  'settings.features.messaging': 'মেসেজিং',
  'settings.features.messagingDesc': 'চ্যানেল ও মেসেজিং ইন্টিগ্রেশন সেটিংস',
  'settings.features.tools': 'টুলস',
  'settings.features.toolsDesc': 'সংযুক্ত টুলস ও ইন্টিগ্রেশন পরিচালনা করুন',
  'settings.ai.localSetup': 'লোকাল AI সেটআপ',
  'settings.ai.localSetupDesc': 'লোকাল AI মডেল ডাউনলোড ও কনফিগার করুন',
  'settings.ai.llmProvider': 'LLM প্রোভাইডার',
  'settings.ai.llmProviderDesc': 'আপনার AI প্রোভাইডার বেছে নিন ও কনফিগার করুন',
  'clearData.title': 'অ্যাপ ডেটা মুছুন',
  'clearData.warning': 'এটি আপনাকে সাইন আউট করবে এবং নিম্নলিখিত লোকাল ডেটা স্থায়ীভাবে মুছে দেবে:',
  'clearData.bulletSettings': 'অ্যাপ সেটিংস এবং কথোপকথন',
  'clearData.bulletCache': 'সব লোকাল ইন্টিগ্রেশন ক্যাশ ডেটা',
  'clearData.bulletWorkspace': 'ওয়ার্কস্পেস ডেটা',
  'clearData.bulletOther': 'অন্যান্য সব লোকাল ডেটা',
  'clearData.irreversible': 'এই কাজটি পূর্বাবস্থায় ফেরানো যাবে না।',
  'clearData.clearing': 'অ্যাপ ডেটা মোছা হচ্ছে...',
  'clearData.failed': 'ডেটা মুছতে ও লগ আউট করতে ব্যর্থ হয়েছে। আবার চেষ্টা করুন।',
  'clearData.failedLogout': 'লগ আউট করতে ব্যর্থ হয়েছে। আবার চেষ্টা করুন।',
  'clearData.failedPersist': 'অ্যাপ স্টেট মুছতে ব্যর্থ হয়েছে। আবার চেষ্টা করুন।',
  'welcome.logoAlt': 'OpenHuman',
  'welcome.title': 'OpenHuman-এ স্বাগতম',
  'welcome.subtitle':
    'আপনার ব্যক্তিগত AI সুপার ইন্টেলিজেন্স। ব্যক্তিগত, সহজ এবং অত্যন্ত শক্তিশালী।',
  'welcome.connectPrompt': 'RPC URL কনফিগার করুন (অ্যাডভান্সড)',
  'welcome.selectRuntime': 'একটি রানটাইম বেছে নিন',
  'welcome.clearingAppData': 'অ্যাপ ডেটা সাফ করা হচ্ছে...',
  'welcome.clearAppDataAndRestart': 'অ্যাপ ডেটা সাফ করুন এবং পুনরায় চালু করুন',
  'welcome.clearAppDataWarning':
    'এটি এই ডিভাইসে স্থানীয়ভাবে সংরক্ষিত সিক্রেট এবং অ্যাকাউন্ট মুছে দেয়। আপনার ক্লাউড অ্যাকাউন্ট প্রভাবিত হয় না: আপনি এরপরই আবার সাইন ইন করতে পারবেন।',
  'welcome.resetErrorFallback':
    'অ্যাপ ডেটা মুছতে পারেনি। OpenHuman বন্ধ করে আবার খুলুন, তারপর আবার চেষ্টা করুন।',
  'welcome.signingIn': 'আপনাকে সাইন ইন করা হচ্ছে...',
  'welcome.termsIntro': 'চালিয়ে যাওয়ার মাধ্যমে, আপনি',
  'welcome.termsOfUse': 'শর্তাবলীতে সম্মত হন',
  'welcome.termsJoiner': 'এবং',
  'welcome.privacyPolicy': 'গোপনীয়তা নীতি',
  'welcome.termsOutro': '.',
  'welcome.urlPlaceholder': 'http://localhost:8089',
  'welcome.invalidUrl': 'একটি বৈধ HTTP বা HTTPS URL দিন',
  'welcome.connecting': 'পরীক্ষা করা হচ্ছে',
  'welcome.connect': 'পরীক্ষা করুন',
  'home.greeting': 'শুভ সকাল',
  'home.greetingAfternoon': 'শুভ বিকেল',
  'home.greetingEvening': 'শুভ সন্ধ্যা',
  'home.askAssistant': 'আপনার অ্যাসিস্ট্যান্টকে যেকোনো কিছু জিজ্ঞেস করুন...',
  'home.statusOk': 'আপনার সহকারী প্রস্তুত। শুরু করতে নিচে কিছু লিখুন।',
  'home.statusBackendOnly': 'ব্যাকএন্ডে পুনরায় সংযোগ হচ্ছে… আপনার এজেন্ট শীঘ্রই আবার পাওয়া যাবে।',
  'home.statusCoreUnreachable':
    'লোকাল কোর সাইডকার সাড়া দিচ্ছে না। OpenHuman ব্যাকগ্রাউন্ড প্রসেস ক্র্যাশ হয়েছে বা শুরু হয়নি।',
  'home.statusInternetOffline':
    'আপনার ডিভাইস এখন অফলাইনে। নেটওয়ার্ক পরীক্ষা করুন বা অ্যাপ রিস্টার্ট করুন।',
  'home.restartCore': 'কোর রিস্টার্ট',
  'home.restartingCore': 'কোর রিস্টার্ট হচ্ছে…',
  'home.themeToggle.toLight': 'লাইট মোডে স্যুইচ করুন',
  'home.themeToggle.toDark': 'ডার্ক মোডে স্যুইচ করুন',
  'home.usageExhaustedTitle': 'আপনার ব্যবহার শেষ হয়ে গেছে',
  'home.usageExhaustedBody':
    'আপাতত আপনার অন্তর্ভুক্ত ব্যবহার শেষ। আরও ধারাবাহিক সক্ষমতা আনলক করতে একটি সাবস্ক্রিপশন শুরু করুন।',
  'home.usageExhaustedCta': 'সাবস্ক্রিপশন শুরু করুন',
  'openrouterFree.cta': 'OpenRouter-এর বিনামূল্যের মডেল ব্যবহার করুন',
  'openrouterFree.saving': 'OpenRouter সংযুক্ত হচ্ছে...',
  'openrouterFree.error':
    'OpenRouter-এর বিনামূল্যের মডেলে স্যুইচ করা যায়নি। আপনার OpenRouter সাইন-ইন পরীক্ষা করে আবার চেষ্টা করুন।',
  'home.routinesCard': 'আপনার রুটিন',
  'home.routinesActive': '{count}টি সক্রিয়',
  'routines.title': 'তোমার বিদ্বান',
  'routines.subtitle': 'আপনার সহকারী স্বয়ংক্রিয়ভাবে যা কিছু করেন',
  'routines.loading': 'তালিকা লোড করা হচ্ছে...',
  'routines.empty': 'এখনই নেই',
  'routines.emptyHint':
    'আপনার সহকারী কোনো তালিকাতে কাজ করতে পারে: যেমন সকালের সংক্ষিপ্ত বিবরণ অথবা রোজকার তালিকা ।',
  'routines.refresh': 'নতুন করে প্রদর্শন',
  'routines.nextRun': 'পরবর্তী চালনা',
  'routines.lastRunSuccess': 'সর্বশেষ সঞ্চালিত হয়েছে',
  'routines.lastRunFailed': 'শেষ ব্যর্থ হয়েছে',
  'routines.notRunYet': 'এখনো চালাও নি',
  'routines.runNow': 'এখন সঞ্চালন করুন',
  'routines.running': 'চলমান...',
  'routines.runNowTimedOut': 'রান টাইমআউট হয়েছে: অনুগ্রহ করে রিফ্রেশ করুন এবং আবার চেষ্টা করুন।',
  'routines.viewHistory': 'পূর্ববর্তী তথ্য প্রদর্শন',
  'routines.loadingHistory': 'লোড করা হচ্ছে...',
  'routines.noHistory': 'এখনো কোন ইতিহাস নেই।',
  'routines.statusSuccess': 'সাফল্য',
  'routines.statusError': 'ত্রুটি',
  'routines.showOutput': 'আউটপুট দেখাও',
  'routines.hideOutput': 'আউটপুট আড়াল করা হবে',
  'routines.toggleEnabled': 'এই ব্যবস্থা নিষ্ক্রিয় অথবা নিষ্ক্রিয় করা যাবে',
  'routines.typeAgent': 'এজেন্ট',
  'routines.typeCommand': 'কমান্ড',
  'nav.routines': 'Routines',
  'chat.newThread': 'নতুন থ্রেড',
  'chat.newConversation': 'নতুন কথোপকথন',
  'chat.newWindowWelcome1': 'স্বাগতম, {name} 👋',
  'chat.newWindowWelcome2': 'চলুন শুরু করি, {name} 🧑‍🍳.',
  'chat.newWindowWelcome3': 'মনোযোগ দেওয়ার সময় 🧘🏻',
  'chat.typeMessage': 'আজ আমি আপনাকে কীভাবে সাহায্য করতে পারি?',
  'chat.send': 'বার্তা পাঠান',
  'chat.stopGeneration': 'জেনারেশন বন্ধ করুন',
  'chat.stoppedByUser': 'থামানো হয়েছে',
  'chat.parallelBranchHint': 'সমান্তরাল শাখা টাইপ করুন: পাঠাতে ⌘/Ctrl+Enter',
  'chat.followupHint':
    'একটি ফলো-আপ সারিবদ্ধ করুন: এই উত্তরের পরে পাঠানো হবে · সমান্তরাল শাখার জন্য ⌘/Ctrl+Enter',
  'chat.queuedFollowups.label': 'সারিবদ্ধ ফলো-আপ',
  'chat.queuedFollowups.clear': 'সাফ করুন',
  'chat.queuedFollowups.clearFailed': 'সারি সাফ করা যায়নি: আবার চেষ্টা করুন।',
  'chat.createThreadFailed': 'নতুন থ্রেড তৈরি করা যায়নি: আবার চেষ্টা করুন।',
  'chat.parallelBranchLabel': 'সমান্তরাল শাখা',
  'chat.thinking': 'ভাবছে...',
  'chat.noMessages': 'এখনো কোনো বার্তা নেই',
  'chat.startConversation': 'একটি কথোপকথন শুরু করুন',
  'chat.regenerate': 'পুনরায় তৈরি করুন',
  'chat.copyResponse': 'উত্তর কপি করুন',
  'chat.citations': 'উদ্ধৃতি',
  'chat.toolUsed': 'ব্যবহৃত টুল',
  'scope.legacy': 'লেগ্যাসি',
  'scope.user': 'ব্যবহারকারী',
  'scope.project': 'প্রজেক্ট',
  'skills.title': 'সংযোগ',
  'skills.search': 'সংযোগ খুঁজুন...',
  'skills.noResults': 'কোনো সংযোগ পাওয়া যায়নি',
  'skills.loadingIntegrations': 'ইন্টিগ্রেশন লোড হচ্ছে…',
  'skills.connect': 'সংযুক্ত করুন',
  'skills.disconnect': 'সংযোগ বিচ্ছিন্ন',
  'skills.configure': 'পরিচালনা',
  'skills.connected': 'সংযুক্ত',
  'skills.available': 'পাওয়া যাচ্ছে',
  'skills.addAccount': 'অ্যাকাউন্ট যোগ করুন',
  'skills.channels': 'মেসেজিং',
  'skills.explorer.emptyCta': 'URL থেকে ইনস্টল করুন',
  'skills.explorer.emptyDescription':
    'একটি SKILL.md প্যাকেজ ইনস্টল করুন বা Hermes-ধাঁচের ফোল্ডার ~/.openhuman/skills-এ রাখুন।',
  'skills.explorer.emptyTitle': 'কোনো স্কিল পাওয়া যায়নি',
  'skills.explorer.installFromUrl': 'URL থেকে ইনস্টল করুন',
  'skills.explorer.newSkill': 'নতুন স্কিল',
  'skills.explorer.subtitle':
    'Hermes-ধাঁচের markdown, scripts, references, templates, examples এবং prompts সহ SKILL.md প্যাকেজ ব্রাউজ করুন।',
  'skills.explorer.title': 'স্কিল এক্সপ্লোরার',
  'skills.explorer.searchPlaceholder': 'স্কিল খুঁজুন...',
  'skills.explorer.scopeUser': 'User',
  'skills.explorer.scopeProject': 'Project',
  'skills.explorer.scopeLegacy': 'Legacy',
  'skills.explorer.noDescription': 'কোনো বিবরণ দেওয়া হয়নি।',
  'skills.explorer.uninstallSuccess': 'স্কিল সফলভাবে আনইনস্টল করা হয়েছে।',
  'skills.explorer.registryTab': 'রেজিস্ট্রি',
  'skills.explorer.installedTab': 'ইনস্টল করা',
  'skills.explorer.allFormats': 'সব ফরম্যাট',
  'skills.explorer.refreshRegistry': 'রেজিস্ট্রি রিফ্রেশ করুন',
  'skills.explorer.registryEmptyTitle': 'কোনো রেজিস্ট্রি এন্ট্রি নেই',
  'skills.explorer.registryEmptyDescription':
    'দক্ষতা রেজিস্ট্রি লোড করা যায়নি। আপনার সংযোগ পরীক্ষা করে রিফ্রেশ করার চেষ্টা করুন।',
  'skills.explorer.showingOf':
    '{total} ফলাফলের মধ্যে {shown}টি দেখানো হচ্ছে। আরও দেখতে আপনার অনুসন্ধান পরিমার্জন করুন।',
  'skills.explorer.installed': 'ইনস্টল করা হয়েছে',
  'skills.explorer.install': 'ইনস্টল করুন',
  'skills.explorer.installing': 'ইনস্টল হচ্ছে…',
  'skills.integrations': 'Composio ইন্টিগ্রেশন',
  'skills.integrationsSubtitle':
    'ক্লাউড-ভিত্তিক OAuth সংযোগ: আপনার অ্যাকাউন্ট দিয়ে সাইন ইন করুন এবং Composio টোকেন পরিচালনা করে যাতে এজেন্টরা আপনার পক্ষে পড়তে এবং কাজ করতে পারে। কোনো API কী পরিচালনা করতে হবে না।',
  'skills.composio.noApiKeyTitle': 'কোনো Composio API Key কনফিগার করা নেই',
  'skills.composio.noApiKeyDescription':
    'লোকাল মোডে আপনার নিজের Composio API key ব্যবহার হয়। এখানে ইন্টিগ্রেশন যুক্ত করার আগে Settings → Advanced → Composio খুলে একটি key যোগ করুন।',
  'skills.composio.noApiKeyCta': 'সেটিংসে খুলুন',
  'skills.tabs.composio': 'Composio',
  'skills.tabs.channels': 'চ্যানেল',
  'skills.tabs.explorer': 'স্কিল',
  'skills.tabs.meetings': 'Google Meet মিটিং',
  'skills.tabs.mcp': 'MCP সার্ভার',
  'connections.tabs.composio': 'Composio',
  'connections.tabs.channels': 'চ্যানেল',
  'connections.tabs.mcp': 'MCP সার্ভার',
  'connections.tabs.skills': 'দক্ষতা',
  'connections.tabs.meetings': 'মিটিং',
  'connections.groups.integrations': 'ইন্টিগ্রেশন',
  'connections.groups.desktop': 'ডেস্কটপ',
  'connections.tabs.oauth': 'OAuth',
  'connections.tabs.composioKey': 'Composio',
  'connections.groups.apiKeys': 'API কী',
  'connections.groups.intelligence': 'বুদ্ধিমত্তা',
  'memory.title': 'মেমোরি',
  'memory.search': 'মেমোরি খুঁজুন...',
  'memory.noResults': 'কোনো মেমোরি পাওয়া যায়নি',
  'memory.empty':
    'এখনো কোনো মেমোরি নেই। আপনি যত ইন্টারঅ্যাক্ট করবেন, মেমোরি স্বয়ংক্রিয়ভাবে তৈরি হবে।',
  'memory.tab.memory': 'মেমোরি',
  'memory.tab.memoryTree': 'মেমোরি ট্রি',
  'memory.tab.tasks': 'টাস্ক',
  'memory.tab.tasksDescription':
    'টাস্ক তৈরি করুন এবং ট্র্যাক করুন: আপনার নিজের কাজের তালিকা এবং এজেন্টরা কথোপকথন জুড়ে যে বোর্ডগুলি তৈরি করে।',
  'memory.tab.subconscious': 'সাবকনশাস',
  'memory.tab.agentWork': 'এজেন্ট কাজ',
  'memory.tab.agentWorkDescription':
    'প্রতিটি ব্যাকগ্রাউন্ড এজেন্ট রানের জন্য একটি কমান্ড সেন্টার: আপনার ইনপুট প্রয়োজন এমন, চলমান এবং সম্পন্ন অনুযায়ী গোষ্ঠীবদ্ধ।',
  'memory.tab.worktrees': 'ওয়ার্কট্রি',
  'memory.tab.worktreesDescription':
    'সমান্তরাল এজেন্ট ওয়ার্কারদের থেকে বিচ্ছিন্ন git ওয়ার্কট্রি: পরিবর্তন পরিদর্শন করুন, খুলুন বা পরিষ্কার করুন।',
  'memory.tab.teams': 'টিম',
  'memory.tab.teamsDescription':
    'সমন্বিত এজেন্ট টিম: কে প্রতিটি কাজের মালিক, কী আটকে আছে, এবং সতীর্থরা একে অপরকে কী বলছে।',
  'memory.tab.agents': 'লাইব্রেরি',
  'memory.tab.agentsDescription':
    'আপনার উপলব্ধ এজেন্টগুলি ব্রাউজ করুন এবং চালান: প্রতিটির নিজস্ব টুল, ক্ষমতা এবং ফোকাস এলাকা রয়েছে।',
  'memory.tab.workflows': 'Workflows',
  'memory.tab.workflowsDescription':
    'পুনর্ব্যবহারযোগ্য, চালানোযোগ্য প্রক্রিয়া: একটি লক্ষ্য এবং তা অর্জনের ধাপগুলো। একটি তৈরি করুন, URL থেকে ইনস্টল করুন, বা চালানোর জন্য ওয়ার্কফ্লো খুলুন।',
  'memory.tab.dreams': 'স্বপ্ন',
  'memory.tab.calls': 'কল',
  'memory.tab.diagram': 'Diagram',
  'memory.tab.centrality': 'Centrality',
  'memory.tab.namespaces': 'নেমস্পেস',
  'memory.tab.timeline': 'Timeline',
  'memory.tab.settings': 'সেটিংস',
  'memory.analyzeNow': 'এখনই বিশ্লেষণ করুন',
  'memoryTimeline.title': 'স্মৃতি টাইমলাইন',
  'memoryTimeline.intro':
    'সহকারী আপনার সম্পর্কে কখন শিখেছে: তথ্যগুলো সেই মাস অনুসারে গোষ্ঠীবদ্ধ যখন সেগুলো সর্বশেষ শক্তিশালী করা হয়েছে। বৃদ্ধি, কার্যকলাপের উত্থান এবং শান্ত সময়কাল দেখায়।',
  'memoryTimeline.loading': 'টাইমলাইন তৈরি হচ্ছে…',
  'memoryTimeline.errorPrefix': 'গ্রাফ লোড করা যায়নি:',
  'memoryTimeline.retry': 'Retry',
  'memoryTimeline.namespaceLabel': 'Namespace',
  'memoryTimeline.namespaceAll': 'সকল নেমস্পেস',
  'memoryTimeline.empty': 'এখনো কোনো জ্ঞান গ্রাফ নেই।',
  'memoryTimeline.emptyHint':
    'যখন সহকারী আপনার সম্পর্কে তথ্য রেকর্ড করবে, তাদের টাইমলাইন এখানে দেখা যাবে।',
  'memoryTimeline.metricTotal': 'Facts',
  'memoryTimeline.metricMonths': 'সক্রিয় মাস',
  'memoryTimeline.metricRecent': 'গত ৩০ দিন',
  'memoryTimeline.heading': 'প্রতি মাসে শেখা তথ্য',
  'memoryTimeline.busiestCaption': 'সবচেয়ে ব্যস্ত: {period} ({count})',
  'memoryTimeline.undatedNote': '{count} তথ্যে কোনো রেকর্ডকৃত তারিখ নেই।',
  'memoryTimeline.truncated': '{total} মাসের মধ্যে সবচেয়ে সাম্প্রতিক {shown} দেখানো হচ্ছে।',
  'namespaceOverview.title': 'নেমস্পেস ওভারভিউ',
  'namespaceOverview.intro':
    'প্রসঙ্গভেদে আপনার জ্ঞান কীভাবে বিতরণ করা হয়েছে: প্রতিটি নেমস্পেসে নথিভুক্ত তথ্য ও স্বতন্ত্র সত্তার সংখ্যা।',
  'namespaceOverview.loading': 'নেমস্পেস একত্রিত করা হচ্ছে…',
  'namespaceOverview.errorPrefix': 'রেখাচিত্র লোড করা যায়নি:',
  'namespaceOverview.retry': 'পুনরায় চেষ্টা করুন',
  'namespaceOverview.empty': 'এখনও কোনো জ্ঞান গ্রাফ নেই।',
  'namespaceOverview.emptyHint':
    'সহকারী প্রসঙ্গভেদে তথ্য রেকর্ড করার সাথে সাথে প্রতিটি নেমস্পেস এখানে দেখা যাবে।',
  'namespaceOverview.metricNamespaces': 'নেমস্পেস',
  'namespaceOverview.metricFacts': 'তথ্য',
  'namespaceOverview.metricEntities': 'সত্তা',
  'namespaceOverview.heading': 'নেমস্পেস অনুযায়ী',
  'namespaceOverview.unnamespaced': '(নেমস্পেসবিহীন)',
  'namespaceOverview.factsLabel': '{count}টি তথ্য',
  'namespaceOverview.entitiesLabel': '{count}টি সত্তা',
  'namespaceOverview.entitiesShort': '{count} সত্তা',
  'namespaceOverview.truncated': '{total}টির মধ্যে শীর্ষ {shown}টি নেমস্পেস দেখানো হচ্ছে।',
  'graphCentrality.title': 'জ্ঞান গ্রাফ',
  'graphCentrality.intro':
    'আপনার মেমরি গ্রাফের উপর প্রদর্শিত পেজের ছবি- এবং সংযোগকারী সত্তার সাথে সংযুক্ত একটি সংযুক্ত চক্রের সংযোগ রয়েছে, যা একটি raw ফ্রিকোয়েন্সি গণনা প্রকাশ করতে পারে না।',
  'graphCentrality.loading': 'কেন্দ্রীয় অবস্থা...',
  'graphCentrality.errorPrefix': 'রেখাচিত্র লোড করতে ব্যর্থ:%s',
  'graphCentrality.retry': 'পুনরায় চেষ্টা করুন',
  'graphCentrality.empty': 'কোনো জ্ঞান নেই এখনো গ্রাফ।',
  'graphCentrality.emptyHint':
    'সহকারী রেকর্ড আপনার সম্পর্কে তথ্য হিসাবে, সবচেয়ে সংযুক্ত সত্ত্বা এখানে থাকবে।',
  'graphCentrality.namespaceLabel': 'নেম-স্পেস',
  'graphCentrality.namespaceAll': 'সমস্ত নেমস্পেস',
  'graphCentrality.metricEntities': 'কর্ম',
  'graphCentrality.metricConnections': 'সংযোগ',
  'graphCentrality.metricClusters': 'স্তবক',
  'graphCentrality.clustersCaption': 'xqxkx জিনোমের সবচেয়ে বড় স্তর হল xq1xqx',
  'graphCentrality.approximateBadge': 'অবধি',
  'graphCentrality.approximateTitle': 'সম্পূর্ণ বিচ্ছিন্ন করার পূর্বে ক্যাপ বন্ধ করা হয়েছে',
  'graphCentrality.rankedHeading': 'প্রভাব দ্বারা টপ',
  'graphCentrality.colRank': '#',
  'graphCentrality.colEntity': 'স্বত্বা',
  'graphCentrality.colInfluence': 'প্রভাব',
  'graphCentrality.colLinks': 'লিঙ্ক',
  'graphCentrality.bridgeBadge': 'স্বয়ংক্রিয়',
  'graphCentrality.bridgeTitle': 'Connector: এর লিংক গণনায় আরও প্রভাবশালী',
  'graphCentrality.degreeTitle': 'xqxqx × xx11x এর জন্য',
  'memory.tab.associations': 'Associations',
  'entityAssociations.title': 'সত্তা সম্পর্ক',
  'entityAssociations.intro':
    'যে সত্তাগুলো অনেক একই সংযোগ ভাগ করে, তারা সম্পর্কিত, এমনকি কোনো একক তথ্য তাদের সরাসরি সংযুক্ত না করলেও। Jaccard সাদৃশ্য এই লুকানো সম্পর্কগুলো প্রকাশ করে।',
  'entityAssociations.loading': 'সম্পর্ক স্কোর করা হচ্ছে…',
  'entityAssociations.errorPrefix': 'গ্রাফ লোড করা যায়নি:',
  'entityAssociations.retry': 'Retry',
  'entityAssociations.empty': 'এখনো কোনো সংযোগ নেই।',
  'entityAssociations.emptyHint':
    'যখন সত্তাগুলো সংযোগ ভাগ করা শুরু করবে, সবচেয়ে শক্তিশালী জোড়াগুলো এখানে দেখা যাবে।',
  'entityAssociations.namespaceLabel': 'Namespace',
  'entityAssociations.namespaceAll': 'সকল নেমস্পেস',
  'entityAssociations.metricEntities': 'Entities',
  'entityAssociations.metricPairs': 'Associations',
  'entityAssociations.rankedHeading': 'সবচেয়ে শক্তিশালী সম্পর্ক',
  'entityAssociations.linkedBadge': 'linked',
  'entityAssociations.inferredBadge': 'inferred',
  'entityAssociations.linkedTitle': 'এই সত্তাগুলো সরাসরি সংযুক্ত।',
  'entityAssociations.inferredTitle':
    'কোনো সরাসরি লিংক নেই: শুধুমাত্র ভাগ করা সংযোগের মাধ্যমে সম্পর্কিত।',
  'entityAssociations.sharedLabel': '{shared} ভাগ করা',
  'entityAssociations.pairTitle': '{jaccard}% সাদৃশ্য · {shared}/{union} সংযোগ ভাগ করা',
  'entityAssociations.truncated': '{shown}/{total} দেখানো হচ্ছে: সবচেয়ে শক্তিশালী প্রথমে।',
  'memory.tab.freshness': 'Freshness',
  'memoryFreshness.title': 'জ্ঞানের তাজাত্ব',
  'memoryFreshness.intro':
    'সহকারী সম্প্রতি যে তথ্যগুলো পুনরায় নিশ্চিত করেনি, সেগুলো বিস্মরণ বক্ররেখা অনুসারে ক্ষয় হয়। এটি দেখায় কোনটি পুরনো হচ্ছে এবং পুনরায় পরীক্ষা করা উচিত, যাতে পুরনো তথ্যকে এখনো নিশ্চিত হিসেবে গণ্য না করা হয়।',
  'memoryFreshness.loading': 'তাজাত্ব স্কোর করা হচ্ছে…',
  'memoryFreshness.errorPrefix': 'গ্রাফ লোড করা যায়নি:',
  'memoryFreshness.retry': 'Retry',
  'memoryFreshness.empty': 'এখনো কোনো জ্ঞান গ্রাফ নেই।',
  'memoryFreshness.emptyHint':
    'যখন সহকারী আপনার সম্পর্কে তথ্য রেকর্ড করবে, তাদের তাজাত্ব এখানে ট্র্যাক করা হবে।',
  'memoryFreshness.namespaceLabel': 'Namespace',
  'memoryFreshness.namespaceAll': 'সকল নেমস্পেস',
  'memoryFreshness.metricFresh': 'Fresh',
  'memoryFreshness.metricFading': 'Fading',
  'memoryFreshness.metricStale': 'Stale',
  'memoryFreshness.recallCaption': '{total} তথ্যে গড় রিকল {recall}%',
  'memoryFreshness.queueHeading': 'পুনরায় নিশ্চিতকরণ সারি',
  'memoryFreshness.queueTruncated': '{shown}/{total} দেখানো হচ্ছে: প্রথমে এগুলো সমাধান করুন।',
  'memoryFreshness.allFresh': 'সমস্ত তথ্য এখনো তাজা: পুনরায় নিশ্চিত করার প্রয়োজন নেই।',
  'memoryFreshness.statusFading': 'fading',
  'memoryFreshness.statusStale': 'stale',
  'memoryFreshness.ageLabel': '{days} দিন আগে',
  'memoryFreshness.recallTitle': '{recall}% রিকল · অর্ধ-জীবন {halfLife} দিন',
  'memory.tab.path': 'পাথ',
  'connectionPath.title': 'সংযোগ পাথ',
  'connectionPath.intro':
    'যেকোনো দুটি এনটিটিকে সংযুক্ত করা সম্পর্কের সবচেয়ে ছোট চেইনটি খুঁজে বের করুন: কয়েকটি হপ পেরিয়ে হলেও গ্রাফ কীভাবে তাদের সংযুক্ত করে।',
  'connectionPath.loading': 'গ্রাফ লোড হচ্ছে…',
  'connectionPath.errorPrefix': 'গ্রাফ লোড করা যায়নি:',
  'connectionPath.retry': 'আবার চেষ্টা করুন',
  'connectionPath.namespaceLabel': 'নেমস্পেস',
  'connectionPath.namespaceAll': 'সব নেমস্পেস',
  'connectionPath.sourceLabel': 'থেকে',
  'connectionPath.targetLabel': 'পর্যন্ত',
  'connectionPath.sourcePlaceholder': 'শুরুর এনটিটি',
  'connectionPath.targetPlaceholder': 'শেষ এনটিটি',
  'connectionPath.prompt': 'তারা কীভাবে সংযুক্ত তা খুঁজে বের করতে দুটি এনটিটি বেছে নিন।',
  'connectionPath.empty': 'এখনও কোনো নলেজ গ্রাফ নেই।',
  'connectionPath.emptyHint':
    'অ্যাসিস্ট্যান্ট সম্পর্কিত তথ্য রেকর্ড করার পরে, আপনি এখানে সংযোগগুলি খুঁজে বের করতে পারবেন।',
  'connectionPath.resultHeading': 'সবচেয়ে ছোট পাথ',
  'connectionPath.pathSummary': '{length} হপ দূরে',
  'connectionPath.sameMessage': 'দুটি ভিন্ন এনটিটি বেছে নিন।',
  'connectionPath.missingSource': '“{entity}” গ্রাফে নেই।',
  'connectionPath.missingTarget': '“{entity}” গ্রাফে নেই।',
  'connectionPath.noPath': '“{source}” এবং “{target}”-এর মধ্যে কোনো সংযোগ পাওয়া যায়নি।',
  'memoryTree.status.title': 'মেমরি ট্রি',
  'memoryTree.status.autoSyncLabel': 'স্বয়ংক্রিয়-sync',
  'memoryTree.status.autoSyncDescription':
    'নতুন অভিযান থামাতে বিরতি দাও। এখানে বিদ্যমান উইকি অনুসন্ধানের জন্য অপেক্ষা করছে।',
  'memoryTree.status.statusTile': 'অবস্থা',
  'memoryTree.status.lastSyncTile': 'সর্বশেষ সুসংগতি',
  'memoryTree.status.totalChunksTile': 'সর্বমোট',
  'memoryTree.status.wikiSizeTile': 'উইকি মাপ',
  'memoryTree.status.statusRunning': 'চলমান',
  'memoryTree.status.statusPaused': 'সাময়িক বিরতি চলছে',
  'memoryTree.status.statusSyncing': 'সুসংগতি',
  'memoryTree.status.statusError': 'ত্রুটি',
  'memoryTree.status.statusIdle': 'নিষ্ক্রিয়',
  'memoryTree.status.never': 'কখনো নয়',
  'memoryTree.status.fetchError': 'মেমরি প্রাপ্ত করতে ব্যর্থ',
  'memoryTree.status.retry': 'পুনরায় চেষ্টা করুন',
  'memoryTree.status.retryFailed': 'ব্যর্থ কাজগুলো আবার চালান',
  'memoryTree.status.retryFailedBusy': 'আবার চেষ্টা করা হচ্ছে...',
  'memoryTree.status.retryFailedDone': 'ব্যর্থ কাজগুলো আবার সারিতে দেওয়া হয়েছে',
  'memoryTree.status.retryFailedCount': '{count}টি কাজ আবার চালানোর জন্য সারিতে রাখা হয়েছে।',
  'memoryTree.status.retryFailedError': 'ব্যর্থ কাজগুলো আবার সারিতে দেওয়া যায়নি',
  'memoryTree.status.toggleFailed': 'স্বয়ংক্রিয়ভাবে সনাক্ত করা সম্ভব হয়নি',
  'memoryTree.status.justNow': 'এখন',
  'memoryTree.status.secondsAgo': 'xqxqx পূর্বে',
  'memoryTree.status.minuteAgo': '১ মিনিট আগে',
  'memoryTree.status.minutesAgo': 'xqxqx মিনিট আগে',
  'memoryTree.status.hourAgo': '১ ঘন্টা আগে',
  'memoryTree.status.hoursAgo': 'Xqxqx+1 পূর্বে',
  'memoryTree.status.dayAgo': '১ দিন পূর্বে',
  'memoryTree.status.daysAgo': 'xqxqx প্রচেষ্টা করুন',
  'memoryTree.status.integrationsTitle': 'প্রতি-ইন্টিগ্রেশন স্বাস্থ্য',
  'memoryTree.status.integrationsEmpty': 'কোনো ইন্টিগ্রেশন সংযুক্ত নেই',
  'memoryTree.status.integrationActive': 'সক্রিয়',
  'memoryTree.status.integrationStale': 'বাসি',
  'memoryTree.status.integrationChunks': 'চাংক: {count}',
  'alerts.title': 'সতর্কতা',
  'alerts.empty': 'এখনো কোনো সতর্কতা নেই',
  'alerts.markAllRead': 'সব পঠিত চিহ্নিত করুন',
  'alerts.unread': 'অপঠিত',
  'rewards.title': 'পুরস্কার',
  'rewards.referrals': 'রেফারেল',
  'rewards.coupons': 'রিডিম',
  'rewards.localUnavailable':
    'লোকাল লগইনে কোনো রিওয়ার্ড, কুপন বা রেফারেল ক্রেডিট মেলে না। রিওয়ার্ড পেতে লগ আউট করে একটি OpenHuman অ্যাকাউন্ট দিয়ে সাইন ইন করুন।',
  'rewards.localUnavailableCta': 'অ্যাকাউন্ট সেটিংস খুলুন',
  'rewards.credits': 'ক্রেডিট',
  'rewards.referralCode': 'আপনার রেফারেল কোড',
  'rewards.copyCode': 'কোড কপি করুন',
  'rewards.share': 'শেয়ার',
  'onboarding.welcome': 'হ্যালো। আমি OpenHuman।',
  'onboarding.welcomeDesc':
    'আপনার সুপার-ইন্টেলিজেন্ট AI অ্যাসিস্ট্যান্ট যা আপনার কম্পিউটারে চলে। ব্যক্তিগত, সহজ এবং অত্যন্ত শক্তিশালী।',
  'onboarding.context': 'কন্টেক্সট সংগ্রহ',
  'onboarding.contextDesc': 'প্রতিদিন ব্যবহার করা টুলস ও সার্ভিস সংযুক্ত করুন।',
  'onboarding.localAI': 'লোকাল AI',
  'onboarding.localAIDesc': 'আপনার মেশিনে চলা একটি লোকাল AI মডেল সেটআপ করুন।',
  'onboarding.chatProvider': 'চ্যাট প্রোভাইডার',
  'onboarding.chatProviderDesc': 'আপনার অ্যাসিস্ট্যান্টের সাথে কীভাবে যোগাযোগ করবেন তা বেছে নিন।',
  'onboarding.referral': 'রেফারেল',
  'onboarding.referralDesc': 'যদি রেফারেল কোড থাকে তা প্রয়োগ করুন।',
  'onboarding.finish': 'সেটআপ সম্পন্ন',
  'onboarding.finishDesc': 'সব প্রস্তুত! OpenHuman ব্যবহার শুরু করুন।',
  'onboarding.skip': 'এড়িয়ে যান',
  'onboarding.getStarted': 'শুরু করুন',
  'onboarding.runtimeChoice.title': 'আপনি কীভাবে OpenHuman চালাতে চান?',
  'onboarding.runtimeChoice.subtitle':
    'আপনার জন্য উপযুক্ত সেটআপ বেছে নিন। পরে সেটিংসে পরিবর্তন করা যাবে।',
  'onboarding.runtimeChoice.cloud.title': 'সহজ',
  'onboarding.runtimeChoice.cloud.tagline': 'OpenHuman সব কিছু পরিচালনা করবে।',
  'onboarding.runtimeChoice.cloud.f1': 'বিল্ট-ইন নিরাপত্তা',
  'onboarding.runtimeChoice.cloud.f2': 'ব্যবহার আরও দীর্ঘ করতে টোকেন কম্প্রেশন',
  'onboarding.runtimeChoice.cloud.f3': 'একটি সাবস্ক্রিপশনে সব মডেল',
  'onboarding.runtimeChoice.cloud.f4': 'API কী পরিচালনার ঝামেলা নেই',
  'onboarding.runtimeChoice.cloud.f5': 'সেটআপ করা সহজ',
  'onboarding.runtimeChoice.custom.title': 'কাস্টম রান',
  'onboarding.runtimeChoice.custom.tagline': 'নিজের কী আনুন। সম্পূর্ণ নিয়ন্ত্রণ আপনার হাতে।',
  'onboarding.runtimeChoice.custom.f1': 'প্রায় সব কিছুর জন্য API কী প্রয়োজন',
  'onboarding.runtimeChoice.custom.f2': 'আপনার বিদ্যমান সার্ভিস পুনরায় ব্যবহার করে',
  'onboarding.runtimeChoice.custom.f3': 'সব লোকালে চালালে বিনামূল্যে হতে পারে',
  'onboarding.runtimeChoice.custom.f4': 'বেশি সেটআপ, বেশি নিয়ন্ত্রণ',
  'onboarding.runtimeChoice.custom.f5': 'পাওয়ার ইউজার ও ডেভেলপারদের জন্য সেরা',
  'onboarding.runtimeChoice.cloud.creditHighlight': 'সাইন আপ করলে বিনামূল্যে ক্রেডিট',
  'onboarding.runtimeChoice.continueCloud': 'সহজ দিয়ে চালিয়ে যান',
  'onboarding.runtimeChoice.continueCustom': 'কাস্টম দিয়ে চালিয়ে যান',
  'onboarding.runtimeChoice.recommended': 'প্রস্তাবিত',
  'onboarding.runtimeChoice.exitError': 'অনবোর্ডিং শেষ করা যায়নি। আবার চেষ্টা করুন।',
  'onboarding.apiKeys.title': 'আপনার API কী যোগ করুন',
  'onboarding.apiKeys.subtitle':
    'এখনই পেস্ট করুন বা এড়িয়ে গিয়ে পরে সংযোগ › API কী-তে যোগ করুন। কীগুলো এই ডিভাইসে এনক্রিপ্ট করে সংরক্ষিত থাকে।',
  'onboarding.apiKeys.openaiLabel': 'OpenAI API কী',
  'onboarding.apiKeys.openaiPlaceholder': 'sk-...',
  'onboarding.apiKeys.openaiOauthHint':
    'ChatGPT Plus/Pro (সাবস্ক্রিপশন) বা একটি OpenAI API কী ব্যবহার করুন: উভয়ের প্রয়োজন নেই।',
  'onboarding.apiKeys.openaiOauthOpening': 'সাইন-ইন খোলা হচ্ছে...',
  'onboarding.apiKeys.openaiOauthConnect': 'ChatGPT দিয়ে সাইন ইন করুন',
  'onboarding.apiKeys.openaiOauthConnected': 'ChatGPT দিয়ে সংযুক্ত',
  'onboarding.apiKeys.openaiOauthCallbackHint':
    'সাইন ইন করার পরে, আপনার ব্রাউজার থেকে সম্পূর্ণ রিডাইরেক্ট URL পেস্ট করুন ({url} দিয়ে শুরু হয়)।',
  'onboarding.apiKeys.oauthDesktopOnly': 'ChatGPT সাইন-ইন শুধুমাত্র ডেস্কটপ অ্যাপে উপলব্ধ।',
  'onboarding.apiKeys.oauthStartFailed':
    'ChatGPT সাইন-ইন শুরু করা যায়নি। আবার চেষ্টা করুন বা একটি API কী ব্যবহার করুন।',
  'onboarding.apiKeys.oauthPasteRedirect':
    'সাইন ইন করার পরে আপনার ব্রাউজার থেকে রিডাইরেক্ট URL পেস্ট করুন।',
  'onboarding.apiKeys.oauthCompleteFailed':
    'ChatGPT সাইন-ইন সম্পূর্ণ হয়নি। রিডাইরেক্ট URL পরীক্ষা করুন এবং আবার চেষ্টা করুন।',
  'onboarding.apiKeys.finishSignIn': 'ChatGPT সাইন-ইন শেষ করুন',
  'onboarding.apiKeys.orApiKey': 'বা API কী',
  'onboarding.apiKeys.anthropicLabel': 'Anthropic API কী',
  'onboarding.apiKeys.anthropicPlaceholder': 'sk-ant-...',
  'onboarding.apiKeys.saveError': 'কীটি সংরক্ষণ করা যায়নি। দয়া করে যাচাই করে আবার চেষ্টা করুন।',
  'onboarding.apiKeys.skipForNow': 'এখনের জন্য এড়িয়ে যান',
  'onboarding.apiKeys.continue': 'সংরক্ষণ করে চালিয়ে যান',
  'onboarding.apiKeys.saving': 'সংরক্ষণ হচ্ছে…',
  'onboarding.custom.stepperInference': 'ইনফারেন্স',
  'onboarding.custom.stepperVoice': 'ভয়েস',
  'onboarding.custom.stepperOAuth': 'OAuth',
  'onboarding.custom.stepperSearch': 'সার্চ',
  'onboarding.custom.stepperEmbeddings': 'Embeddings',
  'onboarding.custom.stepperMemory': 'মেমোরি',
  'onboarding.custom.stepCounter': 'ধাপ {n} / {total}',
  'onboarding.custom.defaultTitle': 'ডিফল্ট',
  'onboarding.custom.defaultSubtitle': 'OpenHuman আপনার হয়ে পরিচালনা করবে।',
  'onboarding.custom.configureTitle': 'কনফিগার',
  'onboarding.custom.configureSubtitle': 'আমি কী ব্যবহার করব তা বেছে নেব।',
  'onboarding.custom.progressAriaLabel': 'অনবোর্ডিং অগ্রগতি',
  'onboarding.custom.continue': 'চালিয়ে যান',
  'onboarding.custom.back': 'পেছনে',
  'onboarding.custom.finish': 'সেটআপ সম্পন্ন',
  'onboarding.custom.configureLater':
    'অনবোর্ডিং শেষে এটি কনফিগার করতে পারবেন। সম্পন্ন হলে সংশ্লিষ্ট সেটিংস পেজে নিয়ে যাওয়া হবে।',
  'onboarding.custom.openSettings': 'সেটিংসে খুলুন',
  'onboarding.custom.inference.title': 'ইনফারেন্স (টেক্সট)',
  'onboarding.custom.inference.subtitle':
    'কোন ল্যাঙ্গুয়েজ মডেল আপনার প্রশ্নের উত্তর দেবে এবং এজেন্ট চালাবে?',
  'onboarding.custom.inference.defaultDesc':
    'OpenHuman প্রতিটি ওয়ার্কলোড একটি সেন্সিবল ডিফল্ট মডেলে রুট করে। কোনো কী বা সেটআপ নেই।',
  'onboarding.custom.inference.configureDesc':
    'নিজের OpenAI বা Anthropic কী আনুন। আমরা সব টেক্সট-ভিত্তিক কাজে এটি ব্যবহার করি।',
  'onboarding.custom.voice.title': 'ভয়েস',
  'onboarding.custom.voice.subtitle': 'ভয়েস মোডের জন্য স্পিচ-টু-টেক্সট এবং টেক্সট-টু-স্পিচ।',
  'onboarding.custom.voice.defaultDesc':
    'OpenHuman ম্যানেজড STT/TTS সহ আসে যা সরাসরি কাজ করে। কিছু সেটআপ করতে হবে না।',
  'onboarding.custom.voice.configureDesc':
    'নিজের ElevenLabs / OpenAI Whisper / ইত্যাদি ব্যবহার করুন। Settings › Voice-এ কনফিগার করুন।',
  'onboarding.custom.oauth.title': 'সংযোগ (OAuth)',
  'onboarding.custom.oauth.subtitle':
    'Gmail, Slack, Notion এবং OAuth প্রয়োজন এমন অন্যান্য সংযুক্ত সার্ভিস।',
  'onboarding.custom.oauth.defaultDesc':
    'OpenHuman একটি ম্যানেজড Composio ওয়ার্কস্পেস চালায়। পরে প্রতিটি সার্ভিস সংযুক্ত করতে এক ক্লিক।',
  'onboarding.custom.oauth.configureDesc':
    'নিজের Composio অ্যাকাউন্ট / API কী আনুন। Settings › Connections-এ কনফিগার করুন।',
  'onboarding.custom.search.title': 'ওয়েব সার্চ',
  'onboarding.custom.search.subtitle': 'OpenHuman আপনার হয়ে কীভাবে ওয়েব সার্চ করে।',
  'onboarding.custom.search.defaultDesc':
    'OpenHuman ম্যানেজড সার্চ ব্যাকএন্ড ব্যবহার করে। কোনো কী লাগে না।',
  'onboarding.custom.search.configureDesc':
    'নিজের সার্চ প্রোভাইডার কী আনুন (Tavily, Brave ইত্যাদি)। Settings › Tools-এ কনফিগার করুন।',
  'onboarding.custom.embeddings.title': 'Embeddings',
  'onboarding.custom.embeddings.subtitle':
    'OpenHuman কীভাবে সিমান্টিক মেমোরি অনুসন্ধানের জন্য ভেক্টর এম্বেডিং তৈরি করে।',
  'onboarding.custom.embeddings.defaultDesc':
    'OpenHuman একটি পরিচালিত এম্বেডিং সেবা ব্যবহার করে। কোনো API কী প্রয়োজন নেই।',
  'onboarding.custom.embeddings.configureDesc':
    'আপনার নিজস্ব এম্বেডিং প্রোভাইডার ব্যবহার করুন (OpenAI, Voyage, Ollama, ইত্যাদি)।',
  'onboarding.custom.memory.title': 'মেমোরি',
  'onboarding.custom.memory.subtitle':
    'OpenHuman কীভাবে আপনার কন্টেক্সট, পছন্দ ও পূর্ববর্তী কথোপকথন মনে রাখে।',
  'onboarding.custom.memory.defaultDesc':
    'OpenHuman স্বয়ংক্রিয়ভাবে মেমোরি স্টোরেজ ও রিট্রিভাল পরিচালনা করে। কিছু সেটআপ করতে হবে না।',
  'onboarding.custom.memory.configureDesc':
    'মেমোরি নিজে পরীক্ষা, এক্সপোর্ট বা মুছুন। Settings › Memory-এ কনফিগার করুন।',
  'accounts.addAccount': 'অ্যাকাউন্ট যোগ করুন',
  'accounts.addApps': 'অ্যাপ যোগ করুন',
  'accounts.manageAccounts': 'অ্যাকাউন্ট পরিচালনা',
  'accounts.noAccounts': 'কোনো অ্যাকাউন্ট সংযুক্ত নেই',
  'accounts.connectAccount': 'শুরু করতে একটি অ্যাকাউন্ট সংযুক্ত করুন',
  'accounts.agent': 'এজেন্ট',
  'accounts.respondQueue': 'রেসপন্ড কিউ',
  'accounts.disconnect': 'সংযোগ বিচ্ছিন্ন',
  'accounts.disconnectConfirm': 'আপনি কি এই অ্যাকাউন্ট সংযোগ বিচ্ছিন্ন করতে চান?',
  'accounts.disconnectClearMemory': 'এই উৎস থেকে মেমোরিও মুছুন',
  'accounts.disconnectClearMemoryHint':
    'এই সংযোগের সাথে যুক্ত স্থানীয় মেমোরি চিরতরে মুছে ফেলা হবে।',
  'accounts.searchAccounts': 'অ্যাকাউন্ট খুঁজুন...',
  'channels.title': 'চ্যানেল',
  'channels.configure': 'চ্যানেল কনফিগার করুন',
  'channels.setup': 'সেটআপ',
  'channels.noChannels': 'কোনো চ্যানেল কনফিগার করা হয়নি',
  'channels.localManagedUnavailable': 'লোকাল ব্যবহারকারীদের জন্য ম্যানেজড চ্যানেল উপলভ্য নয়।',
  'channels.addChannel': 'চ্যানেল যোগ করুন',
  'channels.status.connected': 'সংযুক্ত',
  'channels.status.disconnected': 'সংযোগ বিচ্ছিন্ন',
  'channels.status.error': 'ত্রুটি',
  'channels.status.configuring': 'কনফিগার হচ্ছে',
  'channels.defaultMessaging': 'ডিফল্ট মেসেজিং চ্যানেল',
  'channels.setAsDefault': 'ডিফল্ট হিসেবে সেট করুন',
  'channels.defaultBadge': 'ডিফল্ট',
  'webhooks.title': 'ওয়েবহুক',
  'webhooks.create': 'Webhook তৈরি করুন',
  'webhooks.noWebhooks': 'কোনো webhook কনফিগার করা হয়নি',
  'webhooks.url': 'URL',
  'webhooks.secret': 'সিক্রেট',
  'webhooks.events': 'ইভেন্ট',
  'webhooks.archiveDirectory': 'আর্কাইভ ডিরেক্টরি',
  'webhooks.todayFile': 'আজকের ফাইল',
  'invites.title': 'আমন্ত্রণ',
  'invites.create': 'আমন্ত্রণ তৈরি করুন',
  'invites.noInvites': 'কোনো মুলতুবি আমন্ত্রণ নেই',
  'invites.code': 'আমন্ত্রণ কোড',
  'invites.copyLink': 'লিংক কপি করুন',
  'invites.generate': 'সরান',
  'invites.generating': 'আমন্ত্রণ তৈরি করুন',
  'invites.refreshing': 'জেনারেট করা হচ্ছে...',
  'invites.loading': '[N_18_8] রিফ্রেশ করা হচ্ছে... আমন্ত্রণগুলি লোড হচ্ছে...',
  'invites.copyCodeAria': 'আমন্ত্রণ কোড অনুলিপি করুন',
  'invites.revokeAria': 'আমন্ত্রণ প্রত্যাহার করুন',
  'invites.usedUp': 'ব্যবহৃত হয়েছে',
  'invites.uses': 'ব্যবহারগুলি: _____PH',
  'invites.expiresOn': 'মেয়াদ শেষ হবে {date}',
  'invites.empty': 'এখনো কোনো আমন্ত্রণ নেই',
  'invites.emptyHint': 'অন্যদের সাথে শেয়ার করার জন্য একটি আমন্ত্রণ কোড তৈরি করুন',
  'invites.revokeTitle': 'আমন্ত্রণ কোড প্রত্যাহার করুন',
  'invites.revokePromptPrefix': 'আপনি কি নিশ্চিত যে আপনি আমন্ত্রণ কোড প্রত্যাহার করতে চান',
  'invites.revokeWarning':
    'এই আমন্ত্রণ কোডটি আর বৈধ থাকবে না এবং দলে যোগ দিতে ব্যবহার করা যাবে না।',
  'invites.revoking': 'প্রত্যাহার করা হচ্ছে...',
  'invites.revokeAction': 'আমন্ত্রণ প্রত্যাহার করুন',
  'invites.failedGenerate': 'আমন্ত্রণ তৈরি করতে ব্যর্থ হয়েছে',
  'invites.failedRevoke': 'আমন্ত্রণ প্রত্যাহার করতে ব্যর্থ হয়েছে',
  'team.refreshingMembers': 'সদস্যদের রিফ্রেশ করা হচ্ছে...',
  'team.loadingMembers': 'সদস্য লোড হচ্ছে...',
  'team.memberCount': 'PH__18N_SEP_92731 সদস্য',
  'team.memberCountPlural': '{count} সদস্য',
  'team.you': '(আপনি)',
  'team.removeAria': 'সরান {name}',
  'team.noMembers': 'কোনো সদস্য পাওয়া যায়নি',
  'team.removeTitle': 'দলের সদস্যকে সরান',
  'team.removePromptPrefix': 'আপনি কি টিম থেকে',
  'team.removePromptSuffix': 'কে সরানোর বিষয়ে নিশ্চিত?',
  'team.removeWarning': 'তারা টিম এবং সমস্ত টিম রিসোর্সে অ্যাক্সেস হারাবে।',
  'team.removing': 'সরানো হচ্ছে...',
  'team.removeAction': 'সদস্য সরান',
  'team.changeRoleTitle': 'সদস্যের ভূমিকা পরিবর্তন করুন',
  'team.changeRolePrompt': '{name}-এর ভূমিকা {oldRole} থেকে {newRole}-এ পরিবর্তন করবেন?',
  'team.changeRoleAdminGrant':
    'এটি তাদের দলের সদস্যদের পরিচালনা করার ক্ষমতাসহ সম্পূর্ণ অ্যাডমিন অনুমতি দেবে।',
  'team.changeRoleAdminRemove':
    'এটি তাদের অ্যাডমিন অনুমতি সরিয়ে দেবে এবং তারা আর দল পরিচালনা করতে পারবে না।',
  'team.changing': 'পরিবর্তন হচ্ছে...',
  'team.changeRoleAction': 'ভূমিকা পরিবর্তন করুন',
  'team.failedChangeRole': 'ভূমিকা পরিবর্তন করতে ব্যর্থ হয়েছে',
  'team.failedRemoveMember': 'সদস্য সরাতে ব্যর্থ হয়েছে',
  'devOptions.title': 'অ্যাডভান্সড',
  'devOptions.titleDiagnostics': 'ডেভেলপার ও ডায়াগনস্টিক্স',
  'devOptions.diagnostics': 'ডায়াগনস্টিক্স',
  'devOptions.diagnosticsDesc': 'সিস্টেম স্বাস্থ্য, লগ এবং পারফরম্যান্স মেট্রিক্স',
  'devOptions.toolPolicyDiagnosticsDesc': 'টুল- মেকআপ, নীতি পোস্ট, xqxqxs, এবং সম্প্রতি ব্যবহৃত',
  'devOptions.toolPolicyDiagnostics.loading': 'লোড করা হচ্ছে...',
  'devOptions.toolPolicyDiagnostics.unavailable': 'ডায়াগনস্টিক উপলব্ধ নয়',
  'devOptions.toolPolicyDiagnostics.posture.title': 'পলিসি পোস্টিং',
  'devOptions.toolPolicyDiagnostics.posture.autonomy': 'স্বয়ংক্রিয়রূপে ব্যবহৃত:',
  'devOptions.toolPolicyDiagnostics.posture.workspaceOnly': 'শুধুমাত্র কর্মক্ষেত্র:',
  'devOptions.toolPolicyDiagnostics.posture.maxActionsPerHour':
    'ম্যাক্স এক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সক্সক্সক্স:',
  'devOptions.toolPolicyDiagnostics.posture.approvalMediumRisk': 'উপস্থিত ঝুঁকি:',
  'devOptions.toolPolicyDiagnostics.posture.blockHighRisk': 'সর্বাধিক গুরুত্বের মাত্রা:',
  'devOptions.toolPolicyDiagnostics.inventory.title': 'আরম্ভ',
  'devOptions.toolPolicyDiagnostics.inventory.totalTools': 'মোট সরঞ্জাম',
  'devOptions.toolPolicyDiagnostics.inventory.enabledTools': 'সক্রিয় টুল-টিপ',
  'devOptions.toolPolicyDiagnostics.inventory.mcpStdioTools': 'xqxqx stdio টুল',
  'devOptions.toolPolicyDiagnostics.inventory.jsonRpcTools': 'xqxqx - xx1x2x টুল',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.title': 'xqxqx সার্ভারে অনুমোদন করে',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.summary': 'সক্রিয়: xqxqx সার্ভার',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.unnamed': '<নামহীন>',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.allowDeny': 'xqxqx মোড অগ্রাহ্য করা হবে=x1x1xX1',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.title': 'Xqxqx লিখন ব্যবস্থা',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.summary': 'সক্রিয়: xqxqx  সর্বশেষ (২৪: xx1x)',
  'devOptions.toolPolicyDiagnostics.recentBlocked.title': 'সম্প্রতি ব্যবহৃত কল',
  'devOptions.toolPolicyDiagnostics.recentBlocked.empty': 'সংযোগ বিচ্ছিন্ন করা হয়েছে',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.title': 'পুনরাবৃত্তিমূলক পৃষ্ঠ',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.summary':
    'লেখার সময় মাপ: xqxqxqx নিয়ন্ত্রণ প্রক্রিয়া: xqx1x1xkx2x',
  'devOptions.debugPanels': 'ডিবাগ প্যানেল',
  'devOptions.debugPanelsDesc': 'ফিচার ফ্ল্যাগ, স্টেট ইন্সপেকশন এবং ডিবাগিং টুলস',
  'devOptions.webhooks': 'ওয়েবহুকগুলি',
  'devOptions.webhooksDesc': 'Webhook ইন্টিগ্রেশন কনফিগার ও পরীক্ষা করুন',
  'devOptions.memoryInspection': 'মেমোরি ইন্সপেকশন',
  'devOptions.memoryInspectionDesc': 'মেমোরি এন্ট্রি ব্রাউজ, কোয়েরি ও পরিচালনা করুন',
  'voice.pushToTalk': 'পুশ টু টক',
  'voice.recording': 'রেকর্ড হচ্ছে...',
  'voice.processing': 'প্রক্রিয়া হচ্ছে...',
  'voice.languageHint': 'ভাষা',
  'misc.rehydrating': 'আপনার ডেটা লোড হচ্ছে...',
  'misc.checkingServices': 'সার্ভিস পরীক্ষা হচ্ছে...',
  'misc.serviceUnavailable': 'সার্ভিস পাওয়া যাচ্ছে না',
  'misc.somethingWentWrong': 'কিছু একটা ভুল হয়েছে',
  'misc.tryAgainLater': 'পরে আবার চেষ্টা করুন।',
  'misc.restartApp': 'অ্যাপ রিস্টার্ট করুন',
  'misc.updateAvailable': 'আপডেট পাওয়া গেছে',
  'misc.updateNow': 'এখনই আপডেট করুন',
  'misc.updateLater': 'পরে',
  'misc.downloading': 'ডাউনলোড হচ্ছে...',
  'misc.installing': 'ইনস্টল হচ্ছে...',
  'misc.beta':
    'OpenHuman এখন আর্লি বেটায় আছে। যেকোনো মতামত বা বাগ রিপোর্ট করুন: প্রতিটি রিপোর্ট আমাদের দ্রুত এগিয়ে যেতে সাহায্য করে।',
  'misc.betaFeedback': 'ফিডব্যাক পাঠান',
  'mnemonic.title': 'রিকভারি ফ্রেজ',
  'mnemonic.warning': 'এই শব্দগুলো ক্রমানুসারে লিখে নিরাপদ স্থানে সংরক্ষণ করুন।',
  'mnemonic.copyWarning':
    'আপনার রিকভারি ফ্রেজ কখনো শেয়ার করবেন না। এই শব্দগুলো দিয়ে যে কেউ আপনার অ্যাকাউন্টে প্রবেশ করতে পারবে।',
  'mnemonic.copied': 'রিকভারি ফ্রেজ ক্লিপবোর্ডে কপি হয়েছে',
  'mnemonic.reveal': 'ফ্রেজ দেখুন',
  'mnemonic.revealPhrase': 'পুনরুদ্ধার বাক্যাংশ দেখান',
  'mnemonic.hidden': 'রিকভারি ফ্রেজ লুকানো আছে',
  'privacy.title': 'গোপনীয়তা ও নিরাপত্তা',
  'privacy.description': 'বাহ্যিক সার্ভিসে পাঠানো ডেটার স্বচ্ছতা রিপোর্ট।',
  'privacy.empty': 'কোনো বাহ্যিক ডেটা স্থানান্তর শনাক্ত হয়নি।',
  'privacy.whatLeavesComputer': 'আপনার কম্পিউটার থেকে কী বাইরে যায়',
  'privacy.loading': 'গোপনীয়তার বিবরণ লোড হচ্ছে...',
  'privacy.loadError':
    'লাইভ গোপনীয়তা তালিকা লোড করা যায়নি। নিচের অ্যানালিটিক্স নিয়ন্ত্রণ এখনো কাজ করছে।',
  'privacy.noCapabilities': 'বর্তমানে কোনো ক্যাপাবিলিটি ডেটা মুভমেন্ট প্রকাশ করে না।',
  'privacy.sentTo': 'পাঠানো হয়েছে',
  'privacy.leavesDevice': 'ডিভাইস ছেড়ে যায়',
  'privacy.staysLocal': 'লোকালে থাকে',
  'privacy.anonymizedAnalytics': 'প্রোডাক্ট অ্যানালিটিক্স',
  'privacy.shareAnonymizedData': 'প্রোডাক্ট অ্যানালিটিক্স ও ডায়াগনস্টিকস শেয়ার করুন',
  'privacy.shareAnonymizedDataDesc':
    'গোপনীয়তা-সীমিত ক্র্যাশ রিপোর্ট ও ব্যবহার ইভেন্ট শেয়ার করে OpenHuman উন্নত করতে সাহায্য করুন, যার মধ্যে স্থিতিশীল অ্যাকাউন্ট ID ও অ্যাপ সংস্করণ মেটাডেটা থাকে। বার্তা, ওয়ালেট কী, API কী বা সেশন টোকেন কখনো সংগ্রহ করা হয় না।',
  'privacy.meetingFollowUps': 'মিটিং ফলো-আপ',
  'privacy.autoHandoffMeet': 'Google Meet ট্রান্সক্রিপ্ট স্বয়ংক্রিয়ভাবে অর্কেস্ট্রেটরে পাঠান',
  'privacy.autoHandoffMeetDesc':
    'Google Meet কল শেষ হলে, OpenHuman-এর অর্কেস্ট্রেটর ট্রান্সক্রিপ্ট পড়তে এবং বার্তা ড্রাফট করা, ফলো-আপ নির্ধারণ করা বা সংযুক্ত Slack ওয়ার্কস্পেসে সারসংক্ষেপ পোস্ট করার মতো কাজ করতে পারে। ডিফল্টে বন্ধ।',
  'privacy.analyticsDisclaimer':
    'সক্রিয় থাকলে, প্রোডাক্ট অ্যানালিটিক্স ও ডায়াগনস্টিকসে গোপনীয়তা-সীমিত ক্র্যাশ রিপোর্ট ও ব্যবহার ইভেন্ট, স্থিতিশীল অ্যাকাউন্ট ID এবং অ্যাপ সংস্করণ মেটাডেটা থাকতে পারে। বার্তা, ওয়ালেট কী, API কী বা সেশন টোকেন কখনো সংগ্রহ করা হয় না। যেকোনো সময় এই সেটিং পরিবর্তন করা যাবে।',
  'settings.about.version': 'ভার্সন',
  'settings.about.updateAvailable': 'পাওয়া গেছে',
  'settings.about.softwareUpdates': 'সফটওয়্যার আপডেট',
  'settings.about.lastChecked': 'শেষ পরীক্ষা',
  'settings.about.checking': 'পরীক্ষা হচ্ছে...',
  'settings.about.checkForUpdates': 'আপডেট পরীক্ষা করুন',
  'settings.about.releases': 'রিলিজ',
  'settings.about.releasesDesc': 'GitHub-এ রিলিজ নোট ও আগের বিল্ড দেখুন।',
  'settings.about.openReleases': 'GitHub রিলিজ খুলুন',
  'settings.about.starCta.title': 'OpenHuman ভালো লাগছে?',
  'settings.about.starCta.body':
    'GitHub-এ আমাদের একটি স্টার দিন। এতে আরও বেশি মানুষ আমাদের খুঁজে পান।',
  'settings.about.starCta.star': 'GitHub-এ স্টার দিন',
  'settings.about.starCta.dismiss': 'এখন নয়',
  'settings.about.connection': 'সংযোগ',
  'settings.about.connectionMode': 'মোড',
  'settings.about.connectionModeLocal': 'স্থানীয়',
  'settings.about.connectionModeCloud': 'ক্লাউড',
  'settings.about.connectionModeUnset': 'নির্বাচিত হয়নি',
  'settings.about.serverUrl': 'সার্ভার URL',
  'settings.about.serverUrlUnavailable': 'অনুপলব্ধ',
  'settings.about.connectionHelperLocal':
    'অ্যাপ্লিকেশন চালুর সময় xqx1qx শেল-এ null র‍্যাপেড হয়। প্রারম্ভ হওয়া অবধি এই পোর্টটি নির্বাচন করা হয়েছে, তাই এই xqxqxqx সহযোগে আরম্ভ করা হয় ।',
  'settings.about.connectionHelperCloud':
    'রিমোটের সাথে সংযুক্ত। এটি বুট করা অথবা মেঘের মোড দ্বারা পরিবর্তন করা হবে।',
  'settings.heartbeat.title': 'হার্টবিট এবং লুপস',
  'settings.usage.title': 'ব্যবহার ও সীমা',
  'settings.usage.menuDesc': 'খরচ, টোকেন ব্যবহার, বাজেট এবং পটভূমির কার্যকলাপ',
  'settings.costDashboard.title': 'বিভাজনের স্থান',
  'settings.costDashboard.sevenDayCost': '৭ দিনের মূল্য',
  'settings.costDashboard.sevenDayTokens': '৭ দিনের ব্যবহার',
  'settings.costDashboard.totalSpend': '৭ দিনের মত',
  'settings.costDashboard.monthlyPace': 'মাসিক গতি',
  'settings.costDashboard.budgetLimit': 'বিট- এর সীমা',
  'settings.costDashboard.utilization': 'নিক্তি',
  'settings.costDashboard.modelBreakdown': 'সংখ্যা:',
  'settings.costDashboard.model': 'মডেল',
  'settings.costDashboard.provider': 'পরিসেবা উপলব্ধকারী',
  'settings.costDashboard.cost': 'ব্যয়',
  'settings.costDashboard.tokens': 'টোকেন',
  'settings.costDashboard.requests': 'অনুরোধ',
  'settings.costDashboard.percentOfTotal': 'সর্বমোট%s',
  'settings.costDashboard.inputTokens': 'ইনপুট',
  'settings.costDashboard.outputTokens': 'আউটপুট',
  'settings.costDashboard.budgetNormal': 'ট্র্যাকে',
  'settings.costDashboard.budgetWarning': 'সতর্কবার্তা',
  'settings.costDashboard.budgetExceeded': 'বাজেট',
  'settings.costDashboard.noBudget': 'সময়সীমা নির্ধারিত নেই',
  'settings.costDashboard.noData': 'গত ৭ দিন ধরে কোন খরচ রেকর্ড করা হয়নি।',
  'settings.costDashboard.noModels': 'গত ৭ দিনে কোনো মডেল কর্ম হয়নি।',
  'settings.costDashboard.loading': 'ড্যাশবোর্ড লোড করা হচ্ছে...',
  'settings.costDashboard.disabledHint':
    'কনফিগ- এর ড্যাশবোর্ড নিষ্ক্রিয় করা হয়েছে। এক্স- অক্ষের সাথে ( xxxqx) সক্রিয় করুন = xx1xqxXqx সক্রিয় করুন।',
  'settings.costDashboard.subtitle':
    'লাইভ সময় কাটান আর গোছগাছে পুড়ে যায়। কয়েক সেকেন্ডের মধ্যে বার নতুন করে নতুন করে তৈরি করা হয়: কোনো পৃষ্ঠা পুনরায় লোড করার প্রয়োজন নেই ।',
  'settings.costDashboard.summaryAriaLabel': 'অবস্থানের সংক্ষিপ্ত তথ্য',
  'settings.costDashboard.lastSevenDays': 'গত ৭ দিন',
  'settings.costDashboard.utilizationOf': 'এর',
  'settings.costDashboard.thisMonth': 'এই মাসে',
  'settings.costDashboard.monthlyPaceHint':
    'বর্তমানে প্রতিদিনের রানটাইমে (ভলডেক্স ৩০) মাসিক খরচ হয়।',
  'settings.costDashboard.budgetLimitHint': 'মাসিক বাজেট এক্সqxxxxx থেকে পাঠ করা হয়েছে।',
  'settings.costDashboard.dailyTarget': 'দৈনিক লক্ষ্য',
  'settings.costDashboard.today': 'আজ',
  'settings.costDashboard.todayBadge': 'TODAY',
  'settings.costDashboard.unknownProvider': 'কোনোটিই নয়',
  'settings.costDashboard.justNow': 'এখন',
  'settings.costDashboard.secondsAgo': 'xqxqx পূর্বে',
  'settings.costDashboard.minutesAgo': 'এক্স.qxqx কনফিগারেশন',
  'settings.costDashboard.hoursAgo': 'এক্স.qxqx হর',
  'settings.costDashboard.daysAgo': 'Xqxqx পূর্বে',
  'settings.costDashboard.updated': 'আপডেট করা হয়েছে',
  'settings.costDashboard.refresh': 'নতুন করে প্রদর্শন',
  'settings.costDashboard.utcNote': 'xqxkx-এ অতিবাহিত দিন',
  'settings.costDashboard.stackedNote': 'ইনপুট + আউটপুট স্ট্যাক',
  'settings.costDashboard.modelBreakdownHint': 'গত ৭ দিনে পৃথকীকরণ।',
  'settings.costDashboard.categoryDistribution': 'বিভাগ অনুযায়ী খরচ',
  'settings.costDashboard.categoryDistributionHint':
    'সাম্প্রতিক চ্যাট, এমবেডিং, ভয়েস, ছবি এবং রির্যাঙ্কিং কল রেকর্ড থেকে অনুমান করা।',
  'settings.costDashboard.noCategories': 'এখনও কোনো বিভাগভিত্তিক খরচ নেই।',
  'settings.costDashboard.categoryMeta': '{requests} অনুরোধ • {tokens} টোকেন',
  'settings.costDashboard.usageLog': 'ব্যবহার লগ',
  'settings.costDashboard.usageLogHint': 'গত {days} দিনের নতুন রেকর্ড, সর্বোচ্চ {limit} সারি।',
  'settings.costDashboard.logTotal': '{requests} অনুরোধ • {cost}',
  'settings.costDashboard.noUsageLog': 'এই সময়ের জন্য কোনো ব্যবহার রেকর্ড পাওয়া যায়নি।',
  'settings.costDashboard.when': 'কখন',
  'settings.costDashboard.category': 'বিভাগ',
  'settings.costDashboard.session': 'সেশন',
  'settings.costDashboard.noDataHint': 'এর ফলে, আপনার সঙ্গে যোগাযোগ করুন ।',
  'settings.search.title': 'সার্চ ইঞ্জিন',
  'settings.search.menuDesc':
    'Xqx1q1x - নিজ হাতে অনুসন্ধান অথবা তার নিজের উপলব্ধকারীর সাথে যোগাযোগ স্থাপন করুন। Xqxqxkey কী- র সাথে একযোগে কাজ করার জন্য',
  'settings.search.description':
    'এজেন্ট যে সার্চ ইঞ্জিন ব্যবহার করে তা বেছে নিন, অথবা সার্চ টুলগুলো সম্পূর্ণভাবে নিষ্ক্রিয় করুন। Managed OpenHuman-এর ব্যাকএন্ড ব্যবহার করে (কোনো সেটআপ নেই)। Parallel, Brave, Querit, এবং Exa আপনার API কী ব্যবহার করে সরাসরি আপনার মেশিন থেকে চলে।',
  'settings.search.engineAria': 'সার্চ ইঞ্জিন',
  'settings.search.engineDisabledLabel': 'Disabled',
  'settings.search.engineDisabledDesc':
    'এজেন্ট প্রেক্ষাপট এবং উপলব্ধ টুল তালিকা থেকে সার্চ টুলগুলি সরিয়ে দিন।',
  'settings.search.engineManagedLabel': 'OpenHuman পরিচালিত',
  'settings.search.engineManagedDesc':
    'ডিফল্ট। OpenHuman ব্যাক-এন্ডের মাধ্যমে রুট করা হয়, বর্তমানে Exa দ্বারা চালিত: কোনো API key প্রয়োজন নেই।',
  'settings.search.localManagedUnavailable':
    'লোকাল ব্যবহারকারীদের জন্য OpenHuman Managed সার্চ উপলভ্য নয়। ওয়েব সার্চ চালু করতে আপনার নিজের Parallel, Brave, Querit বা Exa API key যোগ করুন।',
  'settings.search.engineParallelLabel': 'Parallel',
  'settings.search.engineParallelDesc':
    'সরাসরি xqxxxxxxxxxxxxqx; অনুসন্ধান, চ্যাট, গবেষণা, সমৃদ্ধ টুল।',
  'settings.search.engineBraveLabel': 'Brave অনুসন্ধান',
  'settings.search.engineBraveDesc':
    'সরাসরি Xqx1xxxxyxxxxxqxxxxxxxxx;: ওয়েব, সংবাদ, ছবি এবং ভিডিও টুল',
  'settings.search.engineQueritLabel': 'প্রতিদ্বন্ধিতা',
  'settings.search.engineQueritDesc':
    'সরাসরি কিউআরটিএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সএক্সক্স: সাইট, টাইম সীমা, এবং ভাষা ফিল্টার।',
  'settings.search.engineExaLabel': 'Exa',
  'settings.search.engineExaDesc':
    'Exa দ্বারা চালিত নিউরাল সার্চ। আপনার নিজের Exa API key প্রয়োজন। সার্চ, সদৃশ পৃষ্ঠা খোঁজা এবং পৃষ্ঠার বিষয়বস্তু আনার টুল যোগ করে।',
  'settings.search.statusConfigured': 'কনফিগার করা',
  'settings.search.statusNeedsKey': 'API কী প্রয়োজন',
  'settings.search.fallbackToManaged':
    'কোনো কি কনফিগার করা হয়নি: অনুসন্ধান করা হবে একটি কি সংরক্ষণের পূর্বে এই কি দ্বারা নির্ধারিত হয়নি।',
  'settings.search.getApiKey': 'API কী পান',
  'settings.search.save': 'সংরক্ষণ করুন',
  'settings.search.clear': 'সাফ',
  'settings.search.show': 'দেখান',
  'settings.search.hide': 'লুকান',
  'settings.search.statusSaving': 'সংরক্ষণ করা হচ্ছে...',
  'settings.search.statusSaved': 'সংরক্ষিত।',
  'settings.search.statusError': 'ব্যর্থ হয়েছে',
  'settings.search.parallelKeyLabel': 'Parallel API কী',
  'settings.search.braveKeyLabel': 'Brave অনুসন্ধান API কী',
  'settings.search.queritKeyLabel': 'কিউ- টি xxqx কি',
  'settings.search.exaKeyLabel': 'Exa API কী',
  'settings.search.placeholderStored': '•••••••• (সংরক্ষিত)',
  'settings.search.placeholderParallel': 'pk_...',
  'settings.search.placeholderBrave': 'BSA...',
  'settings.search.placeholderQuerit': 'কিউ- টি xxqx কি',
  'settings.search.placeholderExa': 'আপনার Exa API কী পেস্ট করুন…',
  'settings.search.allowedSitesLabel': 'ওয়েবসাইটের অনুমতি দেওয়া হয়েছে',
  'settings.search.allowedSitesHint':
    'যেসব হোস্ট অ্যাসিস্ট্যান্ট খুলতে ও পড়তে পারবে (ওয়েব ফেচ এবং ব্রাউজার টুলের মাধ্যমে) প্রতি লাইনে একটি করে, যেমন reuters.com। একটি হোস্ট তার সাবডোমেইনগুলোও অন্তর্ভুক্ত করে। ওয়েব সার্চ নিজে এই তালিকা দ্বারা সীমাবদ্ধ নয়।',
  'settings.search.allowedSitesAllOn':
    'সহকারীটি যেকোন পাবলিক ওয়েবসাইট খুলতে পারে। স্থানীয় এবং ব্যক্তিগত ঠিকানা প্রতিরোধ করা হয়েছে।',
  'settings.search.allowedSitesPlaceholder': 'xqx+x\nএক্স.qx1x\nxqx2x',
  'settings.search.allowedSitesSave': 'ওয়েবসাইট সংরক্ষণ করো',
  'settings.search.accessModeAria': 'ওয়েব মোড',
  'settings.search.accessAllowAll': 'সকল অনুমোদন করা হবে',
  'settings.search.accessCustom': 'স্বনির্ধারিত',
  'settings.search.accessBlockAll': 'প্রতিরোধ করো',
  'settings.search.accessBlockAllHint':
    'সকল ওয়েব প্রবেশাধিকার ব্লক করা হয়েছে- সহকারী কোন ওয়েবসাইট খুলতে বা পড়তে পারে না।',
  // ─── Settings global search bar ────────────────────────────
  'settings.settingsSearch.placeholder': 'সেটিংস খুঁজুন…',
  'settings.settingsSearch.ariaLabel': 'সেটিংস খুঁজুন',
  'settings.settingsSearch.clear': 'অনুসন্ধান সাফ করুন',
  'settings.settingsSearch.resultsLabel': 'অনুসন্ধানের ফলাফল',
  'settings.settingsSearch.noResults': '“{query}” এর জন্য কোনো সেটিং পাওয়া যায়নি',
  'settings.embeddings.title': 'এমবেডিংস',
  'settings.embeddings.description':
    'কোন এমবেডিং প্রদানকারী মেমরিকে সিমান্টিক সার্চের জন্য ভেক্টরে রূপান্তর করে তা চয়ন করুন। প্রদানকারী, মডেল বা মাত্রা পরিবর্তন করলে সংরক্ষিত ভেক্টর অবৈধ হয়ে যায় এবং সম্পূর্ণ মেমরি রিসেট প্রয়োজন।',
  'settings.embeddings.providerAria': 'এমবেডিং প্রদানকারী',
  'settings.embeddings.statusConfigured': 'কনফিগার করা হয়েছে',
  'settings.embeddings.statusNeedsKey': 'API কী প্রয়োজন',
  'settings.embeddings.requiresSignIn': 'OpenHuman-এ সাইন-ইন প্রয়োজন',
  'settings.embeddings.managedLoginRequired':
    'ম্যানেজড এমবেডিংসের জন্য OpenHuman সাইন-ইন প্রয়োজন। OpenHuman ব্যাকএন্ড ব্যবহার করতে সাইন ইন করুন।',
  'settings.embeddings.managedBannerIntro':
    'ম্যানেজড এমবেডিংস OpenHuman ব্যাকএন্ডের মাধ্যমে চলে এবং একটি OpenHuman অ্যাকাউন্ট সেশন প্রয়োজন।',
  'settings.embeddings.managedBannerLocalSession':
    'এই প্রোভাইডার ব্যবহার করতে স্থানীয় সেশন থেকে বেরিয়ে সাইন ইন করুন, অথবা স্থানীয়/নিজস্ব-কী এমবেডিং প্রোভাইডারে যান।',
  'settings.embeddings.managedBannerRemoteSession':
    'OpenHuman সেশন রিফ্রেশ করতে আবার সাইন ইন করুন, অথবা স্থানীয়/নিজস্ব-কী এমবেডিং প্রোভাইডারে যান।',
  'settings.embeddings.signInAgain': 'আবার সাইন ইন করুন',
  'settings.embeddings.apiKeyLabel': '{provider} API কী',
  'settings.embeddings.apiKeyLabelGeneric': 'API কী',
  'settings.embeddings.placeholderStored': '•••••••• (সঞ্চিত)',
  'settings.embeddings.placeholderKey': 'আপনার API কী পেস্ট করুন…',
  'settings.embeddings.keyStoredEncrypted': 'আপনার API কী এই ডিভাইসে এনক্রিপ্ট করে সংরক্ষিত আছে।',
  'settings.embeddings.show': 'দেখান',
  'settings.embeddings.hide': 'লুকান',
  'settings.embeddings.save': 'সংরক্ষণ',
  'settings.embeddings.clear': 'মুছুন',
  'settings.embeddings.model': 'মডেল',
  'settings.embeddings.dimensions': 'মাত্রা',
  'settings.embeddings.customEndpoint': 'কাস্টম এন্ডপয়েন্ট',
  'settings.embeddings.customModelPlaceholder': 'মডেলের নাম',
  'settings.embeddings.customDimsPlaceholder': 'মাত্রা',
  'settings.embeddings.applyCustom': 'প্রয়োগ',
  'settings.embeddings.testConnection': 'সংযোগ পরীক্ষা',
  'settings.embeddings.testing': 'পরীক্ষা হচ্ছে…',
  'settings.embeddings.testSuccess': 'সংযুক্ত: {dims} মাত্রা',
  'settings.embeddings.connectionTestFailed': 'পরীক্ষা ব্যর্থ হয়েছে',
  'settings.embeddings.verifyFallback':
    'এমবেডিংস এন্ডপয়েন্ট যাচাই করা যায়নি। নিশ্চিত করুন এটি চলছে এবং একটি এমবেডিং মডেল পরিবেশন করছে, তারপর আবার সংরক্ষণ করুন।',
  'settings.embeddings.testFailed': 'ব্যর্থ: {error}',
  'settings.embeddings.saving': 'সংরক্ষণ হচ্ছে…',
  'settings.embeddings.saved': 'সংরক্ষিত।',
  'settings.embeddings.errorPrefix': 'ব্যর্থ',
  'settings.embeddings.wipeTitle': 'মেমরি ভেক্টর রিসেট করবেন?',
  'settings.embeddings.wipeBody':
    'এমবেডিং প্রদানকারী, মডেল বা মাত্রা পরিবর্তন করলে সমস্ত সংরক্ষিত মেমরি ভেক্টর মুছে যাবে। পুনরুদ্ধার কাজ করার আগে মেমরি পুনর্নির্মাণ করতে হবে। এটি পূর্বাবস্থায় ফেরানো যাবে না।',
  'settings.embeddings.cancel': 'বাতিল',
  'settings.embeddings.confirmWipe': 'মুছুন এবং প্রয়োগ করুন',
  'settings.embeddings.setupTitle': '{provider} সেটআপ',
  'settings.embeddings.saveAndSwitch': 'সংরক্ষণ এবং স্যুইচ',
  'settings.embeddings.optional': 'ঐচ্ছিক',
  'settings.embeddings.vectorSearchDisabled':
    'ভেক্টর অনুসন্ধান নিষ্ক্রিয় করা হয়েছে । মনে রাখবেন যে, শুধু শব্দ ও ছাদের সঙ্গে মিল রেখে শব্দ ব্যবহার করা হবে ।',
  'settings.embeddings.clearKey': 'API কী মুছুন',
  'pages.settings.ai.embeddings': 'এমবেডিংস',
  'pages.settings.ai.embeddingsDesc': 'মেমরি পুনরুদ্ধারের জন্য ভেক্টর এনকোডিং মডেল',
  'mcp.alphaBadge': 'আলফা',
  'mcp.alphaBannerText':
    'Xqxqx সার্ভার চালু হয়েছে। স্মিথারি রেজিস্ট্রি, প্রবাহ ইনস্টল, এবং টুলগুলো হয়তো মুক্ত হওয়ার ক্ষেত্রে ভুল অবস্থা অথবা পরিবর্তন করতে পারে ।',
  'mcp.toolList.noTools': 'কোনো টুল উপলব্ধ নেই৷',
  'mcp.setup.secretDialog.title': 'MCP সেটআপ: এন্টার সিক্রেট',
  'mcp.setup.secretDialog.bodyPrefix': 'MCP সেটআপ এজেন্ট প্রয়োজন',
  'mcp.setup.secretDialog.bodySuffix':
    '। আপনার মান সরাসরি কোর প্রসেসে পাঠানো হয় এবং AI কথোপকথনে কখনো প্রবেশ করে না।',
  'mcp.setup.secretDialog.inputLabel': 'মান',
  'mcp.setup.secretDialog.inputPlaceholder': 'এখানে আটকে দিন',
  'mcp.setup.secretDialog.show': 'দেখান',
  'mcp.setup.secretDialog.hide': 'লুকান',
  'mcp.setup.secretDialog.submit': 'জমা দিন',
  'mcp.setup.secretDialog.cancel': 'বাতিল',
  'mcp.setup.secretDialog.submitting': 'জমা দেওয়া হচ্ছে',
  'mcp.setup.secretDialog.errorPrefix': '18_18 জমা দিতে ব্যর্থ হয়েছে:',
  'mcp.setup.secretDialog.privacyNote':
    'স্থানীয় xqxqx গোপন টেবিলের মধ্যে সংরক্ষণ করা হয়েছে। কোনো অস্বীকৃত অথবা কোনো মডেল পাঠানো হয়নি।',
  'devices.betaBadge': 'বিটা',
  'devices.betaText':
    'এই ফিচারটি এখন বেটায় আছে। iOS ফোনকে রিমোট ক্লায়েন্ট হিসেবে ব্যবহার করতে এই OpenHuman-এর সাথে পেয়ার করুন।',
  'devices.comingSoonDescription':
    'ডিভাইস পেয়ারিং শীঘ্রই আসছে। এই পেজে iPhone পেয়ারিং এবং সংযুক্ত ডিভাইস ম্যানেজ করা যাবে।',
  'devices.title': 'ডিভাইস',
  'devices.pairIphone': 'পেয়ার iPhone',
  'devices.noPaired': 'কোনো পেয়ার করা ডিভাইস নেই',
  'devices.emptyState': 'এই OpenHuman সেশনে সংযোগ করতে আপনার iPhone এ একটি QR code স্ক্যান করুন।',
  'devices.devicePairedTitle': 'ডিভাইস পেয়ার করা',
  'devices.devicePairedMessage': 'iPhone সফলভাবে সংযুক্ত হয়েছে৷',
  'devices.deviceRevokedTitle': 'ডিভাইস প্রত্যাহার করা হয়েছে',
  'devices.deviceRevokedMessage': '{label} সরানো হয়েছে৷',
  'devices.revokeFailedTitle': 'প্রত্যাহার করা ব্যর্থ হয়েছে',
  'devices.online': 'অনলাইন',
  'devices.offline': 'অফলাইন',
  'devices.lastSeenNever': 'কখনোই',
  'devices.lastSeenNow': 'এইমাত্র',
  'devices.lastSeenMinutes': '{count}মিনিট আগে',
  'devices.lastSeenHours': '{count}ঘণ্টা আগে',
  'devices.lastSeenDays': '{count}দিন আগে',
  'devices.revoke': 'প্রত্যাহার করুন',
  'devices.revokeAria': 'প্রত্যাহার করুন {label}',
  'devices.confirmRevokeTitle': 'ডিভাইস প্রত্যাহার করবেন?',
  'devices.confirmRevokeBody': '{label} আর সংযোগ করতে পারবে না। এটি পূর্বাবস্থায় ফেরানো যাবে না।',
  'devices.loadFailed': 'ডিভাইসগুলি লোড করতে ব্যর্থ হয়েছে: {message}',
  'devices.pairModal.title': 'পেয়ার iPhone',
  'devices.pairModal.loading': 'পেয়ারিং কোড তৈরি করা হচ্ছে...',
  'devices.pairModal.instructions':
    'আপনার iPhone-এ OpenHuman অ্যাপ খুলুন এবং এই কোডটি স্ক্যান করুন।',
  'devices.pairModal.expiresIn': 'কোডের মেয়াদ ~{count} মিনিটে শেষ হবে',
  'devices.pairModal.expiresInPlural': 'কোডের মেয়াদ ~{count} মিনিটে শেষ হবে',
  'devices.pairModal.showDetails': 'বিবরণ দেখান',
  'devices.pairModal.hideDetails': 'বিবরণ লুকান',
  'devices.pairModal.channelId': 'চ্যানেল আইডি',
  'devices.pairModal.pairingUrl': 'পেয়ারিং URL',
  'devices.pairModal.expiredTitle': 'QR code মেয়াদ শেষ হয়ে গেছে',
  'devices.pairModal.expiredBody': 'পেয়ার করা চালিয়ে যেতে একটি নতুন কোড তৈরি করুন৷',
  'devices.pairModal.generateNewCode': 'নতুন কোড তৈরি করুন',
  'devices.pairModal.successTitle': 'iPhone এর সাথে পেয়ার করা',
  'devices.pairModal.autoClose': 'স্বয়ংক্রিয়ভাবে বন্ধ হচ্ছে...',
  'devices.pairModal.errorPrefix': 'পেয়ারিং তৈরি করতে ব্যর্থ হয়েছে: {message}',
  'devices.pairModal.errorTitle': 'কিছু ভুল হয়েছে',
  'devices.pairModal.copyUrl': 'অনুলিপি',
  'mcp.catalog.searchAria': 'MCP সার্ভার ক্যাটালগ অনুসন্ধান',
  'mcp.catalog.searchPlaceholder': 'MCP সার্ভার অনুসন্ধান করুন...',
  'mcp.catalog.loadFailed': 'ক্যাটালগ করতে ব্যর্থ হয়েছে',
  'mcp.registry.error.notFound':
    'রেজিস্ট্রিতে সার্ভারটি পাওয়া যায়নি। সার্ভারের নাম পরীক্ষা করে আবার চেষ্টা করুন, উপলব্ধ MCP সার্ভার ব্রাউজ করুন, অথবা URL দিয়ে সার্ভারটি ম্যানুয়ালি যোগ করুন।',
  'mcp.registry.error.network':
    'MCP রেজিস্ট্রিতে পৌঁছানো যায়নি। আপনার সংযোগ পরীক্ষা করে আবার চেষ্টা করুন, অথবা URL দিয়ে সার্ভারটি ম্যানুয়ালি যোগ করুন।',
  'mcp.registry.error.unavailable':
    'MCP রেজিস্ট্রি এখন উপলব্ধ নয়। পরে আবার চেষ্টা করুন, উপলব্ধ MCP সার্ভার ব্রাউজ করুন, অথবা URL দিয়ে সার্ভারটি ম্যানুয়ালি যোগ করুন।',
  'mcp.catalog.noResults': 'কোনো সার্ভার পাওয়া যায়নি।',
  'mcp.catalog.noResultsFor': '"{query}" এর জন্য কোনো সার্ভার পাওয়া যায়নি।',
  'mcp.catalog.loadMore': 'আরও লোড করুন',
  'mcp.configAssistant.title': 'কনফিগারেশন সহকারী',
  'mcp.configAssistant.empty': 'কনফিগারেশন জানার জন্য, বিবিধ বৈশিষ্ট্য অথবা প্রস্তুতির প্রয়োজন।',
  'mcp.configAssistant.autoPromptCta': 'ধাপে ধাপে সেটআপ সহায়তা নিন',
  'mcp.configAssistant.suggestedValues': 'প্রস্তাবিত মান:',
  'mcp.configAssistant.valueHidden': '(মান লুকানো)',
  'mcp.configAssistant.applySuggested': 'প্রস্তাবিত মান প্রয়োগ করুন',
  'mcp.configAssistant.reinstallHint': 'এই মানগুলি প্রয়োগ করতে পুনরায় ইনস্টল করুন।',
  'mcp.configAssistant.thinking': 'ভাবছি...',
  'mcp.configAssistant.inputPlaceholder':
    'একটি প্রশ্ন জিজ্ঞাসা করা হবে (আমি যদি এর জন্য জিজ্ঞাসা করি)',
  'mcp.configAssistant.send': 'পাঠান',
  'mcp.configAssistant.failedResponse': 'প্রতিক্রিয়া পেতে ব্যর্থ',
  'mcp.toolList.availableSingular': '{count} টুল উপলব্ধ',
  'mcp.toolList.availablePlural': '{count} টুল উপলব্ধ',
  'mcp.toolList.tryTool': 'চেষ্টা করুন',
  'mcp.toolList.tryToolAria': 'xqxqx এর জন্য সঞ্চালনযোগ্য খেলার নাম',
  'mcp.playground.title': 'xqxqx চালান',
  'mcp.playground.close': 'খেলা বন্ধ করুন',
  'mcp.playground.inputSchema': 'ইনপুট স্কিমা',
  'mcp.playground.argsLabel': 'আর্গুমেন্ট',
  'mcp.playground.argsHelp':
    'ইনপুট স্কিমার ক্ষেত্রে xqxqx প্রয়োগ করা হবে। ফাঁকা ইনপুট পদ্ধতি {} অনুযায়ী চিহ্নিত।',
  'mcp.playground.runShortcut': 'CD/Ctrl+S কমান্ড সঞ্চালন করুন',
  'mcp.playground.format': 'বিন্যাস',
  'mcp.playground.invalidJson': 'অবৈধ xqxqx',
  'mcp.playground.run': 'সরঞ্জাম সঞ্চালন',
  'mcp.playground.running': 'চলমান...',
  'mcp.playground.result': 'ফলাফল',
  'mcp.playground.resultError': 'একটি ত্রুটি দেখা দিয়েছে',
  'mcp.playground.copyResult': 'ফলাফল অনুলিপি করুন',
  'mcp.playground.copied': 'প্রতিলিপি',
  'mcp.playground.history': 'ব্রাউজ-ইতিহাস',
  'mcp.playground.historyEmpty': 'এই সেশন- এ এখনো কোন অনুরোধ নয়।',
  'mcp.playground.historyLoad': 'ভার',
  'mcp.playground.unexpectedError': 'পরিসেবার অজানা ত্রুটি।',
  'mcp.catalog.deployed': 'স্থাপন করা হয়েছে',
  'mcp.catalog.installCount': '{count} ইনস্টল করা হয়েছে',
  'app.update.dismissNotification': 'আপডেট বাতিল করা হয়নি',
  'bootCheck.rpcAuthSuffix': 'প্রতি RPC এ।',
  'app.localAiDownload.expandAria': 'ডাউনলোডের অগ্রগতি প্রসারিত করুন',
  'app.localAiDownload.collapseAria': 'ডাউনলোডের অগ্রগতি আড়াল করুন',
  'app.localAiDownload.dismissAria': 'ডাউনলোড বিজ্ঞপ্তি খারিজ করুন',
  'mobile.nav.ariaLabel': 'মোবাইল নেভিগেশন',
  'progress.stepsAria': 'অগ্রগতির ধাপ',
  'progress.stepAria': 'ধাপ {total} এর {current}',
  'workspace.vaultsTitle': 'নলেজ ভল্ট',
  'workspace.vaultsDesc':
    'একটি স্থানীয় ফোল্ডারে পয়েন্ট করুন; ফাইলগুলিকে টুকরো টুকরো করে মেমরিতে মিরর করা হয়।',
  'calls.title': 'কল',
  'calls.comingSoonBody': 'AI-সহায়তা কলগুলি শীঘ্রই আসছে৷ সাথে থাকুন।',
  'art.rotatingTetrahedronAria': 'ইনভার্টেড টেট্রাহেড্রন মহাকাশযান ঘোরানো',
  'mcp.installed.title': 'ইনস্টল করা হয়েছে',
  'mcp.installed.browseCatalog': 'ক্যাটালগ ব্রাউজ করুন',
  'mcp.installed.empty': 'এখনো কোনো MCP সার্ভার ইনস্টল করা হয়নি।',
  'mcp.installed.toolSingular': '{count} টুল',
  'mcp.installed.toolPlural': '{count} টুল',
  'mcp.health.title': 'স্বাস্থ্য',
  'mcp.health.summaryAria': 'Xqxqx সংযোগের সংক্ষিপ্ত বিবরণ',
  'mcp.health.connectedCount': 'xqxqx সংযুক্ত করা হয়েছে',
  'mcp.health.connectingCount': 'এক্সqxqx সংযোগ ব্যবস্থা',
  'mcp.health.errorCount': 'Xqx+x সংক্রান্ত ত্রুটি',
  'mcp.health.disconnectedCount': 'xqxqx উজ্জ্বলতা%a',
  'mcp.health.retryAll': 'সর্বধরনের ছবি',
  'mcp.health.retryAllAria': 'সকল Xqxqx সংক্রান্ত ত্রুটি Xqx সার্ভার পুনরায় চেষ্টা করুন',
  'mcp.health.disconnectAll': 'সকল বিচ্ছিন্ন করুন (qxick)',
  'mcp.health.disconnectAllAria': 'সব xqxqx সংযুক্ত করা হবে',
  'mcp.health.disconnectConfirm.title': 'সকল xqxqx সার্ভার বন্ধ করা হবে কি?',
  'mcp.health.disconnectConfirm.body':
    'এটা xqxqx- এর সংযোগ বিচ্ছিন্ন করা হবে বর্তমানে xqx1x সার্ভার। ইনস্টল করা কনফিগারেশন ও গোপনীয়তাগুলি সংরক্ষিত হবে; কোনো সার্ভার দ্বারা পুনরায় সংযোগ করা যাবে ।',
  'mcp.health.disconnectConfirm.cancel': 'বাতিল',
  'mcp.health.disconnectConfirm.confirm': 'সকল বিচ্ছিন্ন করুন',
  'mcp.health.opErrorGeneric': 'বুস্টার অপারেশন ব্যর্থ হয়েছে। লগ দেখুন।',
  'mcp.health.bulkPartialFailure': 'xqx1x সার্ভার দ্বারা xqxqx কনফিগারেশন ব্যর্থ হয়েছে। লগ দেখুন।',
  'mcp.installed.search.landmarkAria': 'xqx সার্ভার ইনস্টল করা হয়েছে',
  'mcp.installed.search.inputAria': 'নাম দ্বারা xqxqx সার্ভার ইনস্টল করা হয়েছে',
  'mcp.installed.search.placeholder': 'ফিল্টার সার্ভার...',
  'mcp.installed.search.clearAria': 'ফিল্টার মুছে ফেলুন',
  'mcp.installed.search.countMatches': 'xqx1x সার্ভার',
  'mcp.installed.search.noMatches': 'কোনো সার্ভারের সাথে " xqxqx" মিল পাওয়া যায়নি।',
  'mcp.inventory.openButton': 'আরম্ভ',
  'mcp.inventory.openAria': 'Sharpicizxqx প্যানেল খুলুন',
  'mcp.inventory.title': 'যোজিত xxqxyxridgyrary',
  'mcp.inventory.subtitle':
    'আপনার ইনস্টলxqxqx সার্ভারকে বহনযোগ্য, গোপনীয়-পত্র হিসেবে, অথবা একটি দল থেকে ইম্পোর্ট করুন। গোপনীয় পাওয়ার মান কখনো অন্তর্ভুক্ত করা হয়নি অথবা ইম্পোর্ট করা হয়নি।',
  'mcp.inventory.close': 'প্যানেল বন্ধ করো',
  'mcp.inventory.tablistAria': '[ পাদটীকা]',
  'mcp.inventory.tab.export': 'এক্সপোর্ট করুন',
  'mcp.inventory.tab.import': 'ইম্পোর্ট',
  'mcp.inventory.export.empty':
    'কোনো xqxqx সার্ভার এখনো ইনস্টল করা হয়নি - এক্সপোর্ট করার জন্য কিছু উপস্থিত নেই। ক্যাটালগ থেকে প্রথমে একটি ইনস্টল করুন ।',
  'mcp.inventory.export.privacyTitle': '( ১ করি.',
  'mcp.inventory.export.privacyBody':
    'সার্ভার, যোগ্যতাসম্পন্ন নাম, নাম, নাম, envoxqxqxX1xkxyx, এবং নেস্টেড। গোপনীয় মূল্যবোধ, আপনার মেশিন চিহ্ন, এবং প্রতি মুদ্রণের সময় ইচ্ছে করে ফাঁস হয়ে গেছে।',
  'mcp.inventory.export.serverCount': 'এই প্রদর্শনীতে xqxqx সার্ভার',
  'mcp.inventory.export.copy': 'কপি করুন',
  'mcp.inventory.export.copied': 'প্রতিলিপি',
  'mcp.inventory.export.copyAria': 'প্রদর্শন ( প)',
  'mcp.inventory.export.download': 'ডাউনলোড করা হয়েছে',
  'mcp.inventory.export.downloadAria': 'Xqxqx ফাইল হিসেবে প্রদর্শন করুন',
  'mcp.inventory.import.trustTitle': 'ফাঁকা xqxqx সহযোগে এক্সপোর্ট করা হয়েছে',
  'mcp.inventory.import.trustBody':
    'আপনার প্রতিনিধি নিয়োগকারী একটি Xqxqx সার্ভার। শুধুমাত্র আপনার কাছ থেকে প্রাপ্ত. xq1x1qx এড়িয়ে চলুন। প্রতিটি ইনস্টলের জন্য আপনার স্পষ্ট ক্লিক আবশ্যক; কোনো কিছুই স্বয়ংক্রিয় ইনস্টল করা হয়নি ।',
  'mcp.inventory.import.pasteLabel': 'প্রদর্শন মুছে ফেলুন xqxqx',
  'mcp.inventory.import.pastePlaceholder':
    'এখানে একটি প্রকাশ করুন, অথবা নীচে একটি ফাইল আপলোড করুন ।',
  'mcp.inventory.import.preview': 'প্রাকদর্শন',
  'mcp.inventory.import.clear': 'মুছে ফেলুন',
  'mcp.inventory.import.uploadFile': 'অথবা ফাইল আপলোড অথবা আপলোড করুন',
  'mcp.inventory.import.uploadFileAria': 'একটি ফাইল আপলোড করুন',
  'mcp.inventory.import.fileTooLarge': 'ফাইল অত্যাধিক বড় (২ গিবিবাইটের বেশি)। লোড করতে মানা করছে।',
  'mcp.inventory.import.fileReadFailed': 'ফাইল পড়তে ব্যর্থ।',
  'mcp.inventory.import.parseErrorPrefix': 'বার্তা পার্স করতে ব্যর্থ',
  'mcp.inventory.import.previewHeading': 'প্রাকদর্শন',
  'mcp.inventory.import.previewCounts':
    'xqxqx সার্ভার - xx1x1 নতুন, xxqx কনফিগার করা হয়েছে, xxx2x',
  'mcp.inventory.import.previewEmpty': 'সার্ভারে কোনো সার্ভার উপস্থিত নেই।',
  'mcp.inventory.import.exportedFrom': 'xqxqx থেকে এক্সপোর্ট করা হয়েছে',
  'mcp.inventory.import.exportedAt': 'কে. ডি. ই. ২ ঠিকানা- তালিকা আমদানি করো',
  'mcp.inventory.import.statusNew': 'নতুন',
  'mcp.inventory.import.statusAlreadyInstalled': 'পূর্বেই ইনস্টল করা হয়েছে',
  'mcp.inventory.import.envKeysLabel': 'কী',
  'mcp.inventory.import.install': 'ইনস্টল করুন',
  'mcp.inventory.import.installAria': 'এই প্রদর্শন থেকে xqxqx ইনস্টল করুন',
  'mcp.inventory.import.skipped': 'এড়িয়ে যাও',
  'mcp.inventory.parseError.empty': 'সব ঠিক আছে.',
  'mcp.inventory.parseError.invalidJson': 'অবৈধ xqxqxy',
  'mcp.inventory.parseError.rootNotObject': 'প্রাথমিক পর্যায়ে xqxqx অবজেক্ট হতে হবে।',
  'mcp.inventory.parseError.unsupportedSchema': 'অসমর্থিত স্কিমা এই ফাইল ধারণ করেছিল ।',
  'mcp.inventory.parseError.missingExportedAt': 'অবৈধ অথবা xqxqx ফিল্ড।',
  'mcp.inventory.parseError.missingExportedBy': 'অবৈধ অথবা xqxqx ফিল্ড।',
  'mcp.inventory.parseError.invalidServers': 'অনুপস্থিত অথবা অবৈধ xxqxqx অ্যারে।',
  'mcp.inventory.parseError.serverNotObject': 'একটি সার্ভার এন্ট্রি কোন বস্তু নয়।',
  'mcp.inventory.parseError.serverMissingQualifiedName': 'কোনো সার্ভার এন্ট্রি সনাক্ত করা যায়নি।',
  'mcp.inventory.parseError.serverMissingDisplayName':
    'কোনো সার্ভার এন্ট্রির নাম উল্লেখ করা হয়নি।',
  'mcp.inventory.parseError.serverEnvKeysNotArray':
    'সার্ভারের এনট্রির মধ্যে একটি বিচ্ছিন্ন PGP-কি ক্ষেত্রের মধ্যে উপস্থিত রয়েছে। পরিত্যাগ করা হলে এই মান উপেক্ষা করা হবে না।',
  'mcp.inventory.parseError.serverContainsEnv':
    'একটি সার্ভারের এনট্রিতে একটি Xqxqxqx এর মান রয়েছে। আমদানি করতে অস্বীকার করে: প্রকাশ করা অবশ্যই কেবল ই-মেইল (নাম) বহন করতে হবে, কোন গোপন মূল্যবোধ নয় ।',
  'mcp.inventory.parseError.duplicateQualifiedName':
    'অফ-লাইন অবস্থায় উপস্থিত সর্বোচ্চ সংখ্যা: ( n) প্রতিটি সার্ভারের মধ্যে সবচেয়ে বেশি উপস্থিত থাকা আবশ্যক ।',
  'mcp.tab.loading': 'MCP সার্ভার লোড হচ্ছে...',
  'mcp.tab.emptyDetail': 'একটি সার্ভার বা সারি নির্বাচন করুন।',
  'mcp.tab.filter.all': 'সব',
  'mcp.tab.filter.installed': 'ইনস্টল করা ({count})',
  'mcp.tab.filter.registry': 'রেজিস্ট্রি',
  'mcp.tab.column.name': 'নাম',
  'mcp.tab.column.description': 'বিবরণ',
  'mcp.tab.column.type': 'ধরন',
  'mcp.tab.column.author': 'লেখক',
  'mcp.tab.column.action': 'ক্রিয়া',
  'mcp.tab.transport.hosted': 'হোস্টেড',
  'mcp.tab.transport.local': 'Stdio',
  'mcp.tab.transportFilter.label': 'ধরন',
  'mcp.tab.transportFilter.aria': 'ট্রান্সপোর্ট অনুযায়ী সার্ভার ফিল্টার করুন',
  'mcp.tab.link.website': 'ওয়েবসাইট',
  'mcp.tab.link.repo': 'রিপোজিটরি',
  'mcp.tab.transport.hostedHint':
    'একটি দূরবর্তী সার্ভারে চলে: ইনস্টলের সময় সাইন-ইন বা টোকেন সেট করা হয়',
  'mcp.tab.transport.localHint': 'আপনার ডিভাইসে চলে: ইনস্টলের সময় টোকেন লাগতে পারে',
  'mcp.tab.officialBadge': 'অফিশিয়াল',
  'mcp.tab.officialHint': 'বিক্রেতার অফিশিয়াল সার্ভার',
  'mcp.tab.badge.installed': 'ইনস্টল করা',
  'mcp.tab.badge.registry': 'রেজিস্ট্রি',
  'mcp.tab.action.manage': 'পরিচালনা',
  'mcp.tab.aria.viewDetails': '{name} এর বিবরণ দেখুন',
  'mcp.tab.aria.installServer': '{name} ইনস্টল করুন',
  'mcp.install.loadingDetail': 'সার্ভারের বিবরণ লোড হচ্ছে...',
  'mcp.install.back': 'ফিরে যান',
  'mcp.install.title': '{name} ইনস্টল করুন',
  'mcp.install.requiredEnv': 'প্রয়োজনীয় পরিবেশ ভেরিয়েবল',
  'mcp.install.enterValue': 'লিখুন {key}',
  'mcp.install.show': 'দেখান',
  'mcp.install.hide': 'লুকান',
  'mcp.install.configLabel': 'কনফিগ (ঐচ্ছিক JSON)',
  'mcp.install.configPlaceholder': '{"key": "value"}',
  'mcp.install.missingRequired': '"{key}" প্রয়োজন',
  'mcp.install.invalidJson': 'কনফিগ JSON বৈধ নয় JSON',
  'mcp.install.failedDetail': 'সার্ভারের বিবরণ লোড করতে ব্যর্থ',
  'mcp.install.failedInstall': 'ইনস্টল ব্যর্থ হয়েছে',
  'mcp.install.button': 'ইনস্টল করুন',
  'mcp.install.installing': 'ইনস্টল করা হচ্ছে...',
  'mcp.install.by': 'দ্বারা',
  'mcp.install.useCount': '{count} ইনস্টলেশন',
  'mcp.install.connections': 'উপলব্ধ সংযোগ',
  'mcp.install.published': 'প্রকাশিত',
  'mcp.install.configureAndInstall': 'কনফিগার করুন ও ইনস্টল করুন',
  'mcp.install.configureTitle': '{name} কনফিগার করুন',
  'mcp.install.advancedConfig': 'উন্নত কনফিগারেশন',
  'mcp.detail.suggestedEnvReady': 'প্রস্তাবিত পরিবেশ মান প্রস্তুত',
  'mcp.detail.suggestedEnvBody':
    'এই সার্ভারে-ইনস্টল করার জন্য পরামর্শ দেওয়া হল: xqxq0x ব্যবহার করুন',
  'mcp.detail.connect': 'সংযোগ করুন',
  'mcp.detail.connecting': 'সংযুক্ত হচ্ছে...',
  'mcp.detail.authenticate': 'সাইন ইন করুন',
  'mcp.detail.authRequired':
    'এই সার্ভারটি সংযোগ করার আগে আপনাকে সাইন ইন করতে বা একটি অ্যাক্সেস টোকেন যোগ করতে হবে। প্রমাণীকরণ করতে “সাইন ইন করুন”-এ ক্লিক করুন।',
  'mcp.detail.disconnect': 'সংযোগ বিচ্ছিন্ন করুন',
  'mcp.detail.hideAssistant': 'সহকারী লুকান',
  'mcp.detail.helpConfigure': 'কনফিগার করতে আমাকে সাহায্য করুন',
  'mcp.detail.confirmUninstall': 'আনইনস্টল নিশ্চিত করবেন?',
  'mcp.detail.confirmUninstallAction': 'হ্যাঁ, আনইনস্টল করুন',
  'mcp.detail.uninstall': 'আনইনস্টল',
  'mcp.detail.envVars': 'এনভায়রনমেন্ট ভেরিয়েবল',
  'mcp.detail.reconfigure': 'পুনঃকনফিগার করুন',
  'mcp.detail.reconfigureHint':
    'প্রতিটি ভেরিয়েবলের জন্য নতুন মান লিখুন, তারপর পুনরায় সংযোগ করুন। এটি সংরক্ষিত মান প্রতিস্থাপন করে।',
  'mcp.detail.saveReconnect': 'সংরক্ষণ ও পুনঃসংযোগ',
  'mcp.detail.reconfigureSaving': 'সংরক্ষণ করা হচ্ছে…',
  'mcp.detail.reconfigureSuccess': 'এনভায়রনমেন্ট আপডেট ও পুনঃসংযোগ করা হয়েছে।',
  'mcp.detail.reconfigureReconnectFailed':
    'সংরক্ষিত হয়েছে, তবে নতুন মান দিয়ে পুনঃসংযোগ ব্যর্থ হয়েছে।',
  'mcp.detail.enable': 'সক্রিয় করুন',
  'mcp.detail.disable': 'নিষ্ক্রিয় করুন',
  'mcp.status.disabled': 'নিষ্ক্রিয়',
  'mcp.status.unauthorized': 'সাইন ইন প্রয়োজন',
  'mcp.detail.tools': 'টুলস',
  'mcp.connectAuth.title': '{name} সংযুক্ত করুন',
  'mcp.connectAuth.hint':
    'এই সার্ভারের প্রয়োজনীয় যেকোনো প্রমাণীকরণ যোগ করুন, তারপর সংযুক্ত করুন। টোকেনগুলি এনক্রিপ্ট করে সংরক্ষণ করা হয়। যেসব সার্ভারে প্রমাণীকরণ লাগে না সেগুলির জন্য খালি রাখুন।',
  'mcp.connectAuth.requiredLabel': 'আবশ্যক',
  'mcp.connectAuth.customHeadersLabel': 'কাস্টম হেডার',
  'mcp.connectAuth.customHeadersEmpty':
    'কোনো কাস্টম হেডার নেই। রেজিস্ট্রি ঘোষণা করেনি এমন কোনো প্রমাণীকরণ হেডার এই সার্ভারের প্রয়োজন হলে একটি যোগ করুন।',
  'mcp.connectAuth.addHeader': '+ হেডার যোগ করুন',
  'mcp.connectAuth.headerName': 'হেডারের নাম',
  'mcp.connectAuth.headerValue': 'মান',
  'mcp.connectAuth.removeHeader': 'হেডার সরান',
  'mcp.connectAuth.howToGetToken': 'সহায়তা ও কনফিগার করুন',
  'mcp.connectAuth.tokenProvider': 'টোকেন নিন:',
  'mcp.connectAuth.findToken': 'টোকেন কোথায় পাব?',
  'mcp.connectAuth.hideHelp': 'সহায়তা লুকান',
  'mcp.connectAuth.schemeLabel': 'মানটি কীভাবে পাঠানো হবে',
  'mcp.connectAuth.schemeBearer': 'Bearer',
  'mcp.connectAuth.schemeRaw': 'কোনোটি নয়',
  'mcp.connectAuth.reconnectFailed': 'শংসাপত্র সংরক্ষণ করা হয়েছে, কিন্তু সংযোগ ব্যর্থ হয়েছে।',
  'mcp.connectAuth.oauthHint':
    'এই সার্ভারটি OAuth ব্যবহার করে। OpenHuman-কে অনুমোদন দিতে আপনার ব্রাউজারের মাধ্যমে সাইন ইন করুন।',
  'mcp.connectAuth.signIn': 'ব্রাউজার দিয়ে সাইন ইন করুন',
  'mcp.connectAuth.oauthWaiting': 'সাইন-ইনের জন্য অপেক্ষা করা হচ্ছে…',
  'mcp.connectAuth.oauthOrToken':
    'ইতিমধ্যে একটি অ্যাক্সেস টোকেন আছে? এর পরিবর্তে নিচে Authorization হেডার হিসেবে পেস্ট করুন।',
  'mcp.connectAuth.oauthTimeout':
    'ব্রাউজার সাইন-ইনের জন্য অপেক্ষার সময় শেষ হয়েছে। আবার চেষ্টা করুন।',
  'mcp.connectAuth.authError.oauthRequired':
    'এই সার্ভারটি OAuth ব্যবহার করে। “ব্রাউজার দিয়ে সাইন ইন করুন” ব্যবহার করুন: পেস্ট করা টোকেন গ্রহণ করা হবে না।',
  'mcp.connectAuth.authError.tokenRejected':
    'সার্ভার এই টোকেনটি প্রত্যাখ্যান করেছে। এটি সঠিক এবং এর মেয়াদ শেষ হয়নি তা যাচাই করুন।',
  'mcp.connectAuth.authError.credentialRequired':
    'এই সার্ভারের জন্য প্রমাণীকরণ প্রয়োজন। একটি টোকেন যোগ করুন, অথবা সাইন ইন করুন।',
  'onboarding.skipForNow': 'এখনই এড়িয়ে যান',
  'onboarding.localAI.continueWithCloud': 'ক্লাউডের সাথে চালিয়ে যান',
  'onboarding.localAI.useLocalAnyway':
    'যাইহোক স্থানীয় AI ব্যবহার করুন (আপনার ডিভাইসের জন্য প্রস্তাবিত নয়)',
  'onboarding.localAI.useLocalInstead':
    'পরিবর্তে স্থানীয় AI ব্যবহার করুন (এখনই Ollama সংযোগ করুন)',
  'onboarding.localAI.setupIssue': 'স্থানীয় AI সেটআপ একটি সমস্যার সম্মুখীন হয়েছে',
  'autonomy.title': 'এজেন্ট স্বায়ত্তশাসন',
  'autonomy.maxActionsLabel': 'প্রতি ঘণ্টায় সর্বাধিক অ্যাকশন',
  'autonomy.maxActionsHelp':
    'একজন এজেন্ট প্রতি ঘণ্টায় সর্বোচ্চ কতটি টুল অ্যাকশন চালাতে পারবে। নতুন মান আপনার পরবর্তী চ্যাটে প্রযোজ্য হবে। Cron জব এবং চ্যানেল লিসেনার OpenHuman পুনরায় চালু না করা পর্যন্ত বর্তমান সীমা বজায় রাখবে।',
  'autonomy.statusSaving': 'সংরক্ষণ করা হচ্ছে...',
  'autonomy.statusSaved': 'সংরক্ষিত।',
  'autonomy.statusFailed': 'ব্যর্থ হয়েছে',
  'autonomy.unlimitedNote': 'সীমাহীন: হার সীমিত করা অক্ষম।',
  'autonomy.invalidIntegerMsg':
    'একটি ধনাত্মক পূর্ণসংখ্যা হতে হবে (কোনো সীমা না রাখতে Unlimited প্রিসেট ব্যবহার করুন)।',
  'autonomy.presetUnlimited': 'আনলিমিটেড (ডিফল্ট)',
  'triggers.toggleFailed': '{trigger} এর জন্য {action} ব্যর্থ হয়েছে: {message}',
  'settings.ai.overview': 'AI সিস্টেম ওভারভিউ',
  'settings.ai.configStatus': 'কনফিগারেশন স্ট্যাটাস',
  'settings.ai.fallbackMode': 'ফলব্যাক মোড',
  'settings.ai.loadedFromRuntime': 'রানটাইম থেকে লোড হয়েছে',
  'settings.ai.loadingDuration': 'লোডিং সময়',
  'settings.ai.localRuntime': 'লোকাল মডেল রানটাইম',
  'settings.ai.openManager': 'ম্যানেজার খুলুন',
  'settings.ai.retryDownload': 'ডাউনলোড আবার চেষ্টা করুন',
  'settings.ai.state': 'অবস্থা',
  'settings.ai.targetModel': 'টার্গেট মডেল',
  'settings.ai.download': 'ডাউনলোড',
  'settings.ai.localModelUnavailable': 'লোকাল মডেল স্ট্যাটাস পাওয়া যাচ্ছে না।',
  'settings.ai.soulConfig': 'SOUL পার্সোনা কনফিগারেশন',
  'settings.ai.refreshing': 'রিফ্রেশ হচ্ছে...',
  'settings.ai.refreshSoul': 'SOUL রিফ্রেশ করুন',
  'settings.ai.loadingSoul': 'SOUL কনফিগারেশন লোড হচ্ছে...',
  'settings.ai.identity': 'পরিচয়',
  'settings.ai.personality': 'ব্যক্তিত্ব',
  'settings.ai.safetyRules': 'নিরাপত্তা বিধি',
  'settings.ai.source': 'উৎস',
  'settings.ai.loaded': 'লোড হয়েছে',
  'settings.ai.toolsConfig': 'TOOLS কনফিগারেশন',
  'settings.ai.refreshTools': 'TOOLS রিফ্রেশ করুন',
  'settings.ai.toolsAvailable': 'পাওয়া যাচ্ছে টুলস',
  'settings.ai.tools': 'টুলস',
  'settings.ai.activeSkills': 'সক্রিয় স্কিলস',
  'settings.ai.skills': 'স্কিলস',
  'settings.ai.skillsOverview': 'স্কিলস ওভারভিউ',
  'settings.ai.refreshingAll': 'সব রিফ্রেশ হচ্ছে...',
  'settings.ai.refreshAll': 'সব AI কনফিগারেশন রিফ্রেশ করুন',
  'settings.notifications.suppressAll': 'সব বিজ্ঞপ্তি দমন করুন',
  'settings.notifications.suppressAllDesc':
    'ফোকাস স্টেট নির্বিশেষে এম্বেডেড অ্যাপ থেকে সব OS বিজ্ঞপ্তি টোস্ট ব্লক করুন।',
  'settings.notifications.toggleDnd': 'ডু নট ডিস্টার্ব টগল করুন',
  'settings.notifications.categories': 'ক্যাটাগরি',
  'settings.notifications.categoryFooter':
    'একটি ক্যাটাগরি নিষ্ক্রিয় করলে সেই ধরনের নতুন বিজ্ঞপ্তি বিজ্ঞপ্তি কেন্দ্রে আর দেখাবে না। বিদ্যমান বিজ্ঞপ্তিগুলো পরিষ্কার না করা পর্যন্ত থাকবে।',
  'settings.billing.movedToWeb': 'বিলিং ওয়েবে সরানো হয়েছে',
  'settings.billing.openDashboard': 'বিলিং ড্যাশবোর্ড খুলুন',
  'settings.billing.movedToWebDesc':
    'সাবস্ক্রিপশন পরিবর্তন, পেমেন্ট পদ্ধতি, ক্রেডিট এবং ইনভয়েস এখন ওয়েবে TinyHumans-এ পরিচালনা করা হয়।',
  'settings.billing.backToSettings': 'সেটিংসে ফিরুন',
  'settings.billing.openingBrowser': 'ব্রাউজার খোলা হচ্ছে...',
  'settings.billing.browserNotOpen': 'ব্রাউজার না খুললে উপরের বাটন ব্যবহার করুন।',
  'settings.billing.browserOpenFailed':
    'ব্রাউজার স্বয়ংক্রিয়ভাবে খোলা যায়নি। উপরের বাটন ব্যবহার করুন।',
  'settings.tools.chooseCapabilities':
    'OpenHuman আপনার হয়ে কোন ক্যাপাবিলিটিগুলো ব্যবহার করতে পারবে তা বেছে নিন।',
  'settings.tools.saveChanges': 'পরিবর্তন সংরক্ষণ করুন',
  'settings.tools.preferencesSaved': 'পছন্দ সংরক্ষিত',
  'settings.tools.saveFailed': 'পছন্দ সংরক্ষণ ব্যর্থ। আবার চেষ্টা করুন।',
  'connections.comingSoon': 'শীঘ্রই আসছে',
  'connections.setUp': 'সেটআপ করুন',
  'connections.configured': 'কনফিগার করা হয়েছে',
  'connections.unavailable': 'পাওয়া যাচ্ছে না',
  'connections.checking': 'পরীক্ষা হচ্ছে…',
  'connections.walletConfigured':
    'আপনার রিকভারি ফ্রেজ থেকে লোকাল EVM, BTC, Solana এবং Tron পরিচয় কনফিগার করা হয়েছে।',
  'connections.walletReady':
    'একটি রিকভারি ফ্রেজ থেকে লোকাল EVM, BTC, Solana এবং Tron পরিচয় সেটআপ করুন।',
  'connections.walletError':
    'ওয়ালেট স্ট্যাটাস পরীক্ষা করা যায়নি। রিকভারি ফ্রেজ প্যানেল থেকে আবার চেষ্টা করতে ট্যাপ করুন।',
  'connections.walletChecking': 'ওয়ালেট স্ট্যাটাস পরীক্ষা হচ্ছে...',
  'connections.walletIdentities': 'ওয়ালেট পরিচয়',
  'connections.walletDerived':
    'আপনার রিকভারি ফ্রেজ থেকে লোকালি ডেরাইভ করা এবং শুধু নিরাপদ মেটাডেটা হিসেবে সংরক্ষিত।',
  'connections.privacySecurity': 'গোপনীয়তা ও নিরাপত্তা',
  'connections.privacySecurityDesc':
    'সব ডেটা ও ক্রেডেনশিয়াল জিরো-ডেটা রিটেনশন নীতি সহ লোকালে সংরক্ষিত। আপনার তথ্য এনক্রিপ্ট করা এবং তৃতীয় পক্ষের সাথে কখনো শেয়ার করা হয় না।',
  'channels.status.connecting': 'সংযোগ হচ্ছে',
  'channels.status.notConfigured': 'কনফিগার করা হয়নি',
  'channels.noActiveRoute': 'কোনো সক্রিয় রুট নেই',
  'channels.activeRoute': 'সক্রিয় রুট',
  'channels.loadingDefinitions': 'চ্যানেল ডেফিনিশন লোড হচ্ছে...',
  'channels.channelConnections': 'চ্যানেল সংযোগ',
  'channels.configureAuthModes': 'প্রতিটি মেসেজিং চ্যানেলের জন্য অথ মোড কনফিগার করুন।',
  'channels.configNotAvailable': 'কনফিগারেশন পাওয়া যাচ্ছে না',
  'channels.channel': 'চ্যানেল',
  'devOptions.coreModeNotSet': 'কোর মোড: সেট করা হয়নি',
  'devOptions.coreModeNotSetDesc':
    'বুট-চেক পিকার এখনো নিশ্চিত করা হয়নি। লোকাল বা ক্লাউড বেছে নিতে পিকারে সুইচ মোড ব্যবহার করুন।',
  'devOptions.local': 'লোকাল',
  'devOptions.embeddedCoreSidecar': 'এম্বেডেড কোর সাইডকার',
  'devOptions.sidecarSpawned': 'অ্যাপ লঞ্চে Tauri শেল দ্বারা ইন-প্রসেসে স্প্যান করা হয়েছে।',
  'devOptions.cloud': 'ক্লাউড',
  'devOptions.remoteCoreRpc': 'রিমোট কোর RPC',
  'devOptions.token': 'টোকেন',
  'devOptions.tokenNotSet': 'সেট করা হয়নি: RPC 401 দেবে',
  'devOptions.triggerSentryTest': 'Sentry পরীক্ষা ট্রিগার করুন (স্টেজিং)',
  'devOptions.triggerSentryTestDesc':
    'Sentry পাইপলাইন যাচাই করতে একটি ট্যাগড ত্রুটি পাঠায়। ইস্যু #1072: যাচাইয়ের পরে সরান।',
  'devOptions.sendTestEvent': 'পরীক্ষা ইভেন্ট পাঠান',
  'devOptions.sending': 'পাঠানো হচ্ছে…',
  'devOptions.eventSent': 'ইভেন্ট পাঠানো হয়েছে',
  'devOptions.sentryDisabled': '(কোনও আইডি নেই: এই বিল্ডে সেন্ট্রি নিষ্ক্রিয় করা হয়েছে)',
  'devOptions.failed': 'ব্যর্থ',
  'devOptions.appLogs': 'অ্যাপ লগ',
  'devOptions.appLogsDesc':
    'রোলিং ডেইলি লগ ফাইল ধারণকারী ফোল্ডার খুলুন। ইস্যু রিপোর্ট করার সময় সর্বশেষ ফাইলটি সংযুক্ত করুন।',
  'devOptions.openLogsFolder': 'লগ ফোল্ডার খুলুন',
  'mnemonic.phraseSaved': 'রিকভারি ফ্রেজ সংরক্ষিত',
  'mnemonic.walletReady': 'মাল্টি-চেইন ওয়ালেট পরিচয় প্রস্তুত। সেটিংসে ফিরছে...',
  'mnemonic.writeDownWords': 'এই',
  'mnemonic.wordsInOrder':
    'শব্দগুলো ক্রমানুসারে লিখে নিরাপদ স্থানে সংরক্ষণ করুন। এই ফ্রেজটি আপনার লোকাল এনক্রিপশন কী এবং EVM, BTC, Solana ও Tron ওয়ালেট পরিচয় সুরক্ষিত করে।',
  'mnemonic.cannotRecover':
    'এই ফ্রেজ হারালে কখনো পুনরুদ্ধার করা যাবে না এবং সম্পূর্ণ আপনার ডিভাইসে রাখা উচিত।',
  'mnemonic.copyToClipboard': 'ক্লিপবোর্ডে কপি করুন',
  'mnemonic.alreadyHavePhrase': 'আমার কাছে ইতিমধ্যে একটি রিকভারি ফ্রেজ আছে',
  'mnemonic.consentSaved':
    'আমি এই ফ্রেজটি সংরক্ষণ করেছি এবং লোকাল ওয়ালেট সেটআপের জন্য এটি ব্যবহারে সম্মতি দিচ্ছি',
  'mnemonic.enterPhraseToRestore':
    'আপনার লোকাল ওয়ালেট পরিচয় পুনরুদ্ধার করতে নিচে আপনার রিকভারি ফ্রেজ দিন, বা যেকোনো ফিল্ডে পুরো ফ্রেজ পেস্ট করুন (নতুন ব্যাকআপের জন্য ১২টি শব্দ; পুরনো ভার্সনের ২৪ শব্দের ফ্রেজও কাজ করে)।',
  'mnemonic.words': 'শব্দ',
  'mnemonic.validPhrase': 'বৈধ রিকভারি ফ্রেজ',
  'mnemonic.generateNewPhrase': 'পরিবর্তে একটি নতুন রিকভারি ফ্রেজ তৈরি করুন',
  'mnemonic.securingData': 'আপনার ডেটা সুরক্ষিত হচ্ছে...',
  'mnemonic.saveRecoveryPhrase': 'রিকভারি ফ্রেজ সংরক্ষণ করুন',
  'mnemonic.userNotLoaded':
    'ব্যবহারকারী লোড হয়নি। দয়া করে আবার সাইন ইন করুন বা পেজ রিফ্রেশ করুন।',
  'mnemonic.invalidPhrase': 'অবৈধ রিকভারি ফ্রেজ। আপনার শব্দগুলো পরীক্ষা করে আবার চেষ্টা করুন।',
  'mnemonic.somethingWentWrong': 'কিছু একটা ভুল হয়েছে। আবার চেষ্টা করুন।',
  'mnemonic.walletAlreadyConfigured': 'আপনার ওয়ালেট ইতিমধ্যে সেট আপ করা আছে।',
  'mnemonic.walletSource': 'উৎস',
  'mnemonic.walletWordCount': 'রিকভারি ফ্রেজের দৈর্ঘ্য',
  'mnemonic.walletLastUpdated': 'সর্বশেষ আপডেট',
  'mnemonic.replaceWallet': 'ওয়ালেট প্রতিস্থাপন করুন',
  'mnemonic.replaceWalletWarning':
    'এটি আপনার বর্তমান ওয়ালেটকে স্থায়ীভাবে প্রতিস্থাপন করবে। এগিয়ে যাওয়ার আগে নিশ্চিত করুন যে আপনি আপনার রিকভারি ফ্রেজ ব্যাকআপ করেছেন।',
  'mnemonic.replaceWalletConfirm': 'আমি বুঝতে পারছি, আমার ওয়ালেট প্রতিস্থাপন করুন',
  'mnemonic.loadingWalletStatus': 'ওয়ালেটের স্থিতি পরীক্ষা করা হচ্ছে...',
  'mnemonic.viewAccounts': 'ওয়ালেট অ্যাকাউন্ট',
  'mnemonic.revealRecoveryPhrase': 'পুনরুদ্ধার বাক্যাংশ প্রকাশ করুন',
  'mnemonic.hidePhrase': 'বাক্যাংশ লুকান',
  'team.failedToCreate': 'টিম তৈরি করতে ব্যর্থ',
  'team.invalidInviteCode': 'অবৈধ বা মেয়াদোত্তীর্ণ আমন্ত্রণ কোড',
  'team.failedToSwitch': 'টিম পরিবর্তন করতে ব্যর্থ',
  'team.failedToLeave': 'টিম ছাড়তে ব্যর্থ',
  'team.role.owner': 'মালিক',
  'team.role.admin': 'অ্যাডমিন',
  'team.role.billingManager': 'বিলিং ম্যানেজার',
  'team.role.member': 'সদস্য',
  'team.active': 'সক্রিয়',
  'team.personalTeam': 'ব্যক্তিগত টিম',
  'team.manageTeam': 'টিম পরিচালনা',
  'team.switching': 'পরিবর্তন হচ্ছে...',
  'team.switch': 'পরিবর্তন করুন',
  'team.leaving': 'ছেড়ে যাচ্ছে...',
  'team.leave': 'ছেড়ে যান',
  'team.yourTeams': 'আপনার টিমগুলো',
  'team.createNewTeam': 'নতুন টিম তৈরি করুন',
  'team.teamName': 'টিমের নাম',
  'team.creating': 'তৈরি হচ্ছে...',
  'team.joinExistingTeam': 'বিদ্যমান টিমে যোগ দিন',
  'team.personalAutoCreatedNote':
    'আপনার ব্যক্তিগত টিম স্বয়ংক্রিয়ভাবে তৈরি হয়। সহযোগিতার জন্য, নিচে একটি আমন্ত্রণ কোড দিয়ে বিদ্যমান টিমে যোগ দিন।',
  'team.inviteCode': 'আমন্ত্রণ কোড',
  'team.joining': 'যোগ দেওয়া হচ্ছে...',
  'team.join': 'যোগ দিন',
  'team.leaveTeam': 'টিম ছাড়ুন',
  'team.confirmLeave': 'আপনি কি ছেড়ে যেতে চান',
  'team.leaveWarning':
    'আপনি টিম এবং সব টিম রিসোর্সে অ্যাক্সেস হারাবেন। পুনরায় যোগ দিতে নতুন আমন্ত্রণ প্রয়োজন।',
  'team.management': 'টিম ম্যানেজমেন্ট',
  'team.notFound': 'টিম পাওয়া যায়নি',
  'team.accessDenied': 'অ্যাক্সেস অস্বীকৃত',
  'team.members': 'সদস্য',
  'team.membersDesc': 'দলের সদস্যদের এবং ভূমিকাগুলি পরিচালনা করুন',
  'team.invites': 'আমন্ত্রণগুলি',
  'team.invitesDesc': 'আমন্ত্রণ কোডগুলি তৈরি এবং পরিচালনা করুন',
  'team.settings': 'টিম সেটিংস',
  'team.settingsDesc': 'দলের নাম এবং সেটিংস সম্পাদনা করুন',
  'team.editSettings': 'দলের নাম লিখুন',
  'team.enterName': 'সংরক্ষণ করা হচ্ছে...',
  'team.saving': 'পরিবর্তনগুলি সংরক্ষণ করুন',
  'team.saveChanges': 'টিম মুছুন',
  'team.delete': 'টিম মুছুন',
  'team.deleteDesc': 'টিম মুছুন',
  'team.deleting': 'মুছে ফেলা হচ্ছে...',
  'team.failedToUpdate': 'টিম আপডেট করতে ব্যর্থ হয়েছে',
  'team.failedToDelete': 'দল',
  'team.manageTitle': 'ম্যানেজ করতে ব্যর্থ হয়েছে {name}',
  'team.planCreated': '{plan} পরিকল্পনা • তৈরি করা হয়েছে {date}',
  'team.confirmDelete': 'আপনি কি নিশ্চিত আপনি {name} মুছতে চান?',
  'team.deleteWarning':
    'এই ক্রিয়াটি পূর্বাবস্থায় ফেরানো যাবে না। সমস্ত দলের ডেটা স্থায়ীভাবে মুছে ফেলা হবে।',
  'voice.title': 'ভয়েস ডিক্টেশন',
  'voice.settings': 'ভয়েস সেটিংস',
  'voice.settingsDesc': 'ডিক্টেট করতে এবং সক্রিয় ফিল্ডে টেক্সট ঢোকাতে হটকি ধরে রাখুন।',
  'voice.hotkey': 'হটকি',
  'voice.activationMode': 'অ্যাক্টিভেশন মোড',
  'voice.tapToToggle': 'টগল করতে ট্যাপ করুন',
  'voice.writingStyle': 'লেখার স্টাইল',
  'voice.verbatimTranscription': 'হুবহু ট্রান্সক্রিপশন',
  'voice.naturalCleanup': 'স্বাভাবিক পরিষ্কার',
  'voice.autoStart': 'কোরের সাথে স্বয়ংক্রিয়ভাবে ভয়েস সার্ভার শুরু করুন',
  'voice.customDictionary': 'কাস্টম ডিকশনারি',
  'voice.customDictionaryDesc':
    'স্বীকৃতির নির্ভুলতা উন্নত করতে নাম, প্রযুক্তিগত শব্দ এবং ডোমেন শব্দ যোগ করুন।',
  'voice.addWord': 'একটি শব্দ যোগ করুন...',
  'voice.sttDisabled':
    'লোকাল STT মডেল ডাউনলোড ও প্রস্তুত না হওয়া পর্যন্ত ভয়েস ডিক্টেশন নিষ্ক্রিয়।',
  'voice.openLocalAiModel': 'লোকাল AI মডেল খুলুন',
  'voice.serverRestarted': 'নতুন সেটিংস সহ ভয়েস সার্ভার রিস্টার্ট হয়েছে।',
  'voice.settingsSaved': 'ভয়েস সেটিংস সংরক্ষিত।',
  'voice.serverStarted': 'ভয়েস সার্ভার শুরু হয়েছে।',
  'voice.serverStopped': 'ভয়েস সার্ভার বন্ধ হয়েছে।',
  'voice.saveVoiceSettings': 'ভয়েস সেটিংস সংরক্ষণ করুন',
  'voice.startVoiceServer': 'ভয়েস সার্ভার শুরু করুন',
  'voice.stopVoiceServer': 'ভয়েস সার্ভার বন্ধ করুন',
  'voice.debugTitle': 'ভয়েস ডিবাগ',
  'voice.failedToLoadSettings': 'ভয়েস সেটিংস লোড করতে ব্যর্থ হয়েছে',
  'voice.failedToSaveSettings': 'ভয়েস সেটিংস সংরক্ষণ করতে ব্যর্থ হয়েছে',
  'voice.failedToStartServer': 'ভয়েস সার্ভার শুরু করতে ব্যর্থ হয়েছে',
  'voice.failedToStopServer': 'ভয়েস সার্ভার বন্ধ করতে ব্যর্থ হয়েছে',
  'voice.sttDisabledPrefix':
    'স্থানীয় STT মডেল ডাউনলোড না হওয়া পর্যন্ত ভয়েস ডিকটেশন নিষ্ক্রিয়। ব্যবহার করুন',
  'voice.sttDisabledSuffix': 'বিভাগটি ব্যবহার করুন৷',
  'voice.debug.failedToLoadVoiceDebugData': 'ভয়েস ডিবাগ ডেটা লোড করতে ব্যর্থ হয়েছে',
  'voice.debug.settingsSaved': 'ডিবাগ সেটিংস সংরক্ষণ করা হয়েছে৷',
  'voice.debug.failedToSaveSettings': 'ভয়েস সেটিংস সংরক্ষণ করতে ব্যর্থ হয়েছে',
  'voice.debug.runtimeStatus': 'রানটাইম স্ট্যাটাস',
  'voice.debug.runtimeStatusDesc': 'ভয়েস সার্ভার এবং স্পিচ-টু-টেক্সট ইঞ্জিনের লাইভ ডায়াগনস্টিক।',
  'voice.debug.server': 'সার্ভার',
  'voice.debug.unavailable': 'অনুপলব্ধ',
  'voice.debug.ready': 'প্রস্তুত',
  'voice.debug.notReady': 'প্রস্তুত নয় [[I18N_SEP_92731]',
  'voice.debug.hotkey': 'P_18 কী n/a',
  'voice.debug.notAvailable': 'মোড',
  'voice.debug.mode': 'ট্রান্সক্রিপশন',
  'voice.debug.transcriptions': 'সার্ভারের ত্রুটি',
  'voice.debug.serverError': 'উন্নত সেটিংস',
  'voice.debug.advancedSettings': 'টিউ 18-193 মিটারের নিম্ন স্তরের জন্য উন্নত সেটিংস',
  'voice.debug.advancedSettingsDesc':
    'রেকর্ডিং এবং নীরবতা সনাক্তকরণের জন্য নিম্ন-স্তরের টিউনিং প্যারামিটার।',
  'voice.debug.minimumRecordingSeconds': 'ন্যূনতম রেকর্ডিং সেকেন্ড',
  'voice.debug.silenceThreshold': 'সাইলেন্স থ্রেশহোল্ড (RMS)',
  'voice.debug.silenceThresholdDesc':
    'এই মানের নিচে শক্তির রেকর্ডিংগুলি নীরবতা হিসেবে গণ্য হয় এবং এড়িয়ে যাওয়া হয়। কম মান = আরও সংবেদনশীল।',
  'voice.debug.alwaysOn': 'সবসময় শোনা',
  'voice.debug.alwaysOnDesc':
    'মাইক্রোফোন খোলা রাখুন এবং আপনি যা বলেন তা হটকি ছাড়াই স্বয়ংক্রিয়ভাবে এজেন্টের কাছে পাঠান। স্ক্রিন লক হলে থেমে যায়।',
  'voice.providers.saved': 'ভয়েস প্রদানকারী সংরক্ষিত।',
  'voice.providers.failedToSave': 'ভয়েস প্রদানকারী সংরক্ষণ করতে ব্যর্থ',
  'voice.providers.ellipsis': '…',
  'voice.providers.installing': 'ইনস্টল করা হচ্ছে',
  'voice.providers.installingBusy': 'ইনস্টল করা হচ্ছে...',
  'voice.providers.reinstallLocally': 'স্থানীয়ভাবে পুনরায় ইনস্টল করুন',
  'voice.providers.repair': 'মেরামত',
  'voice.providers.retryLocally': 'স্থানীয়ভাবে পুনরায় চেষ্টা করুন',
  'voice.providers.installLocally': 'স্থানীয়ভাবে ইনস্টল করুন',
  'voice.providers.whisperReady': 'স্থানীয়ভাবে ইনস্টল করুন [[I18N_731 প্রস্তুত]।',
  'voice.providers.whisperInstallStarted': 'হুইস্পার ইনস্টল শুরু হয়েছে৷',
  'voice.providers.queued': 'সারিবদ্ধ',
  'voice.providers.failedToInstallWhisper': 'হুইস্পার ইনস্টল করতে ব্যর্থ',
  'voice.providers.piperReady': 'পাইপার প্রস্তুত।',
  'voice.providers.piperInstallStarted': 'পাইপার ইনস্টল শুরু হয়েছে',
  'voice.providers.failedToInstallPiper': 'পাইপার ইনস্টল করতে ব্যর্থ হয়েছে',
  'voice.mode.title': 'ভয়েস মোড',
  'voice.mode.desc': 'Human ট্যাবে সহকারী কীভাবে কথা বলবে তা বেছে নিন।',
  'voice.mode.realtime': 'রিয়েলটাইম ভয়েস (বেটা)',
  'voice.mode.realtimeDesc': 'পালা করে নেওয়ার বদলে সরাসরি লাইভ কথোপকথন করুন।',
  'voice.mode.start': 'ভয়েস চ্যাট শুরু করুন',
  'voice.mode.stop': 'ভয়েস চ্যাট শেষ করুন',
  'voice.mode.connecting': 'সংযুক্ত হচ্ছে…',
  'voice.mode.listening': 'শুনছে',
  'voice.mode.speaking': 'বলছে',
  'voice.providers.title': 'ভয়েস প্রদানকারী',
  'voice.providers.desc':
    'ট্রান্সক্রিপশন এবং সিনথেসিস কোথায় চলবে তা বেছে নিন। বাইনারি এবং মডেলগুলি আপনার ওয়ার্কস্পেসে ডাউনলোড করতে Install locally বোতাম ব্যবহার করুন। ইনস্টল শেষ হওয়ার আগেই স্থানীয় প্রোভাইডার সংরক্ষণ করা যাবে: কোনো ম্যানুয়াল WHISPER_BIN বা PIPER_BIN সেটআপ প্রয়োজন নেই।',
  'voice.providers.sttProvider': 'স্পিচ-টু-টেক্সট প্রদানকারী',
  'voice.providers.sttProviderAria': 'STT প্রদানকারী',
  'voice.providers.cloudWhisperProxy': 'ক্লাউড (হুইস্পার প্রক্সি)',
  'voice.providers.localWhisper': 'স্থানীয় হুইস্পার',
  'voice.providers.installRequired': '(ইনস্টল করতে হবে)',
  'voice.providers.whisperInstalledTitle':
    'Whisper ইনস্টল করা আছে। পুনরায় ইনস্টল করতে ক্লিক করুন।',
  'voice.providers.whisperDownloadTitle':
    'whisper.cpp এবং GGML মডেল আপনার ওয়ার্কস্পেসে ডাউনলোড করুন।',
  'voice.providers.installed': 'ইনস্টল করা হয়েছে',
  'voice.providers.installFailed': 'ইনস্টল ব্যর্থ হয়েছে',
  'voice.providers.notInstalled': 'ইনস্টল করা হয়নি',
  'voice.providers.whisperModel': 'হুইস্পার মডেল',
  'voice.providers.whisperModelAria': 'হুইস্পার মডেল',
  'voice.providers.whisperModelTiny': 'ছোট (39 MB, দ্রুততম)',
  'voice.providers.whisperModelBase': 'বেস (74 MB)',
  'voice.providers.whisperModelSmall': 'ছোট (244 MB)',
  'voice.providers.whisperModelMedium': '93MB (18 MB মাঝারি, 927) সুপারিশ করা হয়েছে',
  'voice.providers.whisperModelLargeTurbo': 'বড় v3 Turbo (1.5 GB, সর্বোত্তম নির্ভুলতা)',
  'voice.providers.ttsProvider': 'টেক্সট-টু-স্পিচ প্রদানকারী',
  'voice.providers.ttsProviderAria': 'TTS প্রদানকারী',
  'voice.providers.cloudElevenLabsProxy': 'ক্লাউড (ElevenLabs proxy)',
  'voice.providers.localPiper': 'স্থানীয় পাইপার',
  'voice.providers.piperInstalledTitle': 'পাইপার ইনস্টল করা আছে। পুনরায় ইনস্টল করতে ক্লিক করুন.',
  'voice.providers.piperDownloadTitle':
    'Piper এবং বান্ডেল করা en_US-lessac-medium ভয়েস আপনার ওয়ার্কস্পেসে ডাউনলোড করুন।',
  'voice.providers.piperVoice': 'পাইপার ভয়েস',
  'voice.providers.piperVoiceAria': 'পাইপার ভয়েস',
  'voice.providers.customVoiceOption': 'অন্যান্য (নীচে টাইপ করুন)…',
  'voice.providers.customVoiceAria': 'পাইপার ভয়েস আইডি (কাস্টম)',
  'voice.providers.customVoicePlaceholder': 'en_US-lessac-medium',
  'voice.providers.piperVoicesDesc':
    'ভয়েসগুলি huggingface.co/rhasspy/piper-voices থেকে আসে। ভয়েস পরিবর্তন করলে নতুন .onnx ডাউনলোড করতে Install/Reinstall ক্লিক করতে হতে পারে।',
  'voice.providers.mascotVoice': 'মাসকট ভয়েস',
  'voice.providers.mascotVoiceDescPrefix':
    'মাসকট কথিত উত্তরের জন্য যে ElevenLabs ভয়েস ব্যবহার করে তা কনফিগার করা আছে',
  'voice.providers.mascotSettings': 'মাসকট সেটিংস',
  'voice.providers.mascotVoiceDescSuffix': '.',
  'voice.providers.hotkeyPlaceholder': 'Fn এর অধীনে কনফিগার করা হয়েছে',
  'voice.providers.piperPreset.lessacMedium': 'US · Lessac (নিরপেক্ষ, প্রস্তাবিত)',
  'voice.providers.piperPreset.lessacHigh': 'US · Lessac (উচ্চ মানের, বড়)',
  'voice.providers.piperPreset.ryanMedium': 'US · রায়ান (পুরুষ)',
  'voice.providers.piperPreset.amyMedium': 'মার্কিন · অ্যামি (মহিলা)',
  'voice.providers.piperPreset.librittsHigh': 'US · LibriTTS (মাল্টি-স্পীকার)',
  'voice.providers.piperPreset.alanMedium': 'GB · অ্যালান (পুরুষ)',
  'voice.providers.piperPreset.jennyDiocoMedium': 'GB · জেনি ডিওকো (মহিলা)',
  'voice.providers.piperPreset.northernEnglishMaleMedium': 'GB · উত্তর ইংরেজি (পুরুষ)',
  'voice.providers.chip.cloud': 'OpenHuman (পরিচালিত)',
  'voice.providers.chip.cloudAria': 'OpenHuman পরিচালিত প্রোভাইডার সর্বদা সক্রিয়',
  'voice.providers.chip.whisper': 'Whisper (স্থানীয়)',
  'voice.providers.chip.enableWhisper': 'স্থানীয় Whisper STT সক্রিয় করুন',
  'voice.providers.chip.disableWhisper': 'স্থানীয় Whisper STT নিষ্ক্রিয় করুন',
  'voice.providers.chip.piper': 'Piper (স্থানীয়)',
  'voice.providers.chip.enablePiper': 'স্থানীয় Piper TTS সক্রিয় করুন',
  'voice.providers.chip.disablePiper': 'স্থানীয় Piper TTS নিষ্ক্রিয় করুন',
  'voice.providers.chip.enableProvider': 'Enable',
  'voice.providers.chip.disableProvider': 'Disable',
  'voice.providers.chip.apiKeyLabel': 'API কী',
  'voice.providers.chip.apiKeyPlaceholder': 'sk-…',
  'voice.providers.chip.comingSoon': 'শীঘ্রই আসছে',
  'voice.modal.title': 'Configure',
  'voice.modal.desc':
    'এই প্রোভাইডার সক্রিয় করতে আপনার API কী লিখুন। সংরক্ষণের আগে সংযোগ পরীক্ষা করতে পারবেন।',
  'voice.modal.testKey': 'কী পরীক্ষা করুন',
  'voice.modal.testing': 'পরীক্ষা হচ্ছে…',
  'voice.modal.saveAndEnable': 'সংরক্ষণ করুন ও সক্রিয় করুন',
  'voice.modal.enable': 'Enable',
  'voice.modal.whisperDesc':
    'একটি মডেল সাইজ বেছে নিন এবং Whisper বাইনারি ও GGML মডেল আপনার ওয়ার্কস্পেসে ইনস্টল করুন। বড় মডেল আরও নির্ভুল তবে ধীর।',
  'voice.modal.piperDesc':
    'একটি ভয়েস বেছে নিন এবং Piper বাইনারি ও ONNX মডেল আপনার ওয়ার্কস্পেসে ইনস্টল করুন। Piper সম্পূর্ণ অফলাইনে কম লেটেন্সিতে চলে।',
  'voice.routing.title': 'ভয়েস রাউটিং',
  'voice.routing.desc':
    'স্পিচ-টু-টেক্সট এবং টেক্সট-টু-স্পিচ পরিচালনার জন্য সক্রিয় প্রোভাইডার বেছে নিন।',
  'voice.routing.save': 'Save',
  'voice.routing.testStt': 'STT পরীক্ষা করুন',
  'voice.routing.testTts': 'TTS পরীক্ষা করুন',
  'voice.routing.elevenlabsVoice': 'ElevenLabs ভয়েস',
  'voice.routing.elevenlabsVoiceAria': 'ElevenLabs ভয়েস নির্বাচন',
  'voice.routing.elevenlabsVoiceIdAria': 'ElevenLabs ভয়েস ID (কাস্টম)',
  'voice.routing.elevenlabsVoiceDesc':
    'একটি কিউরেটেড ভয়েস বেছে নিন বা আপনার ElevenLabs ড্যাশবোর্ড থেকে একটি কাস্টম ভয়েস ID পেস্ট করুন।',
  'voice.externalProviders.title': 'বাহ্যিক ভয়েস প্রোভাইডার',
  'voice.externalProviders.desc':
    'Deepgram, ElevenLabs, বা OpenAI-এর মতো থার্ড-পার্টি STT/TTS API সরাসরি সংযোগ করুন।',
  'voice.externalProviders.keySet': 'কী সেট করা হয়েছে',
  'voice.externalProviders.noKey': 'কোনো API কী নেই',
  'voice.externalProviders.test': 'Test',
  'voice.externalProviders.testing': 'পরীক্ষা হচ্ছে…',
  'voice.externalProviders.remove': 'Remove',
  'voice.externalProviders.provider': 'Provider',
  'voice.externalProviders.selectProvider': 'একটি প্রোভাইডার বেছে নিন…',
  'voice.externalProviders.apiKey': 'API কী',
  'voice.externalProviders.apiKeyPlaceholder': 'sk-…',
  'voice.externalProviders.add': 'Add',
  'pttSettings.title': 'চাপ দিয়ে কথা বলুন',
  'pttSettings.description':
    'অন্য একটি অ্যাপে থাকার সময় OpenHuman-এর সাথে কথা বলতে একটি কী চেপে ধরে রাখুন। কী ছেড়ে দিলে রেকর্ডিং পাঠানো হয়; «উত্তর পড়ে শোনাও» চালু থাকলে OpenHuman উত্তরটি জোরে পড়ে শোনায়।',
  'pttSettings.shortcutLabel': 'হটকি',
  'pttSettings.shortcutPlaceholder': 'একটি কী চাপুন (যেমন F13)',
  'pttSettings.shortcutUnsetHint':
    'চাপ দিয়ে কথা বলুন বন্ধ আছে: চালু করতে একটি হটকি নির্বাচন করুন।',
  'pttSettings.speakRepliesLabel': 'এজেন্টের উত্তর জোরে পড়ুন',
  'pttSettings.showOverlayLabel': 'চেপে ধরা অবস্থায় ওভারলে দেখান',
  'pttSettings.errorConflictsWithDictation':
    'এই শর্টকাটটি ইতিমধ্যে ডিকটেশনের জন্য ব্যবহৃত হচ্ছে। অন্য একটি কী বেছে নিন।',
  'pttSettings.errorModifierOnly':
    'একটি সাধারণ কী বেছে নিন (যেমন F13): শুধু মডিফায়ার নিয়ে গঠিত শর্টকাট চাপ দিয়ে কথা বলুনের জন্য কাজ করে না।',
  'pttSettings.errorEmpty': 'বাঁধার জন্য একটি কী বেছে নিন।',
  'pttSettings.errorAccessibility':
    'এই শর্টকাটের জন্য macOS-এর অ্যাক্সেসিবিলিটি অনুমতি দরকার। System Settings → Privacy & Security → Accessibility খুলুন এবং OpenHuman চালু করুন।',
  'pttSettings.errorShortcutInUse':
    'অন্য একটি অ্যাপ ইতিমধ্যে এই শর্টকাট ব্যবহার করছে। ভিন্ন একটি বেছে নিন।',
  'pttSettings.errorUnsupportedWayland':
    'Wayland সেশন এখনও OpenHuman-এ গ্লোবাল শর্টকাট সমর্থন করে না: একটি X11 সেশনে চলে যান অথবা অ্যাপের ভেতরের ডিকটেশন টগল ব্যবহার করুন।',
  'pttSettings.exclusiveFullscreenHint':
    'এক্সক্লুসিভ ফুলস্ক্রিন গেমে ওভারলে রেন্ডার হবে না: আপনি শুধু সাউন্ড সংকেতটি শুনতে পাবেন। ওভারলে দেখতে বর্ডারলেস ফুলস্ক্রিনে যান।',
  'pttOverlay.listening': 'শুনছে…',
  'pttOverlay.idle': 'অপেক্ষায়',
  'chat.agentChat': 'এজেন্ট চ্যাট',
  'chat.overrides': 'ওভাররাইড',
  'chat.model': 'মডেল',
  'chat.temperature': 'টেম্পারেচার',
  'chat.conversation': 'কথোপকথন',
  'chat.startAgentConversation': 'এজেন্টের সাথে একটি কথোপকথন শুরু করুন।',
  'chat.you': 'আপনি',
  'chat.agent': 'এজেন্ট',
  'chat.askAgent': 'এজেন্টকে যেকোনো কিছু জিজ্ঞেস করুন...',
  'chat.sendMessage': 'বার্তা পাঠান',
  'composio.triageTitle': 'ইন্টিগ্রেশন ট্রিগার',
  'composio.triageDesc':
    'সক্রিয় থাকলে, প্রতিটি আসন্ত Composio ট্রিগার একটি AI ট্রিয়াজ ধাপের মধ্য দিয়ে যায় যা ইভেন্ট শ্রেণীবদ্ধ করে এবং স্বয়ংক্রিয় কাজ শুরু করতে পারে: প্রতিটি ট্রিগারে একটি লোকাল LLM টার্ন। বৈশ্বিকভাবে বা নির্দিষ্ট ইন্টিগ্রেশনে নিষ্ক্রিয় করুন যদি আপনি ম্যানুয়াল রিভিউ পছন্দ করেন। যদি পরিবেশ ভ্যারিয়েবল',
  'composio.disableAllTriage': 'সব ট্রিগারের জন্য AI ট্রিয়াজ নিষ্ক্রিয় করুন',
  'composio.triggersStillRecorded': 'ট্রিগারগুলো ইতিহাসে রেকর্ড থাকবে: কোনো LLM টার্ন চলবে না।',
  'composio.disableSpecificIntegrations':
    'নির্দিষ্ট ইন্টিগ্রেশনের জন্য AI ট্রিয়াজ নিষ্ক্রিয় করুন',
  'composio.settingsSaved': 'সেটিংস সংরক্ষিত হয়েছে',
  'composio.saveFailed': 'সংরক্ষণ ব্যর্থ। আবার চেষ্টা করুন।',
  'cron.title': 'ক্রন জবস',
  'cron.scheduledJobs': 'নির্ধারিত জবস',
  'cron.manageCronJobs': 'কোর শিডিউলার থেকে ক্রন জবস পরিচালনা করুন।',
  'cron.refreshCronJobs': 'ক্রন জবস রিফ্রেশ করুন',
  'localModel.modelStatus': 'মডেল স্ট্যাটাস',
  'localModel.downloadModels': 'মডেল ডাউনলোড করুন',
  'localModel.usage': 'ব্যবহার',
  'localModel.usageDesc':
    'কোন সাবসিস্টেম লোকাল মডেলে চলবে তা বেছে নিন। বন্ধ থাকলে ক্লাউড ব্যবহার করে।',
  'localModel.enableRuntime': 'লোকাল AI রানটাইম সক্রিয় করুন',
  'localModel.enableRuntimeDesc':
    'মাস্টার সুইচ। ডিফল্টে বন্ধ: Ollama নিষ্ক্রিয় থাকে। চালু হলে, ট্রি সামারাইজার, স্ক্রিন ইন্টেলিজেন্স এবং অটোকমপ্লিট সর্বদা লোকাল মডেল ব্যবহার করে।',
  'localModel.advancedSettings': 'অ্যাডভান্সড সেটিংস',
  'localModel.debugTitle': 'লোকাল মডেল ডিবাগ',
  'memory.debugTitle': 'মেমোরি ডিবাগ',
  'memory.documents': 'নথি',
  'memory.filterByNamespace': 'নামস্থান দ্বারা ফিল্টার করুন...',
  'memory.refresh': 'রিফ্রেশ করুন',
  'memory.noDocumentsFound': 'কোনো নথি পাওয়া যায়নি৷',
  'memory.delete': 'মুছুন',
  'memory.rawResponse': 'কাঁচা প্রতিক্রিয়া',
  'memory.namespaces': 'নেমস্পেস',
  'memory.noNamespacesFound': 'কোনো নামস্থান খুঁজে পাওয়া যায়নি।',
  'memory.queryRecall': 'ক্যোয়ারী এবং রিকল',
  'memory.namespace': 'নেমস্পেস',
  'memory.queryText': 'কোয়েরি পাঠ্য...',
  'memory.defaultMaxChunks': '10',
  'memory.maxChunks': 'সর্বাধিক খণ্ডগুলি',
  'memory.query': 'কোয়েরি',
  'memory.recall': 'প্রত্যাহার করুন',
  'memory.queryLabel': 'প্রশ্ন',
  'memory.recallLabel': 'প্রত্যাহার করুন',
  'memory.queryResult': '923 ফলাফল',
  'memory.recallResult': 'ফলাফল প্রত্যাহার করুন',
  'memory.clearNamespace': 'নামস্থান সাফ করুন',
  'memory.clearNamespaceDescription': 'একটি নামস্থানের মধ্যে থাকা সমস্ত নথি স্থায়ীভাবে মুছুন।',
  'memory.selectNamespace': 'নামস্থান নির্বাচন করুন...',
  'memory.exampleNamespace': 'যেমন skill:gmail:user@example.com',
  'memory.clear': 'সাফ',
  'memory.deleteConfirm': 'নামস্থান "{namespace}" এ নথি "{documentId}" মুছবেন?',
  'memory.clearNamespaceConfirm':
    'এটি "{namespace}" নেমস্পেসের সমস্ত ডকুমেন্ট স্থায়ীভাবে মুছে ফেলবে। চালিয়ে যাবেন?',
  'memory.clearNamespaceSuccess': 'নামস্থান "{namespace}" সাফ করা হয়েছে৷',
  'memory.clearNamespaceEmpty': '"{namespace}" এ পরিষ্কার করার কিছু নেই।',
  'webhooks.debugTitle': 'Webhooks ডিবাগ',
  'webhooks.failedToLoadDebugData': 'ওয়েবহুক ডিবাগ ডেটা লোড করতে ব্যর্থ হয়েছে',
  'webhooks.clearLogsConfirm': 'সমস্ত ক্যাপচার করা ওয়েবহুক ডিবাগ লগ সাফ করবেন?',
  'webhooks.failedToClearLogs': 'ওয়েবহুক লগগুলি সাফ করতে ব্যর্থ হয়েছে',
  'webhooks.loading': 'লোড হচ্ছে...',
  'webhooks.refresh': 'রিফ্রেশ করা হচ্ছে',
  'webhooks.clearing': 'সাফ করা হচ্ছে...',
  'webhooks.clearLogs': 'সাফ করা হচ্ছে...',
  'webhooks.registered': '[[I18N_SEP_92731]] নিবন্ধিত',
  'webhooks.captured': 'ক্যাপচার করা',
  'webhooks.live': 'লাইভ',
  'webhooks.disconnected': 'সংযোগ বিচ্ছিন্ন',
  'webhooks.lastEvent': 'সর্বশেষ ইভেন্ট',
  'webhooks.at': 'এ',
  'webhooks.registeredWebhooks': 'নিবন্ধিত ওয়েবহুক',
  'webhooks.noActiveRegistrations': 'কোন সক্রিয় নিবন্ধন.',
  'webhooks.resolvingBackendUrl': 'ব্যাকএন্ড সমাধান করা হচ্ছে URL…',
  'webhooks.capturedRequests': 'ক্যাপচার করা অনুরোধ',
  'webhooks.noRequestsCaptured': 'কোনো ওয়েবহুকের অনুরোধ এখনও ক্যাপচার করা হয়নি৷',
  'webhooks.unrouted': 'আনরাউটেড',
  'webhooks.pending': 'মুলতুবি',
  'webhooks.requestHeaders': 'অনুরোধ শিরোনাম',
  'webhooks.queryParams': 'কোয়েরি পরম',
  'webhooks.requestBody': 'রিকোয়েস্ট বডি',
  'webhooks.responseHeaders': 'রেসপন্স হেডার',
  'webhooks.responseBody': 'রেসপন্স বডি',
  'webhooks.rawPayload': 'কাঁচা পেলোড',
  'webhooks.empty': '[খালি]',
  'providerSetup.error.defaultDetails': 'প্রদানকারী সেটআপ ব্যর্থ হয়েছে৷',
  'providerSetup.error.providerFallback': 'প্রদানকারী',
  'providerSetup.error.credentialsRejected':
    '{provider} শংসাপত্র প্রত্যাখ্যান করেছে। API কী পরীক্ষা করুন এবং আবার চেষ্টা করুন।',
  'providerSetup.error.endpointNotRecognized':
    '{provider} এন্ডপয়েন্ট সনাক্ত করতে পারেনি। বেস URL পরীক্ষা করুন এবং আবার চেষ্টা করুন।',
  'providerSetup.error.providerUnavailable':
    '{provider} এখন অনুপলব্ধ। আবার চেষ্টা করুন অথবা প্রোভাইডারের স্ট্যাটাস দেখুন।',
  'providerSetup.error.unreachable':
    '{provider}-এ পৌঁছানো যায়নি। এন্ডপয়েন্ট URL এবং নেটওয়ার্ক সংযোগ পরীক্ষা করুন, তারপর আবার চেষ্টা করুন।',
  'providerSetup.error.couldNotReachWithMessage': '{provider} এ পৌঁছানো যায়নি: {message}',
  'providerSetup.error.technicalDetails': 'প্রযুক্তিগত বিবরণ',
  'notifications.routingTitle': 'বিজ্ঞপ্তি রুটিং',
  'notifications.routing.pipelineStats': 'পাইপলাইন পরিসংখ্যান',
  'notifications.routing.total': 'মোট',
  'notifications.routing.unread': 'অপঠিত',
  'notifications.routing.unscored': 'আনস্কোরড',
  'notifications.routing.intelligenceTitle': 'আনস্কোরড [[I18N_SEP_92731] নোটিফিকেশন',
  'notifications.routing.intelligenceDesc':
    'আপনার সংযুক্ত অ্যাকাউন্টের প্রতিটি বিজ্ঞপ্তি একটি স্থানীয় AI মডেল দ্বারা স্কোর করা হয়। উচ্চ-গুরুত্বের বিজ্ঞপ্তিগুলি স্বয়ংক্রিয়ভাবে আপনার অর্কেস্ট্রেটর এজেন্টে রুট করা হয় যাতে কিছু গুরুত্বপূর্ণ মিস না হয়।',
  'notifications.routing.howItWorks': 'এটি কীভাবে কাজ করে',
  'notifications.routing.level.drop': 'ড্রপ',
  'notifications.routing.level.dropDesc': 'নয়েজ / স্প্যাম: সঞ্চিত কিন্তু প্রকাশ করা হয় না',
  'notifications.routing.level.acknowledge': 'স্বীকার করুন',
  'notifications.routing.level.acknowledgeDesc': 'নিম্ন-অগ্রাধিকার: বিজ্ঞপ্তি কেন্দ্রে দেখানো হয়',
  'notifications.routing.level.react': 'প্রতিক্রিয়া',
  'notifications.routing.level.reactDesc':
    'মধ্যম-অগ্রাধিকার: একটি ফোকাসড এজেন্ট প্রতিক্রিয়া চালু করে',
  'notifications.routing.level.escalate': 'এস্কেলেট',
  'notifications.routing.level.escalateDesc': 'উচ্চ-অগ্রাধিকার: অর্কেস্ট্রেটর এজেন্টে পাঠানো হয়',
  'notifications.routing.perProvider': 'প্রতি-প্রদানকারী রাউটিং',
  'notifications.routing.threshold': 'থ্রেশহোল্ড',
  'notifications.routing.routeToOrchestrator': 'অর্কেস্ট্রেটরের রুট',
  'notifications.routing.loadSettingsError':
    'সেটিংস লোড করতে ব্যর্থ হয়েছে। পুনরায় চেষ্টা করতে এই প্যানেলটি আবার খুলুন।',
  'common.reload': 'পুনরায় লোড',
  'common.skip': 'এড়িয়ে যান',
  'common.disable': 'নিষ্ক্রিয় করুন',
  'common.enable': 'সক্রিয় করুন',
  'chat.safetyTimeout':
    '২ মিনিট পরেও এজেন্টের কোনো সাড়া নেই। আবার চেষ্টা করুন বা সংযোগ পরীক্ষা করুন।',
  'chat.filter.general': 'সাধারণ',
  'chat.filter.subconscious': 'সাবকনশাস',
  'chat.filter.meetings': 'মিটিং',
  'chat.filter.tasks': 'টাস্ক',
  'chat.selectThread': 'একটি থ্রেড বেছে নিন',
  'chat.threads': 'থ্রেড',
  'chat.noThreads': 'এখনো কোনো থ্রেড নেই',
  'chat.noLabelThreads': '"{label}" থ্রেড নেই',
  'chat.deleteThread': 'থ্রেড মুছুন',
  'chat.deleteThreadConfirm': 'আপনি কি "{title}" মুছতে চান?',
  'chat.untitledThread': 'শিরোনামহীন থ্রেড',
  'chat.editThreadTitle': 'থ্রেডের শিরোনাম সম্পাদনা করুন',
  'chat.hideSidebar': 'সাইডবার লুকান',
  'chat.showSidebar': 'সাইডবার দেখান',
  'chat.searchThreads': 'কথোপকথন অনুসন্ধান করুন',
  'layout.resizeSidebar': 'সাইডবারের আকার পরিবর্তন করুন',
  'layout.showSidebar': 'সাইডবার দেখান',
  'chat.newThreadShortcut': 'নতুন থ্রেড (/new)',
  'chat.new': 'নতুন',
  'chat.failedToLoadMessages': 'বার্তা লোড করতে ব্যর্থ',
  'chat.thinkingIteration': 'ভাবছে... ({n})',
  'chat.thinkingDots': 'ভাবছে...',
  'chat.approachingLimit': 'ব্যবহার সীমার কাছাকাছি',
  'chat.approachingLimitMsg': 'আপনি আপনার উপলব্ধ কোটার {pct}% ব্যবহার করেছেন।',
  'chat.upgrade': 'আপগ্রেড করুন',
  'chat.weeklyLimitHit': 'আপনি আপনার সাপ্তাহিক সীমায় পৌঁছেছেন।',
  'chat.resets': 'রিসেট হবে',
  'chat.topUpToContinue': 'চালিয়ে যেতে টপ আপ করুন।',
  'chat.budgetComplete':
    'আপনার অন্তর্ভুক্ত বাজেট শেষ হয়েছে। চালিয়ে যেতে ক্রেডিট যোগ করুন বা আপগ্রেড করুন।',
  'chat.topUp': 'টপ আপ',
  'chat.cycle': 'চক্র',
  'chat.cycleSpent': 'এই চক্রে ব্যয়',
  'chat.cycleRemaining': 'অবশিষ্ট',
  'chat.left': 'বাকি',
  'chat.setup': 'সেটআপ করুন',
  'chat.switchToText': 'টেক্সটে পরিবর্তন করুন',
  'chat.superContext.label': 'সুপার কনটেক্সট',
  'chat.superContext.hint':
    'সুপার কনটেক্সট OpenHuman-কে তার অ্যাক্সেসযোগ্য সমস্ত ডেটা থেকে প্রসঙ্গ সংগ্রহ ও প্রস্তুত করতে দেয় যাতে এটি অত্যন্ত প্রাসঙ্গিক উত্তর দিতে পারে। সুপার কনটেক্সট প্রাথমিক বিটা পর্যায়ে রয়েছে।',
  'chat.transcribing': 'ট্রান্সক্রাইব হচ্ছে...',
  'chat.stopAndSend': 'থামুন ও পাঠান',
  'chat.startTalking': 'কথা বলা শুরু করুন',
  'chat.playingVoiceReply': 'ভয়েস রিপ্লি বাজছে',
  'chat.voiceHint': 'কথা বলতে মাইক ব্যবহার করুন',
  'chat.micUnavailable': 'মাইক্রোফোন পাওয়া যাচ্ছে না',
  // Chat mascot: the figure standing on the composer, and its voice stage.
  'chat.mascot.expand': 'আপনার সহকারীর সঙ্গে কথা বলুন',
  'chat.mascot.collapse': 'চ্যাটে ফিরে যান',
  'chat.mascot.speakReplies': 'উত্তর জোরে পড়ে শোনানো হোক',
  'chat.mascot.speakRepliesHint':
    'ম্যাসকট খোলা থাকলে উত্তরগুলি জোরে পড়ে শোনানো হয়। কথোপকথন নীরব রাখতে এটি বন্ধ করুন।',
  'chat.mascot.dismiss': 'Tiny লুকান',
  'chat.mascot.dismissTitle': 'Tiny লুকাবেন?',
  'chat.mascot.dismissBody':
    'মেসেজ বক্সটি নিজের মতো রাখতে চাইলে কোনও অসুবিধা নেই। সেটিংস › উপস্থিতি › চ্যাট থেকে যেকোনো সময় Tiny-কে ফিরিয়ে আনতে পারবেন।',
  'chat.mascot.dismissConfirm': 'Tiny লুকান',
  'chat.mascot.dismissCancel': 'Tiny-কে রাখুন',
  'chat.turn': 'টার্ন',
  'chat.turns': 'টার্ন',
  'chat.openWorkerThread': 'ওয়ার্কার থ্রেড খুলুন',
  'chat.attachment.attach': 'ছবি সংযুক্ত করুন',
  'chat.attachment.remove': '{name} সরান',
  'chat.attachment.tooMany': 'প্রতি বার্তায় সর্বোচ্চ {max}টি ছবি',
  'chat.attachment.tooManyFiles': 'প্রতি বার্তায় সর্বোচ্চ {max}টি ফাইল',
  'chat.attachment.tooManyVideos': 'প্রতি বার্তায় সর্বোচ্চ {max}টি ভিডিও',
  'chat.attachment.videoNotSupported':
    'এই মডেল ভিডিও পড়তে পারে না। আপনার ভিডিও সংযুক্ত করতে আপনি OpenHuman যুক্তি স্তর ব্যবহার করতে পারেন।',
  'chat.attachment.dropToAttach': 'সংযুক্ত করতে ফাইল ছেড়ে দিন',
  'chat.attachment.tooLarge': 'ছবি {max} আকারের সীমা অতিক্রম করেছে',
  'chat.attachment.unsupportedType':
    'অসমর্থিত ফাইল প্রকার। একটি ছবি (PNG, JPEG, WebP, GIF, BMP) অথবা একটি PDF, TXT, বা Markdown ফাইল ব্যবহার করুন।',
  'chat.attachment.imageNotSupported':
    'এই মডেলটি ছবি পড়তে পারে না। আপনার ছবি সংযুক্ত করতে আপনি OpenHuman যুক্তি স্তর ব্যবহার করতে পারেন।',
  'chat.attachment.readFailed': 'ফাইল পড়া যায়নি',
  'memory.searchAria': 'মেমোরি খুঁজুন',
  'memory.searchPlaceholder': 'মেমোরি এন্ট্রি খুঁজুন...',
  'memory.sourceFilter.all': 'সব উৎস',
  'memory.sourceFilter.email': 'ইমেইল',
  'memory.sourceFilter.calendar': 'ক্যালেন্ডার',
  'memory.sourceFilter.telegram': 'Telegram',
  'memory.sourceFilter.aiInsight': 'AI ইনসাইট',
  'memory.sourceFilter.system': 'সিস্টেম',
  'memory.sourceFilter.trading': 'ট্রেডিং',
  'memory.sourceFilter.security': 'নিরাপত্তা',
  'memory.ingestionActivity': 'ইনজেশন অ্যাক্টিভিটি',
  'memory.events': 'ইভেন্ট',
  'memory.event': 'ইভেন্ট',
  'memory.overTheLast': 'গত',
  'memory.months': 'মাসে',
  'memory.peak': 'শীর্ষ',
  'memory.perDay': '/দিন',
  'memory.less': 'কম',
  'memory.more': 'বেশি',
  'memory.on': 'তে',
  'memory.loading': 'মেমোরি লোড হচ্ছে',
  'memory.fetching': 'আপনার মেমোরি এন্ট্রি আনা হচ্ছে...',
  'memory.analyzing': 'মেমোরি বিশ্লেষণ হচ্ছে',
  'memory.analyzingHint': 'ইনসাইট বের করতে আপনার মেমোরি প্রক্রিয়া হচ্ছে...',
  'memory.noMatches': 'কোনো মিল পাওয়া যায়নি',
  'memory.noMatchesHint': 'সার্চ টার্ম বা ফিল্টার পরিবর্তন করে দেখুন।',
  'memory.allCaughtUp': 'সব আপডেট',
  'memory.allCaughtUpHint': 'প্রক্রিয়া করার মতো নতুন মেমোরি এন্ট্রি নেই।',
  'memory.noAnalysis': 'এখনো কোনো বিশ্লেষণ নেই',
  'memory.noAnalysisHint': 'আপনার মেমোরিতে প্যাটার্ন খুঁজে পেতে একটি বিশ্লেষণ চালান।',
  'memory.emptyHint': 'আপনার প্রথম মেমোরি তৈরি করতে ইন্টারঅ্যাক্ট শুরু করুন।',
  'mic.unavailable': 'মাইক্রোফোন পাওয়া যাচ্ছে না',
  'mic.permissionDenied': 'মাইক্রোফোন অনুমতি অস্বীকৃত',
  'mic.failedToStartRecorder': 'রেকর্ডার শুরু করতে ব্যর্থ',
  'mic.deviceUnavailable': 'নির্বাচিত মাইক্রোফোন অনুপলব্ধ: অন্য একটি ডিভাইস ব্যবহার করে দেখুন।',
  'mic.deviceInUse': 'মাইক্রোফোনটি অন্য একটি অ্যাপ্লিকেশন ব্যবহার করছে।',
  'mic.error': 'মাইক্রোফোন ত্রুটি',
  'mic.transcribing': 'ট্রান্সক্রাইব হচ্ছে...',
  'mic.retryingTranscription': 'পুনরায় চেষ্টা করা হচ্ছে… ({attempt}/{max})',
  'mic.tapToSend': 'পাঠাতে ট্যাপ করুন',
  'mic.waitingForAgent': 'এজেন্টের জন্য অপেক্ষা করছে...',
  'mic.tapAndSpeak': 'ট্যাপ করুন ও কথা বলুন',
  'mic.stopRecording': 'রেকর্ডিং বন্ধ করুন ও পাঠান',
  'mic.startRecording': 'রেকর্ডিং শুরু করুন',
  'mic.deviceSelector': 'মাইক্রোফোন ডিভাইস',
  'mic.tapToSendCountdown': 'পাঠাতে ট্যাপ করুন ({seconds}স)',
  'token.usageLimitReached': 'ব্যবহার সীমা পৌঁছেছে',
  'token.approachingLimit': 'সীমার কাছাকাছি',
  'token.planClickForDetails': 'প্ল্যান - বিস্তারিত জানতে ক্লিক করুন',
  'token.sessionTokens': 'ইন: {in} | আউট: {out} | টার্ন: {turns}',
  'token.limit': 'সীমা পৌঁছেছে',
  'token.inLabel': 'ইন',
  'token.outLabel': 'আউট',
  'token.inputTokens': 'এই সেশনে ইনপুট টোকেন',
  'token.outputTokens': 'এই সেশনে আউটপুট টোকেন',
  'token.turnsCount': 'এই সেশনে ইনফারেন্স টার্ন',
  'token.turn': 'টার্ন',
  'token.turns': 'টার্ন',
  'token.ctxLabel': 'CTX',
  'token.contextWindow': 'কনটেক্সট উইন্ডো ব্যবহার (শেষ টার্ন)',
  'token.cachedLabel': 'ক্যাশড',
  'token.costLabel': 'খরচ',
  'token.costTitle': 'এই সেশনের আনুমানিক খরচ (USD)',
  'token.sessionUsageTitle': 'সেশন ব্যবহার',
  'token.subAgentsHeading': 'সাব-এজেন্ট ব্যবহার',
  'token.byAgentHeading': 'এজেন্ট অনুযায়ী',
  'token.orchestrator': 'অর্কেস্ট্রেটর',
  'token.noSubAgents': 'এখনও কোনো সাব-এজেন্ট ব্যবহার নেই',
  'token.popInput': 'ইনপুট টোকেন',
  'token.popOutput': 'আউটপুট টোকেন',
  'token.popCacheHit': 'ক্যাশ হিট',
  'token.popContext': 'কনটেক্সট উইন্ডো',
  'token.tipInput': 'এই সেশনে মডেলে পাঠানো টোকেন: আপনার প্রম্পট এবং কথোপকথনের ইতিহাস।',
  'token.tipOutput': 'এই সেশনে মডেল দ্বারা তৈরি টোকেন।',
  'token.tipCacheHit': 'ক্যাশড প্রম্পট প্রিফিক্স থেকে দেওয়া ইনপুট টোকেন, কম হারে বিল করা হয়।',
  'token.clickForDetails': 'সেশন ব্যবহারের বিবরণের জন্য ক্লিক করুন',
  'catalog.noCapabilityBinding': 'কোনো ক্যাপাবিলিটি বাইন্ডিং নেই',
  'catalog.downloadFailed': 'ডাউনলোড ব্যর্থ',
  'catalog.active': 'সক্রিয়',
  'catalog.installed': 'ইনস্টল করা',
  'catalog.notDownloaded': 'ডাউনলোড করা হয়নি',
  'catalog.inUse': 'ব্যবহারে',
  'catalog.use': 'ব্যবহার করুন',
  'catalog.deleteModel': 'মডেল মুছুন',
  'catalog.download': 'ডাউনলোড',
  'navigator.recent': 'সাম্প্রতিক',
  'navigator.today': 'আজ',
  'navigator.thisWeek': 'এই সপ্তাহ',
  'navigator.sources': 'উৎস',
  'navigator.email': 'ইমেইল',
  'navigator.slack': 'Slack',
  'navigator.chat': 'চ্যাট',
  'navigator.documents': 'ডকুমেন্ট',
  'navigator.people': 'মানুষ',
  'navigator.topics': 'বিষয়',
  'dreams.description':
    'স্বপ্ন হলো AI-জেনারেটেড প্রতিফলন যা আপনার মেমোরি থেকে প্যাটার্ন সংশ্লেষণ করে।',
  'dreams.comingSoon': 'শীঘ্রই আসছে',
  'assignment.memoryLlm': 'মেমোরি LLM',
  'assignment.memoryLlmAria': 'মেমোরি LLM নির্বাচন',
  'assignment.embedder': 'এম্বেডার',
  'assignment.loaded': 'লোড হয়েছে',
  'assignment.notDownloaded': 'ডাউনলোড করা হয়নি',
  'assignment.usedForExtractSummarise': 'নিষ্কাশন এবং সারসংক্ষেপের জন্য ব্যবহৃত',
  'insights.knownFacts': 'পরিচিত তথ্য',
  'insights.preferences': 'পছন্দ',
  'insights.relationships': 'সম্পর্ক',
  'insights.skills': 'দক্ষতা',
  'insights.opinions': 'মতামত',
  'insights.other': 'অন্যান্য',
  'insights.title': 'ইনসাইট',
  'insights.empty': 'এখনো কোনো ইনসাইট নেই। আপনার মেমোরি বাড়ার সাথে ইনসাইট তৈরি হবে।',
  'insights.description': 'আপনার মেমোরি গ্রাফে {count}টি সম্পর্কের উপর ভিত্তি করে।',
  'insights.items': 'আইটেম',
  'insights.more': 'আরও',
  'calls.joiningCall': 'কলে যোগ দিচ্ছে',
  'calls.meetWindowOpening': 'Meet উইন্ডো খুলছে...',
  'calls.failedToStart': 'Meet কল শুরু করতে ব্যর্থ',
  'calls.couldNotStart': 'কল শুরু করা যায়নি',
  'calls.failedToClose': 'কল বন্ধ করতে ব্যর্থ',
  'calls.couldNotClose': 'কল বন্ধ করা যায়নি',
  'calls.joinMeet': 'একটি Google Meet কলে যোগ দিন',
  'calls.joinMeetDescription': 'যোগ দিতে একটি Google Meet লিংক দিন।',
  'calls.meetLink': 'Meet লিংক',
  'calls.displayName': 'প্রদর্শন নাম',
  'calls.openingMeet': 'Meet খোলা হচ্ছে...',
  'calls.joinCall': 'কলে যোগ দিন',
  'calls.activeCalls': 'সক্রিয় কল',
  'calls.leave': 'ছেড়ে যান',
  'workspace.wipeConfirm': 'আপনি কি সব মেমোরি মুছতে চান? এটি পূর্বাবস্থায় ফেরানো যাবে না।',
  'workspace.resetTreeConfirm': 'আপনি কি মেমোরি ট্রি পুনর্নির্মাণ করতে চান?',
  'workspace.wipeTitle': 'মেমোরি মুছুন',
  'workspace.resetting': 'রিসেট হচ্ছে...',
  'workspace.resetMemory': 'মেমোরি রিসেট করুন',
  'workspace.resetTreeTitle': 'মেমোরি ট্রি পুনর্নির্মাণ',
  'workspace.rebuilding': 'পুনর্নির্মাণ হচ্ছে...',
  'workspace.resetMemoryTree': 'মেমোরি ট্রি রিসেট করুন',
  'workspace.building': 'নির্মাণ হচ্ছে...',
  'workspace.buildSummaryTrees': 'সারসংক্ষেপ ট্রি তৈরি করুন',
  'workspace.viewVault': 'ভল্ট দেখুন',
  'workspace.openingVaultTitle': 'ওবসিডিয়ানে ভল্ট খোলা হচ্ছে',
  'workspace.openingVaultMessage':
    'Obsidian না খুললে, obsidian.md থেকে ইনস্টল করুন অথবা Reveal Folder ব্যবহার করুন। ভল্ট পাথ:',
  'workspace.openVaultFailedTitle': 'Obsidian-এ ভল্ট খোলা যায়নি',
  'workspace.openVaultFailedMessage':
    'ভল্ট ডিরেক্টরিটি সরাসরি খুলতে রিভিল ফোল্ডার ব্যবহার করুন। ভল্ট পাথ:',
  'workspace.revealVaultFailed': 'ভল্ট ফোল্ডার দেখানো যায়নি',
  'workspace.revealFolder': 'ফোল্ডার প্রকাশ করুন',
  'workspace.checkingVault': 'যাচাই হচ্ছে…',
  'workspace.vaultNotRegisteredHelp':
    'Obsidian শুধুমাত্র আপনার যোগ করা ফোল্ডারগুলি ভল্ট হিসেবে খোলে। Obsidian-এ, "Open folder as vault" বেছে নিন এবং নিচের ফোল্ডারটি পিক করুন: এটি শুধুমাত্র একবার করতে হবে। তারপর আবার View Vault ক্লিক করুন।',
  'workspace.obsidianNotFoundHelp':
    'আমরা এই ডিভাইসে Obsidian খুঁজে পাইনি। এটি ইনস্টল করুন, অথবা (যদি এটি অ-মানক কোথাও ইনস্টল করা থাকে) Advanced-এর অধীনে এর কনফিগ ফোল্ডার সেট করুন।',
  'workspace.openAnyway': 'যাইহোক Obsidian-এ খুলুন',
  'workspace.installObsidian': 'Obsidian ইনস্টল করুন',
  'workspace.obsidianAdvanced': 'Obsidian অন্য কোথাও ইনস্টল করা আছে?',
  'workspace.obsidianConfigDirLabel': 'Obsidian কনফিগ ফোল্ডার',
  'workspace.obsidianConfigDirHint':
    'obsidian.json ধারণকারী ফোল্ডারের পাথ (যেমন ~/.config/obsidian)। স্বয়ংক্রিয়ভাবে সনাক্ত করতে খালি রাখুন।',
  'workspace.obsidianConfigDirPlaceholder': '~/.config/obsidian',
  'workspace.graphLoadFailed': 'মেমোরি গ্রাফ লোড করতে ব্যর্থ',
  'workspace.loadingGraph': 'মেমোরি গ্রাফ লোড হচ্ছে...',
  'workspace.graphViewMode': 'মেমোরি গ্রাফ ভিউ মোড',
  'workspace.trees': 'ট্রি',
  'workspace.contacts': 'যোগাযোগ',
  'graph.noContactMentions': 'কোনো যোগাযোগ উল্লেখ নেই',
  'graph.noMemory': 'কোনো মেমোরি নেই',
  'graph.source': 'উৎস',
  'graph.topic': 'বিষয়',
  'graph.global': 'বৈশ্বিক',
  'graph.document': 'ডকুমেন্ট',
  'graph.contact': 'যোগাযোগ',
  'graph.nodes': 'নোড',
  'graph.parentChild': 'প্যারেন্ট-চাইল্ড',
  'graph.documentContact': 'ডকুমেন্ট-যোগাযোগ',
  'graph.link': 'লিংক',
  'graph.links': 'লিংক',
  'graph.children': 'চাইল্ড',
  'graph.clickToOpenObsidian': 'Obsidian-এ খুলতে ক্লিক করুন',
  'graph.person': 'ব্যক্তি',
  'graph.resetView': 'ভিউ রিসেট করুন',
  'modal.dontShowAgain': 'একই ধরনের পরামর্শ আর দেখাবেন না',
  'reflections.loading': 'প্রতিফলন লোড হচ্ছে...',
  'reflections.empty': 'এখনো কোনো প্রতিফলন নেই',
  'reflections.title': 'প্রতিফলন',
  'reflections.proposedAction': 'প্রস্তাবিত কাজ',
  'reflections.act': 'কাজ করুন',
  'reflections.dismiss': 'বাদ দিন',
  'reflections.viewConversation': 'দেখুন',
  'subconscious.mode.label': 'অবচেতন মোড',
  'subconscious.mode.off.title': 'বন্ধ',
  'subconscious.mode.off.desc': 'অবচেতন নিষ্ক্রিয়।',
  'subconscious.mode.simple.title': 'সরল',
  'subconscious.mode.simple.desc': 'শুধুমাত্র পঠনযোগ্য পর্যবেক্ষণ। শুধু মেমরি ও ফাইল অ্যাক্সেস।',
  'subconscious.mode.aggressive.title': 'আক্রমণাত্মক',
  'subconscious.mode.aggressive.desc':
    'সম্পূর্ণ টুল অ্যাক্সেস। লিখতে, এজেন্ট তৈরি ও কাজ অর্পণ করতে পারে।',
  'subconscious.mode.aggressiveWarning':
    'আক্রমণাত্মক মোড অবচেতনকে লেখা ও সাব-এজেন্ট তৈরিসহ সম্পূর্ণ টুল অ্যাক্সেস দেয়।',
  'subconscious.interval.label': 'ফ্রিকোয়েন্সি',
  'subconscious.interval.minutes': '{n} মি',
  'subconscious.interval.hours': '{n} ঘ',
  'subconscious.interval.oneHour': '১ ঘণ্টা',
  'subconscious.interval.oneDay': '২৪ ঘণ্টা',
  'whatsapp.chatsSynced': 'চ্যাট সিঙ্ক হয়েছে',
  'whatsapp.chatSynced': 'চ্যাট সিঙ্ক হয়েছে',
  'sync.active': 'সক্রিয়',
  'sync.recent': 'সাম্প্রতিক',
  'sync.idle': 'নিষ্ক্রিয়',
  'sync.memorySources': 'মেমোরি উৎস',
  'sync.noConnectedSources': 'কোনো সংযুক্ত উৎস নেই',
  'sync.chunks': 'চাংক',
  'sync.lastChunk': 'শেষ চাংক:',
  'sync.pending': 'মুলতুবি',
  'sync.processed': 'প্রক্রিয়া করা হয়েছে',
  'sync.syncing': 'সিঙ্ক হচ্ছে…',
  'sync.sync': 'সিঙ্ক',
  'sync.failedToLoad': 'সিঙ্ক স্ট্যাটাস লোড করতে ব্যর্থ',
  'sync.noContent':
    'এখনো কোনো কন্টেন্ট মেমোরিতে সিঙ্ক হয়নি। শুরু করতে একটি ইন্টিগ্রেশন সংযুক্ত করুন।',
  'memorySyncInterval.title': 'সিঙ্ক সময়সূচি',
  'memorySyncInterval.lastSynced': 'সর্বশেষ সিঙ্ক',
  'memorySyncInterval.never': 'কখনও না',
  'memorySyncInterval.everyHours': 'প্রতি {h} ঘণ্টা',
  'memorySyncInterval.everyMinutes': 'প্রতি {m} মিনিট',
  'memorySyncInterval.manual': 'শুধু ম্যানুয়াল',
  'memorySyncInterval.saveFailed': 'সিঙ্ক সময়সূচি আপডেট করা যায়নি',
  'memorySources.title': 'মেমরি উৎস',
  'memorySources.empty': 'কোনো মেমরি পাওয়া যায়নি। স্মৃতি খাওয়া শুরু করতে একটা যোগ করো।',
  'memorySources.customSources': 'স্বনির্ধারিত উৎস',
  'memorySources.addSource': 'উৎস যোগ করুন',
  'memorySources.noCustomSources':
    'কোনো স্বনির্ধারিত উৎস পাওয়া যায়নি। একটি ফোল্ডার যোগ করুন, xqx1x rex, xqxqx pxkx ফিড, অথবা ওয়েব পেজ আরম্ভ করুন।',
  'memorySources.loadingConnections': 'সংযোগ লোড করা হচ্ছে...',
  'memorySources.noConnections': 'কোনো সক্রিয় xqxqx সংযোগ পাওয়া যায়নি। একটা সম্পর্ক প্রথমে।',
  'memorySources.pickConnection': 'একটি সংযোগ নির্বাচন করুন',
  'memorySources.selectConnection': '- একটি সংযোগ নির্বাচন করুন -',
  'memorySources.comingSoon': 'শীঘ্রই আসছে',
  'memorySources.composioListFailed': 'Xqxqx সংযোগ লোড করতে ব্যর্থ।',
  'memorySources.browse': 'ব্রাউজ করুন...',
  'memorySources.folderPathPlaceholder': '/Users/you/notes',
  'memorySources.globPatternPlaceholder': '*ড্যাম',
  'memorySources.repoUrlPlaceholder': 'https://github.com/org/repo',
  'memorySources.branchPlaceholder': 'main',
  'memorySources.feedUrlPlaceholder': 'https://example.com/feed.xml',
  'memorySources.pageUrlPlaceholder': 'https://example.com/article',
  'memorySources.cssSelectorPlaceholder': 'article',
  'memorySources.searchQueryPlaceholder': 'অজানা সংযোগ',
  'memorySources.kind.composio': 'অবধি',
  'memorySources.kind.conversation': 'কথোপকথন',
  'memorySources.kind.folder': 'স্থানীয় ফোল্ডার',
  'memorySources.kind.github_repo': 'xqxqxRox',
  'memorySources.kind.twitter_query': 'Xqxqx অনুসন্ধান',
  'memorySources.kind.rss_feed': 'xqxqx ফিড',
  'memorySources.kind.web_page': 'ওয়েব পেজ',
  'memorySources.sync.successTitle': 'সুসংগতি',
  'memorySources.sync.successMessage': 'অগ্রগতি শীঘ্রই দেখা যাবে।',
  'memorySources.sync.failedTitle': 'সুসংগত করতে ব্যর্থ:',
  'memorySources.sync.completeTitle': 'সিঙ্ক হয়েছে',
  'memorySources.sync.itemsSynced': 'আইটেম সিঙ্ক হয়েছে',
  'memorySources.sync.upToDate': 'হালনাগাদ আছে',
  'memorySources.sync.failedLabel': 'ব্যর্থ',
  'time.justNow': 'এইমাত্র',
  'time.secondsAgoSuffix': 'সেকেন্ড আগে',
  'time.minutesAgoSuffix': 'মিনিট আগে',
  'time.hoursAgoSuffix': 'ঘণ্টা আগে',
  'time.daysAgoSuffix': 'দিন আগে',
  'memorySources.pickKind': 'কোন ধরনের উৎস আপনি যোগ করতে চান?',
  'memorySources.backToKinds': 'উৎস থেকে প্রাপ্ত',
  'memorySources.label': 'লেবেল',
  'memorySources.labelPlaceholder': 'আমার গবেষণা নোট',
  'memorySources.add': 'যোগ করুন',
  'memorySources.adding': 'যোগ করা হচ্ছে...',
  'memorySources.added': 'উৎস যোগ করা হয়েছে',
  'memorySources.removed': 'উৎস সরিয়ে ফেলা হয়েছে',
  'memorySources.remove': 'মুছে ফেলুন',
  'memorySources.enable': 'সক্রিয় করুন',
  'memorySources.disable': 'নিষ্ক্রিয়',
  'memorySources.toggleFailed': 'ব্যর্থ',
  'memorySources.removeFailed': 'মুছে ফেলা যায়নি',
  'memorySources.folderPath': 'ফোল্ডারের পাথ',
  'memorySources.globPattern': 'বিন্যাস',
  'memorySources.repoUrl': 'সংরক্ষণস্থল xqxqxqx',
  'memorySources.branch': 'ব্রাঞ্চ',
  'memorySources.feedUrl': 'ফিড xqxqx',
  'memorySources.pageUrl': 'পৃষ্ঠার xqxqx',
  'memorySources.cssSelector': 'xqxqx নির্বাচক',
  'memorySources.searchQuery': 'অনুসন্ধান',
  'memorySources.build.title': 'তৈরি',
  'memorySources.build.building': 'তৈরি হচ্ছে…',
  'memorySources.build.successTitle': 'ট্রি তৈরি হয়েছে',
  'memorySources.build.failedTitle': 'তৈরি ব্যর্থ',
  'memorySources.build.sealsMessage': 'সিল সম্পন্ন হয়েছে',
  'memorySources.allIn.button': 'সব চালু',
  'memorySources.allIn.title': 'সব সক্রিয় করবেন?',
  'memorySources.allIn.message':
    'এটি সমস্ত মেমরি উৎস সক্রিয় করবে এবং সিঙ্ক সীমা সরিয়ে দেবে। এটি সমৃদ্ধতম মেমরি গ্রাফ তৈরি করে, তবে আরও ক্রেডিট ব্যবহার করতে পারে।',
  'memorySources.allIn.confirm': 'হ্যাঁ',
  'memorySources.allIn.cancel': 'না',
  'memorySources.allIn.success': 'সব উৎস সীমা ছাড়া সক্রিয় হয়েছে। সিঙ্ক শুরু হয়েছে।',
  'memorySources.allIn.failed': 'সব চালু করা সম্ভব হয়নি। আবার চেষ্টা করুন।',
  'memorySources.settings.button': 'সেটিংস',
  'memorySources.settings.title': 'সিঙ্ক সেটিংস',
  'memorySources.settings.maxPrs': 'সর্বোচ্চ পুল রিকোয়েস্ট',
  'memorySources.settings.maxIssues': 'সর্বোচ্চ ইস্যু',
  'memorySources.settings.maxCommits': 'সর্বোচ্চ কমিট',
  'memorySources.settings.maxItems': 'সর্বোচ্চ আইটেম',
  'memorySources.settings.sinceDays': 'পূর্ববর্তী সময় (দিনে)',
  'memorySources.settings.syncDepthDays': 'সিঙ্ক গভীরতা (দিনে)',
  'memorySources.settings.maxTokens': 'প্রতি সিঙ্কে সর্বোচ্চ টোকেন',
  'memorySources.settings.maxCost': 'প্রতি সিঙ্কে সর্বোচ্চ খরচ (USD)',
  'memorySources.settings.unlimited': 'সীমাহীন',
  'memorySources.settings.unlimitedTooltip':
    'আপনি {toolkit}-এর জন্য সর্বাধিক সিঙ্ক করার অপশন বেছে নিয়েছেন। আপনি এখানে সীমা পরিবর্তন করতে পারেন।',
  'memorySources.settings.maxed': 'পূর্ণ',
  'memorySources.settings.save': 'সংরক্ষণ',
  'memorySources.settings.saving': 'সংরক্ষণ হচ্ছে…',
  'memorySources.settings.saved': 'সেটিংস সংরক্ষিত হয়েছে',
  'memorySources.settings.saveFailed': 'সেটিংস সংরক্ষণ করা সম্ভব হয়নি',
  'backend.aiBackend': 'AI ব্যাকএন্ড',
  'backend.cloud': 'ক্লাউড',
  'backend.recommended': 'প্রস্তাবিত',
  'backend.cloudDescription':
    'আমাদের সার্ভারে হোস্ট করা দ্রুত, শক্তিশালী মডেল। সাথে সাথে ব্যবহারের জন্য প্রস্তুত।',
  'backend.privacyNote': 'কোনো ব্যক্তিগত ডেটা, বার্তা বা কী কখনো আমাদের সার্ভারে পাঠানো হয় না।',
  'backend.local': 'লোকাল',
  'backend.advanced': 'অ্যাডভান্সড',
  'backend.localDescription':
    'Ollama ব্যবহার করে নিজের মেশিনে মডেল চালান। সম্পূর্ণ গোপনীয়তা, সেটআপ প্রয়োজন।',
  'backend.ramRecommended': '16GB+ RAM প্রস্তাবিত',
  'subconscious.tasks': 'টাস্ক',
  'subconscious.ticks': 'টিক',
  'subconscious.last': 'শেষ',
  'subconscious.failed': 'ব্যর্থ',
  'subconscious.tickInterval': 'টিক ইন্টারভাল',
  'subconscious.runNow': 'এখনই চালান',
  'subconscious.instance.on': 'চালু',
  'subconscious.instance.off': 'বন্ধ',
  'subconscious.instance.memory.title': 'আপনার জগৎ',
  'subconscious.instance.memory.subtitle': 'সংযুক্ত মেমরি উৎস',
  'subconscious.instance.tinyplace.title': 'অর্কেস্ট্রেশন স্টিয়ারিং',
  'subconscious.instance.tinyplace.subtitle': 'tiny.place সেশন পর্যালোচনা',
  'subconscious.instance.tinyplace.disabledHint':
    'র‍্যাপড সেশন পরিচালনায় অর্কেস্ট্রেশন সক্ষম করুন।',
  'subconscious.instance.tinyplace.viewDirectives': 'নির্দেশাবলী দেখুন →',
  'subconscious.runReviewNow': 'এখন পর্যালোচনা চালান',
  'tinyplaceOrchestration.subconsciousBadge': 'অবচেতন · স্টিয়ারিং',
  'tinyplaceOrchestration.steeringHeader.current': 'সক্রিয় নির্দেশ',
  'tinyplaceOrchestration.steeringHeader.none': 'কোনো সক্রিয় নির্দেশ নেই',
  'tinyplaceOrchestration.steeringHeader.expires': '{n} চক্র পরে মেয়াদ শেষ',
  'tinyplaceOrchestration.steeringHeader.lastReview': 'শেষ পর্যালোচনা',
  'tinyplaceOrchestration.steeringHeader.runReview': 'এখন পর্যালোচনা চালান',
  'tinyplaceOrchestration.steeringHeader.running': 'চলছে…',
  'subconscious.providerUnavailableTitle': 'Subconscious বিরত আছে',
  'subconscious.providerSettings': 'AI সেটিংস',
  'subconscious.scratchpadInfo':
    'প্রতিটি টিকে সাবকনশাস আপনার সংযুক্ত উৎসগুলিতে কী পরিবর্তিত হয়েছে তা যাচাই করে, তারপর আপনার করণীয় তালিকায় ফলো-আপ যোগ করে, আপনার লক্ষ্য আপডেট করে, অথবা কিছু মনোযোগের প্রয়োজন হলে আপনাকে জানায়। মোড এবং ফ্রিকোয়েন্সি কনফিগার করতে সেটিংস → এজেন্ট অ্যাক্সেস দেখুন।',
  'subconscious.approvalNeeded': 'অনুমোদন প্রয়োজন',
  'subconscious.requiresApproval': 'অনুমোদন প্রয়োজন',
  'subconscious.fixInConnections': 'সংযোগে ঠিক করুন',
  'subconscious.goAhead': 'এগিয়ে যান',
  'subconscious.activeTasks': 'সক্রিয় টাস্ক',
  'subconscious.noActiveTasks': 'কোনো সক্রিয় টাস্ক নেই',
  'subconscious.default': 'ডিফল্ট',
  'subconscious.addTaskPlaceholder': 'একটি নতুন টাস্ক যোগ করুন...',
  'subconscious.activityLog': 'অ্যাক্টিভিটি লগ',
  'subconscious.noActivity': 'এখনো কোনো অ্যাক্টিভিটি নেই',
  'subconscious.decision.nothingNew': 'নতুন কিছু নেই',
  'subconscious.decision.completed': 'সম্পন্ন',
  'subconscious.decision.evaluating': 'মূল্যায়ন হচ্ছে',
  'subconscious.decision.waitingApproval': 'অনুমোদনের অপেক্ষায়',
  'subconscious.decision.failed': 'ব্যর্থ',
  'subconscious.decision.cancelled': 'বাতিল',
  'subconscious.decision.skipped': 'এড়িয়ে গেছে',
  // Subconscious triggers (event-driven orchestrator) debug panel
  'subconsciousTriggers.title': 'সাবকনশাস ট্রিগার',
  'subconsciousTriggers.subtitle': 'ইভেন্ট-চালিত ব্যাকগ্রাউন্ড অর্কেস্ট্রেটর',
  'subconsciousTriggers.pipeline': 'পাইপলাইন',
  'subconsciousTriggers.mode': 'মোড',
  'subconsciousTriggers.orchestrator': 'অর্কেস্ট্রেটর',
  'subconsciousTriggers.running': 'চলছে',
  'subconsciousTriggers.stopped': 'বন্ধ',
  'subconsciousTriggers.promotionsPerHour': 'প্রমোশন / ঘণ্টা',
  'subconsciousTriggers.queueDepth': 'সারির গভীরতা',
  'subconsciousTriggers.orchestratorThread': 'অর্কেস্ট্রেটর থ্রেড',
  'subconsciousTriggers.userThread': 'ব্যবহারকারী থ্রেড',
  'subconsciousTriggers.disabledHint': 'পাইপলাইন সক্রিয় করতে ইভেন্ট-চালিত মোড সক্ষম করুন।',
  'subconsciousTriggers.enable': 'সক্ষম করুন',
  'subconsciousTriggers.disable': 'নিষ্ক্রিয় করুন',
  'actionable.complete': 'সম্পন্ন',
  'actionable.dismiss': 'বাদ দিন',
  'actionable.snooze': 'স্নুজ',
  'actionable.new': 'নতুন',
  'stats.storage': 'স্টোরেজ',
  'stats.files': 'ফাইল',
  'stats.documents': 'ডকুমেন্ট',
  'stats.today': 'আজ',
  'stats.namespaces': 'নেমস্পেস',
  'stats.relations': 'সম্পর্ক',
  'stats.firstMemory': 'প্রথম মেমোরি',
  'stats.latest': 'সর্বশেষ',
  'stats.sessions': 'সেশন',
  'stats.tokens': 'টোকেন',
  'bootCheck.invalidUrl': 'একটি রানটাইম URL দিন।',
  'bootCheck.urlMustStartWith': 'URL-টি http:// বা https:// দিয়ে শুরু হতে হবে',
  'bootCheck.validUrlRequired':
    'এটি বৈধ URL মনে হচ্ছে না (চেষ্টা করুন https://core.example.com/rpc)',
  'bootCheck.tokenRequired': 'সংযোগ করতে একটি অথ টোকেন প্রয়োজন।',
  'bootCheck.httpPublicWarning':
    'এটি একটি পাবলিক হোস্টে সাধারণ HTTP URL: ট্রাফিক এনক্রিপ্ট করা হবে না। এই নেটওয়ার্কে আস্থা না থাকলে HTTPS ব্যবহার করুন।',
  'bootCheck.chooseCoreMode': 'একটি রানটাইম বেছে নিন',
  'bootCheck.connectToCore': 'আপনার রানটাইমে সংযুক্ত হন',
  'bootCheck.desktopDescription':
    'OpenHuman চিন্তা করতে একটি রানটাইম প্রয়োজন। এটি কোথায় থাকবে তা বেছে নিন।',
  'bootCheck.webDescription':
    'ওয়েবে, OpenHuman আপনার নিয়ন্ত্রণে একটি রানটাইমে সংযুক্ত হয়। নিচে এর URL ও অথ টোকেন দিন, অথবা সরাসরি আপনার মেশিনে চালাতে ডেস্কটপ অ্যাপ নিন।',
  'bootCheck.preferDesktop': 'সব নিজের ডিভাইসে রাখতে চান?',
  'bootCheck.downloadDesktop': 'ডেস্কটপ অ্যাপ নিন',
  'bootCheck.localRecommended': 'লোকালি চালান (প্রস্তাবিত)',
  'bootCheck.localDescription':
    'সরাসরি আপনার কম্পিউটারে চলে। সবচেয়ে দ্রুত, সম্পূর্ণ ব্যক্তিগত, কিছু সেটআপ করতে হবে না।',
  'bootCheck.cloudMode': 'ক্লাউডে চালান (জটিল)',
  'bootCheck.cloudDescription':
    'অন্য কোথাও হোস্ট করা রানটাইমে সংযুক্ত হন। ২৪×৭ অনলাইন থাকে, এই ডিভাইস চালু রাখতে হয় না।',
  'bootCheck.coreRpcUrl': 'রানটাইম URL',
  'bootCheck.rpcUrlPlaceholder': 'https://core.example.com/rpc',
  'bootCheck.authToken': 'অথ টোকেন',
  'bootCheck.bearerTokenPlaceholder': 'আপনার রিমোট রানটাইম থেকে বেয়ারার টোকেন',
  'bootCheck.storedLocally': 'শুধু এই ডিভাইসে রাখা। পাঠানো হয় ',
  'bootCheck.testing': 'পরীক্ষা হচ্ছে…',
  'bootCheck.testConnection': 'সংযোগ পরীক্ষা করুন',
  'bootCheck.connectedOk': 'সংযুক্ত। সব ঠিকঠাক।',
  'bootCheck.authFailed': 'টোকেনটি কাজ করেনি। আবার পরীক্ষা করুন।',
  'bootCheck.unreachablePrefix': 'পৌঁছানো যায়নি:',
  'bootCheck.checkingCore': 'আপনার রানটাইম জাগানো হচ্ছে…',
  'bootCheck.cannotReach': 'রানটাইমে পৌঁছানো যাচ্ছে না',
  'bootCheck.cannotReachDesc': 'আপনার রানটাইমে সংযোগ করা যায়নি। অন্য একটি চেষ্টা করবেন?',
  'bootCheck.switchMode': 'ভিন্ন রানটাইম বেছে নিন',
  'bootCheck.quit': 'প্রস্থান',
  'bootCheck.legacyDetected': 'লেগ্যাসি ব্যাকগ্রাউন্ড রানটাইম শনাক্ত হয়েছে',
  'bootCheck.legacyDescription':
    'এই ডিভাইসে আলাদাভাবে ইনস্টল করা একটি OpenHuman ডেমন ইতিমধ্যে চলছে। বিল্ট-ইন রানটাইম নিয়ন্ত্রণ নেওয়ার আগে এটি সরাতে হবে।',
  'bootCheck.removing': 'সরানো হচ্ছে…',
  'bootCheck.removeContinue': 'সরান ও চালিয়ে যান',
  'bootCheck.localNeedsRestart': 'লোকাল রানটাইম রিস্টার্ট প্রয়োজন',
  'bootCheck.localNeedsRestartDesc':
    'আপনার লোকাল রানটাইম এই অ্যাপের চেয়ে ভিন্ন ভার্সনে আছে। দ্রুত রিস্টার্ট তাদের আবার সমন্বয় করবে।',
  'bootCheck.restarting': 'রিস্টার্ট হচ্ছে…',
  'bootCheck.restartCore': 'রানটাইম রিস্টার্ট করুন',
  'bootCheck.cloudNeedsUpdate': 'ক্লাউড রানটাইম আপডেট প্রয়োজন',
  'bootCheck.cloudNeedsUpdateDesc':
    'আপনার ক্লাউড রানটাইম এই অ্যাপের চেয়ে ভিন্ন ভার্সনে আছে। আপডেটার চালান।',
  'bootCheck.updating': 'আপডেট হচ্ছে…',
  'bootCheck.updateCloudCore': 'ক্লাউড রানটাইম আপডেট করুন',
  'bootCheck.versionCheckFailed': 'রানটাইম ভার্সন পরীক্ষা ব্যর্থ',
  'bootCheck.versionCheckFailedDesc':
    'আপনার রানটাইম চলছে কিন্তু ভার্সন জানাচ্ছে না। পুরনো হতে পারে। চালিয়ে যেতে রিস্টার্ট বা আপডেট করুন।',
  'bootCheck.working': 'কাজ হচ্ছে…',
  'bootCheck.restartUpdateCore': 'রানটাইম রিস্টার্ট / আপডেট করুন',
  'bootCheck.unexpectedError': 'অপ্রত্যাশিত বুট-চেক ত্রুটি',
  'bootCheck.actionFailed': 'কিছু একটা ভুল হয়েছে। আবার চেষ্টা করুন।',
  'bootCheck.portConflictTitle': 'অ্যাপ ইঞ্জিন চালু করা যায়নি',
  'bootCheck.portConflictBody':
    'অন্য একটি প্রক্রিয়া OpenHuman-এর প্রয়োজনীয় নেটওয়ার্ক পোর্ট ব্যবহার করছে। আমরা স্বয়ংক্রিয়ভাবে এটি ঠিক করার চেষ্টা করব।',
  'bootCheck.portConflictFixButton': 'স্বয়ংক্রিয়ভাবে ঠিক করুন',
  'bootCheck.portConflictFixing': 'ঠিক করা হচ্ছে…',
  'bootCheck.portConflictFixFailed':
    'স্বয়ংক্রিয় সংশোধন কাজ করেনি। অনুগ্রহ করে আপনার কম্পিউটার পুনরায় চালু করুন এবং আবার চেষ্টা করুন।',
  'bootCheck.portConflictOwner':
    '{name} (PID {pid}) OpenHuman-এর প্রয়োজনীয় নেটওয়ার্ক পোর্টটি ব্যবহার করছে।',
  'bootCheck.portConflictGuidance':
    'পোর্টটি মুক্ত করতে ওই প্রোগ্রামটি বন্ধ করুন, অথবা নিচে থেকে জোর করে বন্ধ করুন, তারপর আবার চেষ্টা করুন।',
  'bootCheck.portConflictForceQuit': '{name} জোর করে বন্ধ করুন',
  'bootCheck.portConflictForceQuitting': '{name} বন্ধ করা হচ্ছে…',
  'bootCheck.portConflictForceQuitFailed':
    'প্রোগ্রামটি বন্ধ করা যায়নি। আপনাকে সম্ভবত এটি ম্যানুয়ালি বন্ধ করে আবার চেষ্টা করতে হবে।',
  'notifications.justNow': 'এইমাত্র',
  'notifications.minAgo': '{n} মিনিট আগে',
  'notifications.hrAgo': '{n} ঘণ্টা আগে',
  'notifications.dayAgo': '{n} দিন আগে',
  'notifications.category.messages': 'বার্তা',
  'notifications.category.agents': 'এজেন্ট',
  'notifications.category.skills': 'স্কিলস',
  'notifications.category.system': 'সিস্টেম',
  'notifications.category.meetings': 'মিটিং',
  'notifications.category.reminders': 'রিমাইন্ডার',
  'notifications.category.important': 'গুরুত্বপূর্ণ',
  'notifications.filterAll': 'সব',
  'notifications.filterEmpty': 'এই বিভাগে কোনো সতর্কতা নেই',
  'about.update.status.checking': 'পরীক্ষা হচ্ছে...',
  'about.update.status.available': 'v{version} পাওয়া গেছে',
  'about.update.status.availableNoVersion': 'আপডেট পাওয়া গেছে',
  'about.update.status.downloading': 'ডাউনলোড হচ্ছে...',
  'about.update.status.readyToInstall': 'v{version} ইনস্টলের জন্য প্রস্তুত',
  'about.update.status.readyToInstallNoVersion':
    'নতুন ভার্সন ডাউনলোড হয়ে প্রস্তুত। প্রয়োগ করতে রিস্টার্ট করুন।',
  'about.update.status.installing': 'ইনস্টল হচ্ছে...',
  'about.update.status.restarting': 'রিস্টার্ট হচ্ছে...',
  'about.update.status.upToDate': 'আপনি সর্বশেষ ভার্সন চালাচ্ছেন।',
  'about.update.status.error': 'আপডেট পরীক্ষা ব্যর্থ',
  'about.update.status.default': 'আপডেট পরীক্ষা করুন',
  'welcome.connectionFailed': 'সংযোগ ব্যর্থ: {status} {statusText}',
  'welcome.connectionFailedMsg': 'সংযোগ ব্যর্থ: {message}',
  'welcome.continueLocally': 'স্থানীয়ভাবে চালিয়ে যান',
  'welcome.continueLocallyExperimental': 'লোকালি চালিয়ে যান (প্রায়োগিক)',
  'welcome.localSessionStarting': 'স্থানীয় অধিবেশন শুরু করা হচ্ছে...',
  'welcome.coreConfigUnreadable':
    'রানটাইম তার কনফিগারেশন ফাইল পড়তে পারেনি। config.toml অন্য কোনো ব্যবহারকারী অ্যাকাউন্টের হতে পারে, অথবা অন্য কোনো কারণে রানটাইম প্রক্রিয়ার জন্য দুর্গম হতে পারে। রানটাইম পুনরায় চালু করুন, আর তাতে কাজ না হলে ওয়ার্কস্পেসের মালিকানা ঠিক করুন বা এর ভলিউম নতুন করে তৈরি করুন।',
  'welcome.localSessionErrorFallback': 'স্থানীয় সেশন শুরু করা যায়নি।',
  'welcome.localSessionDesc': 'একটি অফলাইন skips__ BR__Ans স্থানীয় প্রোফাইল ব্যবহার করে।',
  'chat.agentChatDesc': 'এজেন্টের সাথে সরাসরি চ্যাট সেশন খুলুন।',
  'chat.modelPlaceholder': 'gpt-4o',
  'channels.activeRouteValue': '{authMode} এর মাধ্যমে {channel}',
  'privacy.dataKind.messages': 'বার্তা',
  'privacy.dataKind.agents': 'এজেন্ট',
  'privacy.dataKind.skills': 'স্কিলস',
  'privacy.dataKind.system': 'সিস্টেম',
  'privacy.dataKind.meetings': 'মিটিং',
  'privacy.dataKind.reminders': 'রিমাইন্ডার',
  'privacy.dataKind.important': 'গুরুত্বপূর্ণ',
  'onboarding.enableLocalAI': 'লোকাল AI সক্রিয় করুন',
  'onboarding.skills.status.available': 'পাওয়া যাচ্ছে',
  'onboarding.skills.status.connected': 'সংযুক্ত',
  'onboarding.skills.status.connecting': 'সংযোগ হচ্ছে',
  'onboarding.skills.status.error': 'ত্রুটি',
  'onboarding.skills.status.unavailable': 'পাওয়া যাচ্ছে না',
  'composio.statusUnavailable': 'স্ট্যাটাস পাওয়া যাচ্ছে না',
  'composio.authExpired': 'অথ মেয়াদোত্তীর্ণ',
  'composio.reconnect': 'পুনঃসংযোগ',
  'composio.expiredAuthorization': '{name} অনুমোদনের মেয়াদ শেষ',
  'composio.expiredDescription':
    'পুনরায় সংযোগ করতে PH__0 টুল পুনরায় সংযুক্ত করুন। আপনি OAuth অ্যাক্সেস রিফ্রেশ না করা পর্যন্ত OpenHuman এই ইন্টিগ্রেশনটি অনুপলব্ধ রাখবে৷',
  'composio.envVarOverrides': 'সেট থাকলে, এই সেটিং ওভাররাইড করে।',
  'composio.previewBadge': 'পূর্বরূপ',
  'composio.previewTooltip':
    'এজেন্ট ইন্টিগ্রেশন শীঘ্রই আসছে: আপনি সংযোগ করতে পারেন, কিন্তু এজেন্ট এখনও এই টুলকিটটি ব্যবহার করতে পারবেন না।',
  'memory.day.sun': 'রবি',
  'memory.day.mon': 'সোম',
  'memory.day.tue': 'মঙ্গল',
  'memory.day.wed': 'বুধ',
  'memory.day.thu': 'বৃহঃ',
  'memory.day.fri': 'শুক্র',
  'memory.day.sat': 'শনি',
  'memory.ingesting': 'ইনজেস্ট হচ্ছে',
  'memory.ingestionQueued': 'কিউতে',
  'memory.ingestingTitle': '{title} ইনজেস্ট হচ্ছে',
  'mic.noAudioCaptured': 'কোনো অডিও ক্যাপচার হয়নি',
  'mic.noSpeechDetected': 'কোনো কথা শনাক্ত হয়নি',
  'mic.lowConfidenceResult': 'অডিও স্পষ্টভাবে বোঝা যায়নি: আবার চেষ্টা করুন',
  'mic.failedToStopRecording': 'রেকর্ডিং বন্ধ করতে ব্যর্থ: {message}',
  'mic.transcriptionFailed': 'ট্রান্সক্রিপশন ব্যর্থ: {message}',
  'mic.voiceNotCompiled':
    'অ্যাপের এই সংস্করণে ভয়েস ট্রান্সক্রিপশন অন্তর্ভুক্ত নেই। এটি চালু করতে OpenHuman আপডেট করুন।',
  'reflections.kind.retrospective': 'পূর্বদর্শন',
  'reflections.kind.derivedFact': 'ডেরাইভড ফ্যাক্ট',
  'reflections.kind.moodInsight': 'মুড ইনসাইট',
  'reflections.kind.relationshipInsight': 'সম্পর্ক ইনসাইট',
  'graph.tooltip.summary': 'সারসংক্ষেপ',
  'graph.tooltip.contact': 'যোগাযোগ',
  'localModel.usage.never': 'কখনো না',
  'localModel.usage.mediumLoad': 'মাঝারি লোড',
  'localModel.usage.lowLoad': 'কম লোড',
  'localModel.usage.idleMode': 'আইডল মোড',
  'localModel.rebootstrapComplete': 'মডেল রি-বুটস্ট্র্যাপ সম্পন্ন।',
  'localModel.modelsVerified': 'লোকাল মডেল যাচাই করা হয়েছে।',
  'accounts.addModal.allConnected': 'সব সংযুক্ত',
  'accounts.addModal.title': 'অ্যাকাউন্ট যোগ করুন',
  'accounts.respondQueue.empty': 'খালি',
  'accounts.respondQueue.hide': 'প্রতিক্রিয়া সারি লুকান',
  'accounts.respondQueue.loadFailed': 'রেসপন্ড কিউ লোড করতে ব্যর্থ',
  'accounts.respondQueue.loading': 'কিউ লোড হচ্ছে…',
  'accounts.respondQueue.pending': 'মুলতুবি',
  'accounts.respondQueue.show': 'প্রতিক্রিয়া সারি দেখান',
  'accounts.respondQueue.title': 'রেসপন্ড কিউ',
  'accounts.webviewHost.almostReady': 'প্রায় প্রস্তুত...',
  'accounts.webviewHost.loadTimeout': 'Webview লোড টাইমআউট',
  'accounts.webviewHost.loading': '{providerName} লোড হচ্ছে...',
  'accounts.webviewHost.loadingAccount': 'অ্যাকাউন্ট লোড হচ্ছে',
  'accounts.webviewHost.restoringSession': 'সেশন পুনরুদ্ধার হচ্ছে...',
  'accounts.webviewHost.retryLoading': 'লোড আবার চেষ্টা করুন',
  'accounts.webviewHost.takingLonger': '{providerName} প্রত্যাশার চেয়ে বেশি সময় নিচ্ছে।',
  'accounts.webviewHost.timeoutHint': 'টাইমআউট হিন্ট',
  'app.connectionBadge.composio': 'Composio',
  'app.connectionBadge.messaging': 'মেসেজিং',
  'app.connectionIndicator.connected': 'OpenHuman AI-এ সংযুক্ত 🚀',
  'app.connectionIndicator.connecting': 'সংযোগ হচ্ছে',
  'app.connectionIndicator.coreOffline': 'কোর অফলাইন',
  'app.connectionIndicator.disconnected': 'সংযোগ বিচ্ছিন্ন',
  'app.connectionIndicator.offline': 'অফলাইন',
  'app.connectionIndicator.reconnecting': 'পুনঃসংযোগ হচ্ছে…',
  'app.errorFallback.componentStack': 'কম্পোনেন্ট স্ট্যাক',
  'app.errorFallback.contactSupport': 'সহায়তায় যোগাযোগ করুন',
  'app.errorFallback.copyEventId': 'অনুলিপি',
  'app.errorFallback.eventIdCopied': 'অনুলিপি হয়েছে',
  'app.errorFallback.eventIdLabel': 'ত্রুটি আইডি',
  'app.errorFallback.revealLogs': 'লগ দেখান',
  'app.errorFallback.downloadLatest': 'সর্বশেষ ডাউনলোড করুন',
  'app.errorFallback.heading': 'শিরোনাম',
  'app.errorFallback.hint': 'হিন্ট',
  'app.errorFallback.reloadApp': 'অ্যাপ রিলোড করুন',
  'app.errorFallback.subheading': 'উপশিরোনাম',
  'app.errorFallback.tryRecover': 'পুনরুদ্ধার চেষ্টা করুন',
  'app.localAiDownload.installing': 'ইনস্টল হচ্ছে...',
  'app.localAiDownload.preparing': 'প্রস্তুত হচ্ছে...',
  'app.openhumanLink.accounts.continueWith': '{label} সাইন-ইন দিয়ে চালিয়ে যান',
  'app.openhumanLink.accounts.done': 'সম্পন্ন',
  'app.openhumanLink.accounts.intro': 'ভূমিকা',
  'app.openhumanLink.accounts.webviewNote': 'Webview নোট',
  'app.openhumanLink.billing.openDashboard': 'ড্যাশবোর্ড খুলুন',
  'app.openhumanLink.billing.stayOnTrial': 'ট্রায়ালে থাকুন',
  'app.openhumanLink.billing.trialCredit': 'সাইনআপ ক্রেডিট',
  'app.openhumanLink.billing.trialDesc':
    'প্রোমোশন ও অ্যাকাউন্টের যোগ্যতার ওপর ক্রেডিট অফার ভিন্ন হতে পারে।',
  'app.openhumanLink.defaultBody': 'পপআপে এখনো প্রস্তুত নয়। সম্পূর্ণ সেটিংস পেজ খুলুন যখন',
  'app.openhumanLink.discord.intro': 'ভূমিকা',
  'app.openhumanLink.discord.openInvite': 'আমন্ত্রণ খুলুন',
  'app.openhumanLink.discord.perk1': 'সুবিধা ১',
  'app.openhumanLink.discord.perk2': 'সুবিধা ২',
  'app.openhumanLink.discord.perk3': 'সুবিধা ৩',
  'app.openhumanLink.discord.perk4': 'সুবিধা ৪',
  'app.openhumanLink.discordReport.intro':
    'দুঃখিত: আমাদের দিক থেকে কিছু ভুল হয়েছে। আমরা এগুলো স্বয়ংক্রিয়ভাবে লগ করার চেষ্টা করি, তবে Discord-এ বিবরণ শেয়ার করলে আমরা দ্রুত সমাধান করতে পারি।',
  'app.openhumanLink.discordReport.openDiscord': 'Discord খুলুন',
  'app.openhumanLink.done': 'সম্পন্ন',
  'app.openhumanLink.notifications.desktopOnly':
    'নেটিভ বিজ্ঞপ্তি শুধুমাত্র ডেস্কটপ অ্যাপে উপলব্ধ (`pnpm dev:app` চালান)।',
  'app.openhumanLink.notifications.permissionOff':
    'বিজ্ঞপ্তির অনুমতি বন্ধ আছে। সিস্টেম সেটিংস → বিজ্ঞপ্তি-তে OpenHuman সক্রিয় করুন, তারপর পুনরায় চেষ্টা করুন।',
  'app.openhumanLink.notifications.triggerFailed':
    'OpenHuman একটি সিস্টেম বিজ্ঞপ্তি চালু করতে পারেনি। OS-এর বিজ্ঞপ্তি সেটিংস যাচাই করুন এবং পুনরায় চেষ্টা করুন।',
  'app.openhumanLink.notifications.welcomeBody':
    'যখন কোনো কিছুতে আপনার মনোযোগ প্রয়োজন হবে, তখন আপনি এখানে পিং পাবেন।',
  'app.openhumanLink.notifications.welcomeTitle': 'OpenHuman ব্যবহারের জন্য প্রস্তুত',
  'app.openhumanLink.status.closed': 'বন্ধ',
  'app.openhumanLink.status.connected': 'সংযুক্ত',
  'app.openhumanLink.status.error': 'ত্রুটি',
  'app.openhumanLink.status.loading': 'লোড হচ্ছে…',
  'app.openhumanLink.status.needsSignIn': 'সাইন-ইন প্রয়োজন',
  'app.openhumanLink.status.timedOut': 'সময় শেষ',
  'app.openhumanLink.loadingChannelSetup': 'চ্যানেল সেটআপ লোড হচ্ছে',
  'app.openhumanLink.maybeLater': 'হয়তো পরে',
  'app.openhumanLink.notifications.asking': 'OS-এ জিজ্ঞেস করছে…',
  'app.openhumanLink.notifications.blocked': 'ব্লক করা',
  'app.openhumanLink.notifications.blockedStep1': 'ব্লক করা ধাপ ১',
  'app.openhumanLink.notifications.blockedStep2': 'ব্লক করা ধাপ ২',
  'app.openhumanLink.notifications.blockedStep3': 'ব্লক করা ধাপ ৩',
  'app.openhumanLink.notifications.intro': 'ভূমিকা',
  'app.openhumanLink.notifications.promptHint': 'প্রম্পট হিন্ট',
  'app.openhumanLink.notifications.retry': 'পরীক্ষা বিজ্ঞপ্তি আবার চেষ্টা করুন',
  'app.openhumanLink.notifications.send': 'পরীক্ষা বিজ্ঞপ্তি পাঠান',
  'app.openhumanLink.notifications.sendFailed': 'পাঠানো যায়নি: {error}',
  'app.openhumanLink.notifications.sent':
    'টেস্ট নোটিফিকেশন পাঠানো হয়েছে। যদি না পেয়ে থাকেন, System Settings → Notifications → OpenHuman-এ যান, Allow Notifications চালু করুন, এবং Banner Style-কে Persistent-এ সেট করুন।',
  'app.openhumanLink.skipForNow': 'এখনের জন্য এড়িয়ে যান',
  'app.openhumanLink.telegramUnavailable': 'Telegram পাওয়া যাচ্ছে না',
  'app.openhumanLink.title.accounts': 'আপনার অ্যাপ সংযুক্ত করুন',
  'app.openhumanLink.title.billing': 'বিলিং ও ক্রেডিট',
  'app.openhumanLink.title.discord': 'কমিউনিটিতে যোগ দিন',
  'app.openhumanLink.title.discordReport': 'এই ত্রুটি রিপোর্ট করুন',
  'app.openhumanLink.title.messaging': 'একটি চ্যাট চ্যানেল সংযুক্ত করুন',
  'app.openhumanLink.title.notifications': 'বিজ্ঞপ্তির অনুমতি দিন',
  'app.persistRehydration.body': 'বডি',
  'app.persistRehydration.heading': 'শিরোনাম',
  'app.persistRehydration.resetCta': 'রিসেট হচ্ছে…',
  'app.persistRehydration.resetting': 'রিসেট হচ্ছে…',
  'app.routeLoading.initializing': 'OpenHuman শুরু হচ্ছে...',
  'app.update.currentlyOn': '{version}',
  'app.update.errorFallback': 'আপডেটের সময় কিছু একটা ভুল হয়েছে।',
  'app.update.header.default': 'আপডেট',
  'app.update.header.error': 'আপডেট ব্যর্থ',
  'app.update.header.installing': 'আপডেট ইনস্টল হচ্ছে',
  'app.update.header.readyToInstall': 'আপডেট ইনস্টলের জন্য প্রস্তুত',
  'app.update.header.restarting': 'রিস্টার্ট হচ্ছে…',
  'app.update.later': 'পরে',
  'app.update.newVersionReady': 'একটি নতুন ভার্সন ইনস্টলের জন্য প্রস্তুত।',
  'app.update.progress.downloaded': '{amount} ডাউনলোড হয়েছে',
  'app.update.progress.installing': 'নতুন ভার্সন ইনস্টল হচ্ছে…',
  'app.update.progress.restarting': 'অ্যাপ পুনরায় লঞ্চ হচ্ছে…',
  'app.update.progress.working': '{percent}%',
  'app.update.restartNote': 'রিস্টার্ট নোট',
  'app.update.restartNow': 'এখনই রিস্টার্ট করুন',
  'app.update.versionReady': 'ভার্সন {newVersion} ইনস্টলের জন্য প্রস্তুত।',
  'channels.discord.accountLinked': 'অ্যাকাউন্ট লিংক হয়েছে',
  'channels.discord.connect': 'সংযুক্ত করুন',
  'channels.discord.linkTokenExpired': 'লিংক টোকেনের মেয়াদ শেষ। আবার চেষ্টা করুন।',
  'channels.discord.linkTokenInstruction': '{token}',
  'channels.discord.linkTokenLabel': 'লিংক টোকেন লেবেল',
  'channels.discord.linkTokenOnce': 'লিংক টোকেন একবার',
  'channels.discord.picker.allPermissionsOk': 'বট এই চ্যানেলে সব প্রয়োজনীয় অনুমতি পেয়েছে।',
  'channels.discord.picker.botNotInServers': 'বট কোনো সার্ভারে নেই',
  'channels.discord.picker.category': 'ক্যাটাগরি',
  'channels.discord.picker.channel': 'চ্যানেল',
  'channels.discord.picker.checkingPermissions': 'অনুমতি পরীক্ষা হচ্ছে',
  'channels.discord.picker.loadingChannels': 'চ্যানেল লোড হচ্ছে...',
  'channels.discord.picker.loadingServers': 'সার্ভার লোড হচ্ছে...',
  'channels.discord.picker.missingPermissions': 'অনুমতি নেই',
  'channels.discord.picker.noChannels': 'কোনো টেক্সট চ্যানেল পাওয়া যায়নি',
  'channels.discord.picker.noServers': 'কোনো সার্ভার পাওয়া যায়নি',
  'channels.discord.picker.selectChannel': 'একটি চ্যানেল বেছে নিন',
  'channels.discord.picker.selectServer': 'একটি সার্ভার বেছে নিন',
  'channels.discord.picker.server': 'সার্ভার',
  'channels.discord.picker.serverChannelSelection': 'সার্ভার ও চ্যানেল নির্বাচন',
  'channels.discord.savedRestartRequired': 'চ্যানেল সংরক্ষিত। সক্রিয় করতে অ্যাপ রিস্টার্ট করুন।',
  'channels.telegram.connect': 'সংযুক্ত করুন',
  'channels.telegram.managedDmConnecting': 'ম্যানেজড DM সংযোগ হচ্ছে',
  'channels.telegram.managedDmTimeout': 'ম্যানেজড DM টাইমআউট',
  'channels.telegram.reconnect': 'পুনরায় সংযুক্ত করুন',
  'channels.telegram.savedRestartRequired': 'চ্যানেল সংরক্ষিত। সক্রিয় করতে অ্যাপ রিস্টার্ট করুন।',
  'channels.web.alwaysAvailable': 'সর্বদা পাওয়া যায়',
  'chat.approval.approve': 'লিইরোভ',
  'chat.approval.alwaysAllow': 'সর্বদা অনুমতি প্রদান করা হবে',
  'chat.approval.alwaysAllowHint':
    'এই সরঞ্জামের জন্য অনুরোধ করবেন না - সর্বদা আপনার তালিকায় যোগ করুন',
  'chat.approval.deciding': 'চলমান...',
  'chat.approval.deny': 'প্রত্যাখ্যান করুন',
  'chat.approval.error': 'আপনার সিদ্ধান্তের কথা রেকর্ড করা যায় নি: আবার চেষ্টা করুন ।',
  'chat.approval.fallback': 'এজেন্ট এমন কাজ করতে চায় যা আপনার অনুমোদন প্রয়োজন.',
  'chat.approval.title': 'অনুমোদন প্রয়োজন',
  'chat.approval.tool': 'টুল:',
  'chat.flowApproval.title': 'ওয়ার্কফ্লোর জন্য অনুমোদন প্রয়োজন',
  'chat.flowApproval.fallback':
    'একটি ওয়ার্কফ্লো রান আপনার অনুমোদনের প্রয়োজন এমন একটি কাজ সম্পাদন করতে চায়।',
  'chat.flowApproval.tool': 'টুল:',
  'chat.flowApproval.flow': 'ফ্লো:',
  'chat.flowApproval.approve': 'একবার অনুমোদন করুন',
  'chat.flowApproval.approveAlways': 'সর্বদা অনুমোদন করুন',
  'chat.flowApproval.approveAlwaysHint': 'এই ফ্লো-এর ভবিষ্যত রানগুলিতে এই চেকপয়েন্ট এড়িয়ে যান',
  'chat.flowApproval.deny': 'প্রত্যাখ্যান করুন',
  'chat.flowApproval.deciding': 'চলমান...',
  'chat.flowApproval.error': 'আপনার সিদ্ধান্তের কথা রেকর্ড করা যায় নি: আবার চেষ্টা করুন ।',
  'chat.flowProposal.title': 'ওয়ার্কফ্লো প্রস্তাব',
  'chat.flowProposal.subtitle': 'সংরক্ষণ করার আগে এই অটোমেশনটি পর্যালোচনা করুন।',
  'chat.flowProposal.triggerLabel': 'ট্রিগার',
  'chat.flowProposal.stepsLabel': 'ধাপসমূহ',
  'chat.flowProposal.noSteps': 'কোনো অতিরিক্ত ধাপ নেই।',
  'chat.flowProposal.requireApprovalHint':
    'প্রতিটি বহির্গামী কাজের জন্য আপনার অনুমোদন প্রয়োজন হবে।',
  'chat.flowProposal.save': 'সংরক্ষণ ও সক্রিয় করুন',
  'chat.flowProposal.saving': 'সংরক্ষণ করা হচ্ছে…',
  'chat.flowProposal.openInCanvas': 'ক্যানভাসে খুলুন',
  'chat.flowProposal.dismiss': 'খারিজ করুন',
  'chat.flowProposal.error': 'ওয়ার্কফ্লো সংরক্ষণ করা যায়নি। আবার চেষ্টা করুন।',
  'chat.flowProposal.enableError':
    'ওয়ার্কফ্লো সংরক্ষিত হয়েছে, কিন্তু সক্ষম করা যায়নি। আবার চেষ্টা করুন, বা Workflows পৃষ্ঠা থেকে সক্ষম করুন।',
  'chat.flowProposal.savedConfirmation': 'সংরক্ষিত হয়েছে',
  'chat.flowProposal.viewWorkflow': 'ওয়ার্কফ্লো দেখুন',
  'chat.flowProposal.stepKind.agent': 'এজেন্ট',
  'chat.flowProposal.stepKind.toolCall': 'কার্যক্রম',
  'chat.flowProposal.stepKind.httpRequest': 'ওয়েব অনুরোধ',
  'chat.flowProposal.stepKind.code': 'কোড চালান',
  'chat.flowProposal.stepKind.condition': 'শর্ত',
  'chat.flowProposal.stepKind.switch': 'সুইচ',
  'chat.flowProposal.stepKind.merge': 'একত্রিত করুন',
  'chat.flowProposal.stepKind.splitOut': 'বিভক্ত করুন',
  'chat.flowProposal.stepKind.transform': 'রূপান্তর করুন',
  'chat.flowProposal.stepKind.outputParser': 'আউটপুট পার্স করুন',
  'chat.flowProposal.stepKind.subWorkflow': 'সাব-ওয়ার্কফ্লো',
  'channels.authMode.managed_dm': 'OpenHuman দিয়ে লগইন করুন',
  'channels.authMode.oauth': 'OAuth সাইন-ইন করুন',
  'channels.authMode.bot_token': 'আপনার নিজের বট টোকেন ব্যবহার করুন',
  'channels.authMode.api_key': 'আপনার নিজস্ব API কী ব্যবহার করুন',
  'channels.fieldRequired': '{field} প্রয়োজন',
  'channels.mcp.title': '__PH0__ সার্ভার__92731',
  'channels.mcp.description':
    'Model Context Protocol সার্ভার ব্রাউজ করুন এবং পরিচালনা করুন, যা AI-কে নতুন টুল দিয়ে সম্প্রসারিত করে।',
  'channels.discord.displayName': 'Discord',
  'channels.discord.description': 'Discord এর মাধ্যমে বার্তা পাঠান এবং গ্রহণ করুন।',
  'channels.discord.authMode.bot_token.description': 'আপনার নিজস্ব Discord বট টোকেন প্রদান করুন।',
  'channels.discord.authMode.oauth.description':
    'OAuth এর মাধ্যমে আপনার Discord সার্ভারে OpenHuman বট ইনস্টল করুন।',
  'channels.discord.authMode.managed_dm.description':
    'আপনার ব্যক্তিগত Discord অ্যাকাউন্টটি OpenHuman বটের সাথে লিঙ্ক করুন।',
  'channels.discord.fields.bot_token.label': 'বট টোকেন',
  'channels.discord.fields.bot_token.placeholder': 'আপনার Discord বট টোকেন',
  'channels.discord.fields.guild_id.label': 'সার্ভার (গিল্ড) আইডি',
  'channels.discord.fields.guild_id.placeholder': 'ঐচ্ছিক: একটি নির্দিষ্ট সার্ভারে সীমাবদ্ধ',
  'channels.telegram.displayName': 'Telegram',
  'channels.telegram.description': 'Telegram এর মাধ্যমে বার্তা পাঠান এবং গ্রহণ করুন।',
  'channels.telegram.authMode.managed_dm.description': 'সরাসরি OpenHuman Telegram বটকে মেসেজ করুন।',
  'channels.telegram.authMode.bot_token.description':
    '@BotFather থেকে আপনার নিজস্ব Telegram বট টোকেন প্রদান করুন।',
  'channels.telegram.fields.bot_token.label': 'বট টোকেন',
  'channels.telegram.fields.bot_token.placeholder': '123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11',
  'channels.telegram.fields.allowed_users.label': 'অনুমোদিত ব্যবহারকারীদের',
  'channels.telegram.fields.allowed_users.placeholder':
    'কমা দ্বারা পৃথক করা Telegram ব্যবহারকারীর নাম',
  'channels.telegram.remoteControlTitle': 'রিমোট কন্ট্রোল (Telegram)',
  'channels.telegram.remoteControlBody':
    'একটি অনুমোদিত Telegram চ্যাট থেকে, /status, /sessions, /new, অথবা /help পাঠান। মডেল রাউটিং এখনও /মডেল এবং /মডেল ব্যবহার করে।',
  'channels.connectHelp.title': 'কীভাবে সংযুক্ত করবেন',
  'channels.connectHelp.discord':
    'নিচে একটি পদ্ধতি বেছে নিন: OpenHuman-এর মাধ্যমে আপনার অ্যাকাউন্ট লিঙ্ক করুন, OAuth দিয়ে বট ইনস্টল করুন, অথবা Discord ডেভেলপার পোর্টাল থেকে আপনার নিজের বট টোকেন পেস্ট করুন।',
  'channels.connectHelp.telegram':
    'নিচে একটি পদ্ধতি বেছে নিন: লিঙ্ক করতে ম্যানেজড OpenHuman বটে বার্তা পাঠান, অথবা @BotFather থেকে আপনার নিজের বট টোকেন পেস্ট করুন।',
  'channels.connectHelp.slackNote':
    'Slack খুঁজছেন? Slack এখানে মেসেজিং চ্যানেল হিসেবে নয়, সংযোগ → OAuth-এ একটি অ্যাপ হিসেবে সংযুক্ত হয়।',
  'channels.web.displayName': 'ওয়েব',
  'channels.web.description': 'বিল্ট-ইন ওয়েব UI এর মাধ্যমে চ্যাট করুন।',
  'channels.web.authMode.managed_dm.description':
    'এমবেড করা ওয়েব চ্যাট ব্যবহার করুন: কোনো সেটআপের প্রয়োজন নেই।',
  'channels.yuanbao.connect': 'Connect',
  'channels.yuanbao.connecting': 'সংযোগ হচ্ছে…',
  'channels.yuanbao.fieldRequired': '{field} আবশ্যক',
  'channels.yuanbao.reconnect': 'Reconnect',
  'channels.yuanbao.savedRestartRequired':
    'চ্যানেল সংরক্ষিত হয়েছে। সক্রিয় করতে অ্যাপটি পুনরায় চালু করুন।',
  'channels.yuanbao.unexpectedStatus': 'অপ্রত্যাশিত সংযোগ অবস্থা: {status}',
  'chat.unsubscribeApproval.approve': 'অনুমোদন ও আনসাবস্ক্রাইব',
  'chat.unsubscribeApproval.approved': '✓ সফলভাবে আনসাবস্ক্রাইব হয়েছে।',
  'chat.unsubscribeApproval.denied': '✕ অনুরোধ প্রত্যাখ্যাত।',
  'chat.unsubscribeApproval.deny': 'প্রত্যাখ্যান করুন',
  'chat.unsubscribeApproval.processing': 'প্রক্রিয়া হচ্ছে...',
  'chat.unsubscribeApproval.title': 'আনসাবস্ক্রাইব অনুরোধ',
  'commandPalette.ariaLabel': 'কমান্ড প্যালেট',
  'commandPalette.description': 'বিবরণ',
  'commandPalette.label': 'কমান্ড',
  'commandPalette.noResults': 'কোনো ফলাফল নেই',
  'commandPalette.placeholder': 'একটি কমান্ড টাইপ করুন বা খুঁজুন…',
  'commandPalette.searchAria': 'কমান্ড খুঁজুন',
  'commandPalette.shortcutHint': 'সব শর্টকাটের জন্য ? চাপুন',
  'commandPalette.title': 'কমান্ড প্যালেট',
  'kbd.ariaLabel': 'কীবোর্ড শর্টকাট: {shortcut}',
  'shortcuts.title': 'কীবোর্ড শর্টকাট',
  'shortcuts.subtitle': 'এই কীবোর্ড শর্টকাটগুলি দিয়ে আপনার কাজ দ্রুত করুন।',
  'shortcuts.menuDesc': 'অ্যাপ-জুড়ে সব কীবোর্ড শর্টকাট দেখুন।',
  'shortcuts.empty': 'এই মুহূর্তে কোনো কীবোর্ড শর্টকাট উপলব্ধ নেই।',
  'shortcuts.openHint': 'যেকোনো সময় এই তালিকা খুলুন',
  'shortcuts.group.navigation': 'নেভিগেশন',
  'shortcuts.group.profiles': 'প্রোফাইল',
  'shortcuts.group.chat': 'চ্যাট',
  'shortcuts.group.view': 'ভিউ',
  'shortcuts.group.general': 'সাধারণ',
  'shortcuts.group.help': 'সহায়তা',
  'shortcuts.action.home': 'হোমে যান',
  'shortcuts.action.chat': 'চ্যাটে যান',
  'shortcuts.action.knowledge': 'জ্ঞান ও স্মৃতিতে যান',
  'shortcuts.action.connections': 'সংযোগে যান',
  'shortcuts.action.activity': 'কার্যকলাপে যান',
  'shortcuts.action.settings': 'সেটিংস খুলুন',
  'shortcuts.action.newChat': 'নতুন চ্যাট',
  'shortcuts.action.toggleSidebar': 'সাইডবার টগল করুন',
  'shortcuts.action.commandPalette': 'কমান্ড প্যালেট',
  'iosMascot.connectedTo': '[[I18N_SEP_92731]] এর সাথে সংযুক্ত',
  'iosMascot.defaultPairedLabel': 'ডেস্কটপ',
  'iosMascot.disconnect': 'সংযোগ বিচ্ছিন্ন করুন',
  'iosMascot.error.generic': 'কিছু ভুল হয়েছে৷ আবার চেষ্টা করুন.',
  'iosMascot.error.sendFailed': 'পাঠাতে ব্যর্থ হয়েছে৷ আপনার সংযোগ পরীক্ষা করুন.',
  'iosMascot.pushToTalk': 'কথা বলার জন্য চাপ দিন',
  'iosMascot.sendMessage': 'বার্তা পাঠান',
  'iosMascot.thinking': 'থিং...',
  'iosMascot.typeMessage': 'একটি বার্তা টাইপ করুন...',
  'iosPair.connectedLoading': 'সংযুক্ত! লোড হচ্ছে...',
  'iosPair.connecting': 'ডেস্কটপের সাথে সংযুক্ত হচ্ছে...',
  'iosPair.desktopLabel': 'ডেস্কটপ',
  'iosPair.error.camera':
    'ক্যামেরা স্ক্যান ব্যর্থ হয়েছে। ক্যামেরার অনুমতি পরীক্ষা করুন এবং আবার চেষ্টা করুন।',
  'iosPair.error.connectionFailed':
    'সংযোগ ব্যর্থ হয়েছে। নিশ্চিত করুন ডেস্কটপ অ্যাপটি চলছে এবং আবার চেষ্টা করুন।',
  'iosPair.error.invalidQr':
    'অবৈধ QR কোড। নিশ্চিত করুন আপনি একটি OpenHuman পেয়ারিং কোড স্ক্যান করছেন।',
  'iosPair.error.unreachableDesktop':
    'ডেস্কটপে পৌঁছানো যায়নি। নিশ্চিত করুন উভয় ডিভাইস অনলাইনে আছে এবং আবার চেষ্টা করুন।',
  'iosPair.expired': 'QR code মেয়াদ শেষ হয়েছে। কোডটি পুনরায় তৈরি করতে ডেস্কটপকে বলুন।',
  'iosPair.instructions':
    'আপনার ডেস্কটপে OpenHuman খুলুন, Settings > Devices-এ যান, এবং QR কোড দেখাতে "Pair phone" ট্যাপ করুন।',
  'iosPair.retryScan': 'পুনরায় স্ক্যান করার চেষ্টা করুন',
  'iosPair.scanQrCode': 'স্ক্যান QR code',
  'iosPair.scannerOpening': 'স্ক্যানার খোলা হচ্ছে...',
  'iosPair.step.openDesktop': 'ডেস্কটপে OpenHuman খুলুন',
  'iosPair.step.openSettings': 'সেটিংস > ডিভাইসগুলিতে যান',
  'iosPair.step.showQr': 'QR',
  'iosPair.title': 'আপনার ডেস্কটপের সাথে পেয়ার করুন',
  'composio.connect.additionalConfigRequired': 'অতিরিক্ত কনফিগ প্রয়োজন',
  'composio.connect.atlassianSubdomainHint': 'acme',
  'composio.connect.atlassianSubdomainLabel': 'Atlassian সাবডোমেইন লেবেল',
  'composio.connect.connect': 'সংযোগ করুন',
  'composio.connect.connectedAccounts': 'সংযুক্ত অ্যাকাউন্ট',
  'composio.connect.defaultLabel': 'ডিফল্ট',
  'composio.connect.disconnectAccount': 'সরান',
  'composio.connect.addAnotherAccount': 'আরেকটি অ্যাকাউন্ট যোগ করুন',
  'composio.connect.dynamicsOrgNameHint':
    'উদাহরণস্বরূপ, myorg.crm.dynamics.com-এর জন্য "myorg"। সম্পূর্ণ URL নয়, শুধু সংক্ষিপ্ত সংস্থার নাম লিখুন।',
  'composio.connect.dynamicsOrgNameLabel': 'Dynamics 365 সংস্থার নাম',
  'composio.connect.connectionFailed': 'সংযোগ ব্যর্থ (স্ট্যাটাস: {status})।',
  'composio.connect.disconnectFailed': 'সংযোগ বিচ্ছিন্ন করতে ব্যর্থ: {msg}',
  'composio.connect.disconnecting': 'সংযোগ বিচ্ছিন্ন হচ্ছে…',
  'composio.connect.idleDescription': 'সংযোগ করুন আপনার',
  'composio.connect.idleDescriptionSuffix':
    'অ্যাকাউন্ট। আমরা একটি ব্রাউজার উইন্ডো খুলব, সেখানে আপনি অ্যাক্সেস অনুমোদন করবেন, এবং এই অ্যাপ স্বয়ংক্রিয়ভাবে সংযোগ শনাক্ত করবে।',
  'composio.connect.isConnected': 'সংযুক্ত।',
  'composio.connect.manage': 'পরিচালনা',
  'composio.connect.needsFieldsPrefix': 'সংযোগ করতে',
  'composio.connect.needsFieldsSuffix':
    'আমাদের আরও কিছু তথ্য প্রয়োজন। নিচের অনুপস্থিত ফিল্ডগুলি পূরণ করুন এবং আবার চেষ্টা করুন।',
  'composio.connect.needsSubdomain': 'সংযোগ করতে',
  'composio.connect.needsSubdomainSuffix':
    'আপনার Atlassian সাবডোমেইন লিখুন (যেমন acme.atlassian.net-এর জন্য acme) এবং আবার চেষ্টা করুন।',
  'composio.connect.oauthComplete': 'OAuth সম্পূর্ণ করতে…',
  'composio.connect.oauthTimeout': 'OAuth টাইমআউট',
  'composio.connect.permissions': 'অনুমতি',
  'composio.connect.permissionsDefault': 'পড়া + লেখা ডিফল্টে সক্রিয়',
  'composio.connect.permissionsNote': 'প্রকাশ করতে পারে',
  'composio.connect.permissionsNoteSuffix':
    'OpenHuman-এর নিজস্ব এজেন্ট অনুমতি নিচে read, write, এবং admin টগল হিসেবে নিয়ন্ত্রিত।',
  'composio.connect.reopenBrowser': 'ব্রাউজার আবার খুলুন',
  'composio.connect.requestingUrl': 'সংযোগ URL অনুরোধ হচ্ছে…',
  'composio.connect.requiredFieldEmpty': 'এই ফিল্ডটি আবশ্যক।',
  'composio.connect.retryConnection': 'সংযোগ আবার চেষ্টা করুন',
  'composio.connect.scopeLoadError': 'স্কোপ পছন্দ লোড করা যায়নি: {msg}',
  'composio.connect.scopeSaveError': '{key} স্কোপ সংরক্ষণ করা যায়নি: {msg}',
  'composio.connect.scope.read': 'পড়ুন',
  'composio.connect.scope.readHint': 'এজেন্টকে এই সংযোগ থেকে ডেটা পড়ার অনুমতি দিন।',
  'composio.connect.scope.write': 'লিখুন',
  'composio.connect.scope.writeHint':
    'এজেন্টকে এই সংযোগের মাধ্যমে ডেটা তৈরি বা পরিবর্তন করার অনুমতি দিন।',
  'composio.connect.scope.admin': 'প্রশাসক',
  'composio.connect.scope.adminHint':
    'এজেন্টকে সেটিংস, অনুমতি বা ধ্বংসাত্মক ক্রিয়াকলাপ পরিচালনা করার অনুমতি দিন।',
  'composio.connect.subdomainInvalid':
    'শুধু সংক্ষিপ্ত সাবডোমেইন লিখুন (যেমন "acme"), পুরো URL নয়। এতে শুধু অক্ষর, সংখ্যা এবং হাইফেন থাকা উচিত।',
  'composio.connect.subdomainRequired': 'চালিয়ে যেতে আপনার Atlassian সাবডোমেইন দিন।',
  'composio.connect.wabaIdHint':
    'আপনার Meta অ্যাক্সেস টোকেন ব্যবহার করে GET /me/businesses তারপর GET /{business_id}/owned_whatsapp_business_accounts এর মাধ্যমে এটি খুঁজে পান।',
  'composio.connect.wabaIdLabel': 'WABA ID লেবেল',
  'composio.connect.atlassianSubdomainPlaceholder': 'your-subdomain',
  'composio.connect.dynamicsOrgNamePlaceholder': 'myorg',
  'composio.connect.wabaIdPlaceholder': 'e.g. 123456789012345',
  'composio.connect.wabaIdRequired':
    'চালিয়ে যেতে আপনার WhatsApp Business Account ID (WABA ID) দিন।',
  'composio.connect.waitingFor': 'অপেক্ষা করছে',
  'composio.connect.waitingHint': 'অপেক্ষার হিন্ট',
  'composio.triggers.heading': 'ট্রিগার',
  'composio.triggers.listenFrom': 'ইভেন্টের জন্য শুনুন',
  'composio.triggers.loadError': 'ট্রিগার লোড করা যায়নি',
  'composio.triggers.sessionExpired':
    'আপনার OpenHuman সেশনের মেয়াদ শেষ হয়েছে। ট্রিগার লোড করতে আবার সাইন ইন করুন।',
  'composio.triggers.needsConfiguration': 'কনফিগারেশন প্রয়োজন',
  'composio.triggers.noneAvailable': 'বর্তমানে কোনো ট্রিগার উপলব্ধ নেই',
  'conversations.taskKanban.moveLeft': 'বামে সরান',
  'conversations.taskKanban.moveRight': 'ডানে সরান',
  'conversations.taskKanban.title': 'টাস্ক',
  'conversations.threadTodo.title': 'পরিকল্পনা',
  'conversations.planReview.title': 'পরিকল্পনা পর্যালোচনা করুন',
  'conversations.planReview.subtitle':
    'চালানোর জন্য অনুমোদন করুন, বাতিল করতে প্রত্যাখ্যান করুন, অথবা সংশোধনের জন্য মতামত পাঠান।',
  'conversations.planReview.approve': 'অনুমোদন ও চালান',
  'conversations.planReview.reject': 'প্রত্যাখ্যান',
  'conversations.planReview.feedbackLabel': 'পরিবর্তন অনুরোধ করুন',
  'conversations.planReview.feedbackPlaceholder': 'কী পরিবর্তন করতে হবে বর্ণনা করুন…',
  'conversations.planReview.sendFeedback': 'মতামত পাঠান',
  'conversations.threadGoal.label': 'লক্ষ্য',
  'conversations.threadGoal.setCta': 'লক্ষ্য নির্ধারণ',
  'conversations.threadGoal.placeholder': 'এই থ্রেডে কী অর্জন করতে হবে?',
  'conversations.threadGoal.save': 'সংরক্ষণ',
  'conversations.threadGoal.cancel': 'বাতিল',
  'conversations.threadGoal.edit': 'লক্ষ্য সম্পাদনা',
  'conversations.threadGoal.clear': 'লক্ষ্য মুছুন',
  'conversations.threadGoal.complete': 'সম্পন্ন হিসেবে চিহ্নিত করুন',
  'conversations.threadGoal.pause': 'বিরতি',
  'conversations.threadGoal.resume': 'পুনরায় শুরু',
  'conversations.threadGoal.tokensSuffix': 'টোকেন',
  'conversations.threadGoal.status.active': 'সক্রিয়',
  'conversations.threadGoal.status.paused': 'বিরতিতে',
  'conversations.threadGoal.status.budget_limited': 'বাজেট শেষ',
  'conversations.threadGoal.status.complete': 'সম্পন্ন',
  'conversations.taskKanban.approval.default': 'ডিফল্ট',
  'conversations.taskKanban.approval.notRequired': 'প্রয়োজন নেই',
  'conversations.taskKanban.approval.notRequiredBadge': 'অনুমোদন করা হবে না',
  'conversations.taskKanban.approval.required': 'আবশ্যক',
  'conversations.taskKanban.approval.requiredBadge': 'অনুমোদন',
  'conversations.taskKanban.approval.requiredBeforeExecution': 'সঞ্চালনের পূর্বে আবশ্যক',
  'conversations.taskKanban.briefButton': 'কাজের সংক্ষিপ্ত',
  'conversations.taskKanban.briefTitle': 'কাজের সংক্ষিপ্ত',
  'conversations.taskKanban.closeBrief': 'স্বল্প বিরতি বন্ধ করুন',
  'conversations.taskKanban.field.acceptanceCriteria': 'বিশেষ মান গ্রহণ করা হবে',
  'conversations.taskKanban.field.allowedTools': 'ব্যবহারের জন্য চিহ্নিত সামগ্রী',
  'conversations.taskKanban.field.approval': 'বিবিধ বৈশিষ্ট্য',
  'conversations.taskKanban.field.assignedAgent': 'বরাদ্দকৃত এজেন্ট',
  'conversations.taskKanban.field.blocker': 'স্তম্ভ',
  'conversations.taskKanban.field.evidence': 'প্রমাণ',
  'conversations.taskKanban.field.notes': 'নোট',
  'conversations.taskKanban.field.objective': 'উদ্দেশ্য',
  'conversations.taskKanban.field.plan': 'পরিকল্পনা',
  'conversations.taskKanban.field.status': 'অবস্থা',
  'conversations.taskKanban.field.title': 'শিরোনাম',
  'conversations.taskKanban.saveChanges': 'পরিবর্তন সংরক্ষণ করা হবে',
  'conversations.taskKanban.deleteCard': 'Delete',
  'conversations.taskKanban.workTask': 'কাজ শুরু করুন',
  'conversations.taskKanban.viewWork': 'কাজ দেখুন',
  'conversations.taskKanban.startingTask': 'শুরু হচ্ছে...',
  'conversations.taskKanban.updateFailed': 'কাজটি সংরক্ষণ করা যায়নি।',
  'conversations.taskKanban.sourcesButton': 'উৎস',
  'conversations.taskKanban.source.openExternal': 'বাহ্যিক কাজ খুলুন',
  'conversations.taskKanban.source.openExternalShort': 'খুলুন',
  'conversations.taskKanban.source.unknownProvider': 'অজানা উৎস',
  'conversations.taskKanban.source.urgencyValue': 'জরুরিতা {percent}%',
  'conversations.taskKanban.sources.desktopOnly': 'টাস্ক উৎস নিয়ন্ত্রণ ডেস্কটপ অ্যাপে উপলভ্য।',
  'conversations.taskKanban.sources.title': 'টাস্ক উৎস',
  'conversations.taskKanban.sources.statusEnabled': 'স্বয়ংক্রিয় পোলিং চালু',
  'conversations.taskKanban.sources.manage': 'উৎস পরিচালনা করুন',
  'conversations.taskKanban.source.title': 'উৎস',
  'conversations.taskKanban.source.sourceId': 'উৎস আইডি',
  'conversations.taskKanban.source.externalId': 'বাহ্যিক আইডি',
  'conversations.taskKanban.source.repo': 'রিপোজিটরি',
  'conversations.taskKanban.source.urgency': 'জরুরিতা',
  'conversations.toolTimeline.turn': 'টার্ন',
  'conversations.toolTimeline.step': 'ধাপ',
  'conversations.toolTimeline.workerThread': 'ওয়ার্কার থ্রেড',
  'conversations.subagent.viewProcessing': 'সম্পূর্ণ প্রক্রিয়া দেখুন',
  'conversations.subagent.parent': 'মূল',
  'conversations.subagent.thinking': 'ভাবছে',
  'conversations.subagent.thoughts': 'চিন্তাভাবনা',
  'conversations.subagent.response': 'প্রতিক্রিয়া',
  'conversations.subagent.toolCalls': 'টুল কল',
  'conversations.subagent.working': 'কাজ করছে…',
  'conversations.subagent.noOutputYet': 'এখনও কোনো আউটপুট নেই',
  'conversations.subagent.input': 'ইনপুট',
  'conversations.subagent.output': 'আউটপুট',
  'conversations.subagent.noOutput': 'কোনো আউটপুট ফেরত আসেনি',
  'conversations.subagent.close': 'বন্ধ করুন',
  'conversations.subagent.cancel': 'কাজ বাতিল করুন',
  'conversations.subagent.cancelling': 'বাতিল করা হচ্ছে…',
  'conversations.subagent.cancelFailed': 'কাজটি বাতিল করা যায়নি। আবার চেষ্টা করুন।',
  'conversations.subagent.statusRunning': 'চলছে',
  'conversations.subagent.statusCompleted': 'সম্পন্ন',
  'conversations.subagent.statusFailed': 'ব্যর্থ',
  'conversations.subagent.statusAwaitingUser': 'ব্যবহারকারীর অপেক্ষায়',
  'conversations.subagent.statusCancelled': 'বাতিল হয়েছে',
  'conversations.agentTaskInsights.title': 'এজেন্ট টাস্ক অন্তর্দৃষ্টি',
  'conversations.agentTaskInsights.response': 'প্রতিক্রিয়া',
  'conversations.agentTaskInsights.processSourceTitle': 'এজেন্ট প্রক্রিয়া উৎস',
  'conversations.agentTaskInsights.stepsHeading': 'ধাপসমূহ',
  'conversations.agentTaskInsights.sourcesHeading': 'উৎসসমূহ',
  'conversations.agentTaskInsights.noSteps': 'কোনো ধাপ রেকর্ড করা হয়নি',
  'conversations.agentTaskInsights.viewProcessSource': 'সম্পূর্ণ এজেন্ট প্রক্রিয়ার উৎস দেখুন',
  'conversations.agentTaskInsights.processing': 'প্রসেসিং',
  'conversations.agentTaskInsights.done': 'সম্পন্ন',
  'conversations.agentTaskInsights.failed': 'ব্যর্থ',
  'conversations.agentTaskInsights.running': 'চলছে',
  'conversations.agentTaskInsights.cancelled': 'বাতিল',
  'conversations.agentTaskInsights.awaitingUser': 'ইনপুটের অপেক্ষায়',
  'conversations.agentTaskInsights.viewDetails': 'বিস্তারিত দেখুন',
  'conversations.agentTaskInsights.subagentsHeading': 'সাব-এজেন্ট',
  'daemon.serviceBlockingGate.body': 'বডি',
  'daemon.serviceBlockingGate.downloadHint': 'ডাউনলোড হিন্ট',
  'daemon.serviceBlockingGate.downloadLatest': 'সর্বশেষ সংস্করণ ডাউনলোড করুন',
  'daemon.serviceBlockingGate.retryCore': 'Core আবার চেষ্টা করুন',
  'daemon.serviceBlockingGate.retryFailed':
    'আবার চেষ্টা ব্যর্থ। সর্বশেষ অ্যাপ বিল্ড ডাউনলোড করে আবার চেষ্টা করুন।',
  'daemon.serviceBlockingGate.retrying': 'আবার চেষ্টা হচ্ছে...',
  'daemon.serviceBlockingGate.title': 'OpenHuman কোর পাওয়া যাচ্ছে না',
  'home.banners.discordSubtitle': 'Discord সাবটাইটেল',
  'home.banners.discordTitle': 'আমাদের Discord-এ যোগ দিন',
  'home.banners.earlyBirdDismiss': 'আর্লি বার্ড ব্যানার বাদ দিন',
  'home.banners.earlyBirdFirstSub': 'প্রথম সাবস্ক্রিপশন।',
  'home.banners.earlyBirdOn': 'আর্লি বার্ড চালু',
  'home.banners.earlyBirdTitle': 'প্রথম ১,০০০ ব্যবহারকারী ৬০% ছাড় পাবেন।',
  'home.banners.earlyBirdUseCode': 'আর্লি বার্ড কোড ব্যবহার করুন',
  'home.banners.getSubscription': 'সাবস্ক্রিপশন নিন',
  'home.banners.promoCreditsBody': 'আপনার কাছে {amount} প্রোমো ক্রেডিট রয়েছে। আপনি',
  'home.banners.promoCreditsUsage': 'প্রোমো ক্রেডিট ব্যবহার',
  'intelligence.memoryChunk.detail.chunk': 'চাংক',
  'intelligence.memoryChunk.detail.copyChunkId': 'চাংক ID কপি করুন',
  'intelligence.memoryChunk.detail.embeddingInfo': 'bge-m3 1024dim',
  'intelligence.memoryChunk.detail.noEmbedding': 'কোনো এম্বেডিং নেই',
  'intelligence.memoryChunk.letterhead.from': 'থেকে',
  'intelligence.memoryChunk.letterhead.to': 'পর্যন্ত',
  'intelligence.memoryChunk.mentioned.chunkOne': '১টি চাঙ্ক',
  'intelligence.memoryChunk.mentioned.chunkOther': '{count}টি চাঙ্ক',
  'intelligence.memoryChunk.mentioned.heading': 'উ ল্লে খি ত',
  'intelligence.memoryChunk.scoreBars.ariaScore': '{name} স্কোর {pct} শতাংশ',
  'intelligence.memoryChunk.scoreBars.atThreshold': '{threshold}-এ',
  'intelligence.memoryChunk.scoreBars.dropped': 'বাদ দেওয়া হয়েছে',
  'intelligence.memoryChunk.scoreBars.heading': 'কে ন   রা খা',
  'intelligence.memoryChunk.scoreBars.kept': 'রাখা হয়েছে',
  'intelligence.diagram.title': 'আর্কিটেকচার ডায়াগ্রাম',
  'intelligence.diagram.description':
    'কনফিগার করা ডায়াগ্রাম এন্ডপয়েন্ট থেকে সর্বশেষ স্থানীয় আর্কিটেকচার আউটপুট।',
  'intelligence.diagram.refresh': 'Refresh',
  'intelligence.diagram.refreshAria': 'ডায়াগ্রাম রিফ্রেশ করুন',
  'intelligence.diagram.emptyTitle': 'এখনো কোনো ডায়াগ্রাম নেই',
  'intelligence.diagram.emptyDescription':
    'অর্কেস্ট্রেটর থেকে একটি আর্কিটেকচার ডায়াগ্রাম তৈরি করুন এবং এই প্যানেলটি কনফিগার করা স্থানীয় এন্ডপয়েন্ট থেকে রিফ্রেশ হবে।',
  'intelligence.diagram.skillInstallCommand': 'npx skills add yizhiyanhua-ai/fireworks-tech-graph',
  'intelligence.diagram.promptExample':
    'ডার্ক টার্মিনাল স্টাইলে বর্তমান swarm-এর একটি আর্কিটেকচার ডায়াগ্রাম তৈরি করুন',
  'intelligence.diagram.imageAlt': 'সর্বশেষ তৈরি OpenHuman আর্কিটেকচার ডায়াগ্রাম',
  'intelligence.diagram.refreshesEvery': 'প্রতি {seconds}s-এ রিফ্রেশ হয়',
  'intelligence.memoryText.entityTypePrefix': 'এনটিটি ধরন',
  'intelligence.tasks.activeBoardOne': 'কথোপকথনজুড়ে ১টি সক্রিয় বোর্ড',
  'intelligence.tasks.activeBoardOther': 'কথোপকথনজুড়ে {count}টি সক্রিয় বোর্ড',
  'intelligence.tasks.empty': 'এখনো কোনো এজেন্ট টাস্ক বোর্ড নেই',
  'intelligence.tasks.emptyHint': 'খালি হিন্ট',
  'intelligence.tasks.failedToLoad': 'লোড করতে ব্যর্থ',
  'intelligence.tasks.live': 'লাইভ',
  'intelligence.tasks.loadingBoards': 'টাস্ক বোর্ড লোড হচ্ছে…',
  'intelligence.tasks.threadPrefix': 'থ্রেড {thread}',
  'intelligence.tasks.subtitle': 'তোমার কাজ আর এজেন্ট বোর্ড পুরো কর্মক্ষেত্রে.',
  'intelligence.tasks.newTask': 'নতুন কাজ',
  'intelligence.tasks.personalBoardTitle': 'এজেন্ট কাজ',
  'intelligence.tasks.personalEmpty': 'ব্যক্তিগত কোনো কর্ম বর্তমানে উপলব্ধ নয়',
  'intelligence.tasks.composer.title': 'নতুন কাজ',
  'intelligence.tasks.composer.titleLabel': 'শিরোনাম',
  'intelligence.tasks.composer.titlePlaceholder': 'কী করতে হবে?',
  'intelligence.tasks.composer.statusLabel': 'অবস্থা',
  'intelligence.tasks.composer.attachLabel': 'কথোপকথনের সাথে সংযুক্ত করুন',
  'intelligence.tasks.composer.attachNone': 'ব্যক্তিগত (কোনো আলাপন নেই)',
  'intelligence.tasks.composer.objectiveLabel': 'উদ্দেশ্য',
  'intelligence.tasks.composer.objectivePlaceholder': 'ঐচ্ছিক ফলাফল',
  'intelligence.tasks.composer.notesLabel': 'নোট',
  'intelligence.tasks.composer.notesPlaceholder': 'ঐচ্ছিক নোট',
  'intelligence.tasks.composer.create': 'কাজ তৈরি করুন ( T)',
  'intelligence.tasks.composer.creating': 'তৈরি করা হচ্ছে...',
  'intelligence.tasks.composer.createFailed': 'কাজ তৈরি করতে ব্যর্থ',
  'intelligence.tasks.composer.assignAgentLabel': 'একজন এজেন্টকে স্বয়ংক্রিয়ভাবে এটি করতে দিন',
  'intelligence.tasks.composer.assignAgentHint':
    'টাস্ক বোর্ড এটি তুলে নিয়ে আপনার হয়ে চালাবে। সাধারণ ব্যক্তিগত কাজের জন্য বন্ধ রাখুন।',
  'intelligence.tasks.sourceList.subtitle': 'এজেন্টের কাজে রূপান্তরের অপেক্ষায় থাকা উৎস কাজ।',
  'intelligence.tasks.sourceList.empty': 'অপেক্ষায় কোনো উৎস কাজ নেই।',
  'intelligence.tasks.sourceList.queued': 'সারিবদ্ধ',
  'intelligence.tasks.sourceList.workOnTask': 'কাজটি করুন',
  'intelligence.tasks.sourcePlan.title': 'উৎস কাজ পরিমার্জন করুন',
  'intelligence.tasks.sourcePlan.subtitle': 'এজেন্ট কাজ তৈরির আগে গবেষণা খসড়া পর্যালোচনা করুন।',
  'intelligence.tasks.sourcePlan.researchAgent': 'গবেষণা এজেন্টের খসড়া',
  'intelligence.tasks.sourcePlan.approve': 'পরিকল্পনা অনুমোদন করুন',
  'intelligence.tasks.sourcePlan.creating': 'কাজ তৈরি হচ্ছে...',
  'intelligence.tasks.sourcePlan.createFailed': 'এজেন্ট কাজ তৈরি করা যায়নি',
  'intelligence.tasks.workTaskFailed': 'কাজ শুরু করা যায়নি',
  'intelligence.workTask.sourceTaskHeading': 'উৎস টাস্ক:',
  'intelligence.workTask.repositoryLine': '- রিপোজিটরি: {repo}',
  'intelligence.workTask.externalIdLine': '- বাহ্যিক আইডি: {externalId}',
  'intelligence.workTask.urlLine': '- ইউআরএল: {url}',
  'intelligence.workTask.closingInstruction':
    'প্রথমে সুনির্দিষ্ট বাস্তবায়ন পরিকল্পনাটি সংক্ষেপে পুনরায় বলুন, তারপর তা সম্পাদন করুন। এই থ্রেডে অগ্রগতি দৃশ্যমান রাখুন এবং কাজের অবস্থা পরিবর্তিত হলে টাস্ক বোর্ড আপডেট করুন।',
  'intelligence.agentWork.subtitle':
    'প্রতিটি ব্যাকগ্রাউন্ড এজেন্ট রান, জীবনচক্রের অবস্থা অনুযায়ী গোষ্ঠীবদ্ধ।',
  'intelligence.agentWork.loading': 'এজেন্ট কাজ লোড হচ্ছে…',
  'intelligence.agentWork.failedToLoad': 'এজেন্ট কাজ লোড করা যায়নি',
  'intelligence.agentWork.empty': 'এখনও কোনো ব্যাকগ্রাউন্ড এজেন্ট রান নেই।',
  'intelligence.agentWork.bucket.needsInput': 'ইনপুট প্রয়োজন',
  'intelligence.agentWork.bucket.working': 'কাজ চলছে',
  'intelligence.agentWork.bucket.completed': 'সম্পন্ন',
  'intelligence.agentWork.bucket.failed': 'ব্যর্থ',
  'intelligence.agentWork.bucket.stopped': 'বন্ধ',
  'intelligence.agentWork.column.agent': 'এজেন্ট',
  'intelligence.agentWork.column.status': 'স্ট্যাটাস',
  'intelligence.agentWork.column.elapsed': 'অতিবাহিত সময়',
  'intelligence.agentWork.column.cost': 'ব্যয়',
  'intelligence.agentWork.column.tokens': 'টোকেন',
  'intelligence.agentWork.status.pending': 'মুলতুবি',
  'intelligence.agentWork.status.running': 'চলছে',
  'intelligence.agentWork.status.awaitingUser': 'ইনপুট প্রয়োজন',
  'intelligence.agentWork.status.paused': 'বিরতিতে',
  'intelligence.agentWork.status.completed': 'সম্পন্ন',
  'intelligence.agentWork.status.failed': 'ব্যর্থ',
  'intelligence.agentWork.status.cancelled': 'বাতিল',
  'intelligence.agentWork.status.interrupted': 'বিঘ্নিত',
  'intelligence.agentWork.kind.subagent': 'সাব-এজেন্ট',
  'intelligence.agentWork.kind.workerThread': 'ওয়ার্কার থ্রেড',
  'intelligence.agentWork.kind.backgroundAgent': 'ব্যাকগ্রাউন্ড এজেন্ট',
  'intelligence.agentWork.kind.teamMember': 'টিম সদস্য',
  'intelligence.agentWork.kind.workflowChild': 'ওয়ার্কফ্লো চাইল্ড',
  'intelligence.agentWork.openThread': 'থ্রেড খুলুন',
  'intelligence.agentWork.openWorker': 'ওয়ার্কার খুলুন',
  'worktree.label': 'ওয়ার্কট্রি',
  'worktree.dirty': 'কমিট না-করা পরিবর্তন',
  'worktree.clean': 'পরিচ্ছন্ন',
  'worktree.changedFile': 'পরিবর্তিত ফাইল',
  'worktree.changedFiles': 'পরিবর্তিত ফাইল',
  'worktree.removing': 'সরানো হচ্ছে…',
  'worktree.removeFailed': 'ওয়ার্কট্রি সরাতে ব্যর্থ',
  'worktree.diffFailed': 'ডিফ লোড করতে ব্যর্থ',
  'worktree.diffLoading': 'ডিফ লোড হচ্ছে…',
  'worktree.diffEmpty': 'HEAD-এর তুলনায় কোনো পরিবর্তন নেই।',
  'worktree.dirtyConfirm':
    'এই ওয়ার্কট্রিতে কমিট না-করা পরিবর্তন আছে। এটি সরালে সেই কাজ বাতিল হয়ে যাবে। ওয়ার্কার ব্রাঞ্চ রাখা হবে।',
  'worktree.action.open': 'ফোল্ডার খুলুন',
  'worktree.action.diff': 'ডিফ',
  'worktree.action.hideDiff': 'ডিফ লুকান',
  'worktree.action.remove': 'সরান',
  'worktree.action.removeAnyway': 'বাতিল করে সরান',
  'worktree.action.preserve': 'রেখে দিন',
  'worktree.panel.subtitle': 'সমান্তরাল এজেন্ট ওয়ার্কারদের তৈরি করা বিচ্ছিন্ন git ওয়ার্কট্রি।',
  'worktree.panel.loading': 'ওয়ার্কট্রি লোড হচ্ছে…',
  'worktree.panel.failedToLoad': 'ওয়ার্কট্রি লোড করতে ব্যর্থ',
  'worktree.panel.empty':
    'কোনো বিচ্ছিন্ন ওয়ার্কট্রি নেই। ওয়ার্কট্রি বিচ্ছিন্নকরণসহ সমান্তরাল ওয়ার্কাররা এখানে প্রদর্শিত হবে।',
  'worktree.panel.overlapsTitle': 'ওভারল্যাপিং পরিবর্তন',
  'worktree.panel.overlapHint':
    'এই ফাইলগুলো একাধিক ওয়ার্কট্রি দ্বারা পরিবর্তিত হয়েছে: মার্জ করার আগে সমন্বয় করুন।',
  'intelligence.agentWork.action.stop': 'থামান',
  'intelligence.agentWork.action.retry': 'আবার চেষ্টা করুন',
  'intelligence.agentWork.action.continue': 'চালিয়ে যান',
  'intelligence.agentWork.action.followUp': 'ফলো আপ',
  'intelligence.agentWork.action.send': 'পাঠান',
  'intelligence.agentWork.action.cancel': 'বাতিল করুন',
  'intelligence.agentWork.action.continuePlaceholder': 'এই এজেন্টকে আনব্লক করতে উত্তর দিন…',
  'intelligence.agentWork.action.followUpPlaceholder': 'একটি ফলো-আপ নির্দেশনা পাঠান…',
  'intelligence.agentWork.action.failed': 'অ্যাকশন ব্যর্থ হয়েছে',
  'intelligence.teams.subtitle': 'সমন্বিত এজেন্ট টিম এবং তারা যে কাজগুলো ভাগ করে নেয়।',
  'intelligence.teams.loading': 'টিম লোড হচ্ছে…',
  'intelligence.teams.failedToLoad': 'টিম লোড করতে ব্যর্থ হয়েছে',
  'intelligence.teams.empty': 'এখনো কোনো এজেন্ট টিম নেই',
  'intelligence.teams.emptyHint':
    'যখন কোনো এজেন্ট একটি লক্ষ্য ভাগ করে নিতে সমন্বিত সাব-এজেন্ট তৈরি করে, তখন টিম এখানে দেখা যায়।',
  'intelligence.teams.refresh': 'রিফ্রেশ',
  'intelligence.teams.backToList': 'সব টিম',
  'intelligence.teams.status.active': 'সক্রিয়',
  'intelligence.teams.status.closed': 'বন্ধ',
  'intelligence.teams.header.lead': 'লিড',
  'intelligence.teams.header.taskCount': '{count} কাজ',
  'intelligence.teams.header.memberCount': '{count} সদস্য',
  'intelligence.teams.member.active': 'সক্রিয়',
  'intelligence.teams.member.pending': 'মুলতুবি',
  'intelligence.teams.member.idle': 'নিষ্ক্রিয়',
  'intelligence.teams.member.stopped': 'থেমে গেছে',
  'intelligence.teams.column.todo': 'করণীয়',
  'intelligence.teams.column.ready': 'প্রস্তুত',
  'intelligence.teams.column.inProgress': 'চলমান',
  'intelligence.teams.column.blocked': 'ব্লকড',
  'intelligence.teams.column.done': 'সম্পন্ন',
  'intelligence.teams.emptyColumn': 'খালি',
  'intelligence.teams.unclaimed': 'অদাবিকৃত',
  'intelligence.teams.pickedUpBy': '{name} গ্রহণ করেছেন',
  'intelligence.teams.depLockTitle': '{count}টি অপূর্ণ নির্ভরতা',
  'intelligence.teams.gate.pending': 'গেট মুলতুবি',
  'intelligence.teams.gate.passed': 'গেট উত্তীর্ণ',
  'intelligence.teams.gate.failed': 'গেট ব্যর্থ',
  'intelligence.teams.gate.label': 'গেট: {status}',
  'intelligence.teams.activity.title': 'টিম কার্যকলাপ',
  'intelligence.teams.activity.empty': 'এখনো কোনো বার্তা নেই',
  'intelligence.teams.activity.toTeam': 'টিম',
  'intelligence.teams.member.start': 'শুরু',
  'intelligence.teams.composer.placeholder': 'সতীর্থকে বার্তা…',
  'intelligence.teams.composer.send': 'পাঠান',
  'intelligence.teams.composer.recipient': 'প্রাপক',
  'intelligence.teams.composer.toTeam': 'পুরো দল',
  'intelligence.teams.action.blocked': 'নির্ভরতার অপেক্ষায়',
  'intelligence.teams.action.alreadyClaimed': 'অন্য সতীর্থ ইতিমধ্যে নিয়েছে',
  'intelligence.teams.action.alreadyActive': 'সহকর্মী ইতিমধ্যে সক্রিয়',
  'intelligence.teams.action.noClaimableTask': 'এই সতীর্থের জন্য কোনো কাজ প্রস্তুত নেই',
  'intelligence.teams.action.unknownTask': 'কাজ পাওয়া যায়নি',
  'intelligence.refine.objectiveDefault':
    'উৎস টাস্কটিকে বাস্তবায়নের জন্য প্রস্তুত একটি এজেন্ট টাস্কে রূপান্তর করুন: {title}',
  'intelligence.refine.sourceLine': 'উৎস: {url}',
  'intelligence.refine.sourceIntake': 'উৎস: টাস্ক উৎস গ্রহণ',
  'intelligence.refine.repositoryLine': 'রিপোজিটরি: {repo}',
  'intelligence.refine.externalTaskLine': 'বাহ্যিক টাস্ক: {externalId}',
  'intelligence.refine.planStep1':
    'সংযুক্ত উৎস টাস্কটি পড়ুন এবং ঠিক কোন আচরণ চাওয়া হয়েছে তা নিশ্চিত করুন।',
  'intelligence.refine.planStep2':
    'প্রাসঙ্গিক কোড পাথগুলি পরিদর্শন করুন এবং সবচেয়ে ছোট বাস্তবায়ন সীমানা চিহ্নিত করুন।',
  'intelligence.refine.planStep3':
    'ব্যবহারকারী-দৃশ্যমান আচরণ ঘিরে কেন্দ্রীভূত পরীক্ষাসহ পরিবর্তনটি বাস্তবায়ন করুন।',
  'intelligence.refine.planStep4':
    'লক্ষ্যভিত্তিক যাচাই চালান এবং অবশিষ্ট কোনো ঝুঁকি বা পরবর্তী কাজ নথিভুক্ত করুন।',
  'intelligence.refine.acceptance1':
    'উৎস টাস্কের প্রয়োজনীয়তা চূড়ান্ত বাস্তবায়নে প্রতিফলিত হয়েছে।',
  'intelligence.refine.acceptance2':
    'প্রাসঙ্গিক ইউনিট বা ইন্টিগ্রেশন পরীক্ষা পরিবর্তিত আচরণ কভার করে।',
  'intelligence.refine.acceptance3':
    'যাচাইয়ের ফলাফল এবং যেকোনো অমীমাংসিত ঝুঁকি সমাপ্তির সময় নথিভুক্ত করা হয়।',
  'notifications.card.dismiss': 'বিজ্ঞপ্তি বাদ দিন',
  'notifications.card.importanceTitle': 'গুরুত্ব: {pct}%',
  'notifications.center.empty': 'এখনো কোনো বিজ্ঞপ্তি নেই',
  'notifications.center.emptyHint': 'খালি হিন্ট',
  'notifications.center.filterAll': 'সব ফিল্টার',
  'notifications.center.markAllRead': 'সব পঠিত চিহ্নিত করুন',
  'notifications.center.title': 'বিজ্ঞপ্তি',
  'notifications.meeting.joinListen': 'যোগ দিন (শুধু শুনুন)',
  'notifications.meeting.joinActive': 'যোগ দিন ও উত্তর দিন',
  'notifications.meeting.skip': 'এটি নয়',
  'notifications.meeting.alwaysJoin': 'সবসময় যোগ দিন',
  'notifications.meeting.actionError': 'এই কাজটি সম্পন্ন করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'notifications.flow.approveTitle': 'ওয়ার্কফ্লোর জন্য অনুমোদন প্রয়োজন',
  'notifications.flow.approve': 'অনুমোদন করুন',
  'notifications.flow.approving': 'অনুমোদন করা হচ্ছে…',
  'notifications.flow.dismiss': 'খারিজ করুন',
  'notifications.flow.error': 'ওয়ার্কফ্লো আবার শুরু করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'notifications.flow.gateCount': '{count}টি অনুমোদন গেট মুলতুবি আছে',
  'notifications.flow.approveHint': 'এই চেকপয়েন্টের পরে ওয়ার্কফ্লো আবার শুরু করুন',
  'notifications.flow.dismissHint': 'ওয়ার্কফ্লো আবার শুরু না করে এই প্রম্পটটি লুকান',
  'notifications.flow.viewRun': 'রান দেখুন',
  'notifications.flowGate.title': 'ওয়ার্কফ্লোর জন্য অনুমোদন প্রয়োজন',
  'notifications.flowGate.tool': 'টুল:',
  'notifications.flowGate.approve': 'একবার অনুমোদন করুন',
  'notifications.flowGate.approveAlways': 'সর্বদা অনুমোদন করুন',
  'notifications.flowGate.approveAlwaysHint':
    'এই ফ্লো-এর ভবিষ্যত রানগুলিতে এই চেকপয়েন্ট এড়িয়ে যান',
  'notifications.flowGate.deny': 'প্রত্যাখ্যান করুন',
  'notifications.flowGate.deciding': 'চলমান...',
  'notifications.flowGate.error': 'আপনার সিদ্ধান্তের কথা রেকর্ড করা যায় নি: আবার চেষ্টা করুন ।',
  'flowRuns.inspector.title': 'রান বিবরণ',
  'flowRuns.inspector.startedAt': 'শুরু হয়েছে',
  'flowRuns.inspector.finishedAt': 'শেষ হয়েছে',
  'flowRuns.inspector.running': 'চলছে…',
  'flowRuns.inspector.error': 'ত্রুটি',
  'flowRuns.inspector.pendingApprovals': 'মুলতুবি অনুমোদন',
  'flowRuns.inspector.pendingApprovalsCount': '{count}টি নোড অনুমোদনের অপেক্ষায়',
  'flowRuns.inspector.approval.tool': 'টুল:',
  'flowRuns.inspector.approval.approve': 'একবার অনুমোদন করুন',
  'flowRuns.inspector.approval.approveAlways': 'সর্বদা অনুমোদন করুন',
  'flowRuns.inspector.approval.approveAlwaysHint':
    'এই ফ্লো-এর ভবিষ্যত রানগুলিতে এই চেকপয়েন্ট এড়িয়ে যান',
  'flowRuns.inspector.approval.deny': 'প্রত্যাখ্যান করুন',
  'flowRuns.inspector.approval.deciding': 'চলমান...',
  'flowRuns.inspector.approval.loadError': 'এই রানের জন্য মুলতুবি অনুমোদনগুলি লোড করা যায়নি।',
  'flowRuns.inspector.steps': 'ধাপ',
  'flowRuns.inspector.noSteps': 'এখনও কোনো ধাপ রেকর্ড করা হয়নি।',
  'flowRuns.inspector.output': 'কাঁচা আউটপুট দেখান',
  'flowRuns.inspector.summary.failedPrefix': 'সম্পূর্ণ করা যায়নি:',
  'flowRuns.inspector.summary.unknownError': 'কিছু একটা ভুল হয়েছে',
  'flowRuns.inspector.summary.itemsFetched': '{count}টি আইটেম আনা হয়েছে',
  'flowRuns.inspector.summary.completed': 'ধাপ সম্পন্ন হয়েছে',
  'flowRuns.inspector.summary.noOutput': 'কোনো আউটপুট তৈরি হয়নি',
  'flowRuns.inspector.port': 'পোর্ট',
  'flowRuns.inspector.loading': 'রান লোড হচ্ছে…',
  'flowRuns.inspector.loadError': 'এই রানটি লোড করা যায়নি',
  'flowRuns.inspector.fixWithAgent': 'এজেন্ট দিয়ে ঠিক করুন',
  'flowRuns.inspector.dataTable': 'টেবিল',
  'flowRuns.inspector.dataJson': 'JSON',
  'flowRuns.inspector.dataViewLabel': 'আউটপুট ভিউ',
  'flowRuns.inspector.itemCount': '{count}টি আইটেম',
  'flowRuns.inspector.noItems': 'কোনো আউটপুট আইটেম নেই',
  'flowRuns.inspector.emptyValue': '(খালি)',
  'flowRuns.inspector.binaryLabel': 'বাইনারি',
  'flowRuns.inspector.showSource': 'উৎস',
  'flowRuns.inspector.hideSource': 'উৎস লুকান',
  'flowRuns.inspector.sourceInputTitle': 'উৎস ইনপুট আইটেম',
  'flowRuns.status.running': 'চলছে',
  'flowRuns.status.completed': 'সম্পন্ন',
  'flowRuns.status.completed_with_warnings': 'সতর্কতা সহ সম্পন্ন',
  'flowRuns.status.pending_approval': 'অনুমোদনের অপেক্ষায়',
  'flowRuns.status.failed': 'ব্যর্থ',
  'flowRuns.status.cancelled': 'বাতিল করা হয়েছে',
  'flowRuns.status.interrupted': 'বিঘ্নিত',

  'flows.page.title': 'ওয়ার্কফ্লো',
  'flows.page.description': 'সংরক্ষিত অটোমেশন যা আপনি সক্ষম, চালাতে এবং পর্যবেক্ষণ করতে পারেন।',
  'flows.page.emptyTitle': 'এখনো কোনো ওয়ার্কফ্লো নেই',
  'flows.page.emptyDescription':
    'ক্যানভাস থেকে একটি তৈরি করলে সংরক্ষিত ওয়ার্কফ্লোগুলো এখানে দেখা যাবে।',
  'flows.page.loading': 'ওয়ার্কফ্লো লোড হচ্ছে…',
  'flows.page.loadError': 'ওয়ার্কফ্লো লোড করা যায়নি। আবার চেষ্টা করুন।',
  'flows.page.newWorkflow': 'নতুন ওয়ার্কফ্লো',
  'flows.list.lastRun': 'সর্বশেষ চালানো',
  'flows.list.neverRun': 'কখনো চালানো হয়নি',
  'flows.list.justNow': 'এইমাত্র',
  'flows.discoveries.title': 'ওয়ার্কফ্লো আবিষ্কার',
  'flows.discoveries.description':
    'আপনি কীভাবে কাজ করেন তার ভিত্তিতে Flow Scout যেসব অটোমেশন প্রস্তাব করে।',
  'flows.allRuns.title': 'ওয়ার্কফ্লো রান',
  'flows.allRuns.description': 'আপনার ওয়ার্কস্পেসের সব ওয়ার্কফ্লো রান, নতুনতম আগে।',
  'flows.allRuns.loading': 'রান লোড হচ্ছে…',
  'flows.allRuns.empty': 'এখনও কোনো ওয়ার্কফ্লো রান নেই।',
  'flows.allRuns.unknownWorkflow': 'অজানা ওয়ার্কফ্লো',
  'flows.allRuns.status.running': 'চলছে',
  'flows.allRuns.status.completed': 'সম্পন্ন',
  'flows.allRuns.status.completed_with_warnings': 'সতর্কতাসহ সম্পন্ন',
  'flows.allRuns.status.pending_approval': 'অনুমোদনের অপেক্ষায়',
  'flows.allRuns.status.failed': 'ব্যর্থ',
  'flows.allRuns.status.cancelled': 'বাতিল',
  'flows.allRuns.status.interrupted': 'বিঘ্নিত',
  'flows.list.minutesAgo': '{count} মিনিট আগে',
  'flows.list.hoursAgo': '{count} ঘণ্টা আগে',
  'flows.list.daysAgo': '{count} দিন আগে',
  'flows.list.runNow': 'চালান',
  'flows.list.running': 'চলছে…',
  'flows.list.viewRuns': 'রান দেখুন',
  'flows.list.toggleEnabled': 'ওয়ার্কফ্লো সক্ষম করুন',
  'flows.list.enabled': 'সক্ষম',
  'flows.list.paused': 'বিরতি দেওয়া',
  'flows.list.runStarted': 'ওয়ার্কফ্লো শুরু হয়েছে',
  'flows.runs.title': '{name}-এর জন্য রান',
  'flows.runs.titleFallback': 'ওয়ার্কফ্লো রান',
  'flows.runs.loading': 'রান লোড হচ্ছে…',
  'flows.runs.loadError': 'রান লোড করা যায়নি',
  'flows.runs.empty': 'এখনো কোনো রান নেই',
  'flows.promptBar.label': 'একটি ওয়ার্কফ্লো বর্ণনা করুন',
  'flows.promptBar.placeholder': 'আপনার ওয়ার্কফ্লো বর্ণনা করুন',
  'flows.promptBar.copilotTitle': 'কো-পাইলট',
  'flows.promptBar.submit': 'তৈরি করুন',
  'flows.promptBar.startBuilding': 'তৈরি শুরু করুন',
  'flows.promptBar.disclaimer':
    'কো-পাইলট একটি AI এবং ভুল করতে পারে। অনুগ্রহ করে উত্তরগুলি যাচাই করুন।',
  'flows.promptBar.thinking': 'তৈরি হচ্ছে…',
  'flows.promptBar.heroTitle': 'একটি ওয়ার্কফ্লো বর্ণনা করুন',
  'flows.promptBar.heroSubtitle':
    'বিল্ডারকে বলুন কী স্বয়ংক্রিয় করতে হবে এবং তার প্রস্তাব পর্যালোচনা করুন।',
  'flows.promptBar.error': 'ওয়ার্কফ্লো বিল্ডারে পৌঁছানো যায়নি। আবার চেষ্টা করুন।',
  'flows.promptBar.offline': 'আপনি অফলাইন। একটি ওয়ার্কফ্লো তৈরি করতে আবার সংযোগ করুন।',
  'flows.suggest.title': 'আপনার জন্য প্রস্তাবিত',
  'flows.suggest.subtitle':
    'আপনি কীভাবে কাজ করেন তার ভিত্তিতে Flow Scout যেসব অটোমেশন সহায়ক মনে করে।',
  'flows.suggest.discover': 'আবিষ্কার করুন',
  'flows.suggest.rediscover': 'রিফ্রেশ',
  'flows.suggest.discovering': 'অটোমেশন খোঁজা হচ্ছে…',
  'flows.suggest.empty':
    'এখনও কোনো পরামর্শ নেই। আবিষ্কার চালান এবং Flow Scout সেট আপ করার মতো অটোমেশনের জন্য আপনার কাজ পর্যালোচনা করবে।',
  'flows.suggest.error': 'আবিষ্কার চালানো যায়নি। আবার চেষ্টা করুন।',
  'flows.suggest.why': 'কেন',
  'flows.suggest.build': 'এটি তৈরি করুন',
  'flows.suggest.opening': 'খোলা হচ্ছে…',
  'flows.suggest.dismiss': 'বাতিল করুন',
  'flows.suggest.uses': 'ব্যবহার করে',
  'flows.suggest.trigger.schedule': 'নির্ধারিত',
  'flows.suggest.trigger.app_event': 'ইভেন্টে',
  'flows.suggest.trigger.manual': 'চাহিদা অনুযায়ী',
  'flows.copilot.open': 'কো-পাইলট',
  'flows.copilot.title': 'ওয়ার্কফ্লো কো-পাইলট',
  'flows.copilot.subtitle': 'পরিবর্তন চান এবং প্রয়োগ করার আগে প্রতিটি প্রস্তাব পর্যালোচনা করুন।',
  'flows.copilot.close': 'কো-পাইলট বন্ধ করুন',
  'flows.copilot.placeholder': 'একটি পরিবর্তন চান…',
  'flows.copilot.send': 'পাঠান',
  'flows.copilot.thinking': 'ভাবছে…',
  'flows.copilot.error': 'ওয়ার্কফ্লো বিল্ডারে পৌঁছানো যায়নি। আবার চেষ্টা করুন।',
  'flows.copilot.offline': 'আপনি অফলাইন। কো-পাইলট ব্যবহার করতে আবার সংযোগ করুন।',
  'flows.copilot.emptyState':
    'এই ওয়ার্কফ্লোতে একটি পরিবর্তন বর্ণনা করুন এবং বিল্ডার একটি আপডেট প্রস্তাব করবে।',
  'flows.copilot.proposalTitle': 'প্রস্তাবিত পরিবর্তন',
  'flows.copilot.added': '{count}টি যোগ হয়েছে',
  'flows.copilot.removed': '{count}টি সরানো হয়েছে',
  'flows.copilot.noChanges': 'এই প্রস্তাব কোনো নোড পরিবর্তন করে না।',
  'flows.copilot.accept': 'খসড়ায় প্রয়োগ করুন',
  'flows.copilot.acceptAndSave': 'গ্রহণ ও সংরক্ষণ করুন',
  'flows.copilot.saveAndEnable': 'সংরক্ষণ ও সক্রিয় করুন',
  'flows.copilot.saving': 'সংরক্ষণ করা হচ্ছে…',
  'flows.copilot.enabling': 'সক্রিয় করা হচ্ছে…',
  'flows.copilot.enableError':
    'সংরক্ষিত হয়েছে, কিন্তু ওয়ার্কফ্লো সক্রিয় করা যায়নি। তালিকা থেকে এটি চালু করার চেষ্টা করুন।',
  'flows.copilot.reject': 'বাতিল করুন',
  'flows.copilot.previewHint':
    'একটি প্রস্তাবিত খসড়া পর্যালোচনা হচ্ছে: এখনও কিছু সংরক্ষণ করা হয়নি।',
  'flows.copilot.repairDisplay': 'একটি রান ব্যর্থ হয়েছে; এটি দেখুন এবং একটি সমাধান প্রস্তাব করুন।',
  'flows.copilot.tool.proposing': 'ওয়ার্কফ্লো প্রস্তাব করা হচ্ছে…',
  'flows.copilot.tool.dryRunning': 'ওয়ার্কফ্লো ড্রাই-রান করা হচ্ছে…',
  'flows.copilot.tool.saving': 'ওয়ার্কফ্লো সংরক্ষণ করা হচ্ছে…',
  'flows.copilot.tool.usingTools': 'টুল ব্যবহার করা হচ্ছে…',
  'flows.copilot.cappedNotice':
    'এই ওয়ার্কফ্লো শেষ করার আগেই বিল্ডার তার পুনরাবৃত্তির সীমায় পৌঁছে গেছে। চালিয়ে গেলে এটি বর্তমান খসড়া থেকে নির্মাণ চালিয়ে যাবে।',
  'flows.copilot.continueBuilding': 'নির্মাণ চালিয়ে যান',
  'flows.list.view': 'ওয়ার্কফ্লো দেখুন',
  'flows.list.export': 'রপ্তানি',
  'flows.list.exported': 'ওয়ার্কফ্লো রপ্তানি হয়েছে',
  'flows.page.import': 'আমদানি',
  'flows.import.invalidFile': 'এই ফাইলটি বৈধ ওয়ার্কফ্লো JSON নয়।',
  'flows.import.error': 'এই ওয়ার্কফ্লোটি আমদানি করা যায়নি। ফাইলটি পরীক্ষা করে আবার চেষ্টা করুন।',
  'flows.import.warningTitle': 'আমদানি সতর্কতা',
  'flows.canvas.title': 'ওয়ার্কফ্লো',
  'flows.canvas.loading': 'ওয়ার্কফ্লো লোড হচ্ছে…',
  'flows.canvas.loadError': 'এই ওয়ার্কফ্লোটি লোড করা যায়নি। আবার চেষ্টা করুন।',
  'flows.canvas.notFound': 'এই ওয়ার্কফ্লোটি পাওয়া যায়নি।',
  'flows.canvas.draftMissing':
    'খোলার জন্য কোনো ওয়ার্কফ্লো খসড়া নেই। প্রথমে চ্যাট থেকে একটি প্রস্তাব করুন।',
  'flows.canvas.backToList': 'ওয়ার্কফ্লো তালিকায় ফিরে যান',
  'flows.nodeKind.trigger': 'ট্রিগার',
  'flows.nodeKind.agent': 'এজেন্ট',
  'flows.nodeKind.tool_call': 'টুল কল',
  'flows.nodeKind.http_request': 'HTTP অনুরোধ',
  'flows.nodeKind.code': 'কোড',
  'flows.nodeKind.condition': 'শর্ত',
  'flows.nodeKind.switch': 'সুইচ',
  'flows.nodeKind.merge': 'মার্জ করুন',
  'flows.nodeKind.split_out': 'স্প্লিট আউট',
  'flows.nodeKind.transform': 'রূপান্তর',
  'flows.nodeKind.output_parser': 'আউটপুট পার্সার',
  'flows.nodeKind.sub_workflow': 'সাব-ওয়ার্কফ্লো',
  'flows.nodeKind.memory': 'মেমরি',
  'flows.nodeKind.dedup': 'ডুপ্লিকেট অপসারণ',
  'flows.nodeKind.loop': 'লুপ',
  'flows.nodeSummary.trigger.manual': 'চাহিদা অনুযায়ী চলে',
  'flows.nodeSummary.trigger.webhook': 'ইনকামিং ওয়েবহুকে চলে',
  'flows.nodeSummary.trigger.appEventOn': '{parts}-এ',
  'flows.nodeSummary.trigger.appEvent': 'অ্যাপ ইভেন্টে চলে',
  'flows.nodeSummary.trigger.unknownKind': 'ট্রিগার: {kind}',
  'flows.nodeSummary.agent.defaultModel': 'ডিফল্ট মডেল',
  'flows.nodeSummary.agent.withPrompt': '“{prompt}” · {model}',
  'flows.nodeSummary.agent.default': '{model}-কে জিজ্ঞাসা করে',
  'flows.nodeSummary.toolCall.runsNative': '{name} চালায়',
  'flows.nodeSummary.toolCall.pickNative': 'একটি OpenHuman টুল চালায় (একটি বেছে নিন)',
  'flows.nodeSummary.toolCall.runs': '{slug} চালায়',
  'flows.nodeSummary.toolCall.pick': 'একটি অ্যাপ অ্যাকশন চালায় (একটি বেছে নিন)',
  'flows.nodeSummary.http.withUrl': '{method} {url}',
  'flows.nodeSummary.http.noUrl': '{method} অনুরোধ (একটি URL সেট করুন)',
  'flows.nodeSummary.code.runs': '{lang} কোড চালায়',
  'flows.nodeSummary.condition.withField': 'যদি {field} → সত্য / মিথ্যা',
  'flows.nodeSummary.condition.default': 'সত্য / মিথ্যায় শাখা করে',
  'flows.nodeSummary.switch.byExpr': '{expr} অনুযায়ী রুট করে',
  'flows.nodeSummary.switch.byExprWithRoutes': '{expr} অনুযায়ী রুট করে ({count}টি রুট)',
  'flows.nodeSummary.switch.byValue': 'একটি মান অনুযায়ী রুট করে',
  'flows.nodeSummary.switch.byValueWithRoutes': 'একটি মান অনুযায়ী রুট করে ({count}টি রুট)',
  'flows.nodeSummary.merge': 'সমান্তরাল শাখা মার্জ করে',
  'flows.nodeSummary.splitOut.withPath': 'প্রতিটি {path} বিভক্ত করে',
  'flows.nodeSummary.splitOut.default': 'একটি তালিকাকে আইটেমে বিভক্ত করে',
  'flows.nodeSummary.transform.default': 'প্রতিটি আইটেম নতুন রূপে সাজায়',
  'flows.nodeSummary.transform.setFieldsSingular': 'প্রতিটি আইটেমে {n}টি ফিল্ড সেট করে',
  'flows.nodeSummary.transform.setFieldsPlural': 'প্রতিটি আইটেমে {n}টি ফিল্ড সেট করে',
  'flows.nodeSummary.outputParser': 'আগের আউটপুট পার্স করে',
  'flows.nodeSummary.subWorkflow': 'একটি নেস্টেড ওয়ার্কফ্লো চালায়',
  'flows.nodeSummary.memory.flavourWith': '"{flavour}" ধরনটি পড়ে',
  'flows.nodeSummary.memory.flavour': 'একটি মেমরি ধরন পড়ে',
  'flows.nodeSummary.memory.people': 'ব্যক্তি মেমরি খুঁজে দেখে',
  'flows.nodeSummary.memory.remember': 'এই ওয়ার্কফ্লোতে একটি মান মনে রাখে',
  'flows.nodeSummary.memory.forget': 'এই ওয়ার্কফ্লো থেকে একটি মান ভুলে যায়',
  'flows.nodeSummary.memory.searchScoped': 'মেমরি অনুসন্ধান করে ({scope})',
  'flows.nodeSummary.memory.search': 'মেমরি অনুসন্ধান করে',
  'flows.nodeSummary.memory.recallScoped': 'মেমরি থেকে পুনরুদ্ধার করে ({scope})',
  'flows.nodeSummary.memory.recall': 'মেমরি থেকে পুনরুদ্ধার করে',
  'flows.nodeSummary.dedup.withKey': '{key} দ্বারা ইতিমধ্যে দেখা আইটেম বাদ দেয়',
  'flows.nodeSummary.dedup.default': 'ইতিমধ্যে প্রক্রিয়াকৃত আইটেম বাদ দেয়',
  'flows.nodeSummary.loop.upTo': 'সর্বোচ্চ {max} বার পুনরাবৃত্তি করে',
  'flows.nodeSummary.loop.whileCondition':
    'যতক্ষণ {condition} ততক্ষণ সর্বোচ্চ {max} বার পুনরাবৃত্তি করে',
  'flows.palette.title': 'নোড',
  'flows.palette.addNode': '{kind} নোড যোগ করুন',
  'flows.editor.save': 'সংরক্ষণ করুন',
  'flows.editor.deleteSelected': 'নির্বাচিত মুছুন',
  // ── Validation UX + draft/dirty state (issue B5b / Phase 3c–3d)
  'flows.editor.saving': 'সংরক্ষণ করা হচ্ছে…',
  'flows.editor.run': 'চালান',
  'flows.editor.running': 'চলছে…',
  'flows.editor.runFailed': 'রান শুরু করা যায়নি',
  'flows.editor.validate': 'যাচাই করুন',
  'flows.editor.validating': 'যাচাই করা হচ্ছে…',
  'flows.editor.discard': 'পরিবর্তন বাতিল করুন',
  'flows.editor.confirm.runTitle': 'ওয়ার্কফ্লো চালাবেন?',
  'flows.editor.confirm.runBody': 'এটি এখন ওয়ার্কফ্লোটি চালাবে।',
  'flows.editor.confirm.saveTitle': 'পরিবর্তন সংরক্ষণ করবেন?',
  'flows.editor.confirm.saveBody': 'এটি ওয়ার্কফ্লোতে আপনার পরিবর্তনগুলি সংরক্ষণ করবে।',
  'flows.editor.confirm.discardTitle': 'পরিবর্তন বাতিল করবেন?',
  'flows.editor.confirm.discardBody':
    'এটি সমস্ত অসংরক্ষিত সম্পাদনা প্রত্যাবর্তন করে এবং তা পূর্বাবস্থায় ফেরানো যায় না।',
  'flows.editor.confirm.confirm': 'নিশ্চিত করুন',
  'flows.editor.confirm.cancel': 'বাতিল',
  'flows.editor.unsaved': 'অসংরক্ষিত পরিবর্তন',
  'flows.editor.saveBlocked': 'সংরক্ষণের আগে নিচের ত্রুটিগুলো ঠিক করুন।',
  'flows.editor.errorsTitle': 'ত্রুটি',
  'flows.editor.warningsTitle': 'সতর্কতা',
  'flows.editor.saveFailedTitle': 'সংরক্ষণ করা যায়নি',
  'flows.editor.leaveTitle': 'সংরক্ষণ না করে চলে যাবেন?',
  'flows.editor.leaveBody':
    'এই ওয়ার্কফ্লোতে আপনার অসংরক্ষিত পরিবর্তন রয়েছে। এখন চলে গেলে সেগুলো হারিয়ে যাবে।',
  'flows.editor.leaveStay': 'থাকুন',
  'flows.editor.leaveDiscard': 'চলে যান',
  // ── Node config drawer (issue B5b / Phase 3b): per-kind config forms
  'flowRuns.inspector.diagnosticsTitle': 'এক্সপ্রেশন সতর্কতা',
  'flowRuns.inspector.diagnosticResolvedNull': 'null হিসেবে সমাধান হয়েছে',
  'flows.runs.sidebarTitle': 'রান',
  'flows.runs.refresh': 'রান রিফ্রেশ করুন',
  'flows.palette.appAction': 'অ্যাপ অ্যাকশন',
  'flows.palette.ohTool': 'টুল',
  'flows.editor.deleteNode': 'মুছুন',
  'flows.nodeConfig.connections.title': 'সংযোগ',
  'flows.nodeConfig.connections.inputs': 'ইনপুট',
  'flows.nodeConfig.connections.outputs': 'আউটপুট',
  'flows.nodeConfig.connections.none': 'এখনও অন্য কোনো নোডের সাথে যুক্ত নয়।',
  'flows.nodeConfig.connections.remove': 'সংযোগ সরান',
  'flows.nodeConfig.trigger.scheduleCronLabel': 'Cron এক্সপ্রেশন',
  'flows.nodeConfig.trigger.scheduleFreqLabel': 'ফ্রিকোয়েন্সি',
  'flows.nodeConfig.trigger.scheduleFreq_minutes': 'প্রতি N মিনিটে',
  'flows.nodeConfig.trigger.scheduleFreq_hours': 'প্রতি N ঘণ্টায়',
  'flows.nodeConfig.trigger.scheduleFreq_daily': 'প্রতিদিন নির্দিষ্ট সময়ে',
  'flows.nodeConfig.trigger.scheduleEvery': 'প্রতি',
  'flows.nodeConfig.trigger.scheduleInterval': 'ব্যবধান',
  'flows.nodeConfig.trigger.scheduleUnit_minutes': 'মিনিট',
  'flows.nodeConfig.trigger.scheduleUnit_hours': 'ঘণ্টা',
  'flows.nodeConfig.trigger.scheduleAt': 'এ',
  'flows.nodeConfig.trigger.scheduleTime': 'দিনের সময়',
  'flows.nodeConfig.trigger.scheduleDays': 'দিনগুলোতে (ঐচ্ছিক: প্রতিদিনের জন্য খালি রাখুন)',
  'flows.nodeConfig.trigger.scheduleAdvanced': 'উন্নত (cron সম্পাদনা)',
  'flows.nodeConfig.trigger.scheduleSimple': 'সহজ সময়সূচিতে ফিরুন',
  'flows.cron.customSchedule': 'কাস্টম সময়সূচি ({expr})',
  'flows.cron.noScheduleSet': 'কোনো সময়সূচি নির্ধারণ করা নেই',
  'flows.cron.weekdays': 'কর্মদিবস',
  'flows.cron.weekends': 'সাপ্তাহিক ছুটির দিন',
  'flows.cron.everyMinute': 'প্রতি মিনিটে',
  'flows.cron.everyMinuteOnDays': '{days} প্রতি মিনিটে',
  'flows.cron.everyNMinutes': 'প্রতি {n} মিনিটে',
  'flows.cron.everyNMinutesOnDays': '{days} প্রতি {n} মিনিটে',
  'flows.cron.everyHour': 'প্রতি ঘণ্টায়',
  'flows.cron.everyHourOnDays': '{days} প্রতি ঘণ্টায়',
  'flows.cron.everyNHours': 'প্রতি {n} ঘণ্টায়',
  'flows.cron.everyNHoursOnDays': '{days} প্রতি {n} ঘণ্টায়',
  'flows.cron.everyDayAtTime': 'প্রতিদিন {time}-এ',
  'flows.cron.atTimeOnDays': '{days} {time}-এ',
  'flows.cron.invalidInterval': 'অবৈধ ব্যবধান',
  'flows.cron.dailyEvery24h': 'দৈনিক (প্রতি 24 ঘণ্টায়)',
  'flows.cron.everyNDays': 'প্রতি {n} দিনে',
  'flows.cron.everyNHoursShort': 'প্রতি {n} ঘণ্টায়',
  'flows.cron.everyNMinutesShort': 'প্রতি {n} মিনিটে',
  'flows.cron.everySecond': 'প্রতি সেকেন্ডে',
  'flows.cron.everyNSeconds': 'প্রতি {n} সেকেন্ডে',
  'flows.cron.onceAtRaw': '{at}-এ একবার',
  'flows.cron.onceAt': '{at}-এ একবার',
  'flows.nodeConfig.trigger.pickApp': 'আগে একটি সংযুক্ত অ্যাপ বেছে নিন।',
  'flows.nodeConfig.tool.pickConnection': 'আগে একটি সংযোগ বেছে নিন।',
  'flows.nodeConfig.composio.noConnections':
    'এখনও কোনো অ্যাপ সংযুক্ত নেই। Settings → Apps থেকে একটি সংযুক্ত করে এখানে বেছে নিন।',
  'flows.nodeConfig.composio.selectApp': 'একটি অ্যাপ বেছে নিন…',
  'flows.nodeConfig.composio.select': 'বেছে নিন…',
  'flows.nodeConfig.composio.loading': 'লোড হচ্ছে…',
  'flows.nodeConfig.composio.custom': 'ম্যানুয়ালি লিখুন…',
  'flows.nodeConfig.composio.customPlaceholder': 'SLUG_NAME',
  'flows.nodeConfig.agent.modelHint': 'ক্ষমতার স্তর বেছে নিন: ওয়ার্কস্পেস মডেল নির্ধারণ করবে।',
  'flows.nodeConfig.agent.modelInherit': 'ডিফল্ট (উত্তরাধিকার)',
  'flows.nodeConfig.agent.agentRefLabel': 'এজেন্ট',
  'flows.nodeConfig.agent.agentRefHint':
    'এই নোডটি একটি নিবন্ধিত এজেন্ট হিসেবে চালান: এর সরঞ্জাম ও সুরক্ষা প্রযোজ্য।',
  'flows.nodeConfig.agent.agentRefInherit': 'ডিফল্ট (ওয়ার্কফ্লো বিল্ডার)',
  'flows.nodeConfig.agent.modelManagedTiers': 'পরিচালিত স্তর',
  'flows.nodeConfig.agent.modelHints': 'মডেল ইঙ্গিত',
  'flows.nodeConfig.agent.modelCustom': 'কাস্টম মডেল…',
  'flows.nodeConfig.agent.modelCustomPlaceholder': 'যেমন gpt-4o-mini',
  'flows.nodeConfig.tool.requiredMark': 'আবশ্যক',
  'flows.nodeConfig.tool.requiredMissing': 'আবশ্যক: যুক্ত নয়',
  'flows.nodeConfig.tool.argsAdvancedLabel': 'সব আর্গুমেন্ট (উন্নত)',
  'flows.nodeConfig.upstream.insert': 'সন্নিবেশ করুন…',
  'flows.nodeConfig.upstream.insertLabel': 'আগের ধাপ থেকে একটি মান সন্নিবেশ করুন',
  'flows.nodeConfig.native.toolLabel': 'টুল',
  'flows.nodeConfig.native.toolHint': 'সহকারীর বিল্ট-ইন টুলগুলোর একটি (সার্চ, মিডিয়া, ফাইল, …)।',
  'flows.nodeConfig.native.select': 'একটি টুল বেছে নিন…',
  'flows.nodeConfig.native.loading': 'টুল লোড হচ্ছে…',
  'flows.nodeConfig.close': 'সেটিংস বন্ধ করুন',
  'flows.nodeConfig.nameLabel': 'নাম',
  'flows.nodeConfig.namePlaceholder': 'নোডের নাম',
  'flows.nodeConfig.editForm': 'ফর্ম হিসেবে সম্পাদনা করুন',
  'flows.nodeConfig.editJson': 'JSON হিসেবে সম্পাদনা করুন',
  'flows.nodeConfig.rawJsonLabel': 'কনফিগারেশন (JSON)',
  'flows.nodeConfig.rawJsonHint': 'এই নোডের জন্য মুক্ত কনফিগারেশন।',
  'flows.nodeConfig.rawJsonInvalid': 'অবৈধ JSON: পার্স না হওয়া পর্যন্ত পরিবর্তন প্রয়োগ হয় না।',
  'flows.nodeConfig.expressionHint':
    'নোড ইনপুট থেকে মান গণনা করতে = দিয়ে শুরু করুন, যেমন =item.url',
  'flows.nodeConfig.expressionBadge': 'এক্সপ্রেশন',
  'flows.nodeConfig.keymapKeyPlaceholder': 'কী',
  'flows.nodeConfig.keymapValuePlaceholder': 'মান',
  'flows.nodeConfig.keymapRemove': 'সারি সরান',
  'flows.nodeConfig.keymapAdd': 'সারি যোগ করুন',
  'flows.nodeConfig.credentialLabel': 'শংসাপত্র',
  'flows.nodeConfig.credentialHint': 'এই নোডের জন্য একটি সংযুক্ত অ্যাকাউন্ট বা শংসাপত্র বেছে নিন।',
  'flows.nodeConfig.credentialEmpty': 'কোনো সংযুক্ত শংসাপত্র উপলব্ধ নেই।',
  'flows.nodeConfig.credentialNone': 'কোনোটি নয়',
  'flows.nodeConfig.trigger.kindLabel': 'ট্রিগারের ধরন',
  'flows.nodeConfig.trigger.kind_manual': 'ম্যানুয়াল',
  'flows.nodeConfig.trigger.kind_schedule': 'সময়সূচি',
  'flows.nodeConfig.trigger.kind_webhook': 'ওয়েবহুক',
  'flows.nodeConfig.trigger.kind_app_event': 'অ্যাপ ইভেন্ট',
  'flows.nodeConfig.trigger.scheduleLabel': 'ক্রন সময়সূচি',
  'flows.nodeConfig.trigger.scheduleHint': 'ক্রন এক্সপ্রেশন: মিনিট ঘণ্টা দিন মাস সপ্তাহের দিন।',
  'flows.nodeConfig.trigger.toolkitLabel': 'টুলকিট',
  'flows.nodeConfig.trigger.triggerSlugLabel': 'ট্রিগার স্লাগ',
  'flows.nodeConfig.trigger.webhookHint':
    'ওয়েবহুক ট্রিগার সংরক্ষিত হয় তবে এখনও স্বয়ংক্রিয়ভাবে চলে না।',
  'flows.nodeConfig.http.methodLabel': 'পদ্ধতি',
  'flows.nodeConfig.http.urlLabel': 'URL',
  'flows.nodeConfig.http.headersLabel': 'হেডার',
  'flows.nodeConfig.http.bodyLabel': 'বডি (JSON)',
  'flows.nodeConfig.agent.promptLabel': 'প্রম্পট',
  'flows.nodeConfig.agent.promptPlaceholder': 'এজেন্টের জন্য নির্দেশনা…',
  'flows.nodeConfig.agent.modelLabel': 'মডেল',
  'flows.nodeConfig.tool.slugLabel': 'টুল স্লাগ',
  'flows.nodeConfig.tool.argsLabel': 'আর্গুমেন্ট (JSON)',
  'flows.nodeConfig.condition.fieldLabel': 'ক্ষেত্র',
  'flows.nodeConfig.condition.fieldHint':
    'সত্যতা যাচাইয়ের জন্য ইনপুট আইটেমের কী। true বা false এ রুট করে।',
  'flows.nodeConfig.switch.expressionLabel': 'এক্সপ্রেশন',
  'flows.nodeConfig.switch.hint':
    'ফলাফল মান মিলে যাওয়া আউটপুট পোর্ট নির্বাচন করে; null default এ যায়।',
  'flows.nodeConfig.switch.fieldLabel': 'ক্ষেত্র (বিকল্প)',
  'flows.nodeConfig.transform.setLabel': 'ক্ষেত্র সেট করুন',
  'flows.nodeConfig.transform.setHint':
    'প্রতিটি মান প্রতি আইটেমে মূল্যায়িত একটি এক্সপ্রেশন, যেমন =item.name',
  'flows.nodeConfig.code.languageLabel': 'ভাষা',
  'flows.nodeConfig.code.language_javascript': 'JavaScript',
  'flows.nodeConfig.code.language_python': 'Python',
  'flows.nodeConfig.code.sourceLabel': 'সোর্স কোড',
  'flows.nodeConfig.memory.operationLabel': 'অপারেশন',
  'flows.nodeConfig.memory.operation_recall': 'পুনরুদ্ধার',
  'flows.nodeConfig.memory.operation_search': 'অনুসন্ধান',
  'flows.nodeConfig.memory.operation_flavour': 'ধরন',
  'flows.nodeConfig.memory.operation_people': 'ব্যক্তি',
  'flows.nodeConfig.memory.operation_remember': 'মনে রাখুন',
  'flows.nodeConfig.memory.operation_forget': 'ভুলে যান',
  'flows.nodeConfig.memory.scopeLabel': 'পরিধি',
  'flows.nodeConfig.memory.scopeHint': 'এই মেমরিটি কোথায় খুঁজতে হবে।',
  'flows.nodeConfig.memory.scopeWriteHint':
    'শুধু এই ওয়ার্কফ্লোর মধ্যেই লেখার অনুমতি আছে, আপনার ব্যক্তিগত মেমরিতে কখনও নয়।',
  'flows.nodeConfig.memory.scope_user': 'আপনি (শুধু পড়ার জন্য)',
  'flows.nodeConfig.memory.scope_flow': 'এই ওয়ার্কফ্লো',
  'flows.nodeConfig.memory.scope_flows': 'সব ওয়ার্কফ্লো (শুধু পড়ার জন্য)',
  'flows.nodeConfig.memory.queryLabel': 'কোয়েরি',
  'flows.nodeConfig.memory.queryOptionalHint': 'ঐচ্ছিক: মানুষ খোঁজার পরিধি সংকুচিত করে।',
  'flows.nodeConfig.memory.flavourLabel': 'ধরন',
  'flows.nodeConfig.memory.flavourHint': 'কোন ব্যক্তিত্ব দিক পড়তে হবে, যেমন communication।',
  'flows.nodeConfig.memory.flavour_communication': 'যোগাযোগ',
  'flows.nodeConfig.memory.flavour_coding_style': 'কোডিং শৈলী',
  'flows.nodeConfig.memory.flavour_stack': 'প্রযুক্তি স্ট্যাক',
  'flows.nodeConfig.memory.flavour_workflow': 'কর্মপ্রবাহ',
  'flows.nodeConfig.memory.flavour_environment': 'পরিবেশ',
  'flows.nodeConfig.memory.flavour_directives': 'নির্দেশনা',
  'flows.nodeConfig.memory.flavour_anti_preferences': 'অপছন্দসমূহ',
  'flows.nodeConfig.memory.keyLabel': 'কী',
  'flows.nodeConfig.memory.valueLabel': 'মান',
  'flows.nodeConfig.memory.limitLabel': 'সীমা',
  'flows.nodeConfig.memory.limitHint': 'সর্বোচ্চ ফলাফল সংখ্যা।',
  'flows.nodeConfig.memory.minScoreLabel': 'সর্বনিম্ন স্কোর',
  'flows.nodeConfig.memory.minScoreHint': '০ থেকে ১ পর্যন্ত প্রাসঙ্গিকতার থ্রেশহোল্ড।',
  'flows.nodeConfig.dedup.keyLabel': 'কী',
  'flows.nodeConfig.dedup.keyHint':
    'প্রতিটি আইটেমের জন্য একটি স্থিতিশীল আইডি এক্সপ্রেশন, যেমন =item.id। যেসব আইটেমের কী আগে দেখা গেছে সেগুলো এড়িয়ে যাওয়া হয়।',

  // `loop` node: a bounded loop head. Emits on `body` until its cap or
  // condition says stop, then on `done`.
  'flows.nodeConfig.loop.maxIterationsLabel': 'সর্বোচ্চ পুনরাবৃত্তি',
  'flows.nodeConfig.loop.maxIterationsHint': 'লুপ থামার আগে বডি কতবার চলতে পারে। সর্বদা সসীম।',
  'flows.nodeConfig.loop.onExceededLabel': 'সীমায় পৌঁছালে',
  'flows.nodeConfig.loop.onExceededHint':
    'রান ব্যর্থ করুন, অথবা লুপ থামিয়ে শেষ ধাপের আইটেম নিয়ে done পোর্ট দিয়ে এগিয়ে যান।',
  'flows.nodeConfig.loop.onExceeded_error': 'রান ব্যর্থ করুন',
  'flows.nodeConfig.loop.onExceeded_continue': 'আংশিক ফলাফল নিয়ে চালিয়ে যান',
  'flows.nodeConfig.loop.conditionLabel': 'যতক্ষণ চালিয়ে যান',
  'flows.nodeConfig.loop.conditionHint':
    'ঐচ্ছিক। যতক্ষণ এটি সত্য ততক্ষণ লুপ চলে; প্রথম মিথ্যা ফলাফলে done পোর্ট দিয়ে বেরিয়ে যায়।',

  'flows.enableApproval.title': 'এই ওয়ার্কফ্লোকে কাজ করার অনুমতি দেবেন?',
  'flows.enableApproval.intro':
    'নিচের কাজগুলোর জন্য এই ওয়ার্কফ্লোর আপনার অনুমতি দরকার। অনুমোদন শুধু এই ওয়ার্কফ্লোর জন্য প্রযোজ্য।',
  'flows.enableApproval.approveAll': 'সব অনুমোদন করুন',
  'flows.enableApproval.deny': 'প্রত্যাখ্যান',
  'flows.enableApproval.enableAnyway': 'তবুও চালু করুন',
  'flows.enableApproval.granting': 'অনুমোদন করা হচ্ছে…',
  'flows.enableApproval.error': 'অনুমোদনগুলো সংরক্ষণ করা যায়নি। আবার চেষ্টা করুন।',
  'flows.enableApproval.blockedHint': 'আপনার এজেন্ট অ্যাক্সেস সেটিংস দ্বারা অবরুদ্ধ।',
  'flows.enableApproval.dynamicHint':
    'ওয়ার্কফ্লো চলার সময় নির্ধারিত হয়; প্রয়োজনে আপনাকে জিজ্ঞাসা করবে।',
  'flows.enableApproval.agentHint': 'এই AI ধাপটি নিজের কাজের জন্য আলাদাভাবে অনুমতি চাইতে পারে।',
  'flows.enableApproval.deniedDisabled': 'সংরক্ষিত হয়েছে, তবে ওয়ার্কফ্লোটি বন্ধ রাখা হয়েছে।',
  'flows.chooser.title': 'ওয়ার্কফ্লো তৈরি করুন',
  'flows.chooser.subtitle': 'আপনি কীভাবে শুরু করতে চান তা বেছে নিন।',
  'flows.chooser.scratchTitle': 'একদম শুরু থেকে',
  'flows.chooser.scratchDescription':
    'একটি খালি ক্যানভাস এবং একটি একক ম্যানুয়াল ট্রিগার দিয়ে শুরু করুন।',
  'flows.chooser.templateTitle': 'টেমপ্লেট থেকে',
  'flows.chooser.templateDescription':
    'একটি প্রস্তুত উদাহরণ থেকে শুরু করুন এবং এটি কাস্টমাইজ করুন।',
  'flows.chooser.describeTitle': 'বর্ণনা করুন',
  'flows.chooser.describeDescription':
    'সহকারীকে বলুন আপনি কী চান এবং তাকে ওয়ার্কফ্লোর খসড়া তৈরি করতে দিন।',
  'flows.chooser.creating': 'ওয়ার্কফ্লো তৈরি হচ্ছে…',
  'flows.chooser.createError': 'ওয়ার্কফ্লো তৈরি করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'flows.templates.title': 'টেমপ্লেট থেকে শুরু করুন',
  'flows.templates.subtitle': 'একটি শুরুর বিন্দু বেছে নিন এবং সম্পাদকে এটি কাস্টমাইজ করুন।',
  'flows.templates.use': 'টেমপ্লেট ব্যবহার করুন',
  'flows.templates.back': 'পিছনে',
  'flows.templates.empty': 'কোনো টেমপ্লেট উপলব্ধ নেই।',
  'flows.templates.category.scheduled': 'নির্ধারিত',
  'flows.templates.category.triggered': 'ট্রিগারড',
  'flows.templates.category.onDemand': 'চাহিদা অনুযায়ী',
  'flows.templates.daily-digest.name': 'চ্যানেলে দৈনিক সারসংক্ষেপ',
  'flows.templates.daily-digest.description':
    'একটি সময়সূচি অনুযায়ী, একটি এজেন্ট একটি সংক্ষিপ্ত সারসংক্ষেপ লেখে এবং তা চ্যানেলে পোস্ট করে।',
  'flows.templates.scheduled-scrape.name': 'নির্ধারিত স্ক্র্যাপ মেমরিতে',
  'flows.templates.scheduled-scrape.description':
    'সময়সূচি অনুযায়ী একটি উৎস আনুন, ফলাফল পুনর্গঠন করুন এবং মেমরিতে সংরক্ষণ করুন।',
  'flows.templates.webhook-triage.name': 'ওয়েবহুক ট্রায়াজ এবং বিজ্ঞপ্তি',
  'flows.templates.webhook-triage.description':
    'একটি আগত ওয়েবহুক একটি এজেন্ট দ্বারা ট্রায়াজ করা হয়, তারপর আপনাকে জানানো হয়।',
  'flows.templates.app-event-route.name': 'অ্যাপ ইভেন্ট থেকে শর্তসাপেক্ষ ক্রিয়া',
  'flows.templates.app-event-route.description':
    'একটি সংযুক্ত অ্যাপের ইভেন্ট একটি পরীক্ষা চালায়, তারপর মিললে ক্রিয়া সম্পাদন করে।',
  'flows.templates.http-fetch-parse.name': 'API আনুন এবং পার্স করুন',
  'flows.templates.http-fetch-parse.description':
    'চাহিদা অনুযায়ী একটি HTTP এন্ডপয়েন্ট কল করুন এবং প্রতিক্রিয়া ব্যবহারযোগ্য রূপে পার্স করুন।',
  'flows.templates.ask-agent.name': 'এজেন্টকে জিজ্ঞাসা করুন',
  'flows.templates.ask-agent.description':
    'একটি সরল ম্যানুয়াল ট্রিগার যা একটি কাজ এজেন্টকে হস্তান্তর করে।',
  'flows.templates.opus-sonnet-brief.name':
    'গবেষণা সারসংক্ষেপ (Opus পরিকল্পনা করে, Sonnet খসড়া করে)',
  'flows.templates.opus-sonnet-brief.description':
    'একটি রিজনিং-টিয়ার এজেন্ট সারসংক্ষেপ পরিকল্পনা করে, একটি চ্যাট-টিয়ার এজেন্ট খসড়া তৈরি করে, তারপর ফলাফলটি আপনার জন্য সাজানো হয়।',

  'oauth.button.connecting': 'সংযোগ হচ্ছে...',
  'oauth.button.loopbackTimeout':
    'সাইন-ইন টাইম আউট হয়েছে: ব্রাউজার OAuth পুনর্নির্দেশনা সম্পন্ন করেনি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'oauth.login.continueWith': 'দিয়ে চালিয়ে যান',
  'onboarding.contextGathering.buildingDesc': 'বিল্ডিং বিবরণ',
  'onboarding.contextGathering.buildingProfile': 'আপনার প্রোফাইল তৈরি হচ্ছে...',
  'onboarding.contextGathering.continueToChat': 'চ্যাটে চালিয়ে যান',
  'onboarding.contextGathering.coreAlive': 'কোর সংযোগযোগ্য: প্রথম লঞ্চ এক মিনিট সময় নিতে পারে।',
  'onboarding.contextGathering.coreAliveProbing': 'কোর সংযোগ যাচাই করা হচ্ছে…',
  'onboarding.contextGathering.coreUnreachable':
    'কোর সাড়া দিচ্ছে না। আপনি চালিয়ে যেতে পারেন এবং পরে আবার চেষ্টা করতে পারেন।',
  'onboarding.contextGathering.errorDesc':
    'আমরা এখনই আপনার পূর্ণ প্রোফাইল তৈরি করতে পারিনি, কিন্তু সমস্যা নেই: আপনি চালিয়ে যেতে পারেন এবং আপনার প্রোফাইল সময়ের সাথে তৈরি হবে।',
  'onboarding.contextGathering.stillWorkingDesc':
    'আমরা আপনার লোকাল মডেল এবং টুলস প্রস্তুত করছি, প্রথম লঞ্চ ৩০–৬০ সেকেন্ড সময় নিতে পারে। আপনি যেকোনো সময় চ্যাটে যেতে পারেন: প্রোফাইল তৈরি ব্যাকগ্রাউন্ডে চলতে থাকবে।',
  'onboarding.contextGathering.stillWorkingTitle': 'এখনও আপনার প্রোফাইলে কাজ চলছে…',
  'onboarding.contextGathering.title': 'কন্টেক্সট সংগ্রহ',
  'openhuman.team_list_teams': 'টিম তালিকা',
  'overlay.ariaAttention': 'মনোযোগের বার্তা',
  'overlay.ariaCompanion': 'কম্প্যানিয়ন সক্রিয়',
  'overlay.ariaOrb': 'OpenHuman ওভারলে',
  'overlay.ariaVoiceActive': 'ভয়েস ইনপুট সক্রিয়',
  'overlay.companion.error': 'ত্রুটি',
  'overlay.companion.listening': 'শুনছে…',
  'overlay.companion.speaking': 'বলছে…',
  'overlay.companion.thinking': 'ভাবছে…',
  'overlay.orbTitle': 'সরাতে টেনে আনুন · পজিশন রিসেট করতে ডাবল-ক্লিক করুন',
  'pages.settings.account.connections': 'সংযোগ',
  'pages.settings.account.connectionsDesc': 'সংযোগের বিবরণ',
  'pages.settings.account.migration': 'অন্য সহকারী থেকে আমদানি করুন',
  'pages.settings.account.migrationDesc':
    'OpenClaw (এবং শীঘ্রই Hermes) থেকে মেমরি ও নোট এই ওয়ার্কস্পেসে স্থানান্তর করুন।',
  'pages.settings.account.privacy': 'গোপনীয়তা',
  'pages.settings.account.privacyDesc': 'গোপনীয়তার বিবরণ',
  'pages.settings.account.recoveryPhrase': 'রিকভারি ফ্রেজ',
  'pages.settings.account.recoveryPhraseDesc': 'রিকভারি ফ্রেজের বিবরণ',
  'pages.settings.account.team': 'টিম',
  'pages.settings.account.teamDesc': 'টিমের বিবরণ',
  'pages.settings.accountSection.description': 'রিকভারি ফ্রেজ, টিম, সংযোগ এবং গোপনীয়তা সেটিংস।',
  'pages.settings.accountSection.title': 'অ্যাকাউন্ট',
  'pages.settings.ai.llm': 'LLM',
  'pages.settings.ai.llmDesc': 'LLM বিবরণ',
  'pages.settings.ai.voice': 'ভয়েস',
  'pages.settings.ai.voiceDesc': 'ভয়েস বিবরণ',
  'pages.settings.aiSection.description':
    'ল্যাঙ্গুয়েজ মডেল প্রোভাইডার, লোকাল Ollama, এবং ভয়েস (STT / TTS)।',
  'pages.settings.aiSection.title': 'AI',
  'settings.developerMenu.composio.title': 'Composio',
  'settings.developerMenu.composio.desc': 'রাউটিং মোড, ইন্টিগ্রেশন ট্রিগার, এবং ট্রিগার ইতিহাস।',
  'pages.settings.features.messagingChannels': 'মেসেজিং চ্যানেল',
  'pages.settings.features.messagingChannelsDesc': 'মেসেজিং চ্যানেলের বিবরণ',
  'pages.settings.features.notifications': 'বিজ্ঞপ্তি',
  'pages.settings.features.notificationsDesc': 'বিজ্ঞপ্তির বিবরণ',
  'pages.settings.features.tools': 'টুলস',
  'pages.settings.features.toolsDesc': 'টুলসের বিবরণ',
  'pages.settings.featuresSection.title': 'ফিচার',
  'privacy.dataKind.credentials': 'ক্রেডেনশিয়াল',
  'privacy.dataKind.derived': 'ডেরাইভড',
  'privacy.dataKind.diagnostics': 'ডায়াগনস্টিক্স',
  'privacy.dataKind.metadata': 'মেটাডেটা',
  'privacy.dataKind.raw': 'রা',
  'privacy.whatLeaves.link.label': 'আমার কম্পিউটার থেকে কী বের হয়?',
  'rewards.community.achievementsUnlocked': '{total}টির মধ্যে {unlocked}টি অর্জন আনলক হয়েছে',
  'rewards.community.activityStreakHint': 'OpenHuman-এ পরপর সক্রিয় থাকার দিন।',
  'rewards.community.activityTitle': 'আপনার কার্যকলাপ',
  'rewards.community.claimCredited': 'আপনার ব্যালেন্সে {amount} যোগ করা হয়েছে',
  'rewards.community.claimError': 'দাবি করা যায়নি। আবার চেষ্টা করুন।',
  'rewards.community.claimTokens': '{tokens} টোকেন দাবি করুন',
  'rewards.community.claimed': 'দাবি করা হয়েছে',
  'rewards.community.claiming': 'দাবি করা হচ্ছে…',
  'rewards.community.connectDiscord': 'Discord সংযুক্ত করুন',
  'rewards.community.connectDiscordError': 'Discord সংযোগ শুরু করা যায়নি। আবার চেষ্টা করুন।',
  'rewards.community.connectingDiscord': 'সংযুক্ত হচ্ছে…',
  'rewards.community.cumulativeTokens': 'সঞ্চিত টোকেন',
  'rewards.community.currentStreak': 'কার্যকলাপ স্ট্রিক',
  'rewards.community.disconnectDiscord': 'সংযোগ বিচ্ছিন্ন করুন',
  'rewards.community.disconnectDiscordError':
    'Discord সংযোগ বিচ্ছিন্ন করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'rewards.community.disconnectingDiscord': 'সংযোগ বিচ্ছিন্ন করা হচ্ছে…',
  'rewards.community.discordAccount': 'Discord অ্যাকাউন্ট',
  'rewards.community.discordConnected': 'Discord সংযুক্ত',
  'rewards.community.discordConnectedAs': '{username} হিসেবে সংযুক্ত',
  'rewards.community.discordDetails': 'Discord',
  'rewards.community.discordLinkedNotInGuild': 'Discord লিংক কিন্তু গিল্ডে নেই',
  'rewards.community.discordMember': 'সার্ভারে যোগ দিয়েছেন',
  'rewards.community.discordNotLinked': 'Discord লিংক করা হয়নি',
  'rewards.community.discordServer': 'Discord সার্ভার',
  'rewards.community.discordStatusUnavailable': 'Discord স্ট্যাটাস পাওয়া যাচ্ছে না',
  'rewards.community.discordWaiting': 'Discord অপেক্ষায়',
  'rewards.community.heroSubtitle': 'হিরো সাবটাইটেল',
  'rewards.community.heroTitle': 'হিরো শিরোনাম',
  'rewards.community.joinDiscord': 'Discord-এ যোগ দিন',
  'rewards.community.loadingRewards': 'পুরস্কার লোড হচ্ছে…',
  'rewards.community.locked': 'আনলক করা',
  'rewards.community.longestStreak': 'দীর্ঘতম স্ট্রিক',
  'rewards.community.retrying': 'আবার চেষ্টা হচ্ছে…',
  'rewards.community.rewardTokens': '+{tokens} টোকেন',
  'rewards.community.rewardTokensMonthly': '+{tokens} টোকেন/মাস',
  'rewards.community.roleAssigned': 'রোল বরাদ্দ হয়েছে',
  'rewards.community.roleAssignmentCount': '{unlocked}টির মধ্যে {assigned}টি রোল বরাদ্দ হয়েছে',
  'rewards.community.roleClaimDesc':
    'আপনি Discord রোল আনলক করেছেন কিন্তু এখনও OpenHuman সার্ভারে যোগ দেননি। যোগ দিন যাতে সেগুলি স্বয়ংক্রিয়ভাবে বরাদ্দ হয়।',
  'rewards.community.roleClaimTitle': 'আপনার Discord রোল দাবি করুন',
  'rewards.community.roleJoinToClaim': 'দাবি করতে সার্ভারে যোগ দিন',
  'rewards.community.rolePending': 'রোল সিঙ্ক হচ্ছে…',
  'rewards.community.rolesAndRewards': 'রোল ও পুরস্কার',
  'rewards.community.streakDays': '{n} দিন',
  'rewards.community.syncPending': 'পুরস্কার সিঙ্ক মুলতুবি',
  'rewards.community.syncPendingDesc': 'সিঙ্ক মুলতুবির বিবরণ',
  'rewards.community.syncUnavailable': 'সিঙ্ক পাওয়া যাচ্ছে না',
  'rewards.community.tryAgain': 'আবার চেষ্টা হচ্ছে…',
  'rewards.community.unknown': 'অজানা',
  'rewards.community.unlocked': 'আনলক করা',
  'rewards.community.yourProgress': 'আপনার অগ্রগতি',
  'rewards.coupon.colCode': 'কোড',
  'rewards.coupon.colRedeemed': 'রিডিম করা',
  'rewards.coupon.colReward': 'পুরস্কার',
  'rewards.coupon.colStatus': 'স্ট্যাটাস',
  'rewards.coupon.loadingHistory': 'পুরস্কার ইতিহাস লোড হচ্ছে…',
  'rewards.coupon.noCodes': 'এখনও কোনো রিওয়ার্ড কোড রিডিম করা হয়নি।',
  'rewards.coupon.pending': 'মুলতুবি',
  'rewards.coupon.placeholder': 'কুপন কোড',
  'rewards.coupon.promoCredits': 'প্রোমো ক্রেডিট',
  'rewards.coupon.recentRedemptions': 'সাম্প্রতিক রিডেম্পশন',
  'rewards.coupon.redeemAccepted':
    '{code} গৃহীত হয়েছে। প্রয়োজনীয় কাজটি সম্পন্ন হলে {amount} আনলক হবে।',
  'rewards.coupon.redeemButton': 'কোড রিডিম করুন',
  'rewards.coupon.redeemSuccess': '{code} রিডিম হয়েছে। আপনার ক্রেডিটে {amount} যোগ হয়েছে।',
  'rewards.coupon.redeemedCodes': 'রিডিম করা কোড',
  'rewards.coupon.redeeming': 'রিডিম হচ্ছে...',
  'rewards.coupon.statusApplied': 'প্রয়োগ হয়েছে',
  'rewards.coupon.statusPendingAction': 'অ্যাকশন বাকি',
  'rewards.coupon.statusRedeemed': 'রিডিম হয়েছে',
  'rewards.coupon.subtitle': 'সাবটাইটেল',
  'rewards.coupon.title': 'একটি কুপন কোড রিডিম করুন',
  'rewards.referralSection.activity': 'রেফারেল অ্যাক্টিভিটি',
  'rewards.referralSection.apply': 'প্রয়োগ হচ্ছে…',
  'rewards.referralSection.applying': 'প্রয়োগ হচ্ছে…',
  'rewards.referralSection.colReferredUser': 'রেফার করা ব্যবহারকারী',
  'rewards.referralSection.colReward': 'পুরস্কার',
  'rewards.referralSection.colStatus': 'স্ট্যাটাস',
  'rewards.referralSection.colUpdated': 'আপডেট',
  'rewards.referralSection.completed': 'সম্পন্ন',
  'rewards.referralSection.copyCode': 'কোড কপি করুন',
  'rewards.referralSection.copyFailed': 'কপি ব্যর্থ',
  'rewards.referralSection.haveCode': 'রেফারেল কোড আছে?',
  'rewards.referralSection.haveCodeDesc': 'কোড আছে বিবরণ',
  'rewards.referralSection.linked': 'লিংক করা',
  'rewards.referralSection.linkedCode': '(কোড {code})',
  'rewards.referralSection.loading': 'রেফারেল প্রোগ্রাম লোড হচ্ছে…',
  'rewards.referralSection.retry': 'আবার চেষ্টা করুন',
  'rewards.referralSection.noReferrals': 'কোনো রেফারেল নেই',
  'rewards.referralSection.pendingReferrals': 'মুলতুবি রেফারেল',
  'rewards.referralSection.placeholder': 'রেফারেল কোড',
  'rewards.referralSection.share': 'শেয়ার',
  'rewards.referralSection.statusCompleted': 'স্ট্যাটাস সম্পন্ন',
  'rewards.referralSection.statusExpired': 'স্ট্যাটাস মেয়াদোত্তীর্ণ',
  'rewards.referralSection.statusJoined': 'স্ট্যাটাস যোগ দিয়েছে',
  'rewards.referralSection.subtitle': 'সাবটাইটেল',
  'rewards.referralSection.title': 'বন্ধুদের আমন্ত্রণ জানান, ক্রেডিট অর্জন করুন',
  'rewards.referralSection.totalEarned': 'মোট অর্জিত',
  'rewards.referralSection.yourCode': 'আপনার কোড',
  'settings.ai.addCloudProvider': 'ক্লাউড প্রোভাইডার যোগ করুন',
  'settings.ai.addProvider': 'সংরক্ষণ হচ্ছে…',
  'settings.ai.apiKeyFieldLabel': 'API কী ফিল্ড লেবেল',
  'settings.ai.apiKeyRequired': 'চালিয়ে যেতে আপনার API কী পেস্ট করুন।',
  'settings.ai.apiKeyStoredEncrypted': 'API কী এনক্রিপ্ট করে সংরক্ষিত',
  'settings.ai.apiKeysEncrypted': 'xqx+x',
  'settings.ai.clearStoredKey': 'সংরক্ষিত কী মুছুন',
  'settings.ai.connectProvider': 'প্রোভাইডার সংযোগ করুন',
  'settings.ai.customRouting': 'কাস্টম রুটিং',
  'settings.ai.defaultResolvesTo': 'ডিফল্ট এতে সমাধান হয়',
  'settings.ai.discard': 'বাতিল করুন',
  'settings.ai.editProvider': 'প্রোভাইডার সম্পাদনা করুন',
  'settings.ai.llmProviders': 'LLM প্রোভাইডার',
  'settings.ai.llmProvidersDesc': 'LLM প্রোভাইডার বিবরণ',
  'settings.ai.localOllama': 'লোকাল (Ollama)',
  'settings.ai.modelLabel': 'মডেল',
  'settings.ai.noCustomProviders': 'কোনো কাস্টম প্রোভাইডার নেই',
  'settings.ai.openAiCompat.authHeaderExample': 'অনুমোদন: বহনকারী <আপনার কী>',
  'settings.ai.openAiCompat.authHeaderLabel': 'অথ হেডার',
  'settings.ai.openAiCompat.baseUrlLabel': 'বেস URL',
  'settings.ai.openAiCompat.baseUrlUnavailable': 'অনুপলব্ধ',
  'settings.ai.openAiCompat.clearKey': 'ক্লিয়ার কী',
  'settings.ai.openAiCompat.description':
    'এই /v1 সার্ভারে স্থানীয় অপারেটিং সিস্টেমের মাধ্যমে প্রোগ্র্যামক ব্যবহার করে । অনুমোদন ব্যবস্থা আপনার এখানে একটি স্থায়ী চাবি ব্যবহার করে, অ্যাপ্লিকেশনের নিজস্ব প্রধান অংশ নয় ।',
  'settings.ai.openAiCompat.keyConfigured': 'কী কনফিগার করা',
  'settings.ai.openAiCompat.keyRequired': 'কী প্রয়োজন',
  'settings.ai.openAiCompat.rotateKey': 'ঘোরান কী',
  'settings.ai.openAiCompat.setKey': 'সেট কী',
  'settings.ai.openAiCompat.title': 'OpenAI-সামঞ্জস্যপূর্ণ এন্ডপয়েন্ট',
  'settings.ai.providerLabel': 'প্রোভাইডার',
  'skills.mcpComingSoon.title': 'MCP সার্ভার',
  'skills.mcpComingSoon.description':
    'MCP সার্ভার ম্যানেজমেন্ট শীঘ্রই আসছে। এই ট্যাবটি আপনার MCP সার্ভার ইন্টিগ্রেশন আবিষ্কার, সংযোগ এবং পর্যবেক্ষণের জায়গা হবে।',
  'settings.ai.routing': 'রুটিং',
  'settings.ai.claudeCode.button': 'Claude Code',
  'settings.ai.claudeCode.inlineNotConnected':
    'সংযুক্ত নয়: আপনার স্থানীয় Claude Code CLI-এর মাধ্যমে চ্যাট রুট করে।',
  'settings.ai.claudeCode.checkingSignIn': 'সাইন-ইন যাচাই করা হচ্ছে…',
  'settings.ai.claudeCode.inlineConnected': 'সংযুক্ত।',
  'settings.ai.claudeCode.signedInAs': 'সাইন-ইন করেছেন',
  'settings.ai.claudeCode.subscriptionFallback': 'Claude সাবস্ক্রিপশন',
  'settings.ai.claudeCode.usingApiKeyEnv': 'ANTHROPIC_API_KEY ব্যবহার করছে',
  'settings.ai.claudeCode.cliNotInstalled': 'CLI ইনস্টল করা নেই',
  'settings.ai.claudeCode.signInUnknown': 'সাইন-ইন অবস্থা অজানা',
  'settings.ai.claudeCode.connectedNotSignedIn': 'সংযুক্ত · সাইন-ইন করা হয়নি',
  'settings.ai.claudeCode.modalTitle': 'Claude Code CLI',
  'settings.ai.claudeCode.modelHelp':
    'claude CLI যে মডেল আইডি গ্রহণ করে: একটি উপনাম (sonnet, opus) বা পূর্ণ নাম (claude-sonnet-4-5)। এটি হুবহু claude --model-এ পাঠানো হয়, তাই sonnet-4-5-এর মতো বিপণন নাম গ্রহণ করা হয় না।',
  'settings.ai.claudeCode.modalDescription':
    'চ্যাট, এজেন্টিক ও যুক্তিনির্ভর কাজগুলো আপনার স্থানীয়ভাবে ইনস্টল করা Claude Code CLI-এর মাধ্যমে রুট করে। কোনো API কী লাগে না: এটি CLI-এর নিজস্ব লগইন ব্যবহার করে।',
  'settings.ai.claudeCode.close': 'বন্ধ করুন',
  'settings.ai.claudeCode.connection': 'সংযোগ',
  'settings.ai.claudeCode.enabled': 'সক্রিয়',
  'settings.ai.claudeCode.notEnabled': 'সক্রিয় নয়',
  'settings.ai.claudeCode.disconnect': 'সংযোগ বিচ্ছিন্ন করুন',
  'settings.ai.claudeCode.disconnecting': 'সংযোগ বিচ্ছিন্ন করা হচ্ছে…',
  'settings.ai.claudeCode.enable': 'Claude Code সক্রিয় করুন',
  'settings.ai.claudeCode.enabling': 'সক্রিয় করা হচ্ছে…',
  'settings.ai.claudeCode.authentication': 'প্রমাণীকরণ',
  'settings.ai.claudeCode.recheck': 'পুনরায় যাচাই',
  'settings.ai.claudeCode.checking': 'যাচাই করা হচ্ছে…',
  'settings.ai.claudeCode.openingTerminal': 'টার্মিনাল খোলা হচ্ছে…',
  'settings.ai.claudeCode.signIn': 'Claude দিয়ে সাইন ইন করুন',
  'settings.ai.claudeCode.reconnect': 'পুনরায় সংযুক্ত করুন',
  'settings.ai.claudeCode.loginHint':
    'claude login চালানো একটি টার্মিনাল খোলে। সম্পন্ন হলে, পুনরায় যাচাই-এ ক্লিক করুন।',
  'settings.ai.claudeCode.loginError': 'লগইন টার্মিনাল খোলা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'settings.ai.claudeCode.fullAccess': 'সম্পূর্ণ অ্যাক্সেস',
  'settings.ai.claudeCode.fullAccessOn':
    'Claude Code কমান্ড চালাতে, নেটওয়ার্ক ব্যবহার করতে ও সাব-এজেন্ট তৈরি করতে পারে।',
  'settings.ai.claudeCode.fullAccessOff':
    'শুধু সম্পাদনা গ্রহণ করুন: ফাইল সম্পাদনা স্বয়ংক্রিয়ভাবে প্রয়োগ করে, কমান্ড ও নেটওয়ার্ক নিয়ন্ত্রণ করে।',
  'settings.ai.claudeCode.sandboxNoteMac':
    'macOS-এ, উভয় মোডেই ~/.openhuman স্যান্ডবক্স দ্বারা সুরক্ষিত থাকে।',
  'settings.ai.claudeCode.sandboxNoteOther':
    'এই প্ল্যাটফর্মে সম্পূর্ণ অ্যাক্সেস সীমাবদ্ধ নয়: ওয়ার্কস্পেসে আস্থা থাকলেই কেবল সক্রিয় করুন।',
  'settings.ai.claudeCode.enableToCheck': 'সাইন-ইন যাচাই করতে Claude Code সক্রিয় করুন।',
  'settings.ai.claudeCode.usingApiKeyEnvDetail': 'পরিবেশ থেকে ANTHROPIC_API_KEY ব্যবহার করছে।',
  'settings.ai.claudeCode.notFoundInstall':
    'Claude Code CLI পাওয়া যায়নি: ইনস্টল করুন: npm install -g @anthropic-ai/claude-code',
  'settings.ai.claudeCode.unknownDetail':
    'সাইন-ইন অবস্থা নির্ধারণ করা যায়নি। আপনার claude CLI auth status সমর্থনের চেয়ে পুরোনো হতে পারে: পুনরায় সংযুক্ত করুন, তারপর পুনরায় যাচাই করুন।',
  'settings.ai.claudeCode.notSignedIn': 'সাইন-ইন করা হয়নি।',
  'settings.ai.routingCustom': 'কাস্টম রুটিং',
  'settings.ai.routingDefault': 'ডিফল্ট',
  'settings.ai.routingDesc': 'রুটিং বিবরণ',
  'settings.ai.saveChanges': 'সংরক্ষণ হচ্ছে…',
  'settings.ai.saving': 'সংরক্ষণ হচ্ছে…',
  'settings.ai.unsavedChange': 'অসংরক্ষিত পরিবর্তন',
  'settings.ai.unsavedChanges': 'অসংরক্ষিত পরিবর্তন',
  'settings.ai.workloadGroupBackground': 'ওয়ার্কলোড গ্রুপ ব্যাকগ্রাউন্ড',
  'settings.ai.workloadGroupChat': 'ওয়ার্কলোড গ্রুপ চ্যাট',
  'settings.ai.disconnectProvider': 'সংযোগ বিচ্ছিন্ন করুন {label}',
  'settings.ai.connectProviderLabel': 'সংযোগ {label}',
  'settings.ai.editProviderEndpoint': '{label} শেষবিন্দু সম্পাদনা করুন',
  'settings.ai.defaultLocalEndpoint': 'http://localhost:11434/v1',
  'settings.ai.editEndpoint': 'শেষবিন্দু সম্পাদনা করুন',
  'settings.ai.endpointUrlLabel': 'শেষবিন্দু URL',
  'settings.ai.localRuntimeHelper':
    'xqxqx সহযোগে সংযোগ ব্যবস্থা করা হবে। ডিফল্ট স্থানীয় হোস্ট; দূরবর্তী হোস্টটিকে এই অবস্থায় দেখা যাবে (যেমন, xq1xqxqx ব্যবহার করা হচ্ছে)।',
  'settings.ai.endpointUrlRequired': 'এন্ডপয়েন্ট URL প্রয়োজন।',
  'settings.ai.endpointProtocolRequired': 'সমাপ্তির তারিখ / http://wxqxqxkx/x উচিত',
  'settings.ai.connectProviderDialog': 'সংযোগ করুন {label}',
  'settings.ai.getProviderApiKey': 'API Key নিন',
  'settings.ai.or': 'অথবা',
  'settings.ai.codexOauthMissingAuthUrl':
    'Codex OAuth কোনো অনুমোদন URL ফেরত দেয়নি। আবার সাইন ইন করার চেষ্টা করুন।',
  'settings.ai.codexOauthMissingCallbackUrl':
    'সাইন ইন করার পরে আপনার ব্রাউজার থেকে রিডাইরেক্ট URL পেস্ট করুন।',
  'settings.ai.openRouterOauthDescription':
    'xqxqxx সহযোগে সাইন করুন এবং xqxyqx ব্যবহার করে একটি ব্যবহারকারী xxqx কী ইম্পোর্ট করুন',
  'settings.ai.connecting': 'সংযোগ করা হচ্ছে...',
  'settings.ai.codexAuthButton': 'Codex সংযুক্ত করুন',
  'settings.ai.codexAuthHelper': '~/.codex/auth.json থেকে বিদ্যমান Codex CLI লগইন ব্যবহার করে।',
  'settings.ai.backgroundLoops': 'ব্যাকগ্রাউন্ড লুপস',
  'settings.ai.backgroundLoopsDesc':
    'লক্ষ্য করুন যে, কোন আড্ডা ছাড়াই কি করা হয়, হার্টবিটের কাজ বিরতি দিন এবং সম্প্রতি ক্রেডিট কার্ড পরীক্ষা করুন ।',
  'settings.ai.heartbeatControls': 'হার্টবিট নিয়ন্ত্রণ',
  'settings.ai.heartbeatControlsDesc':
    'বন্ধ করো। লুপ সক্রিয় করা হচ্ছে; চলমান কাজ পরিত্যাগ করা হচ্ছে।',
  'settings.ai.heartbeatLoop': 'হার্টবিট লুপ',
  'settings.ai.heartbeatLoopDesc': 'প্লানার + ঐচ্ছিক অবচেতনের মাস্টার শিডিউলার।',
  'settings.ai.subconsciousInference': 'অবচেতন অনুমান',
  'settings.ai.subconsciousInferenceDesc': 'হার্টবিট চেকের জন্য মডেল-বিন্যস্ত xqxqx পরীক্ষা চালান।',
  'settings.ai.calendarMeetingChecks': 'ক্যালেন্ডার মিটিং চেক',
  'settings.ai.calendarMeetingChecksDesc': 'সক্রিয় xqxqx বর্ষপঞ্জির তালিকা।',
  'settings.ai.calendarCap': 'ক্যালেন্ডার ক্যাপ',
  'settings.ai.connectionsPerTick': 'এক্স.x% 1x xx%x+1x',
  'settings.ai.meetingLookahead': 'মিটিং এর আগে',
  'settings.ai.minutesShort': '{count} মিনিট',
  'settings.ai.reminderLookahead': '__PH0__ Re__2 মিনিট] লুকআহেড',
  'settings.ai.cronReminderChecks': 'ক্রোন রিমাইন্ডার চেক করে',
  'settings.ai.cronReminderChecksDesc':
    'বিভিন্ন স্ক্যানের সময় বিশেষ কিছু বস্তু চিহ্নিত করার উদ্দেশ্যে স্বয়ংক্রিয়ভাবে কর্মের কর্ম সক্রিয় করা হয়।',
  'settings.ai.relevantNotificationChecks': 'প্রাসঙ্গিক বিজ্ঞপ্তি চেক',
  'settings.ai.relevantNotificationChecksDesc':
    'সক্রিয় সতর্কতার সাথে স্থানীয় গুরুত্বপূর্ণ বার্তা প্রচার করা।',
  'settings.ai.externalDelivery': 'বাহ্যিক ডেলিভারি',
  'settings.ai.externalDeliveryDesc':
    'হার্টবিট সতর্ক সংকেত দেয় বহিস্থিত চ্যানেলগুলোর কাছে সক্রিয় বার্তা পাঠাতে।',
  'settings.ai.interval': 'ব্যবধান',
  'settings.ai.running': 'চলছে...',
  'settings.ai.plannerTickNow': 'প্ল্যানার এখন টিক দিন',
  'settings.ai.loadingHeartbeatControls': 'হার্টবিট নিয়ন্ত্রণ লোড হচ্ছে...',
  'settings.ai.heartbeatControlsUnavailable': 'হার্টবিট নিয়ন্ত্রণ অনুপলব্ধ৷',
  'settings.ai.loopMap': 'লুপ ম্যাপ',
  'settings.ai.plannerSummary':
    'পরিকল্পনাকারী: {sourceEvents} উৎস ইভেন্ট, {sent} পাঠানো হয়েছে, {deduped} ডিডুড করা হয়েছে।',
  'settings.ai.routeLabel': 'রুট: {route}',
  'settings.ai.on': 'উপর',
  'settings.ai.off': 'বন্ধ',
  'settings.ai.recentUsageLedger': 'সাম্প্রতিক ব্যবহার লেজার',
  'settings.ai.recentUsageLedgerDesc':
    'ব্যাক-এন্ড সারি আজ xqxqxqx; সোর্স ট্যাগের ব্যাক-এন্ড সমর্থন প্রয়োজন।',
  'settings.ai.latestSpend': 'সর্বশেষ খরচ: {amount} এ {time} ({action})',
  'settings.ai.topActions': 'টপ অ্যাকশন',
  'settings.ai.noSpendRows': 'কোনো খরচ সারি লোড করা হয়নি।',
  'settings.ai.topHours': 'সেরা ঘন্টা',
  'settings.ai.noHourlySpend': 'এখনও কোন ঘন্টা খরচ নেই.',
  'settings.ai.openhumanDefault': 'OpenHuman (ডিফল্ট)',
  'settings.ai.localModelResolved': 'Ollama · {model}',
  'settings.ai.customRoutingForWorkload': '{label} এর জন্য কাস্টম রাউটিং',
  'settings.ai.loadingModels': 'মডেল লোড হচ্ছে...',
  'settings.ai.enterModelIdManually': 'অথবা ম্যানুয়ালি মডেল লিখুন',
  'settings.ai.modelIdPlaceholderForProvider': '{slug} মডেল আইডি',
  'settings.ai.modelIdPlaceholder': 'model-id',
  'settings.ai.selectModel': 'একটি মডেল নির্বাচন করুন...',
  'settings.ai.deploymentNameLabel': 'ডিপ্লয়মেন্টের নাম',
  'settings.ai.deploymentNamePlaceholder': 'my-gpt-deployment',
  'settings.ai.deploymentNameHelp':
    'Azure AI Foundry-তে আপনি যে ডিপ্লয়মেন্টের নাম সেট করেছেন তা লিখুন। এটি মডেল আইডি নয়।',
  'settings.ai.deploymentNameLegacyHint':
    'এই মানটি প্রদানকারীর তালিকার বেস মডেল আইডির সঙ্গে মেলে। Azure ডিপ্লয়মেন্টের নাম দিয়ে অনুরোধ পাঠায়, তাই নিশ্চিত করুন এটি আপনার ডিপ্লয়মেন্টের নাম।',
  'settings.ai.deploymentNameProviderHint':
    'Azure এন্ডপয়েন্ট শনাক্ত হয়েছে। এই প্রদানকারী নির্বাচন করার পর মডেল ফিল্ডে আপনার ডিপ্লয়মেন্টের নাম দিন।',
  'settings.ai.chooseModelFromList': 'তালিকা থেকে বেছে নিন',
  'settings.ai.enterModelIdManuallyAction': 'ম্যানুয়ালি মডেল আইডি লিখুন',
  'settings.ai.enterDeploymentNameManuallyAction': 'ম্যানুয়ালি ডিপ্লয়মেন্ট নাম লিখুন',
  'settings.ai.probeFailedHint':
    'এই প্রদানকারীর মডেল তালিকা আমরা পড়তে পারিনি। ওই তালিকা কেবল ড্রপডাউন ভরাট করে, তাই আপনি এখনও প্রদানকারী যোগ করে নিজেই মডেল বা ডিপ্লয়মেন্টের নাম লিখতে পারেন।',
  'settings.ai.probeFailedAddAnyway': 'যাচাই না করেই যোগ করুন',
  'settings.ai.azureV1EndpointHint':
    'Azure-এর জন্য v1 বেস URL ব্যবহার করুন: https://YOUR-RESOURCE.openai.azure.com/openai/v1। পুরোনো রিসোর্স URL কোনো মডেল তালিকা দেয় না এবং ভিন্ন প্রমাণীকরণ হেডার আশা করে।',
  'settings.ai.temperatureOverride': 'তাপমাত্রা ওভাররাইড',
  'settings.ai.temperatureOverrideSlider': 'তাপমাত্রা ওভাররাইড (স্লাইডার)',
  'settings.ai.temperatureOverrideValue': 'তাপমাত্রা ওভাররাইড (মান)',
  'settings.ai.temperatureOverrideDesc':
    'নিচে = আরও বুদ্ধিমান. পরিসেবা উপলব্ধকারীর ডিফল্ট ব্যবহারের জন্য সীমা ধার্য না করা হলে, বন্ধ করুন ।',
  'settings.ai.modelVision': 'ভিশন সমর্থন করে (ছবি ইনপুট)',
  'settings.ai.modelVisionDesc':
    'এই মডেল ছবি গ্রহণ করলে সক্ষম করুন। এই মডেল নির্বাচিত থাকলে চ্যাটে ছবি সংযুক্ত করতে দেয়।',
  'settings.ai.testFailed': 'পরীক্ষা ব্যর্থ হয়েছে',
  'settings.ai.providerTest.authRejected':
    "কী সংরক্ষণ করা হয়েছে, কিন্তু '{slug}' সেটি প্রত্যাখ্যান করেছে। দেখুন আপনি পুরো কী পেস্ট করেছেন কি না এবং সেটি প্রদানকারীর ড্যাশবোর্ডে এখনও সক্রিয় কি না।",
  'settings.ai.providerTest.modelNotRecognized':
    "কী সংরক্ষণ ও গৃহীত হয়েছে, কিন্তু '{slug}' নির্বাচিত মডেলটি চিনতে পারছে না। এই প্রদানকারী সত্যিই দেয় এমন একটি মডেল আইডি বেছে নিন (এর ডিফল্ট মডেল প্রদানকারীর এন্ট্রিতে সেট করা হয়)।",
  'settings.ai.providerTest.quotaOrBilling':
    "কী সংরক্ষণ ও গৃহীত হয়েছে, কিন্তু '{slug}' কোটা বা বিলিংয়ের কারণে অনুরোধটি প্রত্যাখ্যান করেছে। প্রদানকারীর কাছে আপনার অ্যাকাউন্ট ব্যালেন্স ও ব্যবহারের সীমা দেখুন।",
  'settings.ai.providerTest.endpointNotFound':
    "কী সংরক্ষণ করা হয়েছে, কিন্তু '{slug}' এর জন্য কনফিগার করা এন্ডপয়েন্ট 404 ফেরত দিয়েছে। বেস URL দেখুন: OpenAI-সঙ্গতিপূর্ণ প্রদানকারীর সাধারণত '/v1' প্রত্যয় প্রয়োজন (যেমন https://api.openai.com/v1)।",
  'settings.ai.providerTest.timeout':
    "কী সংরক্ষণ করা হয়েছে, কিন্তু '{slug}' সময়মতো সাড়া দেয়নি। এন্ডপয়েন্ট URL ও আপনার নেটওয়ার্ক দেখে আবার পরীক্ষা করুন।",
  'settings.ai.providerTest.emptyReply':
    "কী সংরক্ষণ করা হয়েছে, কিন্তু '{slug}' পরীক্ষামূলক প্রম্পটে খালি উত্তর ফেরত দিয়েছে। এই প্রদানকারীর জন্য কনফিগার করা মডেল আইডি দেখুন।",
  'settings.ai.providerTest.unknown':
    "কী সংরক্ষণ করা হয়েছে, কিন্তু '{slug}' এ পরীক্ষামূলক কল ব্যর্থ হয়েছে। প্রদানকারীর স্ট্যাটাস পৃষ্ঠা ও এন্ডপয়েন্ট URL দেখে আবার পরীক্ষা করুন।",
  'settings.ai.testingModel': 'পরীক্ষার মডেল...',
  'settings.ai.modelResponse': 'মডেল প্রতিক্রিয়া',
  'settings.ai.providerWithValue': 'প্রদানকারী: {value}',
  'settings.ai.noneDash': 'কোনোটিই নয়',
  'settings.ai.promptHelloWorld': 'প্রম্পট: হ্যালো ওয়ার্ল্ড',
  'settings.ai.startedAt': 'শুরু হয়েছে: {value}',
  'settings.ai.waitingForModelResponse': 'মডেল থেকে প্রতিক্রিয়ার জন্য অপেক্ষা করুন...',
  'settings.ai.response': 'প্রতিক্রিয়া',
  'settings.ai.testing': 'পরীক্ষা করা হচ্ছে...',
  'settings.ai.test': 'পরীক্ষা',
  'settings.ai.slugMissingError': 'একটি স্লাগ তৈরি করতে একটি প্রদানকারীর নাম লিখুন৷',
  'settings.ai.slugInUseError': 'সেই প্রদানকারীর নাম ইতিমধ্যেই ব্যবহার করা হচ্ছে৷',
  'settings.ai.slugReservedError': 'একটি ভিন্ন প্রদানকারীর নাম বেছে নিন।',
  'settings.ai.providerNamePlaceholder': 'আমার প্রদানকারী',
  'settings.ai.slugLabel': 'স্লাগ:',
  'settings.ai.openAiUrlLabel': 'এক্স.x১xxx xx+qx',
  'settings.ai.openAiUrlPlaceholder': 'https://api.openai.com/v1',
  'settings.ai.keepExistingKeyPlaceholder': 'বিদ্যমান কী রাখার জন্য ফাঁকা ছেড়ে দিন',
  'settings.ai.reindexingMemory': 'মেমরি পুনঃসূচীকরণ করা হচ্ছে',
  'settings.ai.reindexingMemoryMessage':
    'এম্পটগুলো পুনরায় চালু হচ্ছে। xqxqx মেমরি((s) বর্তমান মডেলের মধ্যে পুনরায় বিবাহ করা হচ্ছে- এই ধরনের কাজ শেষ না হওয়া পর্যন্ত তা কমিয়ে আনা হচ্ছে। শব্দ অনুসন্ধান কাজ করছে, এবং পটভূমিতে আবার অনুসন্ধান চালিয়ে যাচ্ছে যদি আপনি এটা বন্ধ করেন।',
  'settings.ai.signInWithOpenRouter': 'xqxqx সহযোগে সাইন করুন',
  'settings.ai.weekBudget': '__BR0__ দিয়ে সাইন ইন করুন',
  'settings.ai.cycleRemaining': 'সপ্তাহের বাজেট',
  'settings.ai.cycleTotalSpend': 'বাকি সাইকেল',
  'settings.ai.avgSpendRow': 'সাইকেলের মোট খরচ [[I18N_SEP_92731] সারির মোট খরচ [[I18N_SEP_92731]',
  'settings.ai.backgroundApiReads': 'Bg API পড়েছে',
  'settings.ai.backgroundWakeups': 'ঘুম থেকে জেগে উঠ',
  'settings.ai.budgetMath': 'বাজেটের গণিত',
  'settings.ai.rowsLeft': 'সারি বাকি',
  'settings.ai.rowsPerFullWeekBudget': 'পূর্ণ সপ্তাহের বাজেট প্রতি সারি',
  'settings.ai.sampleBurnRate': 'নমুনা পোড়া হার',
  'settings.ai.projectedEmpty': 'খালি অনুমান করা হয়েছে',
  'settings.ai.apiReadsPerDollarRemaining': 'API রিড প্রতি $ অবশিষ্ট',
  'settings.ai.loopCallBudget': 'লুপ কল বাজেট',
  'settings.ai.heartbeatTicks': 'হার্টবিট টিক',
  'settings.ai.calendarPlannerCalls': 'ক্যালেন্ডার পরিকল্পনাকারী কল',
  'settings.ai.calendarFanoutCap': 'ক্যালেন্ডার ফ্যানআউট ক্যাপ',
  'settings.ai.subconsciousModelCalls': 'অবচেতন মডেল কল',
  'settings.ai.composioSyncScans': 'Composio সিঙ্ক স্ক্যান',
  'settings.ai.totalBackgroundApiReadBudget': 'মোট bg API পঠিত বাজেট',
  'settings.ai.memoryWorkerPolls': 'মেমরি কর্মী পোল',
  'settings.ai.defaultProviderName': 'OpenHuman',
  'settings.ai.routing.managed': 'পরিচালিত',
  'settings.ai.routing.managedAlwaysOn': 'সর্বদা চালু',
  'settings.ai.routing.managedHint':
    'পরিচালিত সবসময় একটি ফলব্যাক হিসাবে উপলব্ধ. আপনার নিজের মডেল ব্যবহার করতে, নীচে একটি রাউটিং মোড চয়ন করুন.',
  'settings.ai.routing.managedDesc':
    'xq0xqx সমস্ত প্রকার মেঘে রান করা হবে, কর্মের জন্য সেরা মডেল নির্বাচন করুন, খরচের জন্য ব্যবহারযোগ্য ডিফল্ট মান নির্বাচন করুন।',
  'settings.ai.routing.managedMsg':
    'xqxqx সকল কাজের জন্য ফাংশনসমূহ পরিচালনা করবে এবং স্বয়ংক্রিয়ভাবে ব্যয়, মান, এবং নিরাপত্তার জন্য সেরা পথ নির্বাচন করবে।',
  'settings.ai.routing.useYourOwn': 'আপনার নিজের মডেলগুলি ব্যবহার করুন',
  'settings.ai.routing.useYourOwnDesc':
    'প্রোভাইডার + মডেল এবং প্রত্যেক ওয়ার্কশপে রুট বেছে নিন । এটা খুব সহজ, কিন্তু এটা দক্ষ হতে পারে কারণ লাইটওয়েট এবং ভারী ওজন একই পথ শেয়ার করতে পারে।',
  'settings.ai.routing.advanced': 'উন্নত',
  'settings.ai.routing.advancedDesc':
    'ভিন্ন কাজের জন্য বিভিন্ন মডেল নির্বাচন করুন। এটা হচ্ছে সবচেয়ে ভালো উপায় যে, খরচ কমানোর জন্য সব থেকে বেশী খরচ করা যায়।',
  'settings.ai.routing.customDesc':
    'ফাইন-গ্রান্টিং আপনার জন্য সবচেয়ে ভাল দাম এবং সর্বোচ্চ ক্ষমতা দেয়. নীচে যে সারি ব্যবহার করা হবে তা নির্ধারণ করুন ।',
  'settings.ai.routing.chatAndConversations': 'চ্যাট এবং কথোপকথন',
  'settings.ai.routing.chatDesc':
    'সরাসরি ব্যবহারকারী যোগাযোগ, উত্তর, যুক্তি, এজেন্ট লুপ এবং কোড সাহায্য করার সময় ব্যবহার করা হয়েছে।',
  'settings.ai.routing.backgroundTasks': 'ব্যাকগ্রাউন্ড টাস্ক',
  'settings.ai.routing.bgTasksDesc':
    'তুলনা, হার্টবিট, শিক্ষা এবং অবচেতনের মূল্যায়নের মূল কথোপকথনের বাইরে যে মডেলগুলো ব্যবহার করা হয়েছে সেগুলো ব্যবহার করা হয়েছে।',
  'settings.ai.routing.workload.chat.label': 'Chat',
  'settings.ai.routing.workload.chat.description':
    'প্রত্যক্ষ কথোপকথন সামনে এবং পিছনে: কথোপকথনে "দ্রুত" মোড',
  'settings.ai.routing.workload.chat.hint':
    'প্রস্তাবিত: উচ্চ টোকেন/সেকেন্ড এবং কম বিলম্ব সহ একটি সস্তা বা মাঝারি দামের দ্রুত চ্যাট মডেল৷ ওপেন সোর্স স্থানীয় মডেলগুলি এখানে ভাল কাজ করতে পারে যদি তারা প্রতিক্রিয়াশীল মনে করে।',
  'settings.ai.routing.workload.reasoning.label': 'Reasoning',
  'settings.ai.routing.workload.reasoning.description':
    'প্রধান চ্যাট এজেন্ট, মিটিংয়ের সারাংশ: কথোপকথনে "রিজনিং" মোড',
  'settings.ai.routing.workload.reasoning.hint':
    'প্রস্তাবিত: গভীর চিন্তার জন্য আরও ব্যয়বহুল সীমান্ত বা শক্তিশালী যুক্তি মডেল। এটি প্রধান চ্যাট এজেন্ট, মিটিং সারাংশ এবং ভারী উত্তর সংশ্লেষণের জন্য ব্যবহৃত হয়।',
  'settings.ai.routing.workload.agentic.label': 'Agentic',
  'settings.ai.routing.workload.agentic.description': 'সাব-এজেন্ট রানার, টুল লুপ, GIF সিদ্ধান্ত',
  'settings.ai.routing.workload.agentic.hint':
    'প্রস্তাবিত: শক্তিশালী টুল ব্যবহার সহ একটি নির্ভরযোগ্য নির্দেশ-অনুসরণকারী মডেল। মিড-কস্ট ফ্রন্টিয়ার মডেল সাধারণত সবচেয়ে নিরাপদ; টুল কলিং স্থিতিশীল হলে সক্ষম ওপেন সোর্স মডেল কাজ করতে পারে।',
  'settings.ai.routing.workload.coding.label': 'Coding',
  'settings.ai.routing.workload.coding.description': 'কোড জেনারেশন এবং রিফ্যাক্টর পাস',
  'settings.ai.routing.workload.coding.hint':
    'প্রস্তাবিত: দৃঢ় নির্দেশ অনুসরণ, সম্পাদনা গুণমান এবং দীর্ঘ-প্রসঙ্গ কর্মক্ষমতা সহ একটি কোডিং-টিউনড মডেল। এটি সাধারণত আরও বেশি ব্যয় করার মতো।',
  'settings.ai.routing.workload.vision.label': 'Vision',
  'settings.ai.routing.workload.vision.description':
    'ভিশন সাব-এজেন্টের জন্য চিত্র বোঝা: সর্বদা মাল্টিমডাল',
  'settings.ai.routing.workload.vision.hint':
    'প্রস্তাবিত: একটি মাল্টিমোডাল মডেল যা ইমেজ ইনপুট গ্রহণ করে। পরিচালিত ডিফল্ট (ভিশন-v1) হল ইমেজ-সক্ষম; আপনি এখানে যে কোনো প্রদানকারীকে সর্বদা দৃষ্টি-সক্ষম হিসাবে বিবেচনা করা হয়।',
  'settings.ai.routing.workload.memory.label': 'মেমরি সারসংক্ষেপ',
  'settings.ai.routing.workload.memory.description': 'গাছের নির্যাস এবং একত্রীকরণ',
  'settings.ai.routing.workload.memory.hint':
    'প্রস্তাবিত: একটি সস্তা সংক্ষিপ্তকরণ মডেল। এটি সামঞ্জস্যপূর্ণ এবং কম্প্যাক্ট হওয়া উচিত, তবে এর জন্য প্রিমিয়াম ফ্রন্টিয়ার-লেভেল যুক্তির প্রয়োজন নেই।',
  'settings.ai.routing.workload.heartbeat.label': 'Heartbeat',
  'settings.ai.routing.workload.heartbeat.description': 'ব্যবহারকারী বাঁক মধ্যে পটভূমি যুক্তি',
  'settings.ai.routing.workload.heartbeat.hint':
    'প্রস্তাবিত: একটি সস্তা, দক্ষ ব্যাকগ্রাউন্ড মডেল। এটি প্রায়শই মোড়ের মধ্যে চলে, তাই কম খরচ সর্বাধিক বুদ্ধিমত্তার চেয়ে বেশি গুরুত্বপূর্ণ।',
  'settings.ai.routing.workload.learning.label': 'শিক্ষা · প্রতিফলন',
  'settings.ai.routing.workload.learning.description':
    'সাম্প্রতিক ইতিহাসের উপর পর্যায়ক্রমিক প্রতিফলন',
  'settings.ai.routing.workload.learning.hint':
    'প্রস্তাবিত: একটি শক্তিশালী প্রতিফলিত মডেল। এটি মধ্য-খরচ বা প্রিমিয়াম হতে পারে কারণ সাম্প্রতিক ইতিহাসের তুলনায় এটি আরও ভাল সংশ্লেষণ থেকে উপকৃত হয়।',
  'settings.ai.routing.workload.subconscious.label': 'Subconscious',
  'settings.ai.routing.workload.subconscious.description': 'ইভেন্টফুলনেস স্কোরিং + ড্রিফ্ট চেক',
  'settings.ai.routing.workload.subconscious.hint':
    'প্রস্তাবিত: একটি খুব সস্তা মনিটরিং মডেল, আদর্শভাবে একটি যা হালকা ওজনের এবং অনুমানযোগ্য। এটি ইভেন্টফুলনেস স্কোরিং, ড্রিফ্ট চেক এবং শান্ত পটভূমি মূল্যায়নের জন্য।',
  'settings.ai.routing.addCustomProvider': 'কাস্টম প্রদানকারী যোগ করুন',
  'settings.ai.globalModel.title': 'সবকিছুর জন্য একটি মডেল চয়ন করুন',
  'settings.ai.globalModel.desc':
    'এই সব পথ এক মডেল দ্বারা সীমাবদ্ধ। এটা সহজ, কিন্তু খরচ ও গুণের ক্ষেত্রে এটি দক্ষ হতে পারে, কারণ লাইটওয়েট এবং ভারী কাজ সকল পথ একই ভাবে ব্যবহার করা হবে।',
  'settings.ai.globalModel.noProviders':
    'সংযোগ যোগ অথবা পরিসেবার সাথে সংযোগ স্থাপন করুন । তারপর তুমি প্রতিটি ওয়ার্কশপ পার করতে পারবে একটা মডেল দিয়ে।',
  'settings.ai.globalModel.provider': 'প্রদানকারী',
  'settings.ai.globalModel.model': 'মডেল',
  'settings.ai.globalModel.loadingModels': 'মডেলগুলি লোড করা হচ্ছে...',
  'settings.ai.globalModel.enterModelId': 'মডেল আইডি লিখুন',
  'settings.ai.globalModel.appliesToAll':
    'একই সেবা প্রদানকারী + মডেল, যুক্তি, মেমরি, হার্টবিট, শিক্ষা, এবং অবচেতনের মাধ্যমে কথোপকথন, যুক্তি, যুক্তি, মেমরি, মেমরি, মেমরি, হৃদয়বিট। equice কনফিগার করা হয়েছে। সংরক্ষণ করার সময় পরিবর্তনগুলি সংরক্ষণ করা হবে।',
  'settings.ai.globalModel.saving': 'ইনস্টল করা হয়েছে...',
  'settings.ai.globalModel.saved': 'সংরক্ষণ করা হচ্ছে...',
  'settings.ai.workload.noModel': 'সংরক্ষণ করা হয়েছে',
  'settings.ai.workload.changeModel': 'কোনো মডেল নির্বাচিত হয়নি',
  'settings.ai.workload.chooseModel': 'মডেল পরিবর্তন করুন [[I18N_SEP_92731] মডেল চয়ন করুন',
  'settings.ai.provider.ollama': 'Ollama',
  'settings.billing.autoRecharge.addAmount': 'এই পরিমাণ যোগ করুন',
  'settings.billing.autoRecharge.addCard': 'কার্ড যোগ করুন',
  'settings.billing.autoRecharge.amountHint': 'পরিমাণ হিন্ট',
  'settings.billing.autoRecharge.defaultCard': 'ডিফল্ট কার্ড',
  'settings.billing.autoRecharge.lastRechargeFailed': 'শেষ রিচার্জ ব্যর্থ',
  'settings.billing.autoRecharge.lastRecharged': 'শেষ রিচার্জ',
  'settings.billing.autoRecharge.expires': '{date} এ মেয়াদ শেষ',
  'settings.billing.autoRecharge.noCards': 'কোনো কার্ড নেই',
  'settings.billing.autoRecharge.paymentMethods': 'পেমেন্ট পদ্ধতি',
  'settings.billing.autoRecharge.rechargeInProgress': 'রিচার্জ চলছে',
  'settings.billing.autoRecharge.spentThisWeek': 'এই সপ্তাহে ${spent} / ${limit} ব্যবহৃত',
  'settings.billing.autoRecharge.rechargeWhen': 'ব্যালেন্স কম হলে রিচার্জ করুন',
  'settings.billing.autoRecharge.saveSettings': 'সংরক্ষণ হচ্ছে…',
  'settings.billing.autoRecharge.saving': 'সংরক্ষণ হচ্ছে…',
  'settings.billing.autoRecharge.setDefault': ':',
  'settings.billing.autoRecharge.subtitle': 'সাবটাইটেল',
  'settings.billing.autoRecharge.title': 'অটো-রিচার্জ সক্রিয় করুন',
  'settings.billing.autoRecharge.toggleAriaLabel': 'অটো-রিচার্জ টগল করুন',
  'settings.billing.autoRecharge.weeklyLimit': 'সাপ্তাহিক ব্যয় সীমা',
  'settings.billing.history.desc': 'বিবরণ',
  'settings.billing.history.empty': 'খালি',
  'settings.billing.history.openPortal': 'পোর্টাল খুলুন',
  'settings.billing.history.posted': 'পোস্ট করা',
  'settings.billing.history.title': 'শিরোনাম',
  'settings.billing.inferenceBudget.cycleEnds': 'সাইকেল শেষ',
  'settings.billing.inferenceBudget.exhausted': 'শেষ হয়েছে',
  'settings.billing.inferenceBudget.loadError': 'লোড ত্রুটি',
  'settings.billing.inferenceBudget.noBudgetDesc': 'বাজেট নেই বিবরণ',
  'settings.billing.inferenceBudget.noRecurringBudget': 'কোনো পুনরাবৃত্ত বাজেট নেই',
  'settings.billing.inferenceBudget.noRecurringPlanBudget': 'কোনো পুনরাবৃত্ত প্ল্যান বাজেট নেই',
  'settings.billing.inferenceBudget.noRecurringWeeklyDesc':
    'আপনার বর্তমান পরিকল্পনার মধ্যে রয়েছে নিয়মিত এক সাপ্তাহিক বাজেটের মধ্যে। পরিবর্তে, ব্যবহারের জন্য উপলব্ধ স্বীকৃতি প্রাপ্ত করা হয়েছে ।',
  'settings.billing.inferenceBudget.remaining': 'অবশিষ্ট',
  'settings.billing.inferenceBudget.remainingSummary': '{remaining} / {budget} অবশিষ্ট',
  'settings.billing.inferenceBudget.spentThisCycle': '{amount} এই চক্রটি ব্যয় করেছে',
  'settings.billing.inferenceBudget.cycleEndsOn': 'চক্র শেষ হয় {date}',
  'settings.billing.inferenceBudget.exhaustedDesc':
    'সাবস্ক্রিপশন বিশিষ্ট সাবস্ক্রিপশন ব্যবহৃত হয় না। পরবর্তী চক্রের জন্য অপেক্ষা না করে AI ব্যবহার করার জন্য উপর উপর ক্লিক করুন।',
  'settings.billing.inferenceBudget.discountVsPayg': 'Xqxqx%s-র জন্য চার্জ করা হয়েছে।',
  'settings.billing.inferenceBudget.cycleSpend': 'সাইকেল খরচ',
  'settings.billing.inferenceBudget.totalAmount': '{amount} মোট',
  'settings.billing.inferenceBudget.inference': 'অনুমান',
  'settings.billing.inferenceBudget.integrations': 'ইন্টিগ্রেশন',
  'settings.billing.inferenceBudget.calls': '{count} কল করে',
  'settings.billing.inferenceBudget.dailySpend': 'দৈনিক খরচ',
  'settings.billing.inferenceBudget.dailySpendPoint': '{date}: {amount}',
  'settings.billing.inferenceBudget.topModels': 'শীর্ষ মডেল',
  'settings.billing.inferenceBudget.noInferenceUsage': 'এই চক্রের কোনো অনুমান ব্যবহার নেই।',
  'settings.billing.inferenceBudget.topIntegrations': 'শীর্ষ ইন্টিগ্রেশন',
  'settings.billing.inferenceBudget.noIntegrationUsage': 'এই চক্রের কোনো ইন্টিগ্রেশন ব্যবহার নেই।',
  'settings.billing.inferenceBudget.tenHourCap': 'দশ ঘণ্টার ক্যাপ',
  'settings.billing.inferenceBudget.title': 'শিরোনাম',
  'settings.billing.inferenceBudget.unableToLoad': 'ব্যবহারের ডেটা লোড করতে অক্ষম৷',
  'settings.billing.inferenceBudget.notAvailable': 'n/a',
  'settings.billing.payAsYouGo.available': 'পাওয়া যাচ্ছে',
  'settings.billing.payAsYouGo.chargeCustomAmount': 'খোলা হচ্ছে…',
  'settings.billing.payAsYouGo.chooseTopUpDesc': 'টপ আপ বিবরণ বেছে নিন',
  'settings.billing.payAsYouGo.chooseTopUpTitle': 'টপ আপ শিরোনাম বেছে নিন',
  'settings.billing.payAsYouGo.creditBalanceDesc': 'ক্রেডিট ব্যালেন্স বিবরণ',
  'settings.billing.payAsYouGo.creditBalanceTitle': 'ক্রেডিট ব্যালেন্স শিরোনাম',
  'settings.billing.payAsYouGo.customAmount': 'কাস্টম পরিমাণ',
  'settings.billing.payAsYouGo.enterAmount': 'পরিমাণ দিন',
  'settings.billing.payAsYouGo.opening': 'খোলা হচ্ছে',
  'settings.billing.payAsYouGo.promotionalCredits': 'প্রচারমূলক ক্রেডিট',
  'settings.billing.payAsYouGo.topUpBalance': 'টপ-আপ ব্যালেন্স',
  'settings.billing.payAsYouGo.topUpCredits': 'ক্রেডিট টপ আপ করুন',
  'settings.billing.payAsYouGo.unableToLoad': 'ব্যালেন্স লোড করা যাচ্ছে না।',
  'settings.billing.subscription.annual': 'বার্ষিক',
  'settings.billing.subscription.billedAnnually': 'বার্ষিক বিল',
  'settings.billing.subscription.chooseSubtitle': 'সাবটাইটেল বেছে নিন',
  'settings.billing.subscription.chooseTitle': 'শিরোনাম বেছে নিন',
  'settings.billing.subscription.cryptoDesc': 'ক্রিপ্টো বিবরণ',
  'settings.billing.subscription.cryptoQuestion': 'ক্রিপ্টো প্রশ্ন',
  'settings.billing.subscription.current': 'বর্তমান',
  'settings.billing.subscription.currentPlan': 'বর্তমান প্ল্যান',
  'settings.billing.subscription.monthly': 'মাসিক',
  'settings.billing.subscription.paymentConfirmed': 'পেমেন্ট নিশ্চিত',
  'settings.billing.subscription.perMonth': 'প্রতি মাসে',
  'settings.billing.subscription.popular': 'জনপ্রিয়',
  'settings.billing.subscription.save': '{pct}',
  'settings.billing.subscription.upgrade': 'আপগ্রেড করুন',
  'settings.billing.subscription.waiting': 'অপেক্ষা করছে',
  'settings.billing.subscription.waitingPayment': 'পেমেন্টের অপেক্ষায়',
  'settings.composio.apiKeyDesc': 'এই ডিভাইসে বর্তমানে একটি Composio API key সংরক্ষিত আছে।',
  'settings.composio.apiKeyExamplePlaceholder': 'ck_live_xxxxxxxxxxxxxxxx',
  'settings.composio.apiKeyLabel': 'Composio API কী',
  'settings.composio.apiKeyStored': 'API key সংরক্ষিত',
  'settings.composio.apiKeyStoredPlaceholder':
    '• • • • • • ক • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • ক • • • • • • • • • • • • • • • • • • • • • ক • • • • • • • • • • • • • • • • • • • ক • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • ক ক • • • • • • • • • ক • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • • ক ক • • • • • • • • • • • • • • • • • • • • ক • • • • • • • • • • • • • • • • • ক ক ক • • • • • • • • • • • • • • • • • • • • • • • • • • • • ক ক ক ক ক • • • • • • • • • • • • • • • • • • •',
  'settings.composio.clearedToBackend': 'ব্যাকএন্ড মোডে পরিবর্তিত',
  'settings.composio.confirmItem1': 'API key সহ app.composio.dev-এ একটি অ্যাকাউন্ট',
  'settings.composio.confirmItem2':
    'আপনার ব্যক্তিগত Composio অ্যাকাউন্টের মাধ্যমে প্রতিটি ইন্টিগ্রেশন পুনঃলিঙ্ক করতে',
  'settings.composio.confirmItem3':
    'নোট: Composio ট্রিগার (রিয়েল-টাইম webhooks) এখনও Direct মোডে কাজ করে না: শুধু সিঙ্ক্রোনাস টুল কল',
  'settings.composio.confirmNeedItems': 'আপনার প্রয়োজন হবে:',
  'settings.composio.confirmSwitch': 'আমি বুঝেছি, Direct-এ স্যুইচ করুন',
  'settings.composio.confirmTitle': '⚠️ Direct মোডে স্যুইচ হচ্ছে',
  'settings.composio.confirmWarning':
    'OpenHuman-এর মাধ্যমে লিঙ্ক করা আপনার বিদ্যমান ইন্টিগ্রেশনগুলি (Gmail, Slack, GitHub ইত্যাদি) দৃশ্যমান হবে না: সেগুলি OpenHuman-পরিচালিত Composio টেন্যান্টে থাকে।',
  'settings.composio.intro':
    'Composio ২৫০+ বহিরাগত অ্যাপকে টুল হিসেবে ইন্টিগ্রেট করে যা আপনার এজেন্ট কল করতে পারে। এই টুল কলগুলি কীভাবে রুট হবে তা নির্বাচন করুন।',
  'settings.composio.title': 'Composio',
  'settings.composio.modeDirect': 'ডাইরেক্ট (নিজের API কী আনুন)',
  'settings.composio.modeDirectDesc':
    'কলগুলি সরাসরি backend.composio.dev-এ যায়। সার্বভৌম / অফলাইন-বান্ধব। টুল এক্সিকিউশন সিঙ্ক্রোনাসভাবে কাজ করে; রিয়েল-টাইম ট্রিগার webhooks এখনও direct মোডে রুট করা হয় না (ফলো-আপ ইস্যু)।',
  'settings.composio.modeManaged': 'ম্যানেজড (OpenHuman আপনার হয়ে পরিচালনা করে)',
  'settings.composio.modeManagedDesc':
    'OpenHuman আমাদের ব্যাকএন্ডের মাধ্যমে টুল কল প্রক্সি করে (প্রস্তাবিত)। অথ ব্রোকার করা হয়; আপনি কখনও Composio API key পেস্ট করেন না। Webhooks সম্পূর্ণরূপে রুট করা।',
  'settings.composio.routingMode': 'রুটিং মোড',
  'settings.composio.saveErrorNoKey': 'সংরক্ষণ ব্যর্থ। Direct মোডের জন্য একটি API key প্রয়োজন।',
  'settings.composio.saving': 'সংরক্ষণ হচ্ছে…',
  'settings.composio.switching': 'স্যুইচ হচ্ছে…',
  'settings.cron.jobs.commandRequired': 'শেল জবের জন্য কমান্ড আবশ্যক',
  'settings.cron.jobs.createJob': 'নতুন নির্ধারিত জব',
  'settings.cron.jobs.created': 'জব তৈরি হয়েছে',
  'settings.cron.jobs.custom': 'কাস্টম',
  'settings.cron.jobs.desc': 'বিবরণ',
  'settings.cron.jobs.edit': 'সম্পাদনা',
  'settings.cron.jobs.editJob': 'নির্ধারিত জব সম্পাদনা',
  'settings.cron.jobs.empty': 'কোনো কোর ক্রন জব পাওয়া যায়নি।',
  'settings.cron.jobs.errorCreate': 'cron জব তৈরি করা যায়নি: {message}',
  'settings.cron.jobs.errorLoadList': 'কোর cron জব লোড করা যায়নি: {message}',
  'settings.cron.jobs.errorLoadRuns': 'রান ইতিহাস লোড করা যায়নি: {message}',
  'settings.cron.jobs.errorRemove': 'কোর cron জব সরানো যায়নি: {message}',
  'settings.cron.jobs.errorRun': 'কোর cron জব চালানো যায়নি: {message}',
  'settings.cron.jobs.errorToggle': 'কোর cron জব আপডেট করা যায়নি: {message}',
  'settings.cron.jobs.errorUpdate': 'cron জব আপডেট করা যায়নি: {message}',
  'settings.cron.jobs.formAtLabel': 'যখন চালাবে',
  'settings.cron.jobs.formCancel': 'বাতিল',
  'settings.cron.jobs.formCommand': 'শেল কমান্ড',
  'settings.cron.jobs.formCommandPlaceholder': 'যেমন curl https://example.com/health',
  'settings.cron.jobs.formCreate': 'তৈরি করুন',
  'settings.cron.jobs.formCronCustom': 'কাস্টম এক্সপ্রেশন',
  'settings.cron.jobs.formCronCustomPlaceholder': 'যেমন */30 * * * *',
  'settings.cron.jobs.formCronPreset': 'প্রিসেট',
  'settings.cron.jobs.formCronPreview': 'চলে: {preview}',
  'settings.cron.jobs.formDeleteAfterRun': 'প্রথম রানের পর মুছে ফেলুন',
  'settings.cron.jobs.formDelivery': 'ডেলিভারি মোড',
  'settings.cron.jobs.formDeliveryNone': 'কোনোটি নয় (শুধু আউটপুট)',
  'settings.cron.jobs.formDeliveryProactive': 'সক্রিয় (পুশ নোটিফিকেশন)',
  'settings.cron.jobs.formError': 'জব সংরক্ষণ করা যায়নি',
  'settings.cron.jobs.formEveryLabel': 'ব্যবধান (মিলিসেকেন্ড)',
  'settings.cron.jobs.formEveryPlaceholder': 'যেমন 3600000',
  'settings.cron.jobs.formJobType': 'জবের ধরন',
  'settings.cron.jobs.formJobTypeAgent': 'Agent (AI প্রম্পট)',
  'settings.cron.jobs.formJobTypeShell': 'শেল কমান্ড',
  'settings.cron.jobs.formName': 'জবের নাম',
  'settings.cron.jobs.formNamePlaceholder': 'যেমন daily-report, cleanup-task',
  'settings.cron.jobs.formPrompt': 'Agent প্রম্পট',
  'settings.cron.jobs.formPromptPlaceholder': 'প্রতিটি রানে এজেন্টের কী করা উচিত?',
  'settings.cron.jobs.formPromptRequired': 'এজেন্ট জবের জন্য প্রম্পট আবশ্যক',
  'settings.cron.jobs.formSave': 'সংরক্ষণ',
  'settings.cron.jobs.formSaving': 'সংরক্ষণ করা হচ্ছে…',
  'settings.cron.jobs.formScheduleAt': 'এককালীন (যখন চালাবে)',
  'settings.cron.jobs.formScheduleCron': 'পুনরাবৃত্ত (cron)',
  'settings.cron.jobs.formScheduleEvery': 'ব্যবধান (প্রতি N ms)',
  'settings.cron.jobs.formScheduleRequired': 'শিডিউল আবশ্যক',
  'settings.cron.jobs.formScheduleType': 'শিডিউলের ধরন',
  'settings.cron.jobs.formSessionIsolated': 'বিচ্ছিন্ন (প্রস্তাবিত)',
  'settings.cron.jobs.formSessionMain': 'প্রধান সেশন',
  'settings.cron.jobs.formSessionTarget': 'সেশন টার্গেট',
  'settings.cron.jobs.formProfile': 'এজেন্ট প্রোফাইল',
  'settings.cron.jobs.formProfileNone': 'কোনো প্রোফাইল নয়',
  'settings.cron.jobs.formProfileHint':
    'নির্বাচিত প্রোফাইল হিসেবে এই কাজটি চালান, তার পরিচয়, মেমরি ও ওয়ার্কস্পেস ব্যবহার করে।',
  'settings.cron.jobs.profile': 'প্রোফাইল',
  'settings.cron.jobs.lastStatus': 'শেষ স্ট্যাটাস',
  'settings.cron.jobs.loading': 'ক্রন জব লোড হচ্ছে...',
  'settings.cron.jobs.loadingRuns': 'রান লোড হচ্ছে',
  'settings.cron.jobs.nextRun': 'পরবর্তী রান',
  'settings.cron.jobs.pause': 'বিরতি',
  'settings.cron.jobs.paused': 'বিরতিতে',
  'settings.cron.jobs.recentRuns': 'সাম্প্রতিক রান',
  'settings.cron.jobs.removing': 'অপসারণ হচ্ছে',
  'settings.cron.jobs.resume': 'পুনরায় শুরু',
  'settings.cron.jobs.runningNow': 'এখন চলছে',
  'settings.cron.jobs.saving': 'সংরক্ষণ হচ্ছে…',
  'settings.cron.jobs.schedule': 'সময়সূচি',
  'settings.cron.jobs.title': 'কোর ক্রন জবস',
  'settings.cron.jobs.updated': 'জব আপডেট হয়েছে',
  'settings.cron.jobs.viewRuns': 'রান দেখুন',
  'settings.cron.schedule.every2hours': 'প্রতি ২ ঘণ্টায়',
  'settings.cron.schedule.every30min': 'প্রতি ৩০ মিনিটে',
  'settings.cron.schedule.every6hours': 'প্রতি ৬ ঘণ্টায়',
  'settings.cron.schedule.everyHour': 'প্রতি ঘণ্টায়',
  'settings.cron.schedule.onceDaily': 'দৈনিক একবার (সকাল ৯টা)',
  'settings.localModel.deviceCapability.active': 'সক্রিয়',
  'settings.localModel.deviceCapability.appliedTier': 'প্রয়োগকৃত টায়ার',
  'settings.localModel.deviceCapability.applying': 'প্রয়োগ হচ্ছে',
  'settings.localModel.deviceCapability.cores': '{count}',
  'settings.localModel.deviceCapability.couldNotLoadPresets': 'প্রিসেট লোড করা যায়নি',
  'settings.localModel.deviceCapability.cpu': 'CPU',
  'settings.localModel.deviceCapability.customModelIds': 'কাস্টম মডেল ID',
  'settings.localModel.deviceCapability.detected': 'শনাক্ত',
  'settings.localModel.deviceCapability.disabled': 'নিষ্ক্রিয়',
  'settings.localModel.deviceCapability.disabledDesc': 'নিষ্ক্রিয় বিবরণ',
  'settings.localModel.deviceCapability.downloadingModels': '(মডেল ডাউনলোড হচ্ছে)',
  'settings.localModel.deviceCapability.downloadingSetupDesc':
    'OllamaSetup ইনস্টলার (~2 GB) ডাউনলোড ও আনপ্যাক হচ্ছে। প্রথম ইনস্টলে এক মিনিট সময় লাগতে পারে।',
  'settings.localModel.deviceCapability.failedToApplyPreset': 'প্রিসেট প্রয়োগ করতে ব্যর্থ',
  'settings.localModel.deviceCapability.gpu': 'GPU',
  'settings.localModel.deviceCapability.installFailed': 'Ollama ইনস্টল ব্যর্থ',
  'settings.localModel.deviceCapability.installFailedDesc':
    'Ollama ব্যবহারযোগ্য হওয়ার আগে ইনস্টলার বন্ধ হয়েছে। আবার চেষ্টা করতে ক্লিক করুন, বা ollama.com থেকে ম্যানুয়ালি ইনস্টল করুন।',
  'settings.localModel.deviceCapability.installFirst': 'প্রথমে Ollama চালান।',
  'settings.localModel.deviceCapability.installFirstDesc':
    'লোকাল টিয়ার একটি বাহ্যিকভাবে পরিচালিত Ollama endpoint-এর উপর নির্ভর করে। নিজে এটি শুরু করুন, আপনি যে মডেলগুলি চান তা টানুন, এবং রানটাইম পৌঁছানো না যাওয়া পর্যন্ত "Disabled (cloud fallback)" ব্যবহার করতে থাকুন।',
  'settings.localModel.deviceCapability.installOllamaFirst':
    'এই টিয়ার ব্যবহার করতে প্রথমে Ollama চালান',
  'settings.localModel.deviceCapability.installingOllama': 'Ollama ইনস্টল হচ্ছে',
  'settings.localModel.deviceCapability.loadingDeviceInfo': 'ডিভাইস তথ্য লোড হচ্ছে',
  'settings.localModel.deviceCapability.localAiDisabled':
    'লোকাল AI নিষ্ক্রিয়: ক্লাউড ফলব্যাক ব্যবহার করছে।',
  'settings.localModel.deviceCapability.modelTier': 'মডেল টায়ার',
  'settings.localModel.deviceCapability.needsOllama': 'Ollama প্রয়োজন',
  'settings.localModel.deviceCapability.notDetected': 'শনাক্ত হয়নি',
  'settings.localModel.deviceCapability.disabledLowercase': 'অক্ষম',
  'settings.localModel.deviceCapability.presetDetails':
    'চ্যাট: {chatModel} · দৃষ্টি: {visionModel} · লক্ষ্য RAM: {targetRamGb} GB',
  'settings.localModel.deviceCapability.ram': 'RAM',
  'settings.localModel.deviceCapability.recommended': 'প্রস্তাবিত',
  'settings.localModel.deviceCapability.retryInstall': 'আবার চেষ্টা হচ্ছে…',
  'settings.localModel.deviceCapability.retrying': 'আবার চেষ্টা হচ্ছে…',
  'settings.localModel.deviceCapability.starting': 'শুরু হচ্ছে…',
  'settings.localModel.download.audioPathPlaceholder': 'অডিও ফাইলের পূর্ণ পথ',
  'settings.localModel.download.capabilityChat': 'চ্যাট',
  'settings.localModel.download.capabilityEmbedding': 'এম্বেড করা',
  'settings.localModel.download.capabilityAssets': 'ক্যাপাবিলিটি অ্যাসেট',
  'settings.localModel.download.capabilityStt': 'STT',
  'settings.localModel.download.capabilityTts': 'TTS',
  'settings.localModel.download.capabilityVision': 'দৃষ্টি',
  'settings.localModel.download.downloading': 'ডাউনলোড হচ্ছে...',
  'settings.localModel.download.embeddingDimensions': 'মাত্রা: {dimensions}',
  'settings.localModel.download.embeddingModel': 'মডেল: {modelId}',
  'settings.localModel.download.embeddingPlaceholder': 'প্রতি লাইনে একটি ইনপুট স্ট্রিং...',
  'settings.localModel.download.embeddingVectors': 'ভেক্টর: {count}',
  'settings.localModel.download.noThinkMode': 'থিংক মোড নেই',
  'settings.localModel.download.notAvailable': 'n/a',
  'settings.localModel.download.promptPlaceholder':
    'যেকোনো প্রম্পট টাইপ করুন এবং লোকাল মডেলে চালান...',
  'settings.localModel.download.quantizationPref': 'কোয়ান্টাইজেশন পছন্দ',
  'settings.localModel.download.runEmbeddingTest': 'চলছে...',
  'settings.localModel.download.runPromptTest': 'Prompt Test চালান',
  'settings.localModel.download.runSummaryTest': 'Summary Test চালান',
  'settings.localModel.download.runTranscriptionTest': 'চলছে...',
  'settings.localModel.download.runTtsTest': 'চলছে...',
  'settings.localModel.download.runVisionTest': 'চলছে...',
  'settings.localModel.download.running': 'চলছে...',
  'settings.localModel.download.runningPrompt': 'প্রম্পট চলছে',
  'settings.localModel.download.summaryHelper':
    'রাস্ট কোরের মাধ্যমে `openhuman.inference_summarize` কল করে',
  'settings.localModel.download.summarizePlaceholder':
    'লোকাল মডেল দিয়ে সারসংক্ষেপের জন্য টেক্সট পেস্ট করুন...',
  'settings.localModel.download.testCustomPrompt': 'কাস্টম প্রম্পট পরীক্ষা করুন',
  'settings.localModel.download.testEmbeddings': 'এম্বেডিং পরীক্ষা করুন',
  'settings.localModel.download.testSummarization': 'সারসংক্ষেপ পরীক্ষা করুন',
  'settings.localModel.download.testVisionPrompt': 'ভিশন প্রম্পট পরীক্ষা করুন',
  'settings.localModel.download.testVoiceInput': 'ভয়েস ইনপুট পরীক্ষা করুন (STT)',
  'settings.localModel.download.testVoiceOutput': 'ভয়েস আউটপুট পরীক্ষা করুন (TTS)',
  'settings.localModel.download.transcript': 'ট্রান্সক্রিপ্ট:',
  'settings.localModel.download.ttsOutput': 'আউটপুট: {outputPath}',
  'settings.localModel.download.ttsOutputPlaceholder': 'ঐচ্ছিক আউটপুট WAV পথ',
  'settings.localModel.download.ttsPlaceholder': 'সংশ্লেষণের জন্য টেক্সট দিন...',
  'settings.localModel.download.ttsVoice': 'ভয়েস: {voiceId}',
  'settings.localModel.download.visionImagePlaceholder':
    'প্রতি লাইনে একটি ইমেজ রেফারেন্স (data URI, URL, বা লোকাল পথ মার্কার)',
  'settings.localModel.download.visionPromptPlaceholder': 'ভিশন মডেলের জন্য একটি প্রম্পট দিন...',
  'settings.localModel.status.allChecksPassed': 'সব পরীক্ষা পাস',
  'settings.localModel.status.artifact': 'আর্টিফ্যাক্ট',
  'settings.localModel.status.backend': 'ব্যাকএন্ড',
  'settings.localModel.status.binary': 'বাইনারি',
  'settings.localModel.status.bootstrapResume': 'বুটস্ট্র্যাপ / রিজিউম',
  'settings.localModel.status.checking': 'পরীক্ষা হচ্ছে...',
  'settings.localModel.status.checkingOllama': 'Ollama পরীক্ষা হচ্ছে',
  'settings.localModel.status.contextBelowMinimumBadge':
    '{contextLength} ctx - নীচে {required} মিনিট',
  'settings.localModel.status.contextBelowMinimumTitle':
    'প্রত্যাখ্যান করা হয়েছে: প্রসঙ্গ উইন্ডো {contextLength} টোকেনগুলি মেমরি স্তরের প্রয়োজনীয় ন্যূনতম {required}-টোকেনের নীচে। প্রত্যাহার নীরব ছেদন দ্বারা দূষিত হবে.',
  'settings.localModel.status.contextOkBadge': 'Xqxqxqx সার্ভার মোড ব্যবহার করুন',
  'settings.localModel.status.contextOkTitle':
    'কনটেক্সট উইন্ডো {contextLength} টোকেন মেমরি-লেয়ার ন্যূনতম {required} টোকেন পূরণ করে।',
  'settings.localModel.status.contextUnknownBadge': 'ctx অজানা',
  'settings.localModel.status.contextUnknownTitle':
    'প্রসঙ্গ উইন্ডো অজানা; নিশ্চিত করতে পারেনি এটি {required}-টোকেন মেমরি-লেয়ার ন্যূনতম পূরণ করে।',
  'settings.localModel.status.customLocation': 'কাস্টম লোকেশন',
  'settings.localModel.status.customLocationDesc': 'কাস্টম লোকেশন বিবরণ',
  'settings.localModel.status.diagnosticsHint':
    'Ollama চলছে এবং মডেল ইনস্টল আছে কিনা যাচাই করতে "Run Diagnostics"-এ ক্লিক করুন।',
  'settings.localModel.status.downloadingUnknown': 'ডাউনলোড হচ্ছে (আকার অজানা)',
  'settings.localModel.status.eta': 'ETA',
  'settings.localModel.status.expectedModels': 'প্রত্যাশিত মডেল',
  'settings.localModel.status.expectedChat': 'চ্যাট: {model}',
  'settings.localModel.status.expectedEmbedding': 'এম্বেডিং: {model}',
  'settings.localModel.status.expectedVision': 'দৃষ্টি: {model}',
  'settings.localModel.status.externalProcess': 'বাহ্যিক প্রক্রিয়া',
  'settings.localModel.status.forceRebootstrap': 'ফোর্স রি-বুটস্ট্র্যাপ',
  'settings.localModel.status.generationTps': 'জেনারেশন TPS',
  'settings.localModel.status.hideErrorDetails': 'ত্রুটির বিবরণ লুকান',
  'settings.localModel.status.installManually': 'ম্যানুয়ালি ইনস্টল করুন',
  'settings.localModel.status.installManuallyFrom': 'থেকে ম্যানুয়ালি ইনস্টল করুন',
  'settings.localModel.status.installOllama': 'শুরু হচ্ছে…',
  'settings.localModel.status.installedModels': 'ইনস্টল করা মডেল',
  'settings.localModel.status.installing': 'ইনস্টল হচ্ছে...',
  'settings.localModel.status.installingOllama': 'Ollama রানটাইম ইনস্টল হচ্ছে...',
  'settings.localModel.status.issues': 'সমস্যা',
  'settings.localModel.status.issuesFound': '{count}টি সমস্যা পাওয়া গেছে',
  'settings.localModel.status.lastLatency': 'শেষ লেটেন্সি',
  'settings.localModel.status.model': 'মডেল',
  'settings.localModel.status.notAvailable': 'n/a',
  'settings.localModel.status.notFound': 'পাওয়া যায়নি',
  'settings.localModel.status.notRunning': 'চলছে না',
  'settings.localModel.status.ollamaBinaryPath': 'Ollama বাইনারি পথ',
  'localModel.ollamaServer.helperText': 'উদাহরণ: http://192.168.1.5:11434',
  'localModel.ollamaServer.label': 'Ollama সার্ভার URL',
  'localModel.ollamaServer.modelCount': 'মডেল',
  'localModel.ollamaServer.placeholder': 'http://localhost:11434',
  'localModel.ollamaServer.reachable': 'পৌঁছানো যাচ্ছে',
  'localModel.ollamaServer.resetButton': 'ডিফল্টে পুনরায় সেট করুন',
  'localModel.ollamaServer.saveButton': 'সংরক্ষণ করুন',
  'localModel.ollamaServer.testButton': 'সংযোগ পরীক্ষা করুন',
  'localModel.ollamaServer.unreachable': 'পৌঁছানো যাচ্ছে না',
  'localModel.ollamaServer.validationError': 'একটি বৈধ http:// বা https:// URL হতে হবে',
  'settings.localModel.status.ollamaDiagnostics': 'Ollama ডায়াগনস্টিক্স',
  'settings.localModel.status.ollamaNotInstalled': 'Ollama রানটাইম অনুপলব্ধ',
  'settings.localModel.status.ollamaNotInstalledDesc':
    'OpenHuman এখন Ollama-কে একটি বাহ্যিক ইনফারেন্স রানটাইম হিসেবে গণ্য করে। আপনার নিজের Ollama সার্ভার শুরু করুন, যে মডেলগুলি চান টানুন, এবং ওয়ার্কলোড রাউটিং সেদিকে নির্দেশ করুন।',
  'settings.localModel.status.progress': 'অগ্রগতি',
  'settings.localModel.status.provider': 'প্রোভাইডার',
  'settings.localModel.status.retryBootstrap': 'বুটস্ট্র্যাপ আবার চেষ্টা করুন',
  'settings.localModel.status.runDiagnostics': 'পরীক্ষা হচ্ছে...',
  'settings.localModel.status.running': 'চলছে',
  'settings.localModel.status.runningExternalProcess': 'বাহ্যিক প্রসেসের মাধ্যমে চলছে',
  'settings.localModel.status.runtimeStatus': 'রানটাইম স্ট্যাটাস',
  'settings.localModel.status.server': 'সার্ভার',
  'settings.localModel.status.setPath': 'সেট হচ্ছে...',
  'settings.localModel.status.setting': 'সেট হচ্ছে...',
  'settings.localModel.status.showErrorDetails': 'ত্রুটির বিবরণ লুকান',
  'settings.localModel.status.showInstallErrorDetails': 'ত্রুটির বিবরণ লুকান',
  'settings.localModel.status.suggestedFixes': 'প্রস্তাবিত সমাধান',
  'settings.localModel.status.thenSetPath': 'তারপর পথ সেট করুন',
  'settings.localModel.status.triggering': 'ট্রিগার হচ্ছে...',
  'settings.localModel.status.unavailable': 'পাওয়া যাচ্ছে না',
  'settings.localModel.status.working': 'কাজ হচ্ছে...',
  'settings.developerMenu.ai.title': 'AI কনফিগারেশন',
  'settings.developerMenu.ai.desc':
    'ক্লাউড প্রদানকারী, স্থানীয় Ollama মডেল এবং প্রতি-ওয়ার্কলোড রাউটিং',
  'settings.developerMenu.messagingChannels.title': 'মেসেজিং চ্যানেল',
  'settings.developerMenu.messagingChannels.desc':
    'Telegram/Discord অথেন্টিকেশন মোড এবং ডিফল্ট চ্যানেল রাউটিং কনফিগার করুন',
  'settings.developerMenu.tools.title': 'টুলস',
  'settings.developerMenu.tools.desc':
    'OpenHuman আপনার পক্ষ থেকে যে সক্ষমতাগুলি ব্যবহার করতে পারে সেগুলি চালু বা বন্ধ করুন',
  'settings.developerMenu.agentChat.title': 'এজেন্ট চ্যাট',
  'settings.developerMenu.agentChat.desc':
    'মডেল এবং টেম্পারেচার ওভাররাইডসহ এজেন্ট কথোপকথন পরীক্ষা করুন',
  'settings.developerMenu.devWorkflow.title': 'Beavil কর্ম',
  'settings.developerMenu.devWorkflow.desc':
    'একজন স্বায়ত্তশাসিত এজেন্ট যে আপনার xqxqx বিষয় গ্রহণ করে এবং একটি তালিকাতে জনসংযোগের আয়োজন করে।',
  'settings.developerMenu.devWorkflow.panelDesc':
    'একটি স্বায়ত্তশাসিত ডেভেলপার এজেন্ট আপনার কাছে xqxkx বিষয় নির্বাচন করে এবং একটি সুনির্দিষ্ট সময়ে স্বয়ংক্রিয়ভাবে অনুরোধ জানায়।',
  'settings.developerMenu.skillsRunner.title': 'স্কিলস রানার',
  'settings.developerMenu.skillsRunner.desc':
    'যে কোন একটিd-hoc চালান - এর ইনপুট পূর্ণ করুন এবং স্বায়ত্তশাসিত পটভূমি দিয়ে আগুন জমবে',
  'settings.developerMenu.skillsRunner.panelDesc':
    'একটি জোড়ার দক্ষতা, এর ঘোষণাকৃত ইনপুটে ভর্তি, এবং অগ্নি-গঠিত পটভূমি। যদি আপনি পুনরাবৃত্তিমূলক কাজ করতে চান, তাহলে দেব রো ব্যবহার করুন।',
  'settings.skillsRunner.skill': 'দক্ষতা',
  'settings.skillsRunner.selectSkill': 'একটি দক্ষতা স্তর বেছে নিন...',
  'settings.skillsRunner.loadingSkills': 'দক্ষতা স্তর...',
  'settings.skillsRunner.loadingDescription': 'দক্ষতা ইনপুট করা হচ্ছে...',
  'settings.skillsRunner.noInputs': 'এই দক্ষতায় কোনো ইনপুট নেই।',
  'settings.skillsRunner.placeholder.required': 'required',
  'settings.skillsRunner.runNow': 'এখন সঞ্চালন করুন',
  'settings.skillsRunner.starting': '%s শুরু করা হচ্ছে',
  'settings.skillsRunner.started': 'আরম্ভ করা হয়েছে - ID:',
  'settings.skillsRunner.logPath': 'লগ:',
  'settings.skillsRunner.error.listSkills': 'প্লাগ-ইন লোড করতে ব্যর্থ:',
  'settings.skillsRunner.error.describe': 'ইনপুট লোড করতে ব্যর্থ:%s',
  'settings.skillsRunner.error.missingRequired': 'প্রয়োজনীয় ইনপুট পাওয়া যায়নি:%s',
  'settings.skillsRunner.error.run': 'আরম্ভ করতে ব্যর্থ:',
  'settings.skillsRunner.error.preflightGate': 'প্রিমবট গেট ব্যর্থ হয়েছে',
  'settings.skillsRunner.error.runtimeUnavailable': 'রানটাইম পাওয়া যাচ্ছে না',
  'settings.skillsRunner.error.runtimeUnavailableDefault': 'পাওয়া যাচ্ছে না',
  'settings.skillsRunner.schedule.heading': 'নির্ধারিত সময় অবধি (বিপ)',
  'settings.skillsRunner.schedule.help':
    'এই দক্ষতা + ইনপুট একটি পুনরাবৃত্তিমূলক কাজ হিসাবে সংরক্ষণ করো । যে এজেন্টকে ফোন করা হবে প্রত্যেক টিকতে.',
  'settings.skillsRunner.schedule.frequency': 'ফ্রিকোয়েন্সি',
  'settings.skillsRunner.schedule.every30min': 'প্রতি ৩০ মিনিট',
  'settings.skillsRunner.schedule.everyHour': 'প্রতি ঘন্টায়',
  'settings.skillsRunner.schedule.every2hours': 'প্রতি ২ ঘন্টা',
  'settings.skillsRunner.schedule.every6hours': 'প্রতি ৬ ঘন্টা',
  'settings.skillsRunner.schedule.onceDaily': 'প্রতিদিন (৯: ০০)',
  'settings.skillsRunner.schedule.save': 'সময় সংরক্ষণ করুন',
  'settings.skillsRunner.schedule.saving': 'ইনস্টল করা হয়েছে...',
  'settings.skillsRunner.schedule.saved': 'নির্ধারিত মান সংরক্ষণ করুন ।',
  'settings.skillsRunner.schedule.error': 'সংরক্ষণ করতে ব্যর্থ:',
  'settings.skillsRunner.schedule.loadingJobs': 'উপস্থিত তালিকা লোড করা হচ্ছে...',
  'settings.skillsRunner.schedule.noJobs': 'এই দক্ষতায় এখনো কোন সময় সংরক্ষিত হয়নি।',
  'settings.skillsRunner.schedule.existing': 'এই কাজের জন্য নির্ধারিত কাজ:',
  'settings.skillsRunner.schedule.inputsLabel': 'ইনপুট',
  'settings.skillsRunner.schedule.inputsNone': 'কোনো ইনপুট নেই',
  'settings.skillsRunner.schedule.runNow': 'সঞ্চালন ( R)',
  'settings.skillsRunner.schedule.remove': 'মুছে ফেলুন',
  'settings.skillsRunner.scheduleEnabled': 'সক্রিয়',
  'settings.skillsRunner.scheduleDisabled': 'সাময়িক বিরতি চলছে',
  'settings.skillsRunner.scheduleToggleAria': 'পর্দা পাঠ ব্যবস্থা সক্রিয় করা হবে',
  'settings.skillsRunner.schedule.history': 'ব্রাউজ-ইতিহাস',
  'settings.skillsRunner.schedule.historyLoading': 'ইতিহাস লোড করা হচ্ছে...',
  'settings.skillsRunner.schedule.historyEmpty': 'এই শিডিউলের জন্য এখনো পালাই নি।',
  'settings.skillsRunner.schedule.historyNoOutput': 'কোনো আউটপুট পাওয়া যায়নি।',
  'settings.skillsRunner.schedule.active': 'সক্রিয়',
  'settings.skillsRunner.schedule.lastRunLabel': 'শেষ',
  'settings.skillsRunner.recentRuns.headingForSkill': 'এই কাজের জন্য সম্প্রতি ব্যবহৃত রান',
  'settings.skillsRunner.recentRuns.headingAll': 'সম্প্রতি ব্যবহৃত দক্ষতা স্তর (সকল)',
  'settings.skillsRunner.recentRuns.refresh': 'নতুন করে প্রদর্শন',
  'settings.skillsRunner.recentRuns.loading': 'সর্বশেষ চালানো হচ্ছে...',
  'settings.skillsRunner.recentRuns.empty': 'কোন সাম্প্রতিক রান নেই।',
  'settings.skillsRunner.viewer.loading': 'লগ লোড করা হচ্ছে...',
  'settings.skillsRunner.viewer.tailing': 'লাইভ টেইলিং',
  'settings.skillsRunner.viewer.fetching': 'প্রাপ্ত করা হচ্ছে',
  'settings.skillsRunner.viewer.error': 'লগ- ইন পড়তে ব্যর্থ',
  'settings.skillsRunner.repoPicker.loading': 'সংগ্রহস্থল লোড করা হচ্ছে...',
  'settings.skillsRunner.repoPicker.select': 'সংগ্রহস্থল নির্বাচন করুন',
  'settings.skillsRunner.repoPicker.empty':
    'সংগ্রহস্থল অনুপস্থিত। xqx1x সহযোগে xqxqx সহযোগে xq1-র সাথে সংযোগ করা হবে',
  'settings.skillsRunner.repoPicker.notConnected':
    'xqxqx +x সহযোগে xq1x-র সাথে সংযুক্ত করা হয়নি প্রথমে এটাকে দক্ষতার সাথে এক্সqxxx2x+x এর সাথে সংযুক্ত করুন।',
  'settings.skillsRunner.repoPicker.privateTag': '(ব্যক্তিগত)',
  'settings.skillsRunner.branchPicker.needRepo': 'আগে আর একটা জিনিস নাও...',
  'settings.skillsRunner.branchPicker.loading': 'শাখা লোড করা হচ্ছে...',
  'settings.skillsRunner.branchPicker.select': 'একটি শাখা নির্বাচন করুন...',
  'settings.devWorkflow.githubRepository': 'xqxxqx সংগ্রহস্থল',
  'settings.devWorkflow.loadingRepositories': 'সংগ্রহস্থল লোড করা হচ্ছে...',
  'settings.devWorkflow.selectRepository': 'সংগ্রহস্থল নির্বাচন করুন',
  'settings.devWorkflow.privateTag': '(ব্যক্তিগত)',
  'settings.devWorkflow.detectingForkInfo': 'fork তথ্য সনাক্ত করা হচ্ছে...',
  'settings.devWorkflow.forkDetected': 'k সনাক্ত করা হয়েছে',
  'settings.devWorkflow.upstream': 'উপরে:',
  'settings.devWorkflow.forkPrNote': 'স্ট্রিমিং রিপোজিটরিতে জনসংযোগ করা হবে।',
  'settings.devWorkflow.notForkNote':
    'fork না। সরাসরি এই রিপোজিটরির বিরুদ্ধে জনসংযোগ ব্যবস্থা গ্রহণ করা হবে।',
  'settings.devWorkflow.targetBranch': 'লক্ষ্য ব্রাঞ্চ',
  'settings.devWorkflow.targetBranchNote': 'এই শাখার বিরুদ্ধে জনসংযোগ হবে',
  'settings.devWorkflow.loadingBranches': 'শাখা লোড করা হচ্ছে...',
  'settings.devWorkflow.runFrequency': 'ফ্রিকোয়েন্সি চালানো হবে',
  'settings.devWorkflow.runFrequencyNote': 'এজেন্টরা কত বার এই বিষয়ে যাচাই করে জনসংযোগ করেন।',
  'settings.devWorkflow.updateConfiguration': 'কনফিগারেশন আপডেট করুন',
  'settings.devWorkflow.saveConfiguration': 'কনফিগারেশন সংরক্ষণ করুন',
  'settings.devWorkflow.remove': 'মুছে ফেলুন',
  'settings.devWorkflow.saved': 'সংরক্ষিত',
  'settings.devWorkflow.activeConfiguration': 'সক্রিয় কনফিগারেশন',
  'settings.devWorkflow.activeConfigRepository': 'সংগ্রহস্থল:',
  'settings.devWorkflow.activeConfigUpstream': 'উপরে:',
  'settings.devWorkflow.activeConfigTargetBranch': 'লক্ষ্য শাখা:',
  'settings.devWorkflow.activeConfigSchedule': 'নির্ধারিত & সময়:',
  'settings.devWorkflow.enabled': 'সক্রিয়',
  'settings.devWorkflow.paused': 'সাময়িক বিরতি চলছে',
  'settings.devWorkflow.nextRun': 'পরবর্তী চালনা',
  'settings.devWorkflow.lastRun': 'সর্বশেষ সঞ্চালিত',
  'settings.devWorkflow.runNow': 'এখন সঞ্চালন করুন',
  'settings.devWorkflow.running': 'চলমান...',
  'settings.devWorkflow.recentRuns': 'সম্প্রতি ব্যবহৃত',
  'settings.devWorkflow.cronSaveError': 'কনফিগারেশন সংরক্ষণ করতে ব্যর্থ',
  'settings.devWorkflow.lastOutput': 'শেষ আউটপুট',
  'settings.devWorkflow.noOutput': 'কোনো আউটপুট পাওয়া যায়নি',
  'settings.devWorkflow.runningStatus':
    'এজেন্ট চলছে - একটা সমস্যা হচ্ছে আর ঠিক করার চেষ্টা করছে...',
  'settings.devWorkflow.errorNotConnected':
    'xqxqx সংযুক্ত নয়। অনুগ্রহ করে Xqx1qx; এর মাধ্যমে part- র সাথে সংযোগ করুন উচ্চ পর্যায়ের x xqx2x প্রথমে',
  'settings.devWorkflow.errorToolNotEnabled':
    'xqxqx টুল এই ব্যাক-এন্ডে সক্রিয় করা হয়নি। অনুগ্রহ করে আপনার অ্যাডমিনিস্ট্রেটরের সাথে যোগাযোগ করুন। Xqxq1qx সহযোগে এটি সক্রিয় করার অনুরোধ জানানো হয়েছে।',
  'settings.devWorkflow.errorNotAuthenticated': 'অনুমোদিত নয়। দয়া করে প্রথমে সাইন ইন করুন।',
  'settings.devWorkflow.errorNoRepositories': 'xqxx অ্যাকাউন্টের জন্য কোন সংগ্রহস্থল পাওয়া যায়নি',
  'settings.devWorkflow.schedule.every30min': 'প্রতি ৩০ মিনিট',
  'settings.devWorkflow.schedule.everyHour': 'প্রতি ঘন্টায়',
  'settings.devWorkflow.schedule.every2hours': 'প্রতি ২ ঘন্টা',
  'settings.devWorkflow.schedule.every6hours': 'প্রতি ৬ ঘন্টা',
  'settings.devWorkflow.schedule.onceDaily': 'প্রতিদিন (৯.',
  'settings.developerMenu.tasks.title': 'কাজ',
  'settings.developerMenu.tasks.desc':
    'টাস্ক বোর্ড ব্রাউজ ও পরিচালনা করুন: আপনার নিজের কাজ এবং কথোপকথন জুড়ে এজেন্টদের তৈরি করা বোর্ড।',
  'settings.developerMenu.cronJobs.title': 'Cron জব',
  'settings.developerMenu.cronJobs.desc':
    'রানটাইম স্কিলের জন্য নির্ধারিত জব দেখুন এবং কনফিগার করুন',
  'settings.developerMenu.localModelDebug.title': 'লোকাল মডেল ডিবাগ',
  'settings.developerMenu.localModelDebug.desc':
    'Ollama কনফিগারেশন, অ্যাসেট ডাউনলোড, মডেল টেস্ট এবং ডায়াগনস্টিক্স',
  'settings.developerMenu.webhooks.title': 'ওয়েবহুক',
  'settings.developerMenu.webhooks.desc':
    'রানটাইম ওয়েবহুক রেজিস্ট্রেশন এবং ধরা পড়া রিকোয়েস্ট লগ পরিদর্শন করুন',
  'settings.developerMenu.eventLog.title': 'ইভেন্টের লগ',
  'settings.developerMenu.eventLog.desc':
    'লাইভ রঙ-কোডকৃত সব এজেন্ট, টুল, এবং সিস্টেম ইভেন্টের জন্য',
  'settings.developerMenu.eventLog.allTypes': 'সর্ব প্রকার',
  'settings.developerMenu.eventLog.filterAgent': 'ফিল্টার...',
  'settings.developerMenu.eventLog.download': 'ডাউনলোড করা হয়েছে',
  'settings.developerMenu.eventLog.events': 'ইভেন্ট',
  'settings.developerMenu.eventLog.live': 'লাইভ',
  'settings.developerMenu.eventLog.disconnected': 'বিচ্ছিন্ন',
  'settings.developerMenu.eventLog.waiting': 'ইভেন্টের অপেক্ষা করা হচ্ছে...',
  'settings.developerMenu.eventLog.notConnected': 'সংযুক্ত নয়',
  'settings.developerMenu.eventLog.jumpToLatest': 'সর্বশেষ গুরুত্বপূর্ণ',
  'settings.developerMenu.eventLog.badge.tool': 'TOOL',
  'settings.developerMenu.eventLog.badge.agent': 'AGENT',
  'settings.developerMenu.eventLog.badge.info': 'INFO',
  'settings.developerMenu.eventLog.badge.mem': 'MEM',
  'settings.developerMenu.eventLog.badge.chan': 'CHAN',
  'settings.developerMenu.eventLog.badge.cron': 'CRON',
  'settings.developerMenu.eventLog.badge.hook': 'HOOK',
  'settings.developerMenu.eventLog.badge.warn': 'WARN',
  'settings.developerMenu.eventLog.badge.skill': 'SKILL',
  'settings.developerMenu.eventLog.badge.comp': 'COMP',
  'settings.developerMenu.eventLog.badge.mcp': 'MCP',
  'settings.developerMenu.intelligence.title': 'ইন্টেলিজেন্স',
  'settings.developerMenu.intelligence.desc':
    'মেমরি ওয়ার্কস্পেস, সাবকনশাস ইঞ্জিন, ড্রিমস এবং সেটিংস',
  'settings.developerMenu.notificationRouting.title': 'নোটিফিকেশন রাউটিং',
  'settings.developerMenu.notificationRouting.desc':
    'ইন্টিগ্রেশন অ্যালার্টের জন্য AI গুরুত্ব স্কোরিং এবং অর্কেস্ট্রেটর এসকেলেশন',
  'settings.developerMenu.composeioTriggers.title': 'ComposeIO ট্রিগার',
  'settings.developerMenu.composeioTriggers.desc': 'ComposeIO ট্রিগার ইতিহাস এবং আর্কাইভ দেখুন',
  'settings.developerMenu.composioRouting.title': 'Composio রাউটিং (ডাইরেক্ট মোড)',
  'settings.developerMenu.composioRouting.desc':
    'আপনার নিজস্ব Composio API কী ব্যবহার করুন এবং কল সরাসরি backend.composio.dev-এ রাউট করুন',
  'settings.developerMenu.integrationTriggers.title': 'ইন্টিগ্রেশন ট্রিগার',
  'settings.developerMenu.integrationTriggers.desc':
    'Composio ইন্টিগ্রেশন ট্রিগারের জন্য AI ট্রায়াজ সেটিংস কনফিগার করুন',
  'settings.developerMenu.mcpServer.title': 'MCP লাইব্রেরি অনুপলব্ধ',
  'settings.developerMenu.mcpServer.desc':
    'বাহ্যিক MCP ক্লায়েন্টগুলিকে OpenHuman-এ সংযুক্ত করতে কনফিগার করুন',
  'settings.developerMenu.autonomy.title': 'এজেন্ট স্বায়ত্তশাসন',
  'settings.developerMenu.autonomy.desc': 'টুল অ্যাকশনের রেট সীমা এবং নিরাপত্তা থ্রেশহোল্ড',
  'settings.developerMenu.voiceDebug.title': 'ভয়েস (ডিবাগ)',
  'settings.developerMenu.voiceDebug.desc': 'ভয়েস ডিক্টেশন রানটাইম স্ট্যাটাস এবং ডিবাগ সেটিংস',
  'settings.mcpServer.title':
    'MCP সার্ভারের সাথে সংযোগ করতে বহিরাগত __BR1__ ক্লায়েন্ট কনফিগার করুন',
  'settings.mcpServer.toolsSectionTitle': 'উপলভ্য টুল',
  'settings.mcpServer.toolsSectionDesc': 'উপলভ্য টুলস stdio সার্ভার যখন openhuman-core mcp',
  'settings.mcpServer.configSectionTitle': 'ক্লায়েন্ট কনফিগারেশন চালায়',
  'settings.mcpServer.configSectionDesc':
    'সঠিক কনফিগারেশন স্নিপেট তৈরি করতে আপনার MCP ক্লায়েন্ট নির্বাচন করুন',
  'settings.mcpServer.copySnippet': 'ক্লিপবোর্ডে কপি করুন',
  'settings.mcpServer.copied': 'কপি করা হয়েছে!',
  'settings.mcpServer.openConfigFile': 'কনফিগ ফাইল খুলুন',
  'settings.mcpServer.binaryPathNotFound':
    'OpenHuman বাইনারি পাওয়া যায়নি। উৎস থেকে চললে, এর সাথে তৈরি করুন: cargo build --bin openhuman-core',
  'settings.mcpServer.openConfigError': 'কনফিগার ফাইল খুলতে ব্যর্থ',
  'settings.mcpServer.clientClaudeDesktop': 'Claude Desktop',
  'settings.mcpServer.clientCursor': 'কার্সার',
  'settings.mcpServer.clientCodex': 'কার্সার',
  'settings.mcpServer.clientZed': 'জেড',
  'settings.mcpServer.configFilePath': 'কনফিগার ফাইল',
  'settings.mcpServer.clientSelectorAriaLabel': 'MCP ক্লায়েন্ট নির্বাচক',
  'settings.appearance.menuDesc': 'লাইট, ডার্ক বা সিস্টেম থিমের সাথে মিল বেছে নিন',
  'settings.agentAccess.title': 'এজেন্ট OS ব্যবহার',
  'settings.agentAccess.menuDesc':
    'যেখানে এজেন্ট xqxqx ব্যবহার করে সেটি নিয়ন্ত্রণ করুন এবং শেল ব্যবহার করতে পারেন কি না ।',
  'settings.agentAccess.loadError': 'বৈশিষ্ট্য লোড করতে ব্যর্থ',
  'settings.agentAccess.saveError': 'বৈশিষ্ট্য সংরক্ষণ করতে ব্যর্থ',
  'settings.agentAccess.saved': 'সংরক্ষিত: আপনার পরবর্তী বার্তার ওপর প্রয়োগ করা হয়েছে ।',
  'settings.agentAccess.desktopOnly':
    'শুধুমাত্র ডেস্কটপের মধ্যে উপলব্ধ বৈশিষ্ট্যগুলি উপলব্ধ রয়েছে ।',
  'settings.agentAccess.loading': 'লোড করা হচ্ছে...',
  'settings.agentAccess.accessMode': 'অফলাইন মোড',
  'settings.agentAccess.tier.readonly.title': 'শুধুমাত্র পাঠযোগ্য',
  'settings.agentAccess.tier.readonly.desc':
    'ফাইল পড়ুন এবং শুধুমাত্র পাঠ করুন - কিন্তু কখনো লিখতে পারবেন না, সম্পাদনা, সম্পাদনা অথবা কোনো কিছু পরিবর্তন সাধন করতে পারবেন না ।',
  'settings.agentAccess.tier.supervised.title': 'সম্পাদনা করার পূর্বে জিজ্ঞাসা করা হবে',
  'settings.agentAccess.tier.supervised.desc':
    'অবাধভাবে নতুন ফাইল নির্মাণ করুন, কিন্তু কোনো উপস্থিত ফাইল সম্পাদনা করার পূর্বে আপনার অনুমোদন দাবি করা হবে, একটি কমান্ড চালানো অথবা নেটওয়ার্ক-এ প্রবেশ করান।',
  'settings.agentAccess.tier.full.title': 'সম্পূর্ণ ব্যবহার',
  'settings.agentAccess.tier.full.desc':
    'আপনার সম্পূর্ণ ব্যবহারকারী অ্যাকাউন্ট ব্যবহার করে কমান্ড সঞ্চালনার জন্য এটি xqxqxnx অনুমোদন করতে পারে, শুধুমাত্র পরিচয় এবং সিস্টেম স্টোর ছাড়া। দেশাঞ্চলীয় কমান্ড, নেটওয়ার্ক প্রবেশাধিকার এবং এখনও অনুমোদনের জন্য আবেদন করে।',
  'settings.agentAccess.defaultTag': '(ডিফল্ট)',
  'settings.agentAccess.fullWarning':
    'XKB সম্পূর্ণ ব্যবহার করে আপনার অ্যাকাউন্টের প্রবেশপথ চালু করা হয়েছে এবং আপনি স্যান্ডবক্স না। যখন আপনি xqxqxkx এই মেশিনের এজেন্টটিকে সক্রিয় করতে চান তখন এটি সক্রিয় করুন । অত্যন্ত সক্রিয় এবং সিস্টেম ডিরেক্টরি অবরুদ্ধ থাকবে, এবং ধ্বংসাত্মক হবে, নেটওয়ার্ক এবং অনুমোদন চেয়ে কাজ স্থাপন করবে।',
  'settings.agentAccess.confine.label': 'কর্মক্ষেত্র সক্রিয় করা হবে',
  'settings.agentAccess.confine.desc':
    'কর্মক্ষেত্রের মধ্যে উপস্থিত ফোল্ডারগুলির উপর নির্ভর করে (যেমন কোনো ফোল্ডার), যে কোনো ফোল্ডার নির্বাচন করা হবে। বন্ধ করা হলে, এটি আপনার ব্যবহারকারী যে কোন স্থানে পৌঁছাতে পারে - তবে একমাত্র নির্ধারিত পরিচয় এবং সিস্টেম ডিরেক্টরি ছাড়া।',
  'settings.agentAccess.requireTaskPlanApproval.label': 'কাজের পরিকল্পনা অনুমোদন প্রয়োজন',
  'settings.agentAccess.requireTaskPlanApproval.desc':
    'নির্ধারিত কর্মের পূর্বে একটি author-ed কর্মের সঞ্চালনার পূর্বে কর্ম স্থগিত করা হবে।',
  'settings.agentAccess.autoApproveAll.label': 'সব কাজ স্বয়ংক্রিয়ভাবে অনুমোদন করুন',
  'settings.agentAccess.autoApproveAll.desc':
    'সক্রিয় করা হলে, এজেন্ট আপনার অনুমতি না নিয়েই সব কাজ সম্পাদন করবে। এর মধ্যে রয়েছে ফাইল লেখা, শেল কমান্ড, নেটওয়ার্ক অনুরোধ এবং অন্যান্য যেকোনো পার্শ্বপ্রতিক্রিয়া। কঠোর নিরাপত্তা বাধা (ক্রেডেনশিয়াল ডিরেক্টরি, ওয়ার্কস্পেসের অভ্যন্তরীণ পাথ) তবুও কার্যকর থাকবে।',
  'settings.agentAccess.tinyplaceAutopilot.title': 'স্বয়ংক্রিয় tiny.place এজেন্ট',
  'settings.agentAccess.tinyplaceAutopilot.desc':
    'OpenHuman-কে tiny.place-এ নিজে কাজ করতে দিন। এটি নির্ধারিত সময় অনুযায়ী মূল্যবান কাজ খোঁজে (প্রথমে খোলা বাউন্টি), নিজের দক্ষতার সাথে মানানসই কাজ করে এবং আপনার পরিচয় থেকে কাজ করে। এটি তত্ত্বাবধান ছাড়াই চলে এবং অর্থ ব্যয় করতে পারে, তাই পরীক্ষার সময় এটি devnet-এ রাখুন। ডিফল্টভাবে বন্ধ।',
  'settings.agentAccess.tinyplaceAutopilot.label': 'স্বয়ংক্রিয়ভাবে চালান',
  'settings.agentAccess.timeout.label': 'অ্যাকশন টাইমআউট',
  'settings.agentAccess.timeout.desc':
    'একটি একক টুল বা অ্যাকশন বাতিল হওয়ার আগে কতক্ষণ চলতে পারে। বড় লোকাল মডেল উত্তর শেষ করার আগেই থেমে গেলে এটি বাড়ান।',
  'settings.agentAccess.timeout.unit': 'সেকেন্ড',
  'settings.agentAccess.timeout.invalid': 'অনুমোদিত পরিসরের মধ্যে সেকেন্ডের একটি পূর্ণসংখ্যা লিখুন',
  'settings.agentAccess.timeout.envOverride':
    'OPENHUMAN_TOOL_TIMEOUT_SECS এনভায়রনমেন্ট ভেরিয়েবলটি এই সেটিং ওভাররাইড করছে, তাই এটি আনসেট না করা পর্যন্ত এখানে পরিবর্তনের কোনো প্রভাব পড়বে না।',
  'settings.agentAccess.grantedFolders': 'ফোল্ডার',
  'settings.agentAccess.alwaysAllow': 'সর্বদা অপসারণযোগ্য সরঞ্জাম',
  'settings.agentAccess.alwaysAllowDesc':
    'জিজ্ঞাসা না করে আলাপনের ক্ষেত্রে "সর্বদা" প্রয়োগ করা হবে। পুনরায় লেখার জন্য একটি ফোল্ডার মুছে ফেলা হবে।',
  'settings.agentAccess.alwaysAllowNone': 'এখনো পর্যন্ত কোন যন্ত্র নেই।',
  'settings.agentAccess.grantedDesc':
    'এজেন্টটি পড়তে পারে এবং লিখতে পারে, কর্মক্ষেত্রের সাথে যুক্ত। অন্তর্ভুক্ত স্টোর (~/.s, ~/.gag, ~/.wasg, কীচাইন (etc, /etc, সিস্টেম) এবং সিস্টেম ডিরেক্টরি (etc, C BAR  xqxkxxxx,...) সর্বদা বন্ধ করা হয়, এমনকি একটি ফোল্ডারও নিষিদ্ধ করা হয়।',
  'settings.agentAccess.noneGranted': 'কোন ফোল্ডার দেয়া হয়নি।',
  'settings.agentAccess.readWrite': 'পড়া + লেখা',
  'settings.agentAccess.readOnly': 'শুধুমাত্র পাঠযোগ্য',
  'settings.agentAccess.remove': 'মুছে ফেলুন',
  'settings.agentAccess.pathPlaceholder': 'ফোল্ডারের সম্পূর্ণ পাথ',
  'settings.agentAccess.accessLevelLabel': 'দক্ষতা স্তর',
  'settings.agentAccess.add': 'যোগ করুন',
  'settings.agentAccess.saving': 'ইনস্টল করা হয়েছে...',
  'settings.agentAccess.changesApply': 'পরবর্তী বার্তায় পরিবর্তন প্রয়োগ করা হবে।',
  'settings.agentAccess.directories': 'ডিরেক্টরি',
  'settings.agentAccess.actionSandbox': 'অ্যাকশন স্যান্ডবক্স',
  'settings.agentAccess.readWriteAccess': 'পড়া + লেখা',
  'settings.agentAccess.actionSandboxDesc':
    'শেল, ফাইল এবং git টুলের জন্য ডিফল্ট কার্যকরী ডিরেক্টরি।',
  'settings.agentAccess.actionDir.edit': 'সম্পাদনা',
  'settings.agentAccess.actionDir.save': 'সংরক্ষণ',
  'settings.agentAccess.actionDir.cancel': 'বাতিল',
  'settings.agentAccess.actionDir.placeholder': 'পরম পথ, যেমন /Users/you/Projects',
  'settings.agentAccess.actionDir.envLocked':
    'OPENHUMAN_ACTION_DIR দ্বারা নির্ধারিত। ওভাররাইড করতে এনভায়রনমেন্ট ভেরিয়েবল পরিবর্তন করুন।',
  'settings.agentAccess.actionDir.saved': 'অ্যাকশন ডিরেক্টরি আপডেট হয়েছে।',
  'settings.agentAccess.internalState': 'অভ্যন্তরীণ অবস্থা',
  'settings.agentAccess.agentBlocked': 'এজেন্ট-অবরুদ্ধ',
  'settings.agentAccess.internalStateDesc':
    'মেমরি ডেটাবেস, সেশন, টোকেন এবং অন্যান্য মূল ডেটা। এজেন্ট টুলের কাছে অ্যাক্সেসযোগ্য নয়।',
  'settings.agentAccess.actionDirInputLabel': 'অ্যাকশন স্যান্ডবক্স পাথ',
  'settings.agentAccess.actionDirSave': 'সংরক্ষণ',
  'settings.agentAccess.actionDirSaving': 'সংরক্ষণ করা হচ্ছে…',
  'settings.agentAccess.actionDirSaved': 'অ্যাকশন স্যান্ডবক্স আপডেট করা হয়েছে।',
  'settings.agentAccess.actionDirEmptyError': 'পাথ ফাঁকা থাকতে পারবে না।',
  'settings.agentAccess.actionDirSaveError': 'অ্যাকশন স্যান্ডবক্স আপডেট করা যায়নি।',
  'settings.agentAccess.actionDirEnvOverrideError':
    'OPENHUMAN_ACTION_DIR সেট করা আছে: সেটিংস থেকে সম্পাদনা করতে এনভ ভ্যারিয়েবলটি আনসেট করুন।',
  'settings.agentAccess.actionDirEnvOverrideNote':
    'OPENHUMAN_ACTION_DIR দ্বারা ওভাররাইড হয়েছে: সেটিংস থেকে পরিচালনা করতে এনভ ভ্যারিয়েবলটি আনসেট করুন।',
  'settings.agentAccess.approvalHistory': 'অনুমোদন ইতিহাস',
  'settings.agentAccess.approvalHistoryDesc':
    'এজেন্টের অনুরোধ করা পূর্ববর্তী অনুমোদন/প্রত্যাখ্যান সিদ্ধান্ত পর্যালোচনা করুন।',
  'settings.agentAccess.viewApprovalHistory': 'অনুমোদনের ইতিহাস দেখুন',

  // ── অনুমতি প্যানেল ───────────────────────────────────────────────
  'settings.permissions.title': 'অনুমতি',
  'settings.permissions.menuDesc':
    'আপনার সহকারী কী করতে পারে এবং কোথায় কাজ করতে পারে তা বেছে নিন।',
  'settings.permissions.accessMode': 'সহকারী কী করতে পারে?',
  'settings.permissions.accessModeDesc':
    'আপনার কম্পিউটারে পদক্ষেপ নেওয়ার সময় সহকারীর কতটুকু স্বাধীনতা থাকবে তা বেছে নিন।',
  'settings.permissions.preset.readonly.title': 'দেখো, স্পর্শ করো না',
  'settings.permissions.preset.readonly.desc':
    'সহকারী ফাইল পড়তে এবং অন্বেষণ করতে পারে, কিন্তু কখনো লিখতে, সম্পাদনা করতে বা এমন কিছু চালাতে পারবে না যা অবস্থা পরিবর্তন করে।',
  'settings.permissions.preset.supervised.title': 'আগে আমাকে জিজ্ঞেস করো',
  'settings.permissions.preset.supervised.desc':
    'নতুন ফাইল তৈরি করতে পারে, কিন্তু সম্পাদনা, কমান্ড চালানো বা নেটওয়ার্ক অ্যাক্সেসের আগে সবসময় আপনার অনুমতি চাইবে।',
  'settings.permissions.preset.full.title': 'পূর্ণ নিয়ন্ত্রণ',
  'settings.permissions.preset.full.desc':
    'আপনার পূর্ণ অ্যাকাউন্ট অ্যাক্সেস দিয়ে কাজ করে। ধ্বংসাত্মক কমান্ড, নেটওয়ার্ক অ্যাক্সেস এবং ইনস্টলেশন এখনও অনুমতি চাইবে।',
  'settings.permissions.folders': 'এটি কোথায় কাজ করতে পারে?',
  'settings.permissions.foldersDesc':
    'সহকারী যে ডিফল্ট ফোল্ডার পড়ে এবং লেখে। উন্নত সেটিংসে আপনি আরও ফোল্ডার যোগ করতে পারেন।',

  'settings.meetings.title': 'মিটিং',
  'settings.meetings.menuDesc':
    'মিটিং অ্যাসিস্ট্যান্ট স্বয়ংক্রিয় যোগদান, সারাংশ ও ট্রান্সক্রিপ্ট',
  'settings.meetings.desktopOnly': 'মিটিং সেটিংস কেবল ডেস্কটপে উপলব্ধ।',
  'settings.meetings.loading': 'লোড হচ্ছে…',
  'settings.meetings.loadError': 'মিটিং সেটিংস লোড করা যায়নি।',
  'settings.meetings.saveError': 'মিটিং সেটিংস সংরক্ষণ করা যায়নি।',
  'settings.meetings.saved': 'সংরক্ষিত',
  'settings.meetings.saving': 'সংরক্ষণ হচ্ছে…',
  'settings.meetings.autoJoin.title': 'স্বয়ংক্রিয় যোগদান নীতি',
  'settings.meetings.autoJoin.desc': 'ক্যালেন্ডার ইভেন্টে Google Meet লিঙ্ক থাকলে',
  'settings.meetings.autoJoin.askEachTime': 'প্রতিবার জিজ্ঞাসা করুন',
  'settings.meetings.autoJoin.always': 'সবসময় যোগ দিন',
  'settings.meetings.autoJoin.never': 'কখনও যোগ দেবেন না',
  'settings.meetings.autoSummarize.title': 'কল-পরবর্তী সারাংশ',
  'settings.meetings.autoSummarize.desc': 'কল শেষ হওয়ার পর একটি সারাংশ তৈরি করুন',
  'settings.meetings.autoSummarize.ask': 'কলের পরে জিজ্ঞাসা করুন',
  'settings.meetings.autoSummarize.always': 'সবসময় সারাংশ করুন',
  'settings.meetings.autoSummarize.never': 'কখনও সারাংশ করবেন না',
  'settings.meetings.listenOnly': 'শুধু শোনার মোড',
  'settings.meetings.listenOnlyDesc': 'মাইক্রোফোন মিউট করে যোগ দিন',
  'settings.meetings.ingestTranscripts': 'ব্যাকএন্ড ট্রান্সক্রিপ্ট সংগ্রহ করুন',
  'settings.meetings.ingestTranscriptsDesc': 'মিটিং ট্রান্সক্রিপ্ট মেমরিতে সংরক্ষণ করুন',
  'settings.sandbox.title': 'Sandbox কার্যকরী',
  'settings.sandbox.menuDesc': 'এজেন্ট টুল আইসোলেশনের জন্য Sandbox ব্যাকএন্ড কনফিগার করুন।',
  'settings.sandbox.loading': 'লোড হচ্ছে…',
  'settings.sandbox.desktopOnly': 'Sandbox সেটিংস শুধুমাত্র ডেস্কটপ অ্যাপে পাওয়া যায়।',
  'settings.sandbox.loadError': 'Sandbox সেটিংস লোড করতে ব্যর্থ।',
  'settings.sandbox.saveError': 'Sandbox সেটিংস সংরক্ষণ করতে ব্যর্থ।',
  'settings.sandbox.saved': 'সংরক্ষিত: নতুন এজেন্ট সেশনে প্রযোজ্য।',
  'settings.sandbox.saving': 'সংরক্ষণ হচ্ছে…',
  'settings.sandbox.status': 'অবস্থা',
  'settings.sandbox.dockerStatus': 'Docker',
  'settings.sandbox.available': 'উপলব্ধ',
  'settings.sandbox.unavailable': 'অনুপলব্ধ',
  'settings.sandbox.detectedBackend': 'OS ব্যাকএন্ড',
  'settings.sandbox.enableLabel': 'Sandbox কার্যকরী সক্ষম করুন',
  'settings.sandbox.enableDesc': 'একটি বিচ্ছিন্ন Sandbox পরিবেশের ভিতরে এজেন্ট টুল চালান।',
  'settings.sandbox.backendLabel': 'ব্যাকএন্ড',
  'settings.sandbox.backendDesc':
    'Sandbox কার্যকরীর জন্য কোন আইসোলেশন ব্যাকএন্ড ব্যবহার করবেন তা বেছে নিন।',
  'settings.sandbox.backend.auto': 'স্বয়ংক্রিয় (সেরা উপলব্ধ সনাক্ত করুন)',
  'settings.sandbox.backend.docker': 'Docker',
  'settings.sandbox.backend.landlock': 'Landlock (Linux)',
  'settings.sandbox.backend.firejail': 'Firejail (Linux)',
  'settings.sandbox.backend.bubblewrap': 'Bubblewrap (Linux)',
  'settings.sandbox.backend.none': 'কোনোটি নয় (কোনো Sandbox নেই)',
  'settings.sandbox.dockerSettings': 'Docker সেটিংস',
  'settings.sandbox.dockerImage': 'ইমেজ',
  'settings.sandbox.dockerImagePlaceholder': 'alpine:3.20',
  'settings.sandbox.memoryLimit': 'মেমরি সীমা',
  'settings.sandbox.memoryUnit': 'MB',
  'settings.sandbox.cpuLimit': 'CPU সীমা',
  'settings.sandbox.cpuUnit': 'কোর',
  'settings.sandbox.envPassthrough': 'পরিবেশ পাসথ্রু',
  'settings.sandbox.envPassthroughDesc': 'Sandbox-এ ফরওয়ার্ড করা পরিবেশ ভেরিয়েবল।',
  'settings.sandbox.noEnvVars': 'কোনো পরিবেশ ভেরিয়েবল কনফিগার করা হয়নি।',
  'settings.approvalHistory.title': 'অনুমোদন ইতিহাস',
  'settings.approvalHistory.subtitle': 'সাম্প্রতিক টুল-অনুমোদন সিদ্ধান্ত, নতুনতম প্রথমে।',
  'settings.approvalHistory.refresh': 'Refresh',
  'settings.approvalHistory.loading': 'অনুমোদন ইতিহাস লোড হচ্ছে…',
  'settings.approvalHistory.retry': 'Retry',
  'settings.approvalHistory.emptyState': 'এখনো কোনো অনুমোদন সিদ্ধান্ত রেকর্ড হয়নি।',
  'settings.approvalHistory.errorGeneric': 'অনুমোদন ইতিহাস লোড করা যায়নি। আবার চেষ্টা করুন।',
  'settings.approvalHistory.decidedAt': '{date} তারিখে সিদ্ধান্ত নেওয়া হয়েছে',
  'settings.approvalHistory.decision.approveOnce': 'একবার অনুমোদিত',
  'settings.approvalHistory.decision.approveAlways': 'সর্বদা অনুমোদিত',
  'settings.approvalHistory.decision.approveAlwaysFlow': 'সর্বদা অনুমোদিত (ফ্লো)',
  'settings.approvalHistory.decision.deny': 'Denied',
  'settings.theme.variantLight': 'হালকা',
  'settings.theme.variantDark': 'গাঢ়',
  'settings.theme.variantAuto': 'স্বয়ংক্রিয়',
  'settings.theme.variantAria': 'থিম ভ্যারিয়েন্ট',
  'settings.theme.backdropHeading': 'পটভূমি',
  'settings.theme.backdrop.mesh': 'মেশ',
  'settings.theme.backdrop.solid': 'একরঙা',
  'settings.theme.backdrop.image': 'ছবি',
  'settings.theme.backdropImageUrl': 'পটভূমির ছবির URL',
  'settings.theme.backdropDots': 'পটভূমির বিন্দু দেখান',
  'settings.theme.backdropHint':
    'মেশ অ্যানিমেটেড গ্রেডিয়েন্ট দেখায়; একরঙা একটি সমতল পটভূমি ব্যবহার করে; ছবি আপনার নিজের পটভূমি আঁকে।',
  'settings.theme.autoForkHint':
    'কোনো প্রিসেট সম্পাদনা করলে আপনার পরিবর্তনগুলি স্বয়ংক্রিয়ভাবে একটি নতুন কাস্টম থিম হিসেবে সংরক্ষিত হয়।',
  'settings.theme.title': 'থিম স্টুডিও',
  'settings.theme.menuDesc':
    'রং এবং ফন্ট সম্পূর্ণরূপে কাস্টমাইজ করুন, অথবা একটি প্রিসেট থিম বেছে নিন।',
  'settings.theme.presetsHeading': 'থিম',
  'settings.theme.builtInBadge': 'প্রিসেট',
  'settings.theme.customBadge': 'কাস্টম',
  'settings.theme.customizeHint':
    'অন্তর্নির্মিত প্রিসেটগুলো শুধুমাত্র পড়ার জন্য। এই থিমের রং এবং ফন্ট সম্পাদনা করতে এটি অনুলিপি করুন।',
  'settings.theme.duplicate': 'অনুলিপি ও কাস্টমাইজ করুন',
  'settings.theme.copyName': '{name} (কাস্টম)',
  'settings.theme.importedName': 'আমদানিকৃত থিম',
  'settings.theme.contrastWarn':
    'টেক্সট এবং পটভূমির মধ্যে কম বৈসাদৃশ্য: এই থিমটি পড়া কঠিন হতে পারে।',
  'settings.theme.group.surfaces': 'পৃষ্ঠতল',
  'settings.theme.group.text': 'টেক্সট',
  'settings.theme.group.borders': 'সীমানা',
  'settings.theme.group.accents': 'অ্যাকসেন্ট রং',
  'settings.theme.showShades': 'সব অ্যাকসেন্ট শেড দেখান',
  'settings.theme.hideShades': 'সব অ্যাকসেন্ট শেড লুকান',
  'settings.theme.fontsHeading': 'ফন্ট',
  'settings.theme.fontRole.title': 'শিরোনাম',
  'settings.theme.fontRole.heading': 'হেডিং',
  'settings.theme.fontRole.body': 'মূল লেখা',
  'settings.theme.fontRole.mono': 'মনোস্পেস',
  'settings.theme.fontRole.serif': 'সেরিফ',
  'settings.theme.fontCurrent': 'বর্তমান',
  'settings.theme.actions': 'থিম পরিচালনা করুন',
  'settings.theme.reset': 'ওভাররাইড রিসেট করুন',
  'settings.theme.delete': 'থিম মুছুন',
  'settings.theme.export': 'JSON কপি করুন',
  'settings.theme.copied': 'কপি হয়েছে!',
  'settings.theme.import': 'থিম আমদানি করুন',
  'settings.theme.importHint': 'কাস্টম থিম হিসেবে যোগ করতে রপ্তানিকৃত থিম JSON পেস্ট করুন।',
  'settings.theme.importApply': 'আমদানি করুন',
  'settings.theme.importError': 'সেই থিম JSON পার্স করা যায়নি।',
  'settings.appearance.title': 'উপস্থিতি',
  'settings.appearance.themeHeading': 'থিম',
  'settings.appearance.themeAria': 'থিম',
  'settings.appearance.modeLight': 'হালকা',
  'settings.appearance.modeLightDesc': 'উজ্জ্বল পৃষ্ঠ, অন্ধকার পাঠ্য।',
  'settings.appearance.modeDark': 'অন্ধকার',
  'settings.appearance.modeDarkDesc': 'আবছা পৃষ্ঠ, সন্ধ্যার পরে চোখের উপর সহজ।',
  'settings.appearance.modeSystem': 'ম্যাচ সিস্টেম',
  'settings.appearance.modeSystemDesc': 'আপনার OS চেহারা সেটিং অনুসরণ করুন.',
  'settings.appearance.helperText':
    'ডার্ক মোড পুরো অ্যাপকে স্যুইচ করে (চ্যাট, সেটিংস, প্যানেল) একটি আবছা প্যালেটে। "ম্যাচ সিস্টেম" আপনার OS চেহারা অনুসরণ করে এবং লাইভ আপডেট করে।',
  'settings.appearance.fontSizeHeading': 'ফন্টের আকার',
  'settings.appearance.fontSizeAria': 'ফন্টের আকার',
  'settings.appearance.fontSizeSmall': 'ছোট',
  'settings.appearance.fontSizeSmallDesc': 'কমপ্যাক্ট লেখা: স্ক্রিনে আরও বেশি দেখান।',
  'settings.appearance.fontSizeMedium': 'মাঝারি',
  'settings.appearance.fontSizeMediumDesc': 'ডিফল্ট, সুষম আকার।',
  'settings.appearance.fontSizeLarge': 'বড়',
  'settings.appearance.fontSizeLargeDesc': 'সহজে পড়ার জন্য বড় লেখা।',
  'settings.appearance.fontSizeXLarge': 'অতিরিক্ত বড়',
  'settings.appearance.fontSizeXLargeDesc': 'সর্বাধিক পঠনযোগ্যতার জন্য সবচেয়ে বড় লেখা।',
  'settings.appearance.fontSizeHelperText':
    'সিস্টেম ফন্ট সেটিং নির্বিশেষে পুরো অ্যাপ জুড়ে (চ্যাট, সেটিংস ও প্যানেল) লেখার আকার পরিবর্তন করে।',
  'settings.appearance.fontSizeCustomLabel': 'কাস্টম আকার',
  'settings.appearance.fontSizeCustomAria': 'পিক্সেলে কাস্টম ফন্ট আকার',
  'settings.appearance.fontSizeCustomSliderAria': 'কাস্টম ফন্ট আকারের স্লাইডার, পিক্সেলে',
  'settings.appearance.fontSizeUnit': 'px',
  'settings.appearance.tabBarHeading': 'নীচের ট্যাব বার',
  'settings.appearance.tabBarAlwaysShowLabels': 'সর্বদা লেবেলগুলি দেখান',
  'settings.appearance.tabBarAlwaysShowLabelsDesc':
    'বন্ধ থাকা অবস্থায়, লেবেলগুলি শুধুমাত্র হোভারে বা সক্রিয় ট্যাবের জন্য প্রদর্শিত হয়৷',
  'settings.appearance.chatHeading': 'চ্যাট',
  'settings.appearance.assistantTextMode': 'অ্যাসিস্ট্যান্টের উত্তর টেক্সট হিসেবে',
  'settings.appearance.hideAgentInsights': 'এজেন্টের চিন্তা লুকান',
  'settings.appearance.hideAgentInsightsDesc':
    'চ্যাটে এজেন্টের ধাপে ধাপে লাইভ টাইমলাইন সংকুচিত করুন। একটি ব্লিঙ্কিং "প্রসেসিং" লিঙ্ক এখনও আপনাকে সম্পূর্ণ প্রক্রিয়া খুলতে দেয়।',
  'settings.appearance.showChatMascot': 'মেসেজ বক্সে Tiny দেখান',
  'settings.appearance.showChatMascotDesc':
    'ম্যাসকটটি লেখার বাক্সের উপরে দাঁড়িয়ে থাকবে। লুকালে আবার চালু না করা পর্যন্ত চ্যাট শুধু টেক্সট থাকবে।',
  'settings.appearance.assistantTextModeDesc':
    'আপনার বার্তাগুলি বাবলে রেখে অ্যাসিস্ট্যান্টের উত্তর ফ্রেমহীন টেক্সট হিসেবে দেখান।',
  'settings.mascot.active': 'সক্রিয়',
  'settings.mascot.characterDesc': 'চরিত্রের বিবরণ',
  'settings.mascot.characterDraft': 'খসড়া',
  'settings.mascot.characterHeading': 'চরিত্রের শিরোনাম',
  'settings.mascot.customGifError':
    'একটি HTTPS, file://, বা স্থানীয় ইমেজ URL (PNG, GIF, JPEG, WebP, বা BMP) লিখুন, অথবা একটি ফাইল আপলোড করুন।',
  'settings.mascot.customGifHeading': 'কাস্টম ইমেজ অবতার',
  'settings.mascot.customGifLabel': 'কাস্টম ইমেজ অবতার URL',
  'settings.mascot.customGifPlaceholder': 'https://example.com/avatar.png',
  'settings.mascot.customGifUpload': 'ইমেজ আপলোড করুন',
  'settings.mascot.customGifInvalidType':
    'অসমর্থিত ফাইলের ধরন। একটি PNG, GIF, JPEG, WebP, বা BMP ইমেজ আপলোড করুন।',
  'settings.mascot.customGifTooLarge': 'ইমেজটি খুব বড়। ১.৫ MB পর্যন্ত একটি ফাইল আপলোড করুন।',
  'settings.mascot.customGifReadError': 'ইমেজটি পড়া যায়নি। অন্য একটি ফাইল চেষ্টা করুন।',
  'settings.mascot.characterPreview': 'পূর্বরূপ',
  'settings.mascot.characterStates': 'স্টেটস',
  'settings.mascot.characterVisemes': 'তুষারপাত',
  'settings.mascot.colorAria': 'OpenHuman রঙ',
  'settings.mascot.colorDesc': 'রঙের বিবরণ',
  'settings.mascot.colorHeading': 'রঙের শিরোনাম',
  'settings.mascot.colorBlack': 'কালো',
  'settings.mascot.colorBurgundy': 'বারগান্ডি',
  'settings.mascot.colorCustom': 'স্বনির্ধারিত',
  'settings.mascot.colorNavy': 'নৌবাহিনী',
  'settings.mascot.primaryColor': 'প্রধান রং',
  'settings.mascot.secondaryColor': 'দ্বিতীয় রং',
  'settings.mascot.colorYellow': 'হলুদ',
  'settings.mascot.libraryUnavailable': 'OpenHuman লাইব্রেরি অনুপলব্ধ',
  'settings.mascot.title': 'OpenHuman',
  'settings.mascot.loadingLibrary': 'OpenHuman লাইব্রেরি লোড হচ্ছে…',
  'settings.mascot.loadDetailError': 'মাসকট লোড করা যায়নি৷',
  'settings.mascot.loadLibraryError': 'মাসকট লাইব্রেরি লোড করা যায়নি।',
  'settings.mascot.localDefault': 'লোকাল OpenHuman (ডিফল্ট)',
  'settings.mascot.menuTitle': 'মাসকট',
  'settings.mascot.menuDesc': 'অ্যাপ জুড়ে ব্যবহৃত মাসকটের রঙ বেছে নিন',
  'settings.mascot.noCharacters': 'কোনো OpenHuman ক্যারেক্টার এখনও উপলব্ধ নেই',
  'settings.mascot.noColorVariants': 'কোনো রঙের ভেরিয়েন্ট নেই',
  'settings.mascot.secondaryHeading': 'মিটিং জুটি (দ্বিতীয় ম্যাসকট)',
  'settings.mascot.secondaryDesc':
    'মিটিংয়ের জন্য একটি দ্বিতীয় ম্যাসকট যোগ করুন। দুটি সেট করা থাকলে তারা একসাথে দেখা দেয় এবং পালা করে কথা বলে। একটি ম্যাসকটের জন্য কোনোটি নয় রাখুন।',
  'settings.mascot.secondaryNone': 'কোনোটি নয় (একটি ম্যাসকট)',
  'settings.mascot.perMascotVoiceHeading': 'প্রতি ম্যাসকটের কণ্ঠস্বর',
  'settings.mascot.primaryVoiceLabel': 'প্রথম ম্যাসকটের কণ্ঠস্বর',
  'settings.mascot.secondaryVoiceLabel': 'দ্বিতীয় ম্যাসকটের কণ্ঠস্বর',
  'settings.mascot.voice.current': 'বর্তমান',
  'settings.mascot.voice.customDesc':
    'ভয়েস আইডি খুঁজুন api.elevenlabs.io/v1/voices বা আপনার ElevenLabs ড্যাশবোর্ডে। শুধু আইডি সংরক্ষিত থাকে: আপনার API কী ব্যাকএন্ডে থাকে।',
  'settings.mascot.voice.customHeading': 'কাস্টম ভয়েস আইডি',
  'settings.mascot.voice.customOption': 'অন্যান্য (ভয়েস আইডি পেস্ট করুন)…',
  'settings.mascot.voice.customPlaceholder': 'যেমন 21m00Tcm4TlvDq8ikWAM',
  'settings.mascot.voice.desc':
    'স্পোকেন উত্তরের জন্য ম্যাসকট যে ElevenLabs ভয়েস ব্যবহার করে তা বেছে নিন। জেন্ডার অনুযায়ী ফিল্টার করুন, কিউরেটেড তালিকা থেকে বাছাই করুন, কাস্টম আইডি পেস্ট করুন, অথবা ইন্টারফেস ভাষার সাথে মেলে এমন ভয়েস অ্যাপটিকে বেছে নিতে দিন।',
  'settings.mascot.voice.genderFemale': 'মহিলা',
  'settings.mascot.voice.genderHeading': 'ভয়েস জেন্ডার',
  'settings.mascot.voice.genderMale': 'পুরুষ',
  'settings.mascot.voice.heading': 'ভয়েস',
  'settings.mascot.voice.preset': 'ভয়েস প্রিসেট',
  'settings.mascot.voice.presetHeading': 'ভয়েস প্রিসেট',
  'settings.mascot.voice.preview': 'ভয়েস প্রিভিউ',
  'settings.mascot.voice.previewError': 'ভয়েস প্রিভিউ ব্যর্থ হয়েছে',
  'settings.mascot.voice.previewText': 'হাই, আমি তোমার সহকারী। এটি একটি ভয়েস প্রাকদর্শন.',
  'settings.mascot.voice.previewing': 'প্রিভিউ চলছে…',
  'settings.mascot.voice.reset': 'ডিফল্টে রিসেট করুন',
  'settings.mascot.voice.useLocaleDefault': 'অ্যাপের ভাষার সাথে মিলান',
  'settings.mascot.voice.useLocaleDefaultDesc':
    'বর্তমান ইন্টারফেস ভাষার জন্য স্বয়ংক্রিয়ভাবে একটি ভয়েস বেছে নিন।',
  'settings.persona.title': 'ব্রেসট',
  'settings.persona.menuTitle': 'ব্রেসট',
  'settings.persona.menuDesc':
    'নাম, ব্যক্তিত্ব, অবতার এবং কণ্ঠস্বর: আপনার সহকারীকে এক প্রতীক হিসেবে',
  'settings.persona.identityHeading': 'পরিচয়',
  'settings.persona.identityDesc':
    'আপনার সহায়ক ব্যবস্থার জন্য একটি প্রদর্শন ও বিবরণ। অ্যাপ্লিকেশনে প্রদর্শিত; সহকারী কারণ পরিবর্তন হয় না।',
  'settings.persona.displayNameLabel': 'প্রদর্শনের নাম',
  'settings.persona.displayNamePlaceholder': 'xqxqx সকাল',
  'settings.persona.descriptionLabel': 'বিবরণ',
  'settings.persona.descriptionPlaceholder': 'এক্স.qxqx. শান্ত হও, আমার টিমের কনফিউজিং সহকারী।',
  'settings.persona.soul.heading': 'ব্যক্তিগত ( xxqxqx)',
  'settings.persona.soul.desc':
    '( হিতো. আপনার কর্মক্ষেত্রের ওপর সংরক্ষিত বৈশিষ্ট্য সংরক্ষণ করে পরবর্তী উত্তর সম্পাদন করা হবে।',
  'settings.persona.soul.editorLabel': "xqxqx ছবি. mdn' র",
  'settings.persona.soul.reset': 'ডিফল্ট মান পুনরায় স্থাপন করুন',
  'settings.persona.soul.usingDefault': 'দ্বারা বিভাজিত ডিফল্ট',
  'settings.persona.soul.loadError': 'xqxqx লোড করতে ব্যর্থ',
  'settings.persona.soul.saveError': 'ছবি সংরক্ষণ করতে ব্যর্থx% 1',
  'settings.persona.soul.resetError': 'xqxqx সার্ভার আরম্ভ করতে ব্যর্থ',
  'settings.persona.builder.modeLabel': 'পারসোনা এডিটর মোড',
  'settings.persona.builder.modeGuided': 'গাইডেড',
  'settings.persona.builder.modeAdvanced': 'অ্যাডভান্সড',
  'settings.persona.builder.intro':
    'কয়েকটি ঘর পূরণ করুন, আমরা সেগুলো আপনার পারসোনায় লিখে দেব। মার্কডাউন লাগবে না।',
  'settings.persona.builder.personalityLabel': 'ব্যক্তিত্ব',
  'settings.persona.builder.personalityPlaceholder':
    'যেমন: উষ্ণ, কৌতূহলী ও স্পষ্টবাদী। অনিশ্চয়তায় সৎ।',
  'settings.persona.builder.voiceLabel': 'যোগাযোগের ধরন',
  'settings.persona.builder.voicePlaceholder':
    'যেমন: আগে উত্তর দিন, সংক্ষিপ্ত রাখুন এবং আমার সুরে মিলিয়ে নিন।',
  'settings.persona.builder.aboutLabel': 'আপনার সম্পর্কে',
  'settings.persona.builder.aboutPlaceholder':
    'যেমন: আমি একটি ছোট ডিজাইন স্টুডিও চালাই এবং সহজ ভাষা পছন্দ করি।',
  'settings.persona.builder.preservedNote':
    'আপনার নিজের হাতে লেখা অন্যান্য অংশ সংরক্ষিত থাকে: সম্পূর্ণ পারসোনা দেখতে অ্যাডভান্সড-এ যান।',
  'settings.persona.builder.securityNote': 'সহকারী কী করতে পারবে তা ঠিক করতে চান?',
  'settings.persona.builder.securityLink': 'এজেন্ট অ্যাক্সেস খুলুন',
  'settings.persona.templates.heading': 'টেমপ্লেট থেকে শুরু করুন',
  'settings.persona.templates.desc':
    'একটি শুরুর বিন্দু বেছে নিন: এটি ব্যক্তিত্ব ও যোগাযোগের ধরন পূরণ করে। পরে সব কিছু সম্পাদনা করতে পারবেন।',
  'settings.persona.templates.doctor.label': 'ক্লিনিকাল সহকারী',
  'settings.persona.templates.doctor.desc': 'সতর্ক, সূত্র উল্লেখ করে, অনিশ্চয়তা চিহ্নিত করে',
  'settings.persona.templates.researcher.label': 'গবেষণা সহকারী',
  'settings.persona.templates.researcher.desc': 'নিখুঁত, সুসংগঠিত, প্রমাণ-নির্ভর',
  'settings.persona.templates.executive.label': 'নির্বাহী সহকারী',
  'settings.persona.templates.executive.desc': 'সংক্ষিপ্ত, দৃঢ়, কর্ম-কেন্দ্রিক',
  'settings.persona.templates.teacher.label': 'শিক্ষক',
  'settings.persona.templates.teacher.desc': 'ধৈর্যশীল, ধাপে ধাপে ব্যাখ্যা করে',
  'settings.persona.templates.student.label': 'পড়ার সঙ্গী',
  'settings.persona.templates.student.desc': 'উৎসাহদায়ক, কুইজ করে, সহজ ভাষা',
  'settings.persona.templates.family.label': 'পারিবারিক সহকারী',
  'settings.persona.templates.family.desc': 'উষ্ণ, বন্ধুত্বপূর্ণ, সব বয়সের জন্য নিরাপদ',
  'settings.persona.appearanceHeading': 'অবতার & ভয়েস',
  'settings.persona.appearanceDesc':
    'Mascot রঙের রং, স্বনির্ধারিত xxqxqx অ্যাভাটার, এবং Scotox বৈশিষ্ট্যের মধ্য থেকে ভয়েস কনফিগার করা হয়েছে।',
  'settings.persona.openMascotSettings': 'মাস অনুযায়ী প্রদর্শন ব্যবস্থা আরম্ভ করা হবে',
  'settings.memoryWindow.balanced.badge': 'প্রস্তাবিত',
  'settings.memoryWindow.balanced.hint':
    'যৌক্তিক ডিফল্ট: প্রতিটি রানে অতিরিক্ত টোকেন না পুড়িয়ে ভাল ধারাবাহিকতা।',
  'settings.memoryWindow.balanced.label': 'সুষম',
  'settings.memoryWindow.description':
    'প্রতিটি নতুন এজেন্ট রানে OpenHuman কতটা মনে রাখা প্রসঙ্গ ইনজেক্ট করে। বড় উইন্ডো অতীত কথোপকথন সম্পর্কে বেশি সচেতন মনে হয় কিন্তু প্রতিটি রানে বেশি টোকেন ব্যবহার করে, এবং বেশি খরচ হয়।',
  'settings.memoryWindow.extended.badge': 'আরও প্রসঙ্গ',
  'settings.memoryWindow.extended.hint':
    'প্রতিটি রানে আরও দীর্ঘমেয়াদী মেমরি ইনজেক্ট করা হয়। প্রতি টার্নে উচ্চ টোকেন খরচ।',
  'settings.memoryWindow.extended.label': 'বর্ধিত',
  'settings.memoryWindow.maximum.badge': 'সর্বোচ্চ খরচ',
  'settings.memoryWindow.maximum.hint':
    'সবচেয়ে বড় নিরাপদ উইন্ডো। সেরা ধারাবাহিকতা, প্রতিটি রানে উল্লেখযোগ্যভাবে বেশি টোকেন বিল।',
  'settings.memoryWindow.maximum.label': 'সর্বোচ্চ',
  'settings.memoryWindow.minimal.badge': 'সবচেয়ে সস্তা',
  'settings.memoryWindow.minimal.hint':
    'সবচেয়ে ছোট মেমরি উইন্ডো। সবচেয়ে সস্তা, দ্রুততম, রানগুলির মধ্যে সবচেয়ে কম ধারাবাহিকতা।',
  'settings.memoryWindow.minimal.label': 'ন্যূনতম',
  'settings.memoryWindow.title': 'দীর্ঘমেয়াদী মেমোরি উইন্ডো',
  'settings.agentbox.title': 'AgentBox',
  'settings.agentbox.desc': 'GMI Cloud মার্কেটপ্লেস অ্যাডাপ্টারের অবস্থা এবং প্রদানকারী কনফিগারেশন',
  'settings.agentbox.intro':
    'AgentBox মার্কেটপ্লেস অ্যাডাপ্টারের শুধুমাত্র-পঠনযোগ্য অবস্থা। কোর চালু হওয়ার সময় মোড এবং GMI MaaS প্রদানকারী পরিবেশ ভেরিয়েবল দ্বারা সেট করা হয়।',
  'settings.agentbox.modeLabel': 'মার্কেটপ্লেস মোড',
  'settings.agentbox.providerHeading': 'GMI MaaS প্রদানকারী',
  'settings.agentbox.slug': 'প্রদানকারী স্লাগ',
  'settings.agentbox.baseUrl': 'বেস URL',
  'settings.agentbox.model': 'মডেল',
  'settings.agentbox.notConfigured':
    'কনফিগার করা হয়নি। GMI_MAAS_BASE_URL, GMI_MAAS_API_KEY, এবং GMI_MODELS পরিবেশ ভেরিয়েবল সেট করুন।',
  'settings.agentbox.unavailable': 'AgentBox অবস্থা অনুপলব্ধ',
  'settings.modelHealth.title': 'মডেল স্বাস্থ্য',
  'settings.modelHealth.desc': 'প্রতি মডেল, কল্পনার গুণমান, এবং দাম তুলনার ক্ষেত্রে',
  'settings.modelHealth.allStatuses': 'সমস্ত অবস্থা',
  'settings.modelHealth.models': 'মডেল',
  'settings.modelHealth.loading': 'তথ্যের তথ্য লোড করা হচ্ছে...',
  'settings.modelHealth.empty': 'কোনো মডেল নিবন্ধিত হয়নি',
  'settings.modelHealth.col.model': 'মডেল',
  'settings.modelHealth.col.quality': 'গুণমান',
  'settings.modelHealth.col.halluc': 'হ্যালো. হার',
  'settings.modelHealth.col.cost': 'সময়সীমা',
  'settings.modelHealth.col.agents': 'এজেন্ট',
  'settings.modelHealth.col.status': 'অবস্থা',
  'settings.modelHealth.badge.keep': 'রাখো',
  'settings.modelHealth.badge.replace': 'প্রতিস্থাপন',
  'settings.modelHealth.badge.staging': 'িং পরীক্ষা',
  'settings.modelHealth.badge.vision': 'শুধু দৃষ্টি',
  'settings.modelHealth.swap': 'রক্ত?',
  'settings.modelHealth.modal.title': 'মডেল প্রতিস্থাপন?',
  'settings.modelHealth.modal.hallucRate': 'হার',
  'settings.modelHealth.modal.cancel': 'বাতিল',
  'settings.modelHealth.modal.apply': '& বদলাও',
  'settings.modelHealth.tag.cheaper': 'CHEAPER',
  'settings.modelHealth.tag.better': 'BETTER',
  'skills.card.moreActions': 'আরও কাজ',
  'skills.channelIcon.discord': 'Discord',
  'skills.channelIcon.imessage': 'iMessage',
  'skills.channelIcon.telegram': 'Telegram',
  'skills.channelIcon.web': 'ওয়েব',
  'skills.channelIcon.yuanbao': 'Yuanbao',
  'skills.composio.poweredBy': 'Composio দ্বারা চালিত',
  'skills.composio.staleStatusTitle': 'সংযোগগুলি পুরানো অবস্থা দেখাচ্ছে',
  'skills.create.allowedTools': 'অনুমোদিত টুল',
  'skills.create.allowedToolsHelp': 'হিসাবে SKILL.md ফ্রন্টম্যাটারে রেন্ডার করা হয়েছে',
  'skills.create.allowedToolsPlaceholder': 'node_exec, fetch',
  'skills.create.author': 'লেখক',
  'skills.create.authorPlaceholder': 'আপনার নাম',
  'skills.create.commaSeparated': '(কমা দিয়ে আলাদা)',
  'skills.create.createBtn': 'স্কিল তৈরি করুন',
  'skills.create.createError': 'স্কিল তৈরি করা যায়নি',
  'skills.create.creating': 'তৈরি হচ্ছে…',
  'skills.create.description': 'বিবরণ',
  'skills.create.descriptionPlaceholder': 'এই স্কিল কী করে?',
  'skills.create.optional': '(ঐচ্ছিক)',
  'skills.create.inputs.heading': 'Inputs',
  'skills.create.inputs.help':
    'স্কিলের প্রয়োজনীয় প্যারামিটার ঘোষণা করুন। Skills Runner রানটাইমে এগুলির জন্য একটি ফর্ম রেন্ডার করবে।',
  'skills.create.inputs.add': 'ইনপুট যোগ করুন',
  'skills.create.inputs.row.name': 'ইনপুটের নাম',
  'skills.create.inputs.row.namePlaceholder': 'যেমন repo',
  'skills.create.inputs.row.nameError':
    'শুধুমাত্র অক্ষর, সংখ্যা, আন্ডারস্কোর এবং ড্যাশ; অক্ষর দিয়ে শুরু হতে হবে।',
  'skills.create.inputs.row.description': 'ইনপুট বিবরণ',
  'skills.create.inputs.row.descriptionPlaceholder': 'এই ক্ষেত্রে কী যাবে?',
  'skills.create.inputs.row.type': 'Type',
  'skills.create.inputs.row.required': 'Required',
  'skills.create.inputs.row.remove': 'ইনপুট সরান',
  'skills.create.inputs.type.string': 'Text',
  'skills.create.inputs.type.integer': 'Number',
  'skills.create.inputs.type.boolean': 'হ্যাঁ / না',
  'skills.create.license': 'লাইসেন্স',
  'skills.create.licensePlaceholder': 'MIT',
  'skills.create.name': 'নাম',
  'skills.create.namePlaceholder': 'যেমন Trade Journal',
  'skills.create.scope': 'স্কোপ',
  'skills.create.scopeProjectHint': '/.openhuman/skills/',
  'skills.create.scopeUserHint':
    '~/.openhuman/skills/<slug>/SKILL.md-এ লেখা: সব ওয়ার্কস্পেসে পাওয়া যায়।',
  'skills.create.slugLabel': 'স্লাগ লেবেল',
  'skills.create.subtitle': 'SKILL.md',
  'skills.create.tags': 'ট্যাগ',
  'skills.create.tagsPlaceholder': 'ট্রেডিং, গবেষণা',
  'skills.create.title': 'নতুন স্কিল',
  'skills.detail.allowedTools': 'অনুমোদিত টুলস',
  'skills.detail.author': 'লেখক',
  'skills.detail.license': 'লাইসেন্স',
  'skills.detail.bundledResources': 'বান্ডেলড রিসোর্স',
  'skills.detail.description': 'বিবরণ',
  'skills.detail.closeAriaLabel': 'স্কিলের বিবরণ বন্ধ করুন',
  'skills.detail.location': 'লোকেশন',
  'skills.detail.noBundledResources': 'কোনো বান্ডেলড রিসোর্স নেই।',
  'skills.detail.platforms': 'প্ল্যাটফর্ম',
  'skills.detail.relatedSkills': 'সম্পর্কিত স্কিল',
  'skills.detail.source': 'উৎস URL',
  'skills.detail.sourceFormat': 'ফরম্যাট',
  'skills.detail.stars': 'তারকা',
  'skills.detail.tags': 'ট্যাগ',
  'skills.detail.warnings': 'সতর্কতা',
  'skills.detail.version': 'সংস্করণ',
  'skills.install.errors.alreadyInstalledHint':
    'এই স্লাগের সাথে একটি দক্ষতা ইতিমধ্যেই কর্মক্ষেত্রে বিদ্যমান। প্রথমে এটি সরান বা সামনের বস্তু `metadata.id` / `name` পরিবর্তন করুন।',
  'skills.install.errors.alreadyInstalledTitle': 'দক্ষতা ইতিমধ্যেই ইনস্টল করা হয়েছে',
  'skills.install.errors.fetchFailedHint':
    'অনুরোধটি সফলভাবে সম্পূর্ণ হয়নি৷ একটি পৌঁছানোর পাবলিক ফাইলে URL পয়েন্টগুলি পরীক্ষা করুন, এবং হোস্ট একটি 2xx প্রতিক্রিয়া ফিরিয়ে দিয়েছে৷',
  'skills.install.errors.fetchFailedTitle': 'আনা ব্যর্থ হয়েছে',
  'skills.install.errors.fetchTimedOutHint':
    'দূরবর্তী হোস্ট সময়মতো সাড়া দেয়নি৷ আবার চেষ্টা করুন বা সময়সীমা বাড়ান (1-600 সেকেন্ড)।',
  'skills.install.errors.fetchTimedOutTitle': 'আনার সময় শেষ হয়েছে',
  'skills.install.errors.fetchTooLargeHint':
    'SKILL.md অবশ্যই 1 MiB এর নিচে হতে হবে। বান্ডিল করা সম্পদগুলিকে ইনলাইন করার পরিবর্তে `রেফারেন্স/` বা `স্ক্রিপ্ট/` ফাইলে ভাগ করুন।',
  'skills.install.errors.fetchTooLargeTitle': 'SKILL.md খুব বড়',
  'skills.install.errors.genericHint':
    'ব্যাকএন্ড একটি ত্রুটি ফিরিয়ে দিয়েছে। কাঁচা বার্তা নীচে দেখানো হয়.',
  'skills.install.errors.genericTitle': 'দক্ষতা ইনস্টল করা যায়নি',
  'skills.install.errors.invalidSkillHint':
    'ফ্রন্টম্যাটারটি খালি নয় `নাম` এবং `বর্ণনা` ক্ষেত্র সহ বৈধ YAML হতে হবে, `---` দ্বারা সমাপ্ত।',
  'skills.install.errors.invalidSkillTitle': 'SKILL.md পার্স করেনি',
  'skills.install.errors.invalidUrlHint':
    'শুধুমাত্র সর্বজনীন HTTPS URLগুলি অনুমোদিত। ব্যক্তিগত, লুপব্যাক এবং মেটাডেটা হোস্ট ব্লক করা হয়েছে।',
  'skills.install.errors.invalidUrlTitle': 'URL প্রত্যাখ্যান',
  'skills.install.errors.unsupportedUrlHint':
    'শুধুমাত্র সরাসরি `.md` লিঙ্কগুলি কাজ করে৷ GitHub-এর জন্য, একটি ফাইলের সাথে লিঙ্ক করুন (github.com/owner/repo/blob/.../SKILL.md) - গাছ এবং রেপো রুট ইনস্টল করা নেই।',
  'skills.install.errors.unsupportedUrlTitle': 'URL ফর্ম সমর্থিত নয়',
  'skills.install.errors.writeFailedHint':
    'ওয়ার্কস্পেস দক্ষতা ডিরেক্টরি লেখার যোগ্য ছিল না। `<workspace>/.openhuman/skills/`-এর জন্য ফাইল সিস্টেমের অনুমতি পরীক্ষা করুন।',
  'skills.install.errors.writeFailedTitle': 'SKILL.md লেখা যায়নি',
  'skills.install.fetchLog': 'ফেচ লগ',
  'skills.install.fetchingPrefix': 'আনা হচ্ছে',
  'skills.install.fetchingSuffix': 'এটি আপনার কনফিগার করা সময়সীমা পর্যন্ত নিতে পারে।',
  'skills.install.installBtn': 'ইনস্টল হচ্ছে…',
  'skills.install.installComplete': 'ইনস্টল সম্পন্ন',
  'skills.install.installing': 'ইনস্টল হচ্ছে…',
  'skills.install.parseWarnings': 'পার্স সতর্কতা',
  'skills.install.rawError': 'রা ত্রুটি',
  'skills.install.subtitleMiddle': 'HTTPS এর উপরে এবং এটিকে',
  'skills.install.subtitlePrefix': 'এর অধীনে ইনস্টল করে একটি একক',
  'skills.install.subtitleSuffix':
    'HTTPS শুধুমাত্র আনয়ন করে; ব্যক্তিগত এবং লুপব্যাক হোস্ট অবরুদ্ধ।',
  'skills.install.successDiscovered': 'আবিষ্কৃত {count} নতুন দক্ষতা(গুলি)।',
  'skills.install.successNoNewIds':
    'দক্ষতা ইনস্টল করা হয়েছে, কিন্তু কোনো নতুন দক্ষতা আইডি উপস্থিত হয়নি - ক্যাটালগে ইতিমধ্যেই একই স্লাগ সহ একটি দক্ষতা থাকতে পারে।',
  'skills.install.timeoutHint': '(সেকেন্ড, ঐচ্ছিক)',
  'skills.install.timeoutHelp':
    'ডিফল্ট 60 সেকেন্ড। 1-600 এর বাইরের মানগুলি সার্ভার-সাইডে ক্ল্যাম্প করা হয়৷',
  'skills.install.timeoutInvalid': '1 এবং 600 এর মধ্যে একটি পূর্ণসংখ্যা হতে হবে।',
  'skills.install.timeoutLabel': 'টাইমআউট লেবেল',
  'skills.install.timeoutPlaceholder': '60',
  'skills.install.title': 'URL থেকে স্কিল ইনস্টল করুন',
  'skills.install.urlHelpMiddle': 'ফাইল',
  'skills.install.urlHelpPrefix': 'একটি সরাসরি লিঙ্ক',
  'skills.install.urlHelpSuffix': 'URL এর স্বয়ংক্রিয়-পুনঃলিখন',
  'skills.install.urlInvalidPrefix': 'URL অবশ্যই একটি সুগঠিত',
  'skills.install.urlInvalidSuffix': 'লিঙ্ক হতে হবে।',
  'skills.install.urlLabel': 'স্কিল URL',
  'skills.install.urlPlaceholder': 'https://raw.githubusercontent.com/owner/repo/main/SKILL.md',
  'skills.meetingBots.bannerDesc': 'ব্যানার বিবরণ',
  'skills.meetingBots.bannerTitle': 'ব্যানার শিরোনাম',
  'skills.meetingBots.busyTitle': 'OpenHuman ব্যস্ত',
  'skills.meetingBots.comingSoon': 'শীঘ্রই আসছে',
  'skills.meetingBots.couldNotLeaveTitle': 'মিটিং থেকে বেরোনো যায়নি',
  'skills.meetingBots.couldNotStartTitle': 'OpenHuman শুরু করা যায়নি',
  'skills.meetingBots.displayName': 'প্রদর্শন নাম',
  'skills.meetingBots.failedToStart': 'OpenHuman শুরু করতে ব্যর্থ।',
  'skills.meetingBots.joiningMessage': 'কয়েক সেকেন্ডের মধ্যে অংশগ্রহণকারী হিসেবে দেখা যাবে।',
  'skills.meetingBots.joiningTitle': 'OpenHuman মিটিংয়ে যোগ দিচ্ছে',
  'skills.meetingBots.meetingLink': 'মিটিং লিংক',
  'skills.meetingBots.modalAriaLabel': 'OpenHuman-কে একটি মিটিংয়ে পাঠান',
  'skills.meetingBots.modalDesc': 'মোডাল বিবরণ',
  'skills.meetingBots.modalTitle': 'OpenHuman-কে একটি মিটিংয়ে পাঠান',
  'skills.meetingBots.newBadge': 'নতুন ব্যাজ',
  'skills.meetingBots.platformComingSoon': '{label} সমর্থন শীঘ্রই আসছে।',
  'skills.meetingBots.platformHints.gmeet': 'meet.google.com/abc-defg-hij',
  'skills.meetingBots.platformHints.teams': 'teams.microsoft.com/...',
  'skills.meetingBots.platformHints.webex': 'webex.com/meet/...',
  'skills.meetingBots.platformHints.zoom': 'zoom.us/j/...',
  'skills.meetingBots.platforms.gmeet': 'Google Meet',
  'skills.meetingBots.platforms.teams': 'মাইক্রোসফট টিম',
  'skills.meetingBots.platforms.webex': 'Webex',
  'skills.meetingBots.platforms.zoom': 'জুম',
  'skills.meetingBots.sendTo': 'পাঠান',
  'skills.meetingBots.serverOverloaded':
    'OpenHuman এই মুহূর্তে অত্যধিক চাপের মধ্যে রয়েছে। অনুগ্রহ করে কয়েক মিনিট পরে আবার চেষ্টা করুন।',
  'skills.meetingBots.soonSuffix': 'শীঘ্রই',
  'skills.meetingBots.starting': 'শুরু হচ্ছে…',
  'skills.meetingBots.recentCallsAriaLabel': 'সাম্প্রতিক মিটিং কল',
  'skills.meetingBots.recentCallsHeading': 'সাম্প্রতিক কল',
  'skills.meetingBots.recentCallsEmpty': 'এখনও কোনো আগের কল নেই: আপনার মিটিং ইতিহাস এখানে দেখাবে।',
  'skills.meetingBots.recentCallsLoading': 'লোড হচ্ছে\u2026',
  'skills.meetingBots.recentCallAddedBy': '{name} যোগ করেছেন',
  'skills.meetingBots.recentCallParticipants': '{names} এর সাথে',
  'skills.meetingBots.recentCallTurnSingular': '{count}টি পালা',
  'skills.meetingBots.recentCallTurnPlural': '{count}টি পালা',
  'skills.meetingBots.recentCallDuration': 'কলে {seconds} সেকেন্ড',
  'skills.meetingBots.callDetailLoading': 'ট্রান্সক্রিপ্ট লোড হচ্ছে…',
  'skills.meetingBots.callDetailError': 'ট্রান্সক্রিপ্ট লোড করা যায়নি।',
  'skills.meetingBots.callDetailRetry': 'আবার চেষ্টা করুন',
  'skills.meetingBots.callDetailEmpty':
    'এই কলের জন্য কোনো ট্রান্সক্রিপ্ট বা সারাংশ রেকর্ড করা হয়নি।',
  'skills.meetingBots.callSummaryHeading': 'সারাংশ',
  'skills.meetingBots.callKeyPointsHeading': 'মূল পয়েন্ট',
  'skills.meetingBots.callActionItemsHeading': 'করণীয় কাজ',
  'skills.meetingBots.callTranscriptHeading': 'ট্রান্সক্রিপ্ট',
  'skills.meetingBots.liveBadge': 'লাইভ',
  'skills.meetingBots.liveTitle': 'মিটিংয়ে',
  'skills.meetingBots.liveStatusJoining': 'যোগ দিচ্ছে\u2026',
  'skills.meetingBots.liveStatusActive': 'মিটিংয়ে সরাসরি',
  'skills.meetingBots.liveStatusListening': 'শুনছে (নিঃশব্দ)',
  'skills.meetingBots.liveStatusEnded': 'মিটিং শেষ',
  'skills.meetingBots.liveStatusError': 'যোগ দিতে ব্যর্থ',
  'skills.meetingBots.liveTranscriptHeading': 'লাইভ ট্রান্সক্রিপ্ট',
  'skills.meetingBots.liveTranscriptEmpty': 'কথার জন্য অপেক্ষা করা হচ্ছে…',
  'skills.meetingBots.leaveButton': 'ছেড়ে দিন',
  'skills.meetingBots.leavingButton': 'বেরিয়ে যাচ্ছে…',
  'skills.meetingBots.respondToParticipant': 'এই মিটিংয়ে আপনার নাম',
  'skills.meetingBots.respondToParticipantHint': 'যেমন: রিয়া (কলে আপনার প্রদর্শনী নাম)',
  'skills.meetingBots.replyName.label': 'মিটিংয়ে আপনার নাম',
  'skills.meetingBots.replyName.description':
    'যে নামে বট শোনে ও উত্তর দেয়। কলে যেভাবে দেখায় সেভাবে আপনার নাম দিন: এটি যোগ দেওয়া প্রতিটি মিটিংয়ে প্রযোজ্য।',
  'skills.meetingBots.replyName.placeholder': 'যেমন: অ্যালেক্স কিম',
  'skills.meetingBots.respondToParticipantDesc':
    'মিটিং থেকে আপনার সঠিক প্রদর্শন নাম লিখুন। বট কেবল তখনই সাড়া দেয় যখন আপনি তার নাম বলেন (ওয়েক ফ্রেজ)।',
  'skills.meetingBots.wakePhrase': 'ওয়েক ফ্রেজ',
  'skills.meetingBots.wakePhraseHint': 'Hey OpenHuman',
  'skills.meetingBots.wakePhraseDesc': 'বট সাড়া দেওয়ার আগে অংশগ্রহণকারীকে এটি বলতে হবে।',
  'skills.meetingBots.activeMode': 'আমি ডাকলে উত্তর দেবে',
  'skills.meetingBots.activeModeDesc':
    'চালু থাকলে, আপনি ওয়েক ফ্রেজ বললে বটটি সশব্দে উত্তর দেয়। বন্ধ থাকলে, এটি শুধু শোনে ও প্রতিলিপি তৈরি করে।',
  'skills.meetingBots.history.allPlatforms': 'সব প্ল্যাটফর্ম',
  'skills.meetingBots.history.copyTranscript': 'কপি করুন',
  'skills.meetingBots.history.downloadTranscript': 'ডাউনলোড',
  'skills.meetingBots.history.earlier': 'আগে',
  'skills.meetingBots.history.participantCount': '{count} অংশগ্রহণকারী',
  'skills.meetingBots.history.participantCountPlural': '{count} অংশগ্রহণকারী',
  'skills.meetingBots.history.runWithOpenHuman': 'OpenHuman দিয়ে চালান',
  'skills.meetingBots.history.searchPlaceholder': 'কল খুঁজুন…',
  'skills.meetingBots.history.selectPrompt':
    'সারাংশ এবং ট্রান্সক্রিপ্ট দেখতে একটি কল নির্বাচন করুন।',
  'skills.meetingBots.history.today': 'আজ',
  'skills.meetingBots.history.yesterday': 'গতকাল',
  'skills.meetingBots.upcoming.heading': 'আসন্ন',
  'skills.meetingBots.upcoming.when': 'কখন',
  'skills.meetingBots.upcoming.meeting': 'মিটিং',
  'skills.meetingBots.upcoming.platform': 'প্ল্যাটফর্ম',
  'skills.meetingBots.upcoming.people': 'মানুষ',
  'skills.meetingBots.upcoming.joinPolicy': 'যোগদান নীতি',
  'skills.meetingBots.upcoming.joinNow': 'এখনই যোগ দিন',
  'skills.meetingBots.upcoming.joinNowAriaLabel': '{title}-তে যোগ দিন',
  'skills.meetingBots.upcoming.join': 'যোগ দিন',
  'skills.meetingBots.upcoming.auto': 'অটো',
  'skills.meetingBots.upcoming.ask': 'জিজ্ঞেস করুন',
  'skills.meetingBots.upcoming.skip': 'এড়িয়ে যান',
  'skills.meetingBots.upcoming.today': 'আজ',
  'skills.meetingBots.upcoming.tomorrow': 'আগামীকাল',
  'skills.meetingBots.upcoming.empty':
    'কোনো আসন্ন মিটিং নেই: এখানে দেখতে Google Calendar সংযুক্ত করুন।',
  'skills.meetingBots.upcoming.error': 'আসন্ন মিটিং লোড করা যায়নি।',
  'skills.meetingBots.upcoming.retry': 'পুনরায় চেষ্টা করুন',
  'skills.meetingBots.upcoming.refresh': 'রিফ্রেশ',
  'skills.meetingBots.upcoming.filterAll': 'সব প্ল্যাটফর্ম',
  'skills.meetingBots.upcoming.participants': '{count} অংশগ্রহণকারী',
  'skills.meetingBots.upcoming.imminent': 'শীঘ্রই শুরু হচ্ছে',
  'skills.meetingBots.upcoming.autoJoinsAt': 'স্বয়ংক্রিয়-যোগ ~{time}-এ',
  'skills.meetingBots.upcoming.asksAtStart': 'শুরুতে জিজ্ঞাসা করে',
  'skills.meetingBots.upcoming.watchCalendarHint':
    "'আমার ক্যালেন্ডার দেখুন' ডিফল্টস (গিয়ার আইকন)-এ চালু করুন যাতে স্বয়ংক্রিয়/জিজ্ঞাসা কার্যকর হয়: অন্যথায় এই নীতিগুলি সংরক্ষিত কিন্তু ট্রিগার হবে না।",
  'skills.meetingBots.relative.now': 'এখন',
  'skills.meetingBots.relative.inMinutes': '{count} মিনিটে',
  'skills.meetingBots.relative.inHours': '{count} ঘন্টায়',
  'skills.meetingBots.relative.minutesAgo': '{count} মিনিট আগে',
  'skills.meetingBots.relative.hoursAgo': '{count} ঘন্টা আগে',
  'skills.meetingBots.relative.daysAgo': '{count} দিন আগে',
  'skills.meetingBots.relative.yesterday': 'গতকাল',
  'skills.meetingBots.defaults.drawerTitle': 'মিটিং ডিফল্ট',
  'skills.meetingBots.defaults.closeDrawer': 'বন্ধ করুন',
  'skills.meetingBots.defaults.openDefaults': 'মিটিং সেটিং',
  'skills.meetingBots.defaults.watchCalendar': 'আমার ক্যালেন্ডার দেখুন',
  'skills.meetingBots.defaults.watchCalendarDesc':
    'OpenHuman-কে আপনার সংযুক্ত ক্যালেন্ডার দেখতে দিন যাতে এটি নীচের নীতিগুলির উপর ভিত্তি করে মিটিংয়ে স্বয়ংক্রিয়ভাবে যোগ দিতে বা অনুরোধ করতে পারে। এটি মিটিং অনুস্মারক বিজ্ঞপ্তি থেকে আলাদা।',
  'skills.meetingBots.defaults.globalPolicy': 'বৈশ্বিক স্বয়ংক্রিয়-যোগ দেওয়ার নীতি',
  'skills.meetingBots.defaults.perPlatformTitle': 'প্রতি-প্ল্যাটফর্ম ওভাররাইড',
  'skills.meetingBots.defaults.perPlatformDesc':
    'নির্দিষ্ট প্ল্যাটফর্মের জন্য বৈশ্বিক নীতি ওভাররাইড করুন।',
  'skills.meetingBots.defaults.useDefault': 'ডিফল্ট ব্যবহার করুন',
  'skills.resource.preview.closeAriaLabel': 'প্রিভিউ বন্ধ করুন',
  'skills.resource.preview.failed': 'প্রিভিউ ব্যর্থ',
  'skills.resource.preview.loading': 'প্রিভিউ লোড হচ্ছে…',
  'skills.resource.tree.assets': 'অ্যাসেট',
  'skills.resource.tree.examples': 'উদাহরণ',
  'skills.resource.tree.other': 'অন্যান্য',
  'skills.resource.tree.prompts': 'প্রম্পট',
  'skills.resource.tree.references': 'রেফারেন্স',
  'skills.resource.tree.scripts': 'স্ক্রিপ্ট',
  'skills.resource.tree.templates': 'টেমপ্লেট',
  'skills.resource.tree.empty': 'কোনো বান্ডেলড রিসোর্স নেই।',
  'skills.search.placeholder': 'প্লেসহোল্ডার',
  'skills.setup.voice.activation': 'অ্যাক্টিভেশন',
  'skills.setup.voice.activeDescPrefix': 'Fn',
  'skills.setup.voice.activeDescSuffix': 'Fn',
  'skills.setup.voice.activeTitle': 'ভয়েস ইন্টেলিজেন্স সক্রিয়',
  'skills.setup.voice.customizeSettings': 'সেটিংস কাস্টমাইজ করুন',
  'skills.setup.voice.downloadSttBtn': 'STT ডাউনলোড বাটন',
  'skills.setup.voice.enableDesc': 'সক্রিয় বিবরণ',
  'skills.setup.voice.hotkey': 'হটকি',
  'skills.setup.voice.startBtn': 'শুরু হচ্ছে...',
  'skills.setup.voice.startError': 'ভয়েস সার্ভার শুরু করতে ব্যর্থ',
  'skills.setup.voice.starting': 'শুরু হচ্ছে...',
  'skills.setup.voice.stepEnable': 'ভয়েস সার্ভার শুরু করুন',
  'skills.setup.voice.stepSetup': 'মডেল ডাউনলোড প্রয়োজন',
  'skills.setup.voice.stepSuccess': 'যেতে প্রস্তুত',
  'skills.setup.voice.sttNotReady': 'স্পিচ-টু-টেক্সট মডেল প্রস্তুত নয়',
  'skills.setup.voice.sttNotReadyDesc':
    'ভয়েস ইন্টেলিজেন্সের জন্য ট্রান্সক্রিপশনের জন্য একটি লোকাল Whisper মডেল প্রয়োজন। লোকাল মডেল সেটিংস থেকে ডাউনলোড করুন।',
  'skills.setup.voice.sttReady': 'স্পিচ-টু-টেক্সট মডেল প্রস্তুত',
  'skills.setup.voice.sttReturnHint': 'STT রিটার্ন হিন্ট',
  'skills.setup.voice.title': 'ভয়েস ইন্টেলিজেন্স',
  'skills.uninstall.couldNotUninstall': 'আনইনস্টল করা যায়নি',
  'skills.uninstall.description':
    'এটি স্থায়ীভাবে স্কিল ডিরেক্টরি এবং এর সমস্ত বান্ডল রিসোর্স মুছে ফেলে। এজেন্ট পরবর্তী টার্নে এটি দেখা বন্ধ করবে।',
  'skills.uninstall.title': 'আনইনস্টল',
  'skills.uninstall.uninstallBtn': 'আনইনস্টল',
  'skills.uninstall.uninstalling': 'আনইনস্টল হচ্ছে…',
  'upsell.global.limitMessage': 'চালিয়ে যেতে আপনার প্ল্যান আপগ্রেড করুন বা ক্রেডিট টপ আপ করুন',
  'upsell.global.limitTitle': 'আপনি',
  'upsell.global.nearLimitMessage':
    'আপনি আপনার ব্যবহার সীমার {pct}% ব্যবহার করেছেন। উচ্চ সীমার জন্য আপগ্রেড করুন।',
  'upsell.global.nearLimitTitle': 'ব্যবহার সীমার কাছাকাছি',
  'upsell.usageLimit.bodyBudget':
    'আপনি সাপ্তাহিক সীমায় পৌঁছেছেন।{reset} সীমা এড়াতে আপনার প্ল্যান আপগ্রেড করুন বা ক্রেডিট টপ আপ করুন।',
  'upsell.usageLimit.bodyRate':
    'আপনি ১০-ঘণ্টার ইনফারেন্স রেট সীমায় পৌঁছেছেন।{reset} উচ্চতর সীমার জন্য আপগ্রেড করুন।',
  'upsell.usageLimit.heading': 'ব্যবহার সীমা পৌঁছেছে',
  'upsell.usageLimit.notNow': 'এখন না',
  'upsell.usageLimit.perWindow': '{amount}',
  'upsell.usageLimit.planIncludes': '{plan}',
  'upsell.usageLimit.resetsIn': 'এটি {time} রিসেট হবে।',
  'upsell.usageLimit.upgradePlan': 'প্ল্যান আপগ্রেড করুন',
  'upsell.usageLimit.weeklyInference': '{amount}',
  'walkthrough.steps.startChat.title': 'চ্যাট থেকে শুরু করুন',
  'walkthrough.steps.startChat.content':
    'চ্যাটই আপনার শুরু করার জায়গা। নতুন উইন্ডো সেটআপের পর দেখা একই শুভেচ্ছা ও দ্রুত কাজ নিয়ে খুলবে।',
  'walkthrough.steps.sayHello.title': 'শুভেচ্ছা জানান',
  'walkthrough.steps.sayHello.content':
    'যেকোনো সময় আপনার AI সহকারীর সঙ্গে কথা শুরু করতে এখানে চাপুন।',
  'walkthrough.steps.meetAi.title': 'আপনার AI-কে জানুন',
  'walkthrough.steps.meetAi.content':
    'কথোপকথন এখানেই হয়। প্রশ্ন করুন, সারাংশ নিন বা ভাবনা গুছান। সবকিছু খুঁজে পাওয়া যায়।',
  'walkthrough.steps.connectWorld.title': 'আপনার জগৎ যুক্ত করুন',
  'walkthrough.steps.connectWorld.content':
    'Gmail, Slack, WhatsApp এবং আরও অনেক কিছু: প্রতিটি সংযোগ আপনার সহকারীকে নতুন ক্ষমতা দেয়।',
  'walkthrough.steps.messagingApps.title': 'যেখানে আছেন সেখানেই চ্যাট করুন',
  'walkthrough.steps.messagingApps.content':
    'WhatsApp, Telegram, Slack, Discord যুক্ত করুন, যাতে সহকারী আপনাকে যেকোনো জায়গায় পৌঁছাতে পারে।',
  'walkthrough.steps.settings.title': 'নিজের মতো সাজান',
  'walkthrough.steps.settings.content':
    'পছন্দ, গোপনীয়তা ও নোটিফিকেশন এখানে আছে। এই পেজ থেকে যেকোনো সময় ট্যুরটি আবার শুরু করতে পারেন।',
  'walkthrough.steps.chatTab.title': 'চ্যাটে ফিরে যান',
  'walkthrough.steps.chatTab.content': 'কথোপকথনে ফিরতে চাইলে Chat ট্যাব ব্যবহার করুন।',
  'walkthrough.steps.humanTab.title': 'আপনার Human প্রোফাইল দেখুন',
  'walkthrough.steps.humanTab.content':
    'Human আপনার ব্যক্তিগত প্রসঙ্গ, পরিচয় এবং সহকারীর দেখা প্রোফাইল একত্র করে।',
  'walkthrough.steps.brainTab.title': 'আপনার Brain খুলুন',
  'walkthrough.steps.brainTab.content':
    'Brain হলো মেমোরি গ্রাফ: OpenHuman কী জানে এবং ধারণাগুলো কীভাবে যুক্ত তা দেখার জায়গা।',
  'walkthrough.steps.agentWorldTab.title': 'Agent World ঘুরে দেখুন',
  'walkthrough.steps.agentWorldTab.content':
    'Agent World-এ পুনরায় ব্যবহারযোগ্য এজেন্ট ও শেয়ার করা অটোমেশন থাকে।',
  'walkthrough.steps.connectionsTab.title': 'সংযোগ পরিচালনা করুন',
  'walkthrough.steps.connectionsTab.content':
    'সেবা যোগ বা বদলাতে চাইলে Connections সবসময় প্রধান নেভিগেশনে থাকে।',
  'walkthrough.steps.feedbackTab.title': 'মতামত পাঠান',
  'walkthrough.steps.feedbackTab.content':
    'Feedback সমস্যা জানানো বা উন্নতির অনুরোধ করার সরাসরি জায়গা।',
  'walkthrough.steps.allSet.title': 'সব প্রস্তুত!',
  'walkthrough.steps.allSet.content':
    'আপনার সহকারী একটি স্বাগত নোট রেখে গেছে: এখানে আপনি চ্যাট করতে, প্রশ্ন করতে বা ধারণা গুছাতে পারেন। উপভোগ করুন!',
  'walkthrough.tooltip.letsGo': 'চলুন শুরু করি!',
  'walkthrough.tooltip.next': 'পরবর্তী →',
  'walkthrough.tooltip.skip': 'ট্যুর এড়িয়ে যান',
  'walkthrough.tooltip.stepCounter': '{total}-এর মধ্যে {n}',
  'webhooks.activity.empty': 'খালি',
  'webhooks.activity.title': 'সাম্প্রতিক কার্যক্রম',
  'webhooks.composioHistory.empty': 'খালি',
  'webhooks.composioHistory.metadataId': 'মেটাডেটা ID',
  'webhooks.composioHistory.metadataUuid': 'মেটাডেটা UUID',
  'webhooks.composioHistory.payload': 'পেলোড',
  'webhooks.composioHistory.title': 'ComposeIO ট্রিগার ইতিহাস',
  'webhooks.tunnels.active': 'সক্রিয়',
  'webhooks.tunnels.createFailed': 'টানেল তৈরি করতে ব্যর্থ',
  'webhooks.tunnels.creating': 'তৈরি হচ্ছে...',
  'webhooks.tunnels.deleteFailed': 'টানেল মুছতে ব্যর্থ',
  'webhooks.tunnels.descriptionPlaceholder': 'বিবরণ (ঐচ্ছিক)',
  'webhooks.tunnels.echo': 'ইকো',
  'webhooks.tunnels.empty': 'খালি',
  'webhooks.tunnels.enableEcho': 'ইকো চালু করুন',
  'webhooks.tunnels.inactive': 'নিষ্ক্রিয়',
  'webhooks.tunnels.namePlaceholder': 'টানেলের নাম (যেমন telegram-bot)',
  'webhooks.tunnels.newTunnel': 'নতুন টানেল',
  'webhooks.tunnels.removeEcho': 'ইকো সরান',
  'webhooks.tunnels.title': 'Webhook টানেল',
  'webhooks.tunnels.toggleFailed': 'ইকো টগল করতে ব্যর্থ',
  'composio.directModeRequiresKey': 'সংরক্ষণ ব্যর্থ। Direct মোডের জন্য একটি API key প্রয়োজন।',
  'composio.integrationSlugsHelp': 'কমা-বিচ্ছিন্ন ইন্টিগ্রেশন স্লাগ, যেমন',
  'composio.integrationSlugsExample': 'gmail, slack',
  'composio.integrationSlugsCaseInsensitive': 'কেস-সংবেদনশীল।',
  'composio.integrationSlugsPlaceholder': 'gmail, slack, ...',
  'composio.notYetRouted': 'এখনও রুট করা হয়নি',
  'composio.triggers.loading': 'লোড হচ্ছে…',
  'conversations.taskKanban.todo': 'করণীয়',
  'chat.addReaction': 'প্রতিক্রিয়া যোগ করুন',
  'chat.agentProfile.create': 'এজেন্ট প্রোফাইল তৈরি করুন',
  'chat.agentProfile.createFailed': 'এজেন্ট প্রোফাইল তৈরি করা যায়নি।',
  'chat.agentProfile.customDescription': 'কাস্টম এজেন্ট প্রোফাইল',
  'chat.agentProfile.defaultAgentLabel': 'অর্কেস্ট্রেটর',
  'chat.agentProfile.exists': 'এজেন্ট প্রোফাইল "{name}" ইতিমধ্যেই বিদ্যমান৷',
  'chat.agentProfile.label': 'এজেন্ট প্রোফাইল',
  'chat.agentProfile.quick': 'দ্রুত',
  'chat.agentProfile.reasoning': 'যুক্তি',
  'chat.agentProfile.namePlaceholder': 'প্রোফাইল নাম',
  'chat.agentProfile.promptStylePlaceholder': 'প্রম্পট স্টাইল',
  'chat.agentProfile.allowedToolsPlaceholder': 'অনুমোদিত টুল',
  'chat.backToThread': '{title} এ ফিরে যান',
  'chat.parentThread': 'মূল থ্রেড',
  'chat.removeReaction': '{emoji}',
  'settings.composio.loading': 'লোড হচ্ছে…',
  'settings.mascot.noCharactersAvailable': 'কোনো OpenHuman ক্যারেক্টার এখনও উপলব্ধ নেই',
  'skills.uninstall.confirmTitle': '{name} আনইনস্টল করবেন?',
  'conversations.taskKanban.blocked': 'ব্লকড',
  'conversations.taskKanban.done': 'সম্পন্ন',
  'conversations.taskKanban.pending': 'অসমাপ্ত',
  'conversations.taskKanban.working': 'কাজের',
  'conversations.taskKanban.awaitingApproval': 'অপেক্ষা করা',
  'conversations.taskKanban.ready': 'প্রস্তুত',
  'conversations.taskKanban.rejected': 'প্রত্যাখ্যান করা হয়েছে',
  'conversations.taskKanban.inProgress': 'চলমান',
  'conversations.taskKanban.awaitingApprovalColumn': 'অনুমোদনের অপেক্ষায়',
  'conversations.taskKanban.blockedColumn': 'বাধাপ্রাপ্ত',
  'conversations.taskKanban.evidenceBadge': 'প্রমাণ ({count})',
  'conversations.taskKanban.needsInput': 'এই কাজগুলোর জন্য আপনার মতামত প্রয়োজন',
  'conversations.taskKanban.emptyColumn': 'কোনো কাজ নেই',
  'conversations.taskKanban.dragHint': 'কলামের মধ্যে সরাতে টেনে আনুন',
  'conversations.taskKanban.movingCard': 'সরানো হচ্ছে…',
  'conversations.taskKanban.statusBadge.ready': 'শুরু করতে প্রস্তুত',
  'conversations.taskKanban.statusBadge.rejected': 'প্রত্যাখ্যাত',
  'intelligence.memoryChunk.detail.copiedHint': 'কপি হয়েছে',
  'settings.composio.notYetRouted': 'এখনও রুট করা হয়নি',
  'settings.localModel.download.manageExternal': 'আপনার বাহ্যিক রানটাইমে এই মডেলটি পরিচালনা করুন।',
  'settings.localModel.status.manageOllamaExternal':
    'OpenHuman-এর বাইরে Ollama প্রক্রিয়া এবং মডেল পুল পরিচালনা করুন, তারপর ডায়াগনস্টিক পুনরায় চালান।',
  'settings.localModel.status.ollamaDocs': 'Ollama ডকস',
  'settings.localModel.status.thenRetry':
    'সেটআপ নির্দেশনার জন্য, তারপর আপনার রানটাইম পৌঁছানো গেলে পুনরায় চেষ্টা করুন।',
  'devOptions.menuAi': 'AI কনফিগারেশন',
  'devOptions.menuAiDesc': 'ক্লাউড প্রদানকারী, স্থানীয় Ollama মডেল, এবং প্রতি-ওয়ার্কলোড রাউটিং',
  'devOptions.menuMessaging': 'মেসেজিং চ্যানেলগুলি',
  'devOptions.menuMessagingDesc':
    'কনফিগার করুন Telegram/Discord প্রমাণীকরণ মোড এবং ডিফল্ট চ্যানেল রাউটিং',
  'devOptions.menuTools': 'টুলগুলি',
  'devOptions.menuToolsDesc':
    'টুলগুলি [[I18N_SEP_92731] BR__7 সক্ষম করতে সক্ষম]__3 সক্ষম করতে পারে। আপনার পক্ষে ব্যবহার করুন',
  'devOptions.menuAgentChat': 'এজেন্ট চ্যাট',
  'devOptions.menuAgentChatDesc': 'মডেল এবং তাপমাত্রা ওভাররাইডের সাথে পরীক্ষা এজেন্ট কথোপকথন',
  'devOptions.menuCronJobs': 'ক্রোন জবস',
  'devOptions.menuCronJobsDesc': 'কাজের সময়সূচী চালনার সময়সূচী কনফিগার করুন',
  'devOptions.menuLocalModelDebug': 'স্থানীয় মডেল ডিবাগ',
  'devOptions.menuLocalModelDebugDesc':
    'Ollama কনফিগারেশন, সম্পদ ডাউনলোড, মডেল পরীক্ষা, এবং ডায়াগনস্টিকস',
  'devOptions.menuWebhooksDebug': 'ওয়েবহুক',
  'devOptions.menuWebhooksDebugDesc':
    'রানটাইম ওয়েবহুক নিবন্ধন এবং ক্যাপচার করা অনুরোধ লগগুলি পরিদর্শন করুন',
  'devOptions.menuIntelligence': 'বুদ্ধিমত্তা',
  'devOptions.menuIntelligenceDesc': 'মেমরি ওয়ার্কস্পেস, অবচেতন ইঞ্জিন, স্বপ্ন এবং সেটিংস',
  'devOptions.menuNotificationRouting': 'বিজ্ঞপ্তি রাউটিং',
  'devOptions.menuNotificationRoutingDesc': 'এআই গুরুত্ব স্কোরিং এবং অর্কেস্ট্রেটর বৃদ্ধির জন্য',
  'devOptions.menuComposeIOTriggers': 'ComposeIO ট্রিগারগুলি',
  'devOptions.menuComposeIOTriggersDesc': 'ComposeIO ট্রিগার ইতিহাস দেখুন এবং সংরক্ষণাগার',
  'devOptions.menuComposioRouting': 'Composio রাউটিং (ডাইরেক্ট মোড)',
  'devOptions.menuComposioRoutingDesc':
    'আপনার নিজের Composio এবং Composio Composio __বিরুট সরাসরি কল করুন।',
  'devOptions.menuComposioTriggers': 'ইন্টিগ্রেশন ট্রিগার',
  'devOptions.menuComposioTriggersDesc':
    'Composio ইন্টিগ্রেশন ট্রিগারের জন্য AI ট্রাইজ সেটিংস কনফিগার করুন',
  'memory.sourceFilterAria': 'উত্স দ্বারা ফিল্টার',
  'calls.comingSoonDescription': 'AI-সহায়তা কলগুলি শীঘ্রই আসছে৷ সাথে থাকুন।',
  'whatsapp.title': 'WhatsApp',
  'subconscious.priority.critical': 'গুরুত্বপূর্ণ',
  'subconscious.priority.important': 'গুরুত্বপূর্ণ',
  'subconscious.priority.normal': 'স্বাভাবিক',
  'subconscious.durationSeconds': '{seconds}s',
  'subconscious.durationMilliseconds': '{milliseconds}ms',
  'settings.appearance': 'চেহারা',
  'settings.appearanceDesc': 'হালকা, অন্ধকার বাছুন বা আপনার সিস্টেম থিমের সাথে মেলে',
  'settings.mascot': 'মাসকট',
  'settings.mascotDesc': 'অ্যাপের মাস্কট রঙ জুড়ে ব্যবহার করুন',
  'pages.settings.account.walletBalances': 'ওয়ালেট ব্যালেন্স',
  'pages.settings.account.walletBalancesDesc':
    'আপনার স্থানীয় ওয়ালেটের মাল্টি-চেইন ব্যালেন্স দেখুন',
  'walletBalances.title': 'ওয়ালেট ব্যালেন্স',
  'walletBalances.refresh': 'Refresh',
  'walletBalances.loading': 'ব্যালেন্স লোড হচ্ছে…',
  'walletBalances.retry': 'Retry',
  'walletBalances.emptyState':
    'এখনো কোনো ওয়ালেট অ্যাকাউন্ট নেই: Recovery Phrase-এ একটি ওয়ালেট সেটআপ করুন।',
  'walletBalances.copyAddress': 'ঠিকানা কপি করুন',
  'walletBalances.providerMissing': 'প্রোভাইডার অনুপলব্ধ',
  'walletBalances.rawBalance': 'কাঁচা: {raw}',
  'walletBalances.errorGeneric':
    'ওয়ালেট ব্যালেন্স লোড করতে অক্ষম। Recovery Phrase-এ আপনার ওয়ালেট সেটআপ করুন এবং আবার চেষ্টা করুন।',
  'walletBalances.setupHint':
    'আপনার রিকভারি ফ্রেজ এখনও সেট আপ করা হয়নি। আপনার ওয়ালেট সক্রিয় করতে এবং লাইভ ব্যালেন্স দেখতে এটি সেট আপ করুন।',
  'walletBalances.setupCta': 'রিকভারি ফ্রেজ সেট আপ করুন',
  'walletBalances.notSetUp': 'সেট আপ করা হয়নি',
  'walletBalances.send': 'পাঠান',
  'walletBalances.receive': 'গ্রহণ করুন',
  'walletReceive.scanHint': 'তহবিল গ্রহণ করতে এই কোডটি স্ক্যান করুন বা নিচের ঠিকানাটি কপি করুন।',
  'walletReceive.addressLabel': '{network} ঠিকানা',
  'walletReceive.onlyChainWarning':
    'এই ঠিকানায় শুধুমাত্র {network} সম্পদ পাঠান। অন্য নেটওয়ার্কের সম্পদ পাঠালে স্থায়ীভাবে ক্ষতি হতে পারে।',
  'walletSend.available': 'উপলব্ধ',
  'walletSend.recipient': 'প্রাপকের ঠিকানা',
  'walletSend.recipientPlaceholder': 'গন্তব্য ঠিকানা পেস্ট করুন',
  'walletSend.recipientRequired': 'একটি প্রাপকের ঠিকানা লিখুন',
  'walletSend.amount': 'পরিমাণ',
  'walletSend.invalidAmount': 'একটি বৈধ পরিমাণ লিখুন',
  'walletSend.review': 'পর্যালোচনা',
  'walletSend.preparing': 'প্রস্তুত করা হচ্ছে…',
  'walletSend.confirmHint':
    'নিচের বিবরণ পর্যালোচনা করুন। স্বাক্ষর স্থানীয়ভাবে হয়: আপনি নিশ্চিত না করা পর্যন্ত কিছুই সম্প্রচার হয় না।',
  'walletSend.estimatedFee': 'আনুমানিক নেটওয়ার্ক ফি',
  'walletSend.confirmSend': 'নিশ্চিত করে পাঠান',
  'walletSend.sending': 'পাঠানো হচ্ছে…',
  'walletSend.sent': 'লেনদেন পাঠানো হয়েছে',
  'walletSend.txHash': 'লেনদেন হ্যাশ',
  'walletSend.viewExplorer': 'এক্সপ্লোরারে দেখুন',
  'walletSend.done': 'সম্পন্ন',
  'walletSend.genericError': 'স্থানান্তর সম্পূর্ণ করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'settings.taskSources.title': 'কাজের উৎস',
  'settings.integrations.title': 'ইন্টিগ্রেশন',
  'settings.integrations.menuDesc': 'টাস্ক সোর্স, Composio রাউটিং এবং ওয়েবহুক ট্রিগার',
  'settings.taskSources.subtitle': 'আপনার টুল থেকে Tworet পরিচালনা করুন',
  'settings.taskSources.description':
    'GitHub, Notion, Linear, এবং ClickUp থেকে কাজের আইটেম সংগ্রহ করুন, সেগুলো সমৃদ্ধ করুন, এবং এজেন্টের টোডো বোর্ডে রুট করুন।',
  'settings.taskSources.connectHint':
    'আপনার সংযুক্ত অ্যাকাউন্ট ব্যবহার করে কাজের উৎস খুঁজে নিন। প্রথমে তাদের সাথে যোগাযোগ করুন।',
  'settings.taskSources.disabledBanner':
    'কাজের উৎস নিষ্ক্রিয় করা হয়েছে। স্বয়ংক্রিয়ভাবে পোল করার ব্যবস্থা সক্রিয় করা হবে।',
  'settings.taskSources.loadError': 'কাজ লোড করতে ব্যর্থ',
  'settings.taskSources.addTitle': 'কাজ যোগ করুন',
  'settings.taskSources.provider': 'পরিসেবা উপলব্ধকারী',
  'settings.taskSources.name': 'নাম (ঐচ্ছিক)',
  'settings.taskSources.namePlaceholder': 'এক্স.qxqx. আমার খোলা বিষয়গুলো',
  'settings.taskSources.github.repo': 'ডক ( xqxqx, ঐচ্ছিক)',
  'settings.taskSources.github.labels': 'লেবেল (মাউন্ট করা যায় না)',
  'settings.taskSources.notion.database': 'ডাটাবেস (board) আইডি',
  'settings.taskSources.notion.browseDatabases': 'ডেটাবেস ব্রাউজ করুন',
  'settings.taskSources.notion.loadingDatabases': 'ডেটাবেস লোড হচ্ছে…',
  'settings.taskSources.notion.selectDatabase': 'একটি ডেটাবেস নির্বাচন করুন…',
  'settings.taskSources.notion.noDatabases': 'এই সংযোগের জন্য কোনো ডেটাবেস পাওয়া যায়নি।',
  'settings.taskSources.linear.team': 'দল ID (ঐচ্ছিক)',
  'settings.taskSources.clickup.team': 'কর্মক্ষেত্র (ঐচ্ছিক)',
  'settings.taskSources.assignedToMe': 'শুধুমাত্র আমার করা আইটেমগুলি',
  'settings.taskSources.add': 'উৎস যোগ করুন',
  'settings.taskSources.adding': 'যোগ করা হচ্ছে...',
  'settings.taskSources.preview': 'প্রাকদর্শন',
  'settings.taskSources.previewResult': 'এই ফিল্টারের জন্য xqxqx প্রচেষ্টা করুন',
  'settings.taskSources.fetchNow': 'এখন নিয়ে এসো',
  'settings.taskSources.fetching': 'প্রাপ্ত করা হচ্ছে...',
  'settings.taskSources.fetchResult':
    '{fetched}টি কাজের মধ্যে {routed}টি রাউট করা হয়েছে; {pruned}টি পুরোনো কাজ সরানো হয়েছে',
  'settings.taskSources.syncAll': 'সব সিঙ্ক করুন',
  'settings.taskSources.syncing': 'সিঙ্ক হচ্ছে...',
  'settings.taskSources.configured': '%d-টি উৎসস্থল কনফিগার করুন',
  'settings.taskSources.empty': 'কোনো কর্ম কনফিগার করা হয়নি।',
  'settings.taskSources.proactive': 'আকর্ষণীয়',
  'settings.taskSources.lastFetch': 'সর্বশেষ প্রাপ্ত',
  'settings.taskSources.never': 'কখনো নয়',
  'settings.taskSources.statusEnabled': 'সক্রিয়',
  'settings.taskSources.statusDisabled': 'নিষ্ক্রিয়',
  'settings.taskSources.enable': 'সক্রিয় করুন',
  'settings.taskSources.disable': 'নিষ্ক্রিয়',
  'settings.taskSources.remove': 'মুছে ফেলুন',
  'settings.taskSources.removeConfirm':
    'এই কাজটি মুছে ফেলা হবে কি? সকল পূর্ববর্তী তথ্য মুছে ফেলা হবে এবং তা উদ্ধার করা যাবে না।',
  'settings.taskSources.refresh': 'নতুন করে প্রদর্শন',
  'settings.taskSources.providers.github': 'GitHub',
  'settings.taskSources.providers.notion': 'সংযোগ',
  'settings.taskSources.providers.linear': 'লিনিয়ার',
  'settings.taskSources.providers.clickup': 'উপরে ক্লিক করুন',
  'skills.dashboard.enable': 'নির্ধারিত ওয়ার্কফ্লো সক্রিয় করুন',
  'skills.dashboard.disable': 'নির্ধারিত ওয়ার্কফ্লো নিষ্ক্রিয় করুন',
  'skills.dashboard.lastRun': 'শেষ চালানো',
  'skills.dashboard.nextRun': 'পরবর্তী চালানো',
  'skills.dashboard.cardOpenRunner': 'রানারে খুলুন',
  'skills.new.title': 'একটি ওয়ার্কফ্লো তৈরি করুন',
  'settings.agents.title': 'এজেন্ট',
  'settings.agents.subtitle':
    'প্রতিনিধিদের জন্য উপলব্ধ এজেন্টগুলো তৈরি করা হয় – ডিফল্ট এবং আপনার নিজস্ব কাস্টম এজেন্টদের জন্য।',
  'settings.agents.menuDesc': 'প্লাগ-ইন ও স্বনির্ধারিত এজেন্ট পরিচালনা করুন',
  'settings.agents.newAgent': 'নতুন এজেন্ট',
  'settings.agents.loadError': 'এজেন্ট লোড করতে ব্যর্থ',
  'settings.agents.empty': 'এখনো কোন এজেন্ট নেই',
  'settings.agents.sourceDefault': 'অন্তর্ভুক্ত',
  'settings.agents.sourceCustom': 'স্বনির্ধারিত',
  'settings.agents.enable': 'সক্রিয় করা হবে',
  'settings.agents.disable': 'নিষ্ক্রিয় করুন',
  'settings.agents.edit': 'সম্পাদনা',
  'settings.agents.delete': 'Delete',
  'settings.agents.reset': 'ডিফল্ট মান পুনরায় স্থাপন করুন',
  'settings.agents.modelLabel': 'মডেল',
  'settings.agents.toolsLabel': 'সরঞ্জাম',
  'settings.agents.toolsAll': 'সকল টুল',
  'settings.agents.toolsCount': 'xqxqx টুল',
  'settings.agents.actionFailed': 'কর্ম আপডেট করা যায়নি',
  'settings.agents.orchestratorLocked': 'অর্কেস্ট্রা সবসময় সক্রিয় থাকে.',
  'settings.agents.editor.createTitle': 'নতুন এজেন্ট',
  'settings.agents.editor.editTitle': 'এজেন্ট সম্পাদনা',
  'settings.agents.editor.id': 'ID',
  'settings.agents.editor.idHint': 'ছোট অক্ষর, সংখ্যা, এবং - শুধুমাত্র।',
  'settings.agents.editor.name': 'নাম',
  'settings.agents.editor.description': 'বিবরণ',
  'settings.agents.editor.model': 'মডেল (ঐচ্ছিক)',
  'settings.agents.editor.modelPlaceholder': 'xqxqx; এর উত্তর, ইঙ্গিত: fast, অথবা একটি মডেল',
  'settings.agents.editor.systemPrompt': 'সিস্টেম প্রম্পট (ঐচ্ছিক)',
  'settings.agents.editor.tools': 'ব্যবহারের জন্য চিহ্নিত সামগ্রী',
  'settings.agents.editor.toolsHint':
    'প্রতিটি রেখার জন্য একটি টুল-নেম * সব হাতিয়ারের জন্য * ব্যবহার করুন ।',
  'settings.agents.editor.defaultsNote':
    'একটি নির্মিত ইন-ইন এজেন্ট সম্পাদনা করে আপনি পরে পুনরায় নির্ধারণ করতে পারবেন।',
  'settings.agents.editor.save': 'সংরক্ষণ',
  'settings.agents.editor.create': 'নির্মাণ করুন',
  'settings.agents.editor.saving': 'ইনস্টল করা হয়েছে...',
  'nav.workflows': 'Workflows',
  'workflows.title': 'ওয়ার্কফ্লো',
  'workflows.subtitle':
    'পুনর্ব্যবহারযোগ্য, চালানোযোগ্য প্রক্রিয়া: একটি লক্ষ্য এবং তা অর্জনের ধাপগুলো। একটি তৈরি করুন, URL থেকে ইনস্টল করুন, বা চালানোর জন্য ওয়ার্কফ্লো খুলুন।',
  'workflows.createNew': 'নতুন ওয়ার্কফ্লো',
  'workflows.listHeading': 'Workflows',
  'workflows.delete': 'ওয়ার্কফ্লো মুছুন',
  'workflows.deleteError': 'ওয়ার্কফ্লো মুছতে ব্যর্থ',
  'workflows.warnings': '{count} সতর্কতা',
  'workflows.empty.title': 'এখনো কোনো ওয়ার্কফ্লো নেই',
  'workflows.empty.body':
    'টাস্ক জীবনচক্র পর্যায়ের জন্য নিয়ম ও স্ক্রিপ্ট সংজ্ঞায়িত করতে ওয়ার্কফ্লো তৈরি করুন।',
  'workflows.create.title': 'নতুন ওয়ার্কফ্লো',
  'workflows.create.subtitle': 'এজেন্টের জন্য জীবনচক্র-সংযুক্ত নিয়ম সেট সংজ্ঞায়িত করুন।',
  'workflows.create.name': 'Name',
  'workflows.create.namePlaceholder': 'যেমন Python প্রকল্প ওয়ার্কফ্লো',
  'workflows.create.description': 'Description',
  'workflows.create.descriptionPlaceholder': 'এই ওয়ার্কফ্লো কী করে?',
  'workflows.create.whenToUse': 'কখন ব্যবহার করবেন',
  'workflows.create.whenToUsePlaceholder': 'এজেন্ট কখন এই ওয়ার্কফ্লো নেবে?',
  'workflows.create.optional': '(ঐচ্ছিক)',
  'workflows.create.createBtn': 'ওয়ার্কফ্লো তৈরি করুন',
  'workflows.create.creating': 'Creating…',
  'workflows.create.createError': 'ওয়ার্কফ্লো তৈরি করা যায়নি',
  'workflows.create.successTitle': 'ওয়ার্কফ্লো তৈরি হয়েছে',
  'workflows.create.successMessage': 'সফলভাবে তৈরি হয়েছে।',
  'workflows.deleteConfirm.title': 'ওয়ার্কফ্লো মুছুন',
  'workflows.deleteConfirm.body': '"{name}" সরাবেন? এটি পূর্বাবস্থায় ফেরানো যাবে না।',
  'workflows.detail.tags': 'Tags',
  'workflows.detail.location': 'Location',
  'workflows.detail.warnings': 'Warnings',
  'workflows.detail.phases': 'Phases',
  'workflows.detail.noPhases': 'কোনো পর্যায় সংজ্ঞায়িত নেই।',
  'workflows.detail.loadError': 'সম্পূর্ণ ওয়ার্কফ্লো লোড করতে ব্যর্থ',
  'workflows.phase.rules': 'Rules',
  'workflows.phase.rules.empty': 'কোনো নিয়ম নেই।',
  'workflows.phase.scripts': 'Scripts',
  'workflows.phase.scripts.empty': 'কোনো স্ক্রিপ্ট নেই।',
  'workflows.phase.toolScope': 'টুল স্কোপ',
  'workflows.phase.toolScope.allow': 'Allow',
  'workflows.phase.toolScope.deny': 'Deny',
  'workflows.phase.toolScope.inherited': 'ওয়ার্কফ্লো ডিফল্ট থেকে উত্তরাধিকারসূত্রে প্রাপ্ত।',
  'workflows.phase.toolScope.empty': 'কোনো টুল সীমাবদ্ধতা নেই।',
  'workflows.phase.context': 'Context',
  'workflows.phase.context.empty': 'কোনো কনটেক্সট প্রদানকারী নেই।',
  'settings.agentsSection.title': 'Agents',
  'settings.agentsSection.description':
    'আপনার এজেন্ট, তাদের স্বায়ত্তশাসন এবং এই কম্পিউটারে তারা কী অ্যাক্সেস করতে পারে তা পরিচালনা করুন।',
  'settings.agentsSection.menuDesc': 'রেজিস্ট্রি, স্বায়ত্তশাসন ও ওএস অ্যাক্সেস',
  'settings.cryptoSection.title': 'ক্রিপ্টো',
  'settings.cryptoSection.description':
    'আপনার রিকভারি ফ্রেজ পরিচালনা করুন এবং আপনার ওয়ালেট অ্যাকাউন্টগুলির ব্যালেন্স দেখুন।',
  'settings.cryptoSection.menuDesc': 'রিকভারি ফ্রেজ ও ওয়ালেট ব্যালেন্স',
  'settings.notificationsHub.title': 'বিজ্ঞপ্তি',
  'settings.notificationsHub.description':
    'আপনার অ্যালার্ট ইনবক্স দেখুন এবং বিজ্ঞপ্তির পছন্দ ও রাউটিং পরিচালনা করুন।',
  'settings.notificationsHub.menuDesc': 'অ্যালার্ট ইনবক্স ও বিজ্ঞপ্তির পছন্দ',
  'settings.notificationsHub.settingsItem': 'বিজ্ঞপ্তি সেটিংস',
  'settings.notificationsHub.settingsItemDesc': 'পছন্দ ও রাউটিং',
  'settings.agents.editor.notFound': 'এজেন্ট পাওয়া যায়নি।',
  'settings.agents.editor.modelInherit': 'উত্তরাধিকার (প্ল্যাটফর্ম ডিফল্ট)',
  'settings.agents.editor.modelHints': 'রুট হিন্টস',
  'settings.agents.editor.modelTiers': 'মডেল স্তর',
  'settings.agents.editor.modelCustom': 'কাস্টম মডেল আইডি…',
  'settings.agents.editor.modelCustomPlaceholder': 'যেমন anthropic/claude-sonnet-4',
  'settings.agents.editor.selectTools': 'টুল যোগ করুন',
  'settings.agents.editor.toolsAllSelected': 'সব টুল',
  'settings.agents.editor.toolsNoneSelected': 'কোনো টুল নির্বাচিত নয়',
  'settings.agents.editor.removeToolAria': '{tool} সরান',
  'settings.agents.editor.toolsModalTitle': 'অনুমোদিত টুল',
  'settings.agents.editor.toolsSelectedCount': '{count}টি নির্বাচিত',
  'settings.agents.editor.toolsSearchPlaceholder': 'টুল খুঁজুন…',
  'settings.agents.editor.toolsAllowAll': 'সব টুল অনুমতি দিন (*)',
  'settings.agents.editor.toolsAllowAllHint': 'এই এজেন্ট প্রতিটি উপলব্ধ টুল ব্যবহার করতে পারে।',
  'settings.agents.editor.toolsLoading': 'টুল লোড হচ্ছে…',
  'settings.agents.editor.toolsLoadError': 'টুল লোড করা যায়নি',
  'settings.agents.editor.toolsEmpty': 'আপনার অনুসন্ধানের সাথে কোনো টুল মেলে না।',
  'settings.agents.editor.toolsDone': 'Done',
  'settings.agents.editor.builtInReadonly':
    'বিল্ট-ইন এজেন্ট সম্পাদনা করা যাবে না। আপনি এজেন্ট তালিকা থেকে সেগুলো সক্রিয়, নিষ্ক্রিয় বা পুনরায় সেট করতে পারেন।',
  // Chat: agent-generated artifacts (#2779)
  'chat.artifact.aria': 'আর্টিফ্যাক্ট: {title}',
  'chat.artifact.generating': '{kind} তৈরি হচ্ছে…',
  'chat.artifact.ready': 'প্রস্তুত',
  'chat.artifact.failed': 'তৈরি ব্যর্থ হয়েছে',
  'chat.artifact.download': 'ডাউনলোড',
  'chat.artifact.downloading': 'ডাউনলোড হচ্ছে…',
  'chat.artifact.downloaded': '{path} এ সংরক্ষিত',
  'chat.artifact.download_failed': 'ডাউনলোড ব্যর্থ: {reason}',
  'chat.artifact.retry': 'পুনরায় চেষ্টা',
  'chat.artifact.reveal': 'ফোল্ডারে দেখান',
  'chat.artifact.show_more': 'আরও দেখুন',
  'chat.artifact.show_less': 'কম দেখুন',

  // Chat: files panel (#3024)
  'chat.files.chip.aria.one': 'এই চ্যাটে {count}টি ফাইল',
  'chat.files.chip.aria.other': 'এই চ্যাটে {count}টি ফাইল',
  'chat.files.panel.aria': 'এই চ্যাটের ফাইল',
  'chat.files.panel.title': 'ফাইল ({count})',
  'chat.files.panel.empty': 'এখনো কোনো ফাইল নেই। এজেন্টকে একটি তৈরি করতে বলুন।',
  'chat.files.panel.close': 'ফাইল প্যানেল বন্ধ করুন',
  'chat.files.delete.aria': '{title} মুছুন',
  'chat.files.delete.confirm': 'এই ফাইলটি মুছবেন?',
  'chat.files.delete.cancel': 'বাতিল',
  'chat.files.delete.action': 'মুছুন',
  'chat.files.delete.failed': 'ফাইল মোছা যায়নি। আবার চেষ্টা করুন।',
  'chat.files.error.not_desktop': 'ডাউনলোড শুধুমাত্র ডেস্কটপ অ্যাপে উপলব্ধ।',
  'chat.files.error.missing_artifact_id': 'আর্টিফ্যাক্ট আইডি অনুপস্থিত।',
  'chat.files.error.missing_artifact_path': 'কোর প্রতিক্রিয়া থেকে আর্টিফ্যাক্ট পথ অনুপস্থিত।',
  'chat.files.error.resolve_failed': 'আর্টিফ্যাক্ট সমাধান করা যায়নি। আবার চেষ্টা করুন।',
  'chat.files.error.download_failed': 'ডাউনলোড ব্যর্থ হয়েছে। আবার চেষ্টা করুন।',
  'chat.files.error.delete_failed': 'ফাইল মোছা যায়নি। আবার চেষ্টা করুন।',
  'memory.tab.council': 'Council',
  'activity.tabs.automations': 'অটোমেশন',
  'activity.tabs.automationsDescription':
    'পুনর্ব্যবহারযোগ্য, রানযোগ্য পদ্ধতি: একটি লক্ষ্য এবং সেখানে পৌঁছানোর ধাপগুলি।',
  'activity.tabs.backgroundActivity': 'সাবকনশাস',
  'activity.tabs.alerts': 'সতর্কতা',

  'intelligence.agents.title': 'এজেন্ট লাইব্রেরি',
  'intelligence.agents.subtitle':
    'চালানো যায় এমন বিশেষজ্ঞদের দেখুন এবং নির্দিষ্ট এজেন্টকে একটি কাজ পাঠান।',
  'intelligence.agents.refresh': 'রিফ্রেশ',
  'intelligence.agents.loading': 'এজেন্ট লোড হচ্ছে…',
  'intelligence.agents.failedToLoad': 'এজেন্ট লোড করা যায়নি',
  'intelligence.agents.empty': 'চালানোর মতো কোনো এজেন্ট নেই।',
  'intelligence.agents.readOnly': 'শুধু পড়া',
  'intelligence.agents.writeCapable': 'লিখতে পারে',
  'intelligence.agents.allTools': 'সব টুল',
  'intelligence.agents.toolCountOne': '{count} টুল',
  'intelligence.agents.toolCountOther': '{count} টুল',
  'intelligence.agents.subagentCountOne': '{count} সাব-এজেন্ট',
  'intelligence.agents.subagentCountOther': '{count} সাব-এজেন্ট',
  'intelligence.agents.startChat': 'চ্যাট শুরু করুন',
  'intelligence.agents.startChatPrompt':
    'এই এজেন্টের সঙ্গে চ্যাট শুরু করুন। নিজের বিশেষত্ব জানান, কী জানা দরকার জিজ্ঞেস করুন, তারপর আমার কাজের অপেক্ষা করুন।',
  'intelligence.agents.copyId': 'ID কপি করুন',
  'intelligence.agents.copied': 'কপি হয়েছে',
  'intelligence.agents.taskPlaceholder': 'এই এজেন্টের কাজ',
  'intelligence.agents.runTask': 'কাজ চালান',
  'intelligence.agents.running': 'চলছে…',
  'intelligence.agents.runFailed': 'নির্বাচিত এজেন্ট শুরু করা যায়নি',
  'intelligence.agents.model.inherit': 'উত্তরাধিকার',
  'intelligence.agents.tier.chat': 'চ্যাট',
  'intelligence.agents.tier.reasoning': 'যুক্তি',
  'intelligence.agents.tier.worker': 'ওয়ার্কার',
  'graphCohesion.brokerBadge': 'ব্রোকার',
  'graphCohesion.brokerTitle':
    'কাঠামোগত ছিদ্র: এই সত্তার প্রতিবেশীরা একে অপরের সাথে যুক্ত নয়: এটিই তাদের মধ্যে একমাত্র সংযোগ।',
  'graphCohesion.colCohesion': 'সংসক্তি',
  'graphCohesion.colEntity': 'সত্তা',
  'graphCohesion.colLinks': 'লিঙ্ক',
  'graphCohesion.colRank': '#',
  'graphCohesion.empty': 'এখনও কোনো জ্ঞান গ্রাফ নেই।',
  'graphCohesion.emptyHint':
    'সহকারী যখন আপনার সম্পর্কে সংযুক্ত তথ্য রেকর্ড করে, তাদের ক্লাস্টারিং কাঠামো এখানে উঠে আসবে।',
  'graphCohesion.errorPrefix': 'গ্রাফ লোড করা যায়নি:',
  'graphCohesion.intro':
    'প্রতিটি সত্তার চারপাশে প্রতিবেশ কতটা দৃঢ়ভাবে বোনা। ব্রোকার (যেসব সত্তার প্রতিবেশী একে অপরের সাথে যুক্ত নয়) তারাই একমাত্র বিন্দু যা পরস্পর-বিচ্ছিন্ন ক্লাস্টারকে একত্রে ধরে রাখে, যা ফ্রিকোয়েন্সি বা PageRank সাজানি প্রকাশ করতে পারে না।',
  'graphCohesion.loading': 'সংসক্তি গণনা করা হচ্ছে…',
  'graphCohesion.metricConnections': 'সংযোগ',
  'graphCohesion.metricEntities': 'সত্তা',
  'graphCohesion.metricTriangles': 'ত্রিভুজ',
  'graphCohesion.namespaceAll': 'সমস্ত নেমস্পেস',
  'graphCohesion.namespaceLabel': 'নেমস্পেস',
  'graphCohesion.noBrokers': 'এখনও দুই বা তার বেশি সংযোগওয়ালা কোনো সত্তা নেই।',
  'graphCohesion.rankedHeading': 'ব্রোকার: সবচেয়ে শিথিল প্রতিবেশ',
  'graphCohesion.retry': 'পুনরায় চেষ্টা',
  'graphCohesion.summaryCaption': 'গড় ক্লাস্টারিং {avg} · সংক্রমণতা {transitivity}',
  'graphCohesion.title': 'গ্রাফ সংসক্তি',
  'memory.tab.cohesion': 'Cohesion',

  // Keyring consent & security
  'harnessInit.title': 'সেটআপ করা হচ্ছে',
  'announcement.gotIt': 'বুঝেছি',
  'harnessInit.subtitle': 'প্রথম চালুর সময় OpenHuman প্রয়োজনীয় উপাদানগুলো প্রস্তুত করছে।',
  'harnessInit.stepPython': 'Python রানটাইম',
  'harnessInit.stepSpacy': 'ভাষা মডেল',
  'harnessInit.stepNode': 'Node.js রানটাইম',
  'harnessInit.statePending': 'অপেক্ষমাণ',
  'harnessInit.stateRunning': 'ইনস্টল করা হচ্ছে…',
  'harnessInit.stateDone': 'প্রস্তুত',
  'harnessInit.stateSkipped': 'এড়িয়ে যাওয়া হয়েছে',
  'harnessInit.stateFailed': 'ব্যর্থ',
  'harnessInit.failedMessage':
    'কিছু সেটআপ ধাপ সম্পন্ন হয়নি। আপনি পুনরায় চেষ্টা করতে পারেন, অথবা চালিয়ে যেতে পারেন: OpenHuman একটি অন্তর্নির্মিত ফলব্যাক ব্যবহার করবে।',
  'harnessInit.retry': 'পুনরায় চেষ্টা করুন',
  'harnessInit.continueAnyway': 'তবুও চালিয়ে যান',
  'harnessInit.runInBackground': 'ব্যাকগ্রাউন্ডে চালান',
  'harnessInit.backgroundHint':
    'এটি শেষ হওয়া পর্যন্ত আপনি OpenHuman ব্যবহার করা চালিয়ে যেতে পারেন।',

  'keyring.consent.title': 'নিরাপদ সঞ্চয়স্থান অনুপলব্ধ',
  'keyring.consent.description':
    'আপনার অপারেটিং সিস্টেমের কিচেন অ্যাক্সেসযোগ্য নয়। OpenHuman-এর পরিবর্তে স্থানীয় এনক্রিপ্টেড সঞ্চয়স্থান ব্যবহার করে গোপনীয়তা সংরক্ষণ করতে আপনার অনুমতি প্রয়োজন।',
  'keyring.consent.reasonPrefix': 'কারণ:',
  'keyring.consent.showDetails': 'এটার মানে কী?',
  'keyring.consent.hideDetails': 'বিবরণ লুকান',
  'keyring.consent.tradeoffTitle': 'নিরাপত্তা বিনিময়',
  'keyring.consent.tradeoffBody':
    'স্থানীয় এনক্রিপ্টেড সঞ্চয়স্থানে, আপনার গোপনীয়তা ডিস্কে একটি মাস্টার কী দিয়ে এনক্রিপ্ট করা হয় যা ডেটার পাশাপাশি সংরক্ষিত থাকে। এটি OS কিচেনের চেয়ে কম নিরাপদ, যা হার্ডওয়্যার-সমর্থিত সুরক্ষা ব্যবহার করে। ব্যাকআপ বা ফাইল সিঙ্কিংয়ে এনক্রিপ্টেড ডেটা অন্তর্ভুক্ত হতে পারে।',
  'keyring.consent.consentButton': 'স্থানীয় এনক্রিপ্টেড সঞ্চয়স্থান ব্যবহার করুন',
  'keyring.consent.retryButton': 'OS Keychain পুনরায় চেষ্টা করুন',
  'keyring.consent.declineButton': 'প্রত্যাখ্যান করুন',
  'keyring.consent.retrying': 'পুনরায় চেষ্টা হচ্ছে…',
  'keyring.consent.error': 'পছন্দ সংরক্ষণ ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।',
  'keyring.consent.retryFailed': 'কিচেন এখনও অনুপলব্ধ।',
  'keyring.settings.title': 'নিরাপত্তা',
  'keyring.settings.storageMode': 'গোপনীয়তা সঞ্চয়স্থান মোড',
  'keyring.settings.mode.osKeychain': 'OS কীচেইন',
  'keyring.settings.mode.encryptedFile': 'স্থানীয় এনক্রিপ্টেড',
  'keyring.settings.mode.consentPending': 'কনফিগার করা হয়নি',
  'keyring.settings.mode.declined': 'প্রত্যাখ্যান করা হয়েছে',
  'keyring.settings.availability': 'কিচেন প্রাপ্যতা',
  'keyring.settings.available': 'OS কিচেন উপলব্ধ',
  'keyring.settings.unavailable': 'OS কিচেন অনুপলব্ধ',
  'keyring.settings.backend': 'ব্যাকএন্ড',
  'keyring.settings.retryButton': 'কিচেন সনাক্তকরণ পুনরায় চেষ্টা করুন',
  'keyring.settings.retryFailed': 'পুনরায় চেষ্টা ব্যর্থ। কিচেন এখনও অনুপলব্ধ।',
  'keyring.settings.consentTitle': 'সঞ্চয়স্থান সম্মতি',
  'keyring.settings.consentDescription':
    'OS কিচেন অনুপলব্ধ থাকলে গোপনীয়তা কীভাবে সংরক্ষণ করা হবে তা বেছে নিন।',
  'keyring.settings.grantConsent': 'স্থানীয় এনক্রিপ্টেড সঞ্চয়স্থান অনুমতি দিন',
  'keyring.settings.revokeConsent': 'স্থানীয় সঞ্চয়স্থান প্রত্যাখ্যান করুন',
  'pages.settings.account.security': 'নিরাপত্তা',
  'pages.settings.account.securityDesc': 'গোপনীয়তা সঞ্চয়স্থান মোড এবং কিচেন অবস্থা',
  // #002 memory-pipeline-hardening: degraded badges + typed remediation.
  'memoryTree.status.statusDegraded': 'অবনমিত',
  'memoryTree.status.statusBudgetExhausted': 'বিরতি: এমবেডিং বাজেট শেষ',
  'memoryTree.status.degradedRecall': 'সিম্যান্টিক রিকল নিষ্ক্রিয়',
  'memoryTree.status.degradedStructure': 'উইকি কাঠামো অসম্পূর্ণ',
  'memoryTree.status.extractionCoverage': 'এক্সট্র্যাকশন কভারেজ: {pct}% অংশের কাঠামো আছে',
  'memory.health.remediation.budget_exhausted':
    'মেমরি এমবেডিং পরিচালিত বাজেটে পৌঁছেছে। স্থানীয় Ollama এমবেডিং সেট আপ করুন (সংযোগ → API কী → এমবেডিংস) অথবা মেমরি তৈরি চালিয়ে যেতে আপনার নিজস্ব এমবেডিং API কী যোগ করুন।',
  'memory.health.remediation.auth_missing':
    'কোনও এমবেডিং শংসাপত্র পাওয়া যায়নি। OpenHuman-এ লগ ইন করুন, অথবা সংযোগ → API কী → এমবেডিংস-এ স্থানীয় Ollama এমবেডিং সেট আপ করুন।',
  'memory.health.remediation.auth_invalid':
    'আপনার এমবেডিং শংসাপত্র প্রত্যাখ্যাত হয়েছে। পুনরায় প্রমাণীকরণ করুন, অথবা সংযোগ → API কী → এমবেডিংস-এ স্থানীয় Ollama এমবেডিং-এ স্যুইচ করুন।',
  'memory.health.remediation.embeddings_unconfigured':
    'কোনও এমবেডিং প্রদানকারী কনফিগার করা নেই, তাই সিম্যান্টিক রিকল বন্ধ। স্থানীয় Ollama এমবেডিং সেট আপ করুন (প্রস্তাবিত) অথবা সংযোগ → API কী → এমবেডিংস-এ একটি এমবেডিং কী যোগ করুন।',
  'memory.health.remediation.embedding_dim_mismatch':
    'এমবেডিং মডেল ভুল ভেক্টর আকার ফেরত দেয় (মেমরি 1024 মাত্রা প্রত্যাশা করে)। 1024-মাত্রার একটি মডেল বেছে নিন, অথবা আপনার প্রদানকারীর কাছে 1024 মাত্রা অনুরোধ করুন।',
  'memory.health.remediation.local_model_unavailable':
    'একটি প্রয়োজনীয় স্থানীয় মডেল উপলব্ধ নেই। Ollama ইনস্টল/চালু করুন এবং মডেলটি ডাউনলোড করুন, অথবা সংযোগ → API কী-তে এই কাজের চাপ একটি ক্লাউড প্রদানকারীতে স্যুইচ করুন।',
  'memory.health.remediation.extraction_timeout':
    'মেমরি এক্সট্র্যাকশন মডেল টাইম আউট হচ্ছে, তাই উইকিতে সামান্য কাঠামো আছে। সংযোগ → API কী → LLM-তে মেমরি এক্সট্র্যাকশন মডেল একটি দ্রুততর মডেলে পরিবর্তন করুন।',
  'memory.health.remediation.summarizer_unavailable':
    'সারাংশ ট্রি তৈরির জন্য কোনও সারাংশ প্রদানকারী উপলব্ধ নেই। স্থানীয় AI (Ollama) সক্ষম করুন, অথবা memory_tree.cloud_summarization_opt_in=true সেট করে সংযোগ → API কী → LLM-তে একটি LLM প্রদানকারী কনফিগার করুন।',
  'memory.health.remediation.empty_input_refused':
    'একটি মেমরি আইটেম এড়িয়ে যাওয়া হয়েছে কারণ এর পাঠ্য খালি ছিল। কোনো পদক্ষেপের প্রয়োজন নেই: নতুন আইটেমগুলি স্বাভাবিকভাবে এমবেড করতে থাকে।',
  'memory.health.remediation.storage_unavailable':
    'OpenHuman তার মেমরি স্টোরেজে লিখতে পারছে না: ডিস্ক বা SD কার্ডটি ত্রুটিপূর্ণ, পূর্ণ বা শুধু-পঠনযোগ্য বলে মনে হচ্ছে। ড্রাইভটি পরীক্ষা করুন এবং কিছু জায়গা খালি করুন; স্টোরেজ আবার লেখার উপযোগী হলে মেমরি প্রক্রিয়াকরণ স্বয়ংক্রিয়ভাবে পুনরায় শুরু হবে।',
  'memory.health.remediation.transient':
    'একটি অস্থায়ী ত্রুটি মেমরি প্রক্রিয়াকরণে বাধা দিয়েছে। স্বয়ংক্রিয়ভাবে পুনরায় চেষ্টা করা হবে।',
  'memory.health.remediation.unknown':
    'মেমরি প্রক্রিয়াকরণে একটি সমস্যা হয়েছে। কনফিগারেশনের জন্য সংযোগ → API কী পরীক্ষা করুন।',
  // Chat: agent-generated artifacts (#2779)

  // Chat composer toolbar
  'composer.attachFile': 'ফাইল সংযুক্ত করুন',
  'composer.modelSelector': 'মডেল',
  'composer.voiceMode': 'ভয়েস মোড',
  'composer.qualityHigh': 'উচ্চ',
  // Agent activity level
  'activityLevel.title': 'এজেন্ট কার্যকলাপের স্তর',
  'activityLevel.description':
    'আপনার এজেন্ট কতটা সক্রিয় তা নিয়ন্ত্রণ করুন। উচ্চ স্তরে বেশি টোকেন ব্যবহার হয়।',
  'activityLevel.off': 'বন্ধ',
  'activityLevel.offDesc': 'পটভূমিতে কোনো প্রক্রিয়াকরণ নেই। শুধুমাত্র বোতাম চাপলে সিঙ্ক করে।',
  'activityLevel.minimal': 'ন্যূনতম',
  'activityLevel.minimalDesc': 'প্রতিদিন একবার উৎস সিঙ্ক করে। কোনো সক্রিয় বার্তা নেই।',
  'activityLevel.moderate': 'মাঝারি',
  'activityLevel.moderateDesc':
    'প্রতি ঘণ্টায় সিঙ্ক করে। দৈনিক সারসংক্ষেপ। কর্মপন্থা প্রস্তাব করে।',
  'activityLevel.active': 'সক্রিয়',
  'activityLevel.activeDesc':
    'প্রতি ১০ মিনিটে সিঙ্ক করে। চ্যানেল পর্যবেক্ষণ, বাছাই ও উত্তর খসড়া করে।',
  'activityLevel.alwaysOn': 'সর্বদা চালু',
  'activityLevel.alwaysOnDesc': 'রিয়েল-টাইম সিঙ্ক। নির্ধারিত সীমার মধ্যে পূর্ণ স্বায়ত্তশাসন।',
  'activityLevel.currentMonth': 'এই মাস: ${amount}',
  'activityLevel.saved': 'কার্যকলাপের স্তর আপডেট হয়েছে।',
  'activityLevel.default': 'ডিফল্ট',
  'activityLevel.costFree': '$০',
  'activityLevel.costRange': '~${min}–${max}/মাস',

  // Sync budget dialog
  'syncBudget.title': 'সিঙ্ক বাজেট',
  'syncBudget.maxTokens': 'প্রতি সিঙ্কে সর্বোচ্চ টোকেন',
  'syncBudget.maxTokensHelp': 'এতটা টোকেন ব্যবহার হলে সিঙ্ক বন্ধ করুন।',
  'syncBudget.maxCost': 'প্রতি সিঙ্কে সর্বোচ্চ খরচ (USD)',
  'syncBudget.maxCostHelp': 'প্রতিটি সিঙ্ক রানের জন্য নির্দিষ্ট ডলার সীমা।',
  'syncBudget.syncDepth': 'সিঙ্ক গভীরতা',
  'syncBudget.syncDepthHelp': 'কেবল এই সময়সীমার আইটেম আনুন।',
  'syncBudget.days7': 'গত ৭ দিন',
  'syncBudget.days30': 'গত ৩০ দিন',
  'syncBudget.days90': 'গত ৯০ দিন',
  'syncBudget.allTime': 'সব সময়',
  'syncBudget.unlimited': 'সীমাহীন',
  'syncBudget.saved': 'বাজেট সংরক্ষিত হয়েছে।',

  // Sync confirm dialog
  'syncConfirm.title': 'সিঙ্ক নিশ্চিত করুন',
  'syncConfirm.message':
    'এই সিঙ্ক ~{items}টি আইটেম (~{tokens} টোকেন, আনুমানিক ${cost}) প্রক্রিয়া করবে।',
  'syncConfirm.budgetNote': 'বাজেট সীমা: ${max}',
  'syncConfirm.proceed': 'চালিয়ে যান',
  'syncConfirm.cancel': 'বাতিল',
  'syncConfirm.estimating': 'খরচ অনুমান করা হচ্ছে...',

  // Monthly cost badge
  'monthlyCost.badge': 'এই মাসে ${amount}',
  'monthlyCost.noData': 'এই মাসে কোনো সিঙ্ক নেই',

  // Onboarding: Custom > Activity
  'onboarding.custom.stepperActivity': 'কার্যকলাপ',
  'onboarding.custom.stepperVault': 'ভল্ট',
  'onboarding.custom.activity.title': 'এজেন্টের কার্যকলাপ',
  'onboarding.custom.activity.subtitle':
    'আপনার এজেন্ট পটভূমিতে কতটা সক্রিয়ভাবে পর্যবেক্ষণ ও কাজ করে।',
  'onboarding.custom.activity.defaultDesc':
    'মাঝারি কার্যকলাপ: প্রতি ঘণ্টায় সিঙ্ক, দৈনিক সারসংক্ষেপ।',
  'onboarding.custom.activity.configureDesc':
    'নিজের কার্যকলাপের স্তর বেছে নিন। সেটিংস › এজেন্ট কার্যকলাপ স্তরে কনফিগার করুন।',
  'onboarding.custom.vault.title': 'মেমোরি ও ভল্ট সেটআপ',
  'onboarding.custom.vault.subtitle':
    'নিশ্চিত করুন মেমোরি নোট কোথায় লেখা হয়, উৎস ডেটা কীভাবে পড়া হয় এবং আপনার ভল্ট পাইপলাইন সুস্থ কিনা।',
  'onboarding.custom.vault.defaultDesc':
    'OpenHuman-পরিচালিত মেমোরির ডিফল্ট ব্যবহার করুন। ভল্ট পাথ এবং সিঙ্ক স্বাস্থ্য পরে পর্যালোচনা করা যাবে।',
  'onboarding.custom.vault.configureDesc':
    'ভল্টের মালিকানা পর্যালোচনা করুন, স্বাস্থ্য পরীক্ষা চালান এবং এখনই মেমোরি নিয়ন্ত্রণ সামঞ্জস্য করুন।',
  'onboarding.custom.vault.localDisabledReason':
    'পরিচালিত সেটআপের জন্য OpenHuman সাইন-ইন প্রয়োজন এবং লোকাল মোডে উপলব্ধ নয়।',
  'onboarding.custom.vault.exitError': 'অনবোর্ডিং শেষ করা যায়নি। আবার চেষ্টা করুন।',
  'vaultHealth.title': 'ভল্ট স্বাস্থ্য চেকলিস্ট',
  'vaultHealth.setupTitle': 'ভল্ট সেটআপ স্বাস্থ্য',
  'vaultHealth.workspaceVault': 'ওয়ার্কস্পেস ভল্ট:',
  'vaultHealth.refresh': 'রিফ্রেশ',
  'vaultHealth.refreshing': 'রিফ্রেশ হচ্ছে…',
  'vaultHealth.revealFolder': 'ফোল্ডার দেখান',
  'vaultHealth.openInObsidian': 'Obsidian-এ খুলুন',
  'vaultHealth.installObsidian': 'Obsidian ইনস্টল করুন',
  'vaultHealth.openObsidianError': 'Obsidian খোলা যায়নি',
  'vaultHealth.revealError': 'ভল্ট ফোল্ডার দেখানো যায়নি',
  'vaultHealth.downloadError': 'Obsidian ডাউনলোড পৃষ্ঠা খোলা যায়নি',
  'vaultHealth.loadError': 'ভল্ট স্বাস্থ্য লোড করা যায়নি:',
  'vaultHealth.lastSync': 'শেষ সিঙ্ক:',
  'vaultHealth.passed': 'পাস হয়েছে',
  'vaultHealth.needsAttention': 'মনোযোগ প্রয়োজন',
  'vaultHealth.existsLabel': 'ওয়ার্কস্পেস ভল্ট পাথ বিদ্যমান',
  'vaultHealth.existsRecovery':
    'ভল্ট ফোল্ডার নেই। একটি সিঙ্ক শুরু করুন বা এই ফোল্ডারটি তৈরি করুন, তারপর এই চেকলিস্ট রিফ্রেশ করুন।',
  'vaultHealth.writableLabel': 'ভল্ট OpenHuman দ্বারা লিখনযোগ্য',
  'vaultHealth.writableRecovery':
    'OpenHuman এখনও এই ভল্টে লিখতে পারছে না। লেখার অনুমতি দিন এবং রিফ্রেশ করুন।',
  'vaultHealth.obsidianLabel': 'ভল্ট Obsidian-এ নিবন্ধিত',
  'vaultHealth.obsidianRecovery':
    'Obsidian-এ এই পাথটির জন্য "ফোল্ডার ভল্ট হিসেবে খুলুন" বেছে নিন, তারপর এই চেকলিস্ট রিফ্রেশ করুন।',
  'vaultHealth.pipelineLabel': 'মেমোরি পাইপলাইন সুস্থ',
  'vaultHealth.pipelineRecovery':
    'মেমোরি পাইপলাইন বিরতিতে আছে বা ত্রুটিতে আছে। মেমোরি ট্রি স্ট্যাটাসে অটো-সিঙ্ক পুনরায় সক্ষম করুন এবং পুনরায় চেষ্টা করুন।',
  'vaultHealth.timeNever': 'কখনো না',
  'vaultHealth.timeJustNow': 'এইমাত্র',
  'vaultHealth.timeMinAgo': '{n} মিনিট আগে',
  'vaultHealth.timeHrAgo': '{n} ঘণ্টা আগে',
  'vaultHealth.timeDayAgo': '{n} দিন আগে',
  'vaultHealth.timeDaysAgo': '{n} দিন আগে',
  'memoryData.howItWorks': 'মেমোরি স্টোরেজ কীভাবে কাজ করে',
  'memoryData.workspaceVault': 'ওয়ার্কস্পেস ভল্ট · লেখা',
  'memoryData.workspaceVaultDesc': 'OpenHuman তৈরি মেমোরি নোট memory_tree/content-এ লেখে।',
  'memoryData.connectedSources': 'সংযুক্ত উৎস · পড়া',
  'memoryData.connectedSourcesDesc':
    'ফোল্ডার, মেইলবক্স, চ্যাট এবং রেপো মেমোরি ইন্ডেক্সিংয়ের জন্য আমদানি করা হয়: তাদের মূল ফাইল কখনো পুনরায় লেখা হয় না।',
  'memoryData.internalFiles': 'অভ্যন্তরীণ মেমোরি-ট্রি ফাইল',
  'memoryData.internalFilesDesc':
    'ইন্ডেক্স, কিউ স্টেট এবং সারসংক্ষেপ OpenHuman দ্বারা পরিচালিত হয় যাতে রিকল ও সিঙ্ক সুস্থ থাকে।',
  'memoryData.windowError': 'মেমোরি উইন্ডো',
  'memoryData.windowUpdated': 'মেমোরি উইন্ডো আপডেট হয়েছে',
  'memoryData.windowUpdatedMsg': '{window}-এ সেট করা হয়েছে।',
  'skills.create.whenToUse': 'কখন ব্যবহার করবেন',
  'skills.create.whenToUsePlaceholder': 'যেমন, যখন ব্যবহারকারী তাদের ইনবক্স গোছাতে বলেন',
  'skills.create.whenToUseHelp':
    'যে ট্রিগারের ভিত্তিতে একটি এজেন্ট এই ওয়ার্কফ্লো চালানোর সিদ্ধান্ত নেয়। বিবরণ পুনরায় ব্যবহার করতে ফাঁকা রাখুন।',
  'skills.create.inputs.row.descriptionError': 'প্রতিটি ইনপুটের জন্য একটি বিবরণ প্রয়োজন।',
  'skills.detail.run': 'চালান',
  'skills.detail.runAriaLabel': 'এই ওয়ার্কফ্লো চালান',
  'skills.run.title': 'ওয়ার্কফ্লো',
  'workflows.installFromUrl': 'URL থেকে ইনস্টল করুন',
  // Security banner (approval-gate host-aware boot state)
  'security.approvalGateDisabled.title': 'অনুমোদন গেট নিষ্ক্রিয়',
  'security.approvalGateDisabled.body':
    'আপনার পরিবেশে OPENHUMAN_APPROVAL_GATE=0 সেট করা আছে। বাহ্যিক প্রভাব সম্পন্ন টুলগুলি নিশ্চিতকরণ ছাড়াই চলবে।',
  'security.approvalGateOverrideIgnored.title': 'ওভাররাইড অবরুদ্ধ',
  'security.approvalGateOverrideIgnored.body':
    'একটি OPENHUMAN_APPROVAL_GATE=0 ওভাররাইড সনাক্ত করা হয়েছিল কিন্তু উপেক্ষা করা হয়েছে: ডেস্কটপ অ্যাপ সর্বদা অনুমোদন গেট চালু রাখে।',

  // Run queue
  'runQueue.mode.interrupt': 'বাধা দিন',
  'runQueue.mode.steer': 'পরিচালনা করুন',
  'runQueue.mode.followup': 'ফলো-আপ',
  'runQueue.mode.collect': 'প্রসঙ্গ যোগ করুন',
  'runQueue.queued': 'বার্তা সারিবদ্ধ হয়েছে',
  'runQueue.steerHint': 'বর্তমান পর্যায় পরিচালনা করুন',
  'runQueue.followupHint': 'ফলো-আপ হিসেবে সারিতে যোগ করুন',
  'runQueue.collectHint': 'অতিরিক্ত প্রসঙ্গ হিসেবে যোগ করুন',
  'runQueue.status': '{total}টি সারিবদ্ধ',
  'runQueue.cleared': 'সারি পরিষ্কার করা হয়েছে',
  'notch.ready': 'প্রস্তুত',
  'notch.processing': 'প্রক্রিয়াকরণ চলছে…',
  'notch.listening': 'শুনছি…',
  'notch.thinking': 'ভাবছি…',
  'notch.speaking': 'বলছি…',
  'notch.transcribing': 'ট্রান্সক্রাইব করছি…',
  'notch.executing': 'চালাচ্ছি…',
  'memory.tab.orchestration': 'অর্কেস্ট্রেশন',
  'memory.tab.orchestrationDescription':
    'বহু-এজেন্ট ওয়ার্কফ্লো চালান: একটি প্রশ্নকে সমান্তরাল এজেন্টদের মধ্যে ছড়িয়ে দিন, তাদের ফলাফল পরস্পর যাচাই করুন, এবং দেখুন প্রতিটি ধাপ কীভাবে একটি সমন্বিত উত্তরে সম্পূর্ণ হয়।',
  'orchestration.subtitle':
    'একটি বহু-এজেন্ট ওয়ার্কফ্লো শুরু করুন, এর ধাপগুলোর অগ্রগতি দেখুন, এবং সমন্বিত ফলাফল পড়ুন।',
  'orchestration.loading': 'ওয়ার্কফ্লো লোড হচ্ছে…',
  'orchestration.failedToLoad': 'ওয়ার্কফ্লো লোড করতে ব্যর্থ',
  'orchestration.definitions': 'উপলব্ধ ওয়ার্কফ্লো',
  'orchestration.noDefinitions': 'কোনো ওয়ার্কফ্লো সংজ্ঞা উপলব্ধ নেই।',
  'orchestration.approvalRequired': 'অনুমোদন প্রয়োজন',
  'orchestration.start': 'শুরু করুন',
  'orchestration.confirmStart': 'রান শুরু করুন',
  'orchestration.starting': 'শুরু হচ্ছে…',
  'orchestration.questionLabel': 'গবেষণা প্রশ্ন (ঐচ্ছিক)',
  'orchestration.questionPlaceholder': 'এজেন্টদের কী গবেষণা করা উচিত?',
  'orchestration.runProgress': 'রানের অগ্রগতি',
  'orchestration.recentRuns': 'সাম্প্রতিক রান',
  'orchestration.noRuns': 'এখনও কোনো ওয়ার্কফ্লো রান নেই।',
  'orchestration.close': 'বন্ধ করুন',
  'orchestration.tier.readOnly': 'শুধু-পড়া',
  'orchestration.tier.standard': 'মানক',
  'orchestration.tier.editCapable': 'সম্পাদনা-সক্ষম',
  'orchestration.approval.title': 'এই ওয়ার্কফ্লো রান অনুমোদন করুন',
  'orchestration.approval.body':
    'এটি একটি উচ্চ-ব্যয় বা উচ্চ-সমান্তরালতার রান এবং শুরুর আগে এর জন্য আপনার স্পষ্ট অনুমোদন প্রয়োজন:',
  'orchestration.approval.reason.tier': 'এর এজেন্টরা শুধু-পড়া গবেষণার বাইরেও পদক্ষেপ নিতে পারে।',
  'orchestration.approval.reason.concurrency': 'এটি একই সময়ে অনেক এজেন্ট চালায়।',
  'orchestration.approval.reason.children': 'এটি সর্বমোট বিপুল সংখ্যক এজেন্ট তৈরি করতে পারে।',
  'orchestration.approval.tier': 'নিরাপত্তা স্তর',
  'orchestration.approval.concurrency': 'সমান্তরালতা',
  'orchestration.approval.maxChildren': 'সর্বোচ্চ এজেন্ট',
  'orchestration.approval.approve': 'অনুমোদন ও শুরু করুন',
  'orchestration.approval.starting': 'শুরু হচ্ছে…',
  'orchestration.approval.cancel': 'বাতিল',
  'orchestration.runStatus.pending': 'অপেক্ষমাণ',
  'orchestration.runStatus.running': 'চলছে',
  'orchestration.runStatus.completed': 'সম্পন্ন',
  'orchestration.runStatus.failed': 'ব্যর্থ',
  'orchestration.runStatus.cancelled': 'বাতিল',
  'orchestration.runStatus.interrupted': 'বিঘ্নিত',
  'orchestration.phaseStatus.pending': 'অপেক্ষমাণ',
  'orchestration.phaseStatus.running': 'চলছে',
  'orchestration.phaseStatus.completed': 'সম্পন্ন',
  'orchestration.phaseStatus.failed': 'ব্যর্থ',
  'orchestration.detail.stop': 'থামান',
  'orchestration.detail.resume': 'পুনরায় শুরু করুন',
  'orchestration.detail.agents': 'এজেন্ট',
  'orchestration.detail.childRefs': 'চাইল্ড এজেন্ট',
  'orchestration.detail.synthesis': 'চূড়ান্ত সংশ্লেষণ',
  // ── Agent Profiles ───────────────────────────────────────────────────────
  'settings.profiles.title': 'এজেন্ট প্রোফাইল',
  'settings.profiles.subtitle':
    'স্বতন্ত্র এজেন্ট: প্রতিটির নিজস্ব আত্মা, স্মৃতি, কানেক্টর ও দক্ষতা।',
  'settings.profiles.menuDesc': 'এজেন্ট প্রোফাইল তৈরি ও পরিচালনা করুন',
  'settings.profiles.new': 'নতুন প্রোফাইল',
  'settings.profiles.empty': 'এখনও কোনো এজেন্ট প্রোফাইল নেই',
  'settings.profiles.loadError': 'প্রোফাইল লোড করা যায়নি',
  'settings.profiles.active': 'সক্রিয়',
  'settings.profiles.setActive': 'সক্রিয় হিসেবে সেট করুন',
  'settings.profiles.sourceBuiltIn': 'অন্তর্নির্মিত',
  'settings.profiles.sourceCustom': 'কাস্টম',
  'settings.profiles.deleteConfirm': 'এই প্রোফাইল মুছবেন? এটি ফেরানো যাবে না।',
  'settings.profiles.editor.createTitle': 'নতুন প্রোফাইল',
  'settings.profiles.editor.editTitle': 'প্রোফাইল সম্পাদনা',
  'settings.profiles.editor.name': 'নাম',
  'settings.profiles.editor.id': 'আইডি',
  'settings.profiles.editor.idHint': 'শুধু ছোট হাতের অক্ষর, সংখ্যা ও ড্যাশ।',
  'settings.profiles.editor.description': 'বিবরণ',
  'settings.profiles.editor.soul': 'আত্মা (SOUL.md)',
  'settings.profiles.editor.soulHint':
    'এই প্রোফাইলের কাস্টম পরিচয়। খালি থাকলে ওয়ার্কস্পেসের SOUL.md ব্যবহার হয়।',
  'settings.profiles.editor.baseAgent': 'বেস এজেন্ট',
  'settings.profiles.editor.baseAgentHint':
    'এই প্রোফাইল যে এজেন্ট সংজ্ঞা হিসেবে চলে (যেমন orchestrator)।',
  'settings.profiles.editor.model': 'মডেল',
  'settings.profiles.editor.modelHint': 'ঐচ্ছিক মডেল ওভাররাইড। খালি থাকলে ডিফল্ট উত্তরাধিকার নেয়।',
  'settings.profiles.editor.temperature': 'তাপমাত্রা',
  'settings.profiles.editor.systemPromptSuffix': 'সিস্টেম প্রম্পট প্রত্যয়',
  'settings.profiles.editor.agentConversations': 'এজেন্ট কথোপকথন স্মরণ',
  'settings.profiles.editor.agentConversationsHint':
    'এই প্রোফাইলের প্রসঙ্গে পূর্ববর্তী ও ক্রস-চ্যাট স্মৃতি অন্তর্ভুক্ত করুন।',
  'settings.profiles.editor.memorySources': 'স্মৃতির উৎস',
  'settings.profiles.editor.memorySourcesHint': 'এই প্রোফাইল যেসব উৎস থেকে স্মরণ করে।',
  'settings.profiles.editor.connectors': 'কানেক্টর',
  'settings.profiles.editor.connectorsHint': 'এই প্রোফাইল যেসব Composio টুলকিট ব্যবহার করতে পারে।',
  'settings.profiles.editor.skills': 'দক্ষতা',
  'settings.profiles.editor.skillsHint': 'এই প্রোফাইল যেসব ওয়ার্কফ্লো তালিকাভুক্ত ও চালাতে পারে।',
  'settings.profiles.editor.mcpServers': 'MCP সার্ভার',
  'settings.profiles.editor.mcpServersHint': 'এই প্রোফাইল যেসব MCP সার্ভারে পৌঁছাতে পারে।',
  'settings.profiles.editor.dedicatedMemory': 'নিবেদিত মেমরি',
  'settings.profiles.editor.dedicatedMemoryHint':
    'ডিফল্ট মেমরি ভাগ করার পরিবর্তে এই প্রোফাইলকে নিজস্ব মেমরি দিন।',
  'settings.profiles.editor.dedicatedWorkspace': 'নিবেদিত ওয়ার্কস্পেস',
  'settings.profiles.editor.dedicatedWorkspaceHint':
    'ফাইল ও টুল কাজের জন্য এই প্রোফাইলকে নিজস্ব ওয়ার্কিং ডিরেক্টরি দিন।',
  'settings.profiles.editor.soulMdFile': 'SOUL.md ফাইল',
  'settings.profiles.editor.workspaceDir': 'ওয়ার্কস্পেস ডিরেক্টরি',
  'settings.profiles.editor.skillsDir': 'স্কিল ডিরেক্টরি',
  'settings.profiles.editor.skillsDirHint':
    'এখানে রাখা SKILL.md ফাইলগুলি শুধু এই প্রোফাইলের জন্য ব্যক্তিগত।',
  'settings.profiles.editor.all': 'সব',
  'settings.profiles.editor.selected': 'নির্বাচিত',
  'settings.profiles.editor.addPlaceholder': 'একটি আইডি লিখে এন্টার চাপুন',
  'settings.profiles.editor.removeAria': '{item} সরান',
  'settings.profiles.editor.notFound': 'প্রোফাইল পাওয়া যায়নি',
  'settings.profiles.editor.saving': 'সংরক্ষণ হচ্ছে…',
  'settings.profiles.editor.idRequired': 'প্রোফাইল আইডি খালি রাখা যাবে না',
  'agentworld.jobs.applyModal.title': 'চাকরির জন্য আবেদন করুন',
  'agentworld.jobs.applyModal.successHeading': 'প্রস্তাব সফলভাবে জমা দেওয়া হয়েছে!',
  'agentworld.jobs.applyModal.successBody': 'চাকরি পোস্টকারী আপনার আবেদন পর্যালোচনা করবেন।',
  'agentworld.jobs.applyModal.coverLetterLabel': 'কভার লেটার',
  'agentworld.jobs.applyModal.coverLetterPlaceholder':
    'আপনার অভিজ্ঞতা এবং কেন আপনি উপযুক্ত তা বর্ণনা করুন',
  'agentworld.jobs.applyModal.bidAmountLabel': 'বিড পরিমাণ',
  'agentworld.jobs.applyModal.bidAmountPlaceholder': 'যেমন: 450 USDC',
  'agentworld.jobs.applyModal.deliveryLabel': 'আনুমানিক ডেলিভারি',
  'agentworld.jobs.applyModal.deliveryPlaceholder': 'যেমন: 2 সপ্তাহ',
  'agentworld.feed.live': 'লাইভ',
  'agentworld.jobs.applyModal.cancel': 'বাতিল',
  'agentworld.jobs.applyModal.submit': 'আবেদন জমা দিন',
  'agentworld.jobs.applyModal.submitting': 'আবেদন করা হচ্ছে…',
  'agentworld.messaging.live': 'লাইভ',
  'agentworld.messaging.missingSignalBundle':
    'এই ব্যবহারকারী এখনো এনক্রিপ্টেড মেসেজিং চালু করেননি। বার্তা পাঠানোর আগে তাকে Agent World খুলে নিরাপদ DM চালু করতে বলুন।',
  'agentworld.messaging.notAContact':
    'এই ব্যক্তি পরিচিতি না হওয়া পর্যন্ত আপনি তাকে বার্তা পাঠাতে পারবেন না। একটি পরিচিতি অনুরোধ পাঠান এবং তিনি গ্রহণ করার পর আবার চেষ্টা করুন।',
  'agentworld.messaging.sendContactRequest': 'পরিচিতি অনুরোধ পাঠান',
  'agentworld.messaging.contactRequestSending': 'অনুরোধ পাঠানো হচ্ছে…',
  'agentworld.messaging.contactRequestSent':
    'পরিচিতি অনুরোধ পাঠানো হয়েছে। তিনি গ্রহণ করলে আপনি তাকে বার্তা পাঠাতে পারবেন।',
  'agentworld.messaging.contactRequestFailed': 'পরিচিতি অনুরোধ পাঠানো যায়নি। আবার চেষ্টা করুন।',

  // User-actionable runtime errors (#3931)
  'userErrors.title': 'পদক্ষেপ প্রয়োজন',
  'userErrors.dismiss': 'বাতিল করুন',
  'userErrors.action.openBilling': 'বিলিং খুলুন',
  'userErrors.action.openProviderSettings': 'প্রদানকারী সেটিংস',
  'userErrors.action.openEmbeddingsSettings': 'এমবেডিং সেট আপ করুন',
  'userErrors.budgetExceeded.title': 'পরিচালিত বাজেট শেষ',
  'userErrors.budgetExceeded.body': 'পরিচালিত AI বাজেট শেষ। বাজেট যোগ করুন বা প্ল্যান বদলান।',
  'userErrors.insufficientCredits.title': 'প্রদানকারীর ক্রেডিট প্রয়োজন',
  'userErrors.insufficientCredits.body':
    'AI প্রদানকারীর ক্রেডিট শেষ। রিচার্জ করুন বা API কী বদলান।',
  'userErrors.apiKeyMissing.title': 'API কী প্রয়োজন',
  'userErrors.apiKeyMissing.body':
    'আপনার AI প্রদানকারীর কোনো API কী সেট নেই। চালিয়ে যেতে প্রদানকারী সেটিংসে একটি যোগ করুন।',
  'userErrors.localModelUnavailable.title': 'লোকাল মডেল অনুপলব্ধ',
  'userErrors.localModelUnavailable.body':
    'কনফিগার করা এন্ডপয়েন্টে Ollama-তে পৌঁছানো যাচ্ছে না, অথবা সেখানে প্রয়োজনীয় মডেলটি ইনস্টল করা নেই। Ollama চালু করে সেই এন্ডপয়েন্টে মডেলটি পুল করুন, অথবা এই কাজটি কোনো ক্লাউড প্রোভাইডারে সরিয়ে নিন।',
  'userErrors.scope.chat': 'চ্যাট',
  'userErrors.scope.cron': 'নির্ধারিত কাজ',
  'userErrors.scope.workspace': 'ওয়ার্কস্পেস',
  'userErrors.memoryBudgetExhausted.title': 'মেমরি আর বাড়ছে না',
  'userErrors.memoryBudgetExhausted.body':
    'আপনার এমবেডিং বাজেট শেষ, তাই নতুন কনটেন্ট আর মেমরিতে যুক্ত হচ্ছে না। আবার শুরু করতে লোকাল এমবেডিং সেট আপ করুন বা নিজের API কী যোগ করুন।',
  'memoryBudget.approachingTitle': 'মেমরি এমবেডিং সীমার কাছাকাছি',
  'memoryBudget.approachingMessage':
    'আপনি এমবেডিং বাজেটের {pct}% ব্যবহার করেছেন। মেমরি নিরবচ্ছিন্নভাবে বাড়তে থাকুক, তার জন্য লোকাল এমবেডিং সেট আপ করুন বা নিজের API কী যোগ করুন।',
  'memoryBudget.exhaustedTitle': 'মেমরি আর বাড়ছে না',
  'memoryBudget.exhaustedMessage':
    'আপনার এমবেডিং বাজেট শেষ, তাই নতুন কনটেন্ট আর মেমরিতে যুক্ত হচ্ছে না। আবার শুরু করতে লোকাল এমবেডিং সেট আপ করুন বা নিজের API কী যোগ করুন।',
  'memoryBudget.cta': 'এমবেডিং সেট আপ করুন',
  'userErrors.scope.memory': 'মেমরি',
  // Agent World: Identity trading (confirm-before-spend + balance gate)
  'agentWorld.trading.amountLabel': 'পরিমাণ',
  'agentWorld.trading.networkLabel': 'নেটওয়ার্ক',
  'agentWorld.trading.balanceLabel': 'আপনার ব্যালেন্স',
  'agentWorld.trading.walletLabel': 'ওয়ালেট',
  'agentWorld.trading.balanceUnknown': 'অজানা',
  'agentWorld.trading.cancel': 'বাতিল',
  'agentWorld.trading.addFunds': 'অর্থ যোগ করুন',
  'agentWorld.trading.confirmPay': 'নিশ্চিত করুন ও পরিশোধ করুন',
  'agentWorld.trading.confirmCommit': 'নিশ্চিত করুন',
  'agentWorld.trading.continue': 'চালিয়ে যান',
  'agentWorld.trading.submitting': 'জমা দেওয়া হচ্ছে…',
  'agentWorld.trading.placeBid': 'বিড করুন',
  'agentWorld.trading.submitOffer': 'অফার জমা দিন',
  'agentWorld.trading.bidTitlePrefix': 'বিড:',
  'agentWorld.trading.offerTitlePrefix': 'অফার:',
  'agentWorld.trading.bidReviewTitlePrefix': 'বিড নিশ্চিত করুন:',
  'agentWorld.trading.offerReviewTitlePrefix': 'অফার নিশ্চিত করুন:',
  'agentWorld.trading.spendInsufficient':
    'এই পেমেন্ট সম্পূর্ণ করার জন্য পর্যাপ্ত ব্যালেন্স নেই। চালিয়ে যেতে আপনার ওয়ালেটে অর্থ যোগ করুন।',
  'agentWorld.trading.spendBroadcastNote': 'আপনার ওয়ালেট এই পেমেন্টে স্বাক্ষর করে সম্প্রচার করবে',
  'agentWorld.trading.commitInsufficientWarning':
    'প্রতিশ্রুতিটি গৃহীত হলে আপনার ব্যালেন্স এটি কভার নাও করতে পারে। আপনি এটি জমা দিতে পারেন: অর্থ কেবল গ্রহণের সময়ই স্থানান্তরিত হয়।',
  'agentWorld.trading.commitSettleNote':
    'এটি একটি স্বাক্ষরিত প্রতিশ্রুতি: গৃহীত হলেই কেবল অর্থ স্থানান্তরিত হয়।',
  'agentWorld.trading.commitReviewSubtitle': 'জমা দেওয়ার আগে আপনার প্রতিশ্রুতি পর্যালোচনা করুন।',
  'agentWorld.trading.balanceUnverified':
    'আমরা আপনার ওয়ালেট ব্যালেন্স যাচাই করতে পারিনি। আপনি চালিয়ে যেতে পারেন: জমা দেওয়ার সময় পেমেন্ট যাচাই করা হয়।',
  'agentWorld.trading.amountTooManyDecimals': 'এই পরিমাণে অত্যধিক দশমিক স্থান রয়েছে।',
  'agentWorld.trading.amountMustBePositive': 'শূন্যের চেয়ে বড় একটি পরিমাণ লিখুন।',
  'agentWorld.trading.amountInvalid': 'একটি বৈধ পরিমাণ লিখুন।',

  // Code block chrome
  'codeBlock.copy': 'কপি করুন',
  'codeBlock.copied': 'কপি হয়েছে!',
  'flows.editor.undo': 'পূর্বাবস্থায় ফিরুন',
  'flows.editor.redo': 'পুনরায় করুন',
  'flows.editor.onboardingTitle': 'আপনার ওয়ার্কফ্লো তৈরি করুন',
  'flows.editor.onboardingBody':
    'বাঁদিকের প্যালেট থেকে একটি নোড যোগ করুন, তারপর প্রতিটি কার্ডের বিন্দুগুলোর মধ্যে টেনে সেগুলো সংযুক্ত করুন।',
  'flows.palette.search': 'নোড খুঁজুন…',
  'flows.palette.noResults': 'কোনো মিলে যাওয়া নোড নেই',
  'flows.palette.group.triggers': 'ট্রিগার',
  'flows.palette.group.actions': 'ক্রিয়া',
  'flows.palette.group.logic': 'লজিক',
  'flows.list.duplicate': 'অনুলিপি করুন',
  'flows.list.duplicated': 'ওয়ার্কফ্লো অনুলিপি হয়েছে',
  'flows.list.delete': 'মুছুন',
  'flows.list.deleted': 'ওয়ার্কফ্লো মুছে ফেলা হয়েছে',
  'flows.list.moreActions': 'আরও ক্রিয়া',
  'flows.delete.title': 'ওয়ার্কফ্লো মুছবেন?',
  'flows.delete.body':
    '"{name}" এবং এর রান ইতিহাস স্থায়ীভাবে মুছে ফেলা হবে। এটি পূর্বাবস্থায় ফেরানো যাবে না।',
  'flows.delete.cancel': 'বাতিল করুন',
  'flows.delete.confirm': 'মুছুন',
  'flows.delete.deleting': 'মুছে ফেলা হচ্ছে…',
  'flows.canvas.renameLabel': 'ওয়ার্কফ্লো পুনঃনামকরণ করুন',
  'memorySources.codingSessions.title': 'কোডিং-এজেন্ট সেশন',
  'memorySources.codingSessions.description':
    'Codex ও Claude Code-এর সিদ্ধান্ত এবং সংশোধনকে ব্যক্তিগত পারসোনা মেমরিতে রূপ দিন।',
  'memorySources.codingSessions.importAll': 'সব সেশন আমদানি করুন',
  'memorySources.codingSessions.draining': 'আমদানি হচ্ছে… পাস {passes}',
  'memorySources.codingSessions.stop': 'থামান',
  'memorySources.codingSessions.progress':
    '{processed}টি সেশন আমদানি হয়েছে · {observations}টি পর্যবেক্ষণ',
  'memorySources.codingSessions.remaining': 'আরও প্রায় {remaining} বাকি',
  'memorySources.codingSessions.stopped': 'আমদানি থামানো হয়েছে',
  'memorySources.codingSessions.stoppedMessage':
    '{processed}টি সেশন আমদানি হয়েছে। বাকি {remaining}টি চালিয়ে যেতে আবার আমদানি চালান।',
  'memorySources.codingSessions.claude': 'ক্লড কোড',
  'memorySources.codingSessions.codex': 'Codex',
  'memorySources.codingSessions.counts': '{files}টি সেশন · {evidence}টি মানব বার্তা',
  'memorySources.codingSessions.notFound': 'কোনো স্থানীয় ইতিহাস পাওয়া যায়নি',
  'memorySources.codingSessions.scanning': 'স্থানীয় সেশন ইতিহাস স্ক্যান করা হচ্ছে…',
  'memorySources.codingSessions.truncated': 'স্ক্যানটি প্রথম ১,০০০টি সেশন ফাইলে সীমাবদ্ধ ছিল।',
  'memorySources.codingSessions.complete': 'কোডিং সেশন গ্রহণ সম্পন্ন',
  'memorySources.codingSessions.completeMessage':
    '{processed}টি সেশন থেকে {observations}টি পারসোনা পর্যবেক্ষণ তৈরি হয়েছে।',
  'memorySources.codingSessions.partialFailure':
    '{processed}টি সেশন প্রক্রিয়া করার সময় {failed}টি ব্যর্থ হয়েছে। আবার চেষ্টা করতে গ্রহণ পুনরায় চালান।',
  'memorySources.codingSessions.failed': 'কোডিং সেশন গ্রহণ ব্যর্থ হয়েছে',
  'flows.canvas.sidePanelToggle': 'সাইড প্যানেল',
  'flows.canvas.legendTab': 'ম্যানুয়াল',

  // Privacy status pill + per-action egress disclosure (#4437 / S3)
  'privacy.status.ariaLabel': 'গোপনীয়তা স্থিতি',
  'privacy.status.external': 'ডিভাইসের বাইরে',
  'privacy.status.local': 'ডিভাইসে',
  // Data Sync layered pipeline status (GH-4690)
  'sync.pipeline.ingestedOnly': 'শুধু গৃহীত',
  'sync.pipeline.storedWithoutVectors': 'ভেক্টর ছাড়াই সংরক্ষিত। শব্দার্থিক অনুসন্ধান অনুপলব্ধ।',
  'sync.pipeline.signInToEnable': 'সক্রিয় করতে সাইন ইন করুন',
  'sync.pipeline.extractionFailed': 'মেমরি কাঠামো নিষ্কাশন ব্যর্থ হয়েছে। উইকি অসম্পূর্ণ হতে পারে।',
  'sync.pipeline.treeDegraded': 'মেমরি ট্রি অবনমিত। পুনরুদ্ধার পুরনো ফলাফল দিতে পারে।',
  'sync.pipeline.viewHealth': 'মেমরির স্বাস্থ্য দেখুন',
  'notifications.configRecovered.title': 'সেটিংস ফাইল পুনরুদ্ধার করা হয়েছে',
  'notifications.configRecovered.body':
    'আপনার সেটিংস ফাইল পড়া যায়নি, তাই এটি একটি ব্যাকআপ থেকে পুনরুদ্ধার করা হয়েছে বা ডিফল্টে রিসেট করা হয়েছে। অপঠনযোগ্য ফাইলটি, প্রয়োজনে ব্যবহারের জন্য, ".corrupted" প্রত্যয় সহ রাখা হয়েছে।',
};

export default messages;
